(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as eI, getPartnerDevApiHeaders as nI, WidgetContextProvider as tI, makeExecuteQuery as rI, makeUseLazyQuery as iI, makeUseQuery as aI, makeUseMutation as oI, useWidgetSettingsMutations as ur, useWidgetSettingsQuery as mr, useRenderConditions as pr, PartnerSettingsWrapper as fr, handleWidgetSubmit as hr, MisconfigurationBanner as yr, validateApiHostName as bl, PartnerHookFormSecretText as Er, WidgetSettingsFormFooter as gr, useTracking as Fn, useWidgetContext as yn, hasDownstreamApiForbiddenError as xl, hasDownstreamApiAuthorizationError as _l, DisplayErrors as Tn, settingsToFormValues as Sl, useCopyWithDelay as Jt, defaultDateFormat as jt, displayAttributeValue as Li, OAuthSettings as fi, useData as fy, isDownstreamApiNotFoundError as sI, isDownstreamApiAuthorizationError as pw, isDownstreamApiPermissionError as lI, capitalizeFirstCharacter as fw, humanizeKey as cI, hasDownstreamApiTooManyRequestsError as dI, hasDownstreamApiPermissionError as hw, PartnerHookFormBasicAuth as uI, hasDownstreamApiNotFoundError as ba, getCountryNameFromCountryCode as mI, parseBoolean as pI, parseString as fI, IntegrationModal as yw, useInboundOAuthContext as hI, getWidgetConfigurationByIdQuery as yI, createWidgetConfigurationMutation as gI, updateWidgetConfigurationMutation as vI, trackRenderConditionsSaved as kI, deleteWidgetConfigurationMutation as bI } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import qe, { useMemo as Yn, useState as me, useEffect as Je, useRef as $r, useCallback as yt, useReducer as xI, useLayoutEffect as _I, useContext as hy, isValidElement as gw, Fragment as vw, createContext as kw, createElement as SI } from "react";
import { FlexBox as b, Switch as Io, FieldLabel as bw, FieldWrapper as He, InputText as dr, InputSelectionList as ni, FormGrid as nt, FormField as Z, Text as $, Spinner as hn, Icon as ve, Tooltip as Ze, List as Xe, Badge as Bn, Button as et, IconButton as ir, Tag as Jn, NavigationButton as Lt, Select as Tr, CollapseCard as xr, Box as lt, Modal as wt, ModalHead as Ct, ModalBody as Ft, ModalFoot as Et, Textarea as Nh, TagsInput as Nl, Image as xa, Banner as jl, FieldSwitch as wl, SelectionList as ut, Divider as Cl, FieldText as tr, FieldTextarea as NI, CopyToClipboardButton as jI, getSelectionListContext as wI, Avatar as yy, Timestamp as CI, Attachment as FI, EmptyState as Eo, Table as ot, Checkbox as Xg, TextWithHighlight as xw, ErrorBoundaryContext as _w } from "@dixa/lib-shared-habla";
import dt from "classnames";
import { ApolloLink as gy, Observable as Sw, ApolloClient as II, InMemoryCache as EI, createHttpLink as $I, ApolloProvider as TI, useApolloClient as OI, ApolloConsumer as DI, NetworkStatus as rr, isApolloError as Nw, gql as Fl, ApolloError as jw, useQuery as PI, useMutation as Zg } from "@apollo/client";
import RI from "cross-fetch";
import { config as $o } from "lib-shared-backend-config";
import Qn from "moment";
import "moment-timezone";
import { __rest as AI, __assign as ec } from "tslib";
import { useLocation as LI } from "react-router-dom";
function vy(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Xo = { exports: {} }, Da = {};
var ev;
function VI() {
  if (ev) return Da;
  ev = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Da.Fragment = r, Da.jsx = s, Da.jsxs = s, Da;
}
var Pa = {};
var nv;
function zI() {
  return nv || (nv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c, E));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Pa.Fragment = i, Pa.jsx = Un, Pa.jsxs = Kn;
  })()), Pa;
}
var tv;
function UI() {
  return tv || (tv = 1, process.env.NODE_ENV === "production" ? Xo.exports = VI() : Xo.exports = zI()), Xo.exports;
}
var Ke = UI();
function ww(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: MI } = Object.prototype, { getPrototypeOf: fa } = Object, { iterator: Ro, toStringTag: Cw } = Symbol, Js = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), To = (e, n) => {
  let r = e;
  const i = [];
  for (; r != null && r !== Object.prototype; ) {
    if (i.indexOf(r) !== -1)
      return !1;
    if (i.push(r), Js(r, n))
      return !0;
    r = fa(r);
  }
  return !1;
}, BI = (e, n) => e != null && To(e, n) ? e[n] : void 0, ky = /* @__PURE__ */ ((e) => (n) => {
  const r = MI.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Or = (e) => (e = e.toLowerCase(), (n) => ky(n) === e), Il = (e) => (n) => typeof n === e, { isArray: Vi } = Array, ha = Il("undefined");
function _a(e) {
  return e !== null && !ha(e) && e.constructor !== null && !ha(e.constructor) && er(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Fw = Or("ArrayBuffer");
function qI(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Fw(e.buffer), n;
}
const HI = Il("string"), er = Il("function"), Iw = Il("number"), Sa = (e) => e !== null && typeof e == "object", WI = (e) => e === !0 || e === !1, Ds = (e) => {
  if (!Sa(e))
    return !1;
  const n = fa(e);
  return (n === null || n === Object.prototype || fa(n) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
  // Symbol.iterator as evidence the value is a tagged/iterable type rather
  // than a plain object, while ignoring keys injected onto Object.prototype.
  !To(e, Cw) && !To(e, Ro);
}, KI = (e) => {
  if (!Sa(e) || _a(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, GI = Or("Date"), YI = Or("File"), JI = (e) => !!(e && typeof e.uri < "u"), QI = (e) => e && typeof e.getParts < "u", XI = Or("Blob"), ZI = Or("FileList"), eE = (e) => Sa(e) && er(e.pipe);
function nE() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const rv = nE(), iv = typeof rv.FormData < "u" ? rv.FormData : void 0, tE = (e) => {
  if (!e) return !1;
  if (iv && e instanceof iv) return !0;
  const n = fa(e);
  if (!n || n === Object.prototype || !er(e.append)) return !1;
  const r = ky(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && er(e.toString) && e.toString() === "[object FormData]";
}, rE = Or("URLSearchParams"), [iE, aE, oE, sE] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Or), lE = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ao(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Vi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (_a(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function Ew(e, n) {
  if (_a(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const Ei = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, $w = (e) => !ha(e) && e !== Ei;
function jh(...e) {
  const { caseless: n, skipUndefined: r } = $w(this) && this || {}, i = {}, a = (o, s) => {
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    const l = n && typeof s == "string" && Ew(i, s) || s, d = Js(i, l) ? i[l] : void 0;
    Ds(d) && Ds(o) ? i[l] = jh(d, o) : Ds(o) ? i[l] = jh({}, o) : Vi(o) ? i[l] = o.slice() : (!r || !ha(o)) && (i[l] = o);
  };
  for (let o = 0, s = e.length; o < s; o++) {
    const l = e[o];
    if (!l || _a(l) || (Ao(l, a), typeof l != "object" || Vi(l)))
      continue;
    const d = Object.getOwnPropertySymbols(l);
    for (let m = 0; m < d.length; m++) {
      const u = d[m];
      bE.call(l, u) && a(l[u], u);
    }
  }
  return i;
}
const cE = (e, n, r, { allOwnKeys: i } = {}) => (Ao(
  n,
  (a, o) => {
    r && er(a) ? Object.defineProperty(e, o, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: ww(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      __proto__: null,
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), dE = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), uE = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, mE = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && fa(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, pE = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, fE = (e) => {
  if (!e) return null;
  if (Vi(e)) return e;
  let n = e.length;
  if (!Iw(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, hE = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && fa(Uint8Array)), yE = (e, n) => {
  const i = (e && e[Ro]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, gE = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, vE = Or("HTMLFormElement"), kE = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), { propertyIsEnumerable: bE } = Object.prototype, xE = Or("RegExp"), Tw = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  Ao(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, _E = (e) => {
  Tw(e, (n, r) => {
    if (er(e) && ["arguments", "caller", "callee"].includes(r))
      return !1;
    const i = e[r];
    if (er(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, SE = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Vi(e) ? i(e) : i(String(e).split(n)), r;
}, NE = () => {
}, jE = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function wE(e) {
  return !!(e && er(e.append) && e[Cw] === "FormData" && e[Ro]);
}
const CE = (e) => {
  const n = /* @__PURE__ */ new WeakSet(), r = (i) => {
    if (Sa(i)) {
      if (n.has(i))
        return;
      if (_a(i))
        return i;
      if (!("toJSON" in i)) {
        n.add(i);
        const a = Vi(i) ? [] : {};
        return Ao(i, (o, s) => {
          const l = r(o);
          !ha(l) && (a[s] = l);
        }), n.delete(i), a;
      }
    }
    return i;
  };
  return r(e);
}, FE = Or("AsyncFunction"), IE = (e) => e && (Sa(e) || er(e)) && er(e.then) && er(e.catch), Ow = ((e, n) => e ? setImmediate : n ? ((r, i) => (Ei.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === Ei && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), Ei.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", er(Ei.postMessage)), EE = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ei) : typeof process < "u" && process.nextTick || Ow, Dw = (e) => e != null && er(e[Ro]), $E = (e) => e != null && To(e, Ro) && Dw(e), ye = {
  isArray: Vi,
  isArrayBuffer: Fw,
  isBuffer: _a,
  isFormData: tE,
  isArrayBufferView: qI,
  isString: HI,
  isNumber: Iw,
  isBoolean: WI,
  isObject: Sa,
  isPlainObject: Ds,
  isEmptyObject: KI,
  isReadableStream: iE,
  isRequest: aE,
  isResponse: oE,
  isHeaders: sE,
  isUndefined: ha,
  isDate: GI,
  isFile: YI,
  isReactNativeBlob: JI,
  isReactNative: QI,
  isBlob: XI,
  isRegExp: xE,
  isFunction: er,
  isStream: eE,
  isURLSearchParams: rE,
  isTypedArray: hE,
  isFileList: ZI,
  forEach: Ao,
  merge: jh,
  extend: cE,
  trim: lE,
  stripBOM: dE,
  inherits: uE,
  toFlatObject: mE,
  kindOf: ky,
  kindOfTest: Or,
  endsWith: pE,
  toArray: fE,
  forEachEntry: yE,
  matchAll: gE,
  isHTMLForm: vE,
  hasOwnProperty: Js,
  hasOwnProp: Js,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: To,
  getSafeProp: BI,
  reduceDescriptors: Tw,
  freezeMethods: _E,
  toObjectSet: SE,
  toCamelCase: kE,
  noop: NE,
  toFiniteNumber: jE,
  findKey: Ew,
  global: Ei,
  isContextDefined: $w,
  isSpecCompliantForm: wE,
  toJSONObject: CE,
  isAsyncFn: FE,
  isThenable: IE,
  setImmediate: Ow,
  asap: EE,
  isIterable: Dw,
  isSafeIterable: $E
}, TE = ye.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), OE = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && TE[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
};
function DE(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
const PE = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), RE = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function by(e, n) {
  return ye.isArray(e) ? e.map((r) => by(r, n)) : DE(String(e).replace(n, ""));
}
const AE = (e) => by(e, PE), LE = (e) => by(e, RE);
function Pw(e) {
  const n = /* @__PURE__ */ Object.create(null);
  return ye.forEach(e.toJSON(), (r, i) => {
    n[i] = LE(r);
  }), n;
}
const av = /* @__PURE__ */ Symbol("internals");
function Ra(e) {
  return e && String(e).trim().toLowerCase();
}
function Ps(e) {
  return e === !1 || e == null ? e : ye.isArray(e) ? e.map(Ps) : AE(String(e));
}
function VE(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const zE = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function nc(e, n, r, i, a) {
  if (ye.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ye.isString(n)) {
    if (ye.isString(i))
      return n.indexOf(i) !== -1;
    if (ye.isRegExp(i))
      return i.test(n);
  }
}
function UE(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function ME(e, n) {
  const r = ye.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Ut = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = Ra(d);
      if (!u)
        return;
      const f = ye.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = Ps(l));
    }
    const s = (l, d) => ye.forEach(l, (m, u) => o(m, u, d));
    if (ye.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ye.isString(n) && (n = n.trim()) && !zE(n))
      s(OE(n), r);
    else if (ye.isObject(n) && ye.isSafeIterable(n)) {
      let l = /* @__PURE__ */ Object.create(null), d, m;
      for (const u of n) {
        if (!ye.isArray(u))
          throw new TypeError("Object iterator must return a key-value pair");
        m = u[0], ye.hasOwnProp(l, m) ? (d = l[m], l[m] = ye.isArray(d) ? [...d, u[1]] : [d, u[1]]) : l[m] = u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = Ra(n), n) {
      const i = ye.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return VE(a);
        if (ye.isFunction(r))
          return r.call(this, a, i);
        if (ye.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = Ra(n), n) {
      const i = ye.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || nc(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Ra(s), s) {
        const l = ye.findKey(i, s);
        l && (!r || nc(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ye.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || nc(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ye.forEach(this, (a, o) => {
      const s = ye.findKey(i, o);
      if (s) {
        r[s] = Ps(a), delete r[o];
        return;
      }
      const l = n ? UE(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Ps(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ye.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ye.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[av] = this[av] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Ra(s);
      i[l] || (ME(a, s), i[l] = !0);
    }
    return ye.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Ut.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
ye.reduceDescriptors(Ut.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ye.freezeMethods(Ut);
const BE = "[REDACTED ****]";
function qE(e) {
  if (ye.hasOwnProp(e, "toJSON"))
    return !0;
  let n = Object.getPrototypeOf(e);
  for (; n && n !== Object.prototype; ) {
    if (ye.hasOwnProp(n, "toJSON"))
      return !0;
    n = Object.getPrototypeOf(n);
  }
  return !1;
}
function HE(e, n) {
  const r = new Set(n.map((o) => String(o).toLowerCase())), i = [], a = (o) => {
    if (o === null || typeof o != "object" || ye.isBuffer(o)) return o;
    if (i.indexOf(o) !== -1) return;
    o instanceof Ut && (o = o.toJSON()), i.push(o);
    let s;
    if (ye.isArray(o))
      s = [], o.forEach((l, d) => {
        const m = a(l);
        ye.isUndefined(m) || (s[d] = m);
      });
    else {
      if (!ye.isPlainObject(o) && qE(o))
        return i.pop(), o;
      s = /* @__PURE__ */ Object.create(null);
      for (const [l, d] of Object.entries(o)) {
        const m = r.has(l.toLowerCase()) ? BE : a(d);
        ye.isUndefined(m) || (s[l] = m);
      }
    }
    return i.pop(), s;
  };
  return a(e);
}
let ln = class Rw extends Error {
  static from(n, r, i, a, o, s) {
    const l = new Rw(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    const n = this.config, r = n && ye.hasOwnProp(n, "redact") ? n.redact : void 0, i = ye.isArray(r) && r.length > 0 ? HE(n, r) : ye.toJSONObject(n);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: i,
      code: this.code,
      status: this.status
    };
  }
};
ln.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
ln.ERR_BAD_OPTION = "ERR_BAD_OPTION";
ln.ECONNABORTED = "ECONNABORTED";
ln.ETIMEDOUT = "ETIMEDOUT";
ln.ECONNREFUSED = "ECONNREFUSED";
ln.ERR_NETWORK = "ERR_NETWORK";
ln.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
ln.ERR_DEPRECATED = "ERR_DEPRECATED";
ln.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
ln.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
ln.ERR_CANCELED = "ERR_CANCELED";
ln.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
ln.ERR_INVALID_URL = "ERR_INVALID_URL";
ln.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const WE = null, Aw = 100;
function wh(e) {
  return ye.isPlainObject(e) || ye.isArray(e);
}
function Lw(e) {
  return ye.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function tc(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = Lw(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function KE(e) {
  return ye.isArray(e) && !e.some(wh);
}
const GE = ye.toFlatObject(ye, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function El(e, n, r) {
  if (!ye.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ye.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(g, D) {
      return !ye.isUndefined(D[g]);
    }
  );
  const i = r.metaTokens, a = r.visitor || F, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, d = r.maxDepth === void 0 ? Aw : r.maxDepth, m = l && ye.isSpecCompliantForm(n), u = [];
  if (!ye.isFunction(a))
    throw new TypeError("visitor must be a function");
  function f(x) {
    if (x === null) return "";
    if (ye.isDate(x))
      return x.toISOString();
    if (ye.isBoolean(x))
      return x.toString();
    if (!m && ye.isBlob(x))
      throw new ln("Blob is not supported. Use a Buffer instead.");
    return ye.isArrayBuffer(x) || ye.isTypedArray(x) ? m && typeof Blob == "function" ? new Blob([x]) : Buffer.from(x) : x;
  }
  function h(x) {
    if (x > d)
      throw new ln(
        "Object is too deeply nested (" + x + " levels). Max depth: " + d,
        ln.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function k(x, g) {
    if (d === 1 / 0)
      return JSON.stringify(x);
    const D = [];
    return JSON.stringify(x, function(C, w) {
      if (!ye.isObject(w))
        return w;
      for (; D.length && D[D.length - 1] !== this; )
        D.pop();
      return D.push(w), h(g + D.length - 1), w;
    });
  }
  function F(x, g, D) {
    let I = x;
    if (ye.isReactNative(n) && ye.isReactNativeBlob(x))
      return n.append(tc(D, g, o), f(x)), !1;
    if (x && !D && typeof x == "object") {
      if (ye.endsWith(g, "{}"))
        g = i ? g : g.slice(0, -2), x = k(x, 1);
      else if (ye.isArray(x) && KE(x) || (ye.isFileList(x) || ye.endsWith(g, "[]")) && (I = ye.toArray(x)))
        return g = Lw(g), I.forEach(function(w, A) {
          !(ye.isUndefined(w) || w === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? tc([g], A, o) : s === null ? g : g + "[]",
            f(w)
          );
        }), !1;
    }
    return wh(x) ? !0 : (n.append(tc(D, g, o), f(x)), !1);
  }
  const j = Object.assign(GE, {
    defaultVisitor: F,
    convertValue: f,
    isVisitable: wh
  });
  function N(x, g, D = 0) {
    if (!ye.isUndefined(x)) {
      if (h(D), u.indexOf(x) !== -1)
        throw new Error("Circular reference detected in " + g.join("."));
      u.push(x), ye.forEach(x, function(C, w) {
        (!(ye.isUndefined(C) || C === null) && a.call(n, C, ye.isString(w) ? w.trim() : w, g, j)) === !0 && N(C, g ? g.concat(w) : [w], D + 1);
      }), u.pop();
    }
  }
  if (!ye.isObject(e))
    throw new TypeError("data must be an object");
  return N(e), n;
}
function ov(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function xy(e, n) {
  this._pairs = [], e && El(e, this, n);
}
const Vw = xy.prototype;
Vw.append = function(n, r) {
  this._pairs.push([n, r]);
};
Vw.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, ov);
  } : ov;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function YE(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function zw(e, n, r) {
  if (!n)
    return e;
  const i = ye.isFunction(r) ? {
    serialize: r
  } : r, a = ye.getSafeProp(i, "encode") || YE, o = ye.getSafeProp(i, "serialize");
  let s;
  if (o ? s = o(n, i) : s = ye.isURLSearchParams(n) ? n.toString() : new xy(n, i).toString(a), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class sv {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ye.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const _y = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0,
  advertiseZstdAcceptEncoding: !1,
  validateStatusUndefinedResolves: !0
}, JE = typeof URLSearchParams < "u" ? URLSearchParams : xy, QE = typeof FormData < "u" ? FormData : null, XE = typeof Blob < "u" ? Blob : null, ZE = {
  isBrowser: !0,
  classes: {
    URLSearchParams: JE,
    FormData: QE,
    Blob: XE
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Sy = typeof window < "u" && typeof document < "u", Ch = typeof navigator == "object" && navigator || void 0, e$ = Sy && (!Ch || ["ReactNative", "NativeScript", "NS"].indexOf(Ch.product) < 0), n$ = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", t$ = Sy && window.location.href || "http://localhost", r$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Sy,
  hasStandardBrowserEnv: e$,
  hasStandardBrowserWebWorkerEnv: n$,
  navigator: Ch,
  origin: t$
}, Symbol.toStringTag, { value: "Module" })), Rt = {
  ...r$,
  ...ZE
};
function i$(e, n) {
  return El(e, new Rt.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Rt.isNode && ye.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
const lv = Aw;
function Uw(e) {
  if (e > lv)
    throw new ln(
      "FormData field is too deeply nested (" + e + " levels). Max depth: " + lv,
      ln.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function a$(e) {
  const n = [], r = /\w+|\[(\w*)]/g;
  let i;
  for (; (i = r.exec(e)) !== null; )
    Uw(n.length), n.push(i[0] === "[]" ? "" : i[1] || i[0]);
  return n;
}
function o$(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function Mw(e) {
  function n(r, i, a, o) {
    Uw(o);
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && ye.isArray(a) ? a.length : s, d ? (ye.hasOwnProp(a, s) ? a[s] = ye.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!ye.hasOwnProp(a, s) || !ye.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ye.isArray(a[s]) && (a[s] = o$(a[s])), !l);
  }
  if (ye.isFormData(e) && ye.isFunction(e.entries)) {
    const r = {};
    return ye.forEachEntry(e, (i, a) => {
      n(a$(i), a, r, 0);
    }), r;
  }
  return null;
}
const Gi = (e, n) => e != null && ye.hasOwnProp(e, n) ? e[n] : void 0;
function s$(e, n, r) {
  if (ye.isString(e))
    try {
      return (n || JSON.parse)(e), ye.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const Lo = {
  transitional: _y,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ye.isObject(n);
      if (o && ye.isHTMLForm(n) && (n = new FormData(n)), ye.isFormData(n))
        return a ? JSON.stringify(Mw(n)) : n;
      if (ye.isArrayBuffer(n) || ye.isBuffer(n) || ye.isStream(n) || ye.isFile(n) || ye.isBlob(n) || ye.isReadableStream(n))
        return n;
      if (ye.isArrayBufferView(n))
        return n.buffer;
      if (ye.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const d = Gi(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return i$(n, d).toString();
        if ((l = ye.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const m = Gi(this, "env"), u = m && m.FormData;
          return El(
            l ? { "files[]": n } : n,
            u && new u(),
            d
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), s$(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = Gi(this, "transitional") || Lo.transitional, i = r && r.forcedJSONParsing, a = Gi(this, "responseType"), o = a === "json";
      if (ye.isResponse(n) || ye.isReadableStream(n))
        return n;
      if (n && ye.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, Gi(this, "parseReviver"));
        } catch (d) {
          if (l)
            throw d.name === "SyntaxError" ? ln.from(d, ln.ERR_BAD_RESPONSE, this, null, Gi(this, "response")) : d;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Rt.classes.FormData,
    Blob: Rt.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ye.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (e) => {
  Lo.headers[e] = {};
});
function rc(e, n) {
  const r = this || Lo, i = n || r, a = Ut.from(i.headers);
  let o = i.data;
  return ye.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function Bw(e) {
  return !!(e && e.__CANCEL__);
}
let Vo = class extends ln {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", ln.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function qw(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new ln(
    "Request failed with status code " + r.status,
    r.status >= 400 && r.status < 500 ? ln.ERR_BAD_REQUEST : ln.ERR_BAD_RESPONSE,
    r.config,
    r.request,
    r
  ));
}
function l$(e) {
  const n = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return n && n[1] || "";
}
function c$(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const k = u && m - u;
    return k ? Math.round(h * 1e3 / k) : void 0;
  };
}
function d$(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const Qs = (e, n, r = 3) => {
  let i = 0;
  const a = c$(50, 250);
  return d$((o) => {
    if (!o || typeof o.loaded != "number")
      return;
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = l != null ? Math.min(s, l) : s, m = Math.max(0, d - i), u = a(m);
    i = Math.max(i, d);
    const f = {
      loaded: d,
      total: l,
      progress: l ? d / l : void 0,
      bytes: m,
      rate: u || void 0,
      estimated: u && l ? (l - d) / u : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, cv = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, dv = (e) => (...n) => ye.asap(() => e(...n)), u$ = Rt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Rt.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Rt.origin),
  Rt.navigator && /(msie|trident)/i.test(Rt.navigator.userAgent)
) : () => !0, m$ = Rt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      ye.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), ye.isString(i) && l.push(`path=${i}`), ye.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), ye.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.split(";");
      for (let r = 0; r < n.length; r++) {
        const i = n[r].replace(/^\s+/, ""), a = i.indexOf("=");
        if (a !== -1 && i.slice(0, a) === e)
          return decodeURIComponent(i.slice(a + 1));
      }
      return null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function p$(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function f$(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
const h$ = /^https?:(?!\/\/)/i, y$ = /[\t\n\r]/g;
function g$(e) {
  let n = 0;
  for (; n < e.length && e.charCodeAt(n) <= 32; )
    n++;
  return e.slice(n);
}
function v$(e) {
  return g$(e).replace(y$, "");
}
function uv(e, n) {
  if (typeof e == "string" && h$.test(v$(e)))
    throw new ln(
      'Invalid URL: missing "//" after protocol',
      ln.ERR_INVALID_URL,
      n
    );
}
function Hw(e, n, r, i) {
  uv(n, i);
  let a = !p$(n);
  return e && (a || r === !1) ? (uv(e, i), f$(e, n)) : n;
}
const mv = (e) => e instanceof Ut ? { ...e } : e;
function zi(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(u, f, h, k) {
    return ye.isPlainObject(u) && ye.isPlainObject(f) ? ye.merge.call({ caseless: k }, u, f) : ye.isPlainObject(f) ? ye.merge({}, f) : ye.isArray(f) ? f.slice() : f;
  }
  function a(u, f, h, k) {
    if (ye.isUndefined(f)) {
      if (!ye.isUndefined(u))
        return i(void 0, u, h, k);
    } else return i(u, f, h, k);
  }
  function o(u, f) {
    if (!ye.isUndefined(f))
      return i(void 0, f);
  }
  function s(u, f) {
    if (ye.isUndefined(f)) {
      if (!ye.isUndefined(u))
        return i(void 0, u);
    } else return i(void 0, f);
  }
  function l(u) {
    const f = ye.hasOwnProp(n, "transitional") ? n.transitional : void 0;
    if (!ye.isUndefined(f))
      if (ye.isPlainObject(f)) {
        if (ye.hasOwnProp(f, u))
          return f[u];
      } else
        return;
    const h = ye.hasOwnProp(e, "transitional") ? e.transitional : void 0;
    if (ye.isPlainObject(h) && ye.hasOwnProp(h, u))
      return h[u];
  }
  function d(u, f, h) {
    if (ye.hasOwnProp(n, h))
      return i(u, f);
    if (ye.hasOwnProp(e, h))
      return i(void 0, u);
  }
  const m = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: d,
    headers: (u, f, h) => a(mv(u), mv(f), h, !0)
  };
  return ye.forEach(Object.keys({ ...e, ...n }), function(f) {
    if (f === "__proto__" || f === "constructor" || f === "prototype") return;
    const h = ye.hasOwnProp(m, f) ? m[f] : a, k = ye.hasOwnProp(e, f) ? e[f] : void 0, F = ye.hasOwnProp(n, f) ? n[f] : void 0, j = h(k, F, f);
    ye.isUndefined(j) && h !== d || (r[f] = j);
  }), ye.hasOwnProp(n, "validateStatus") && ye.isUndefined(n.validateStatus) && l("validateStatusUndefinedResolves") === !1 && (ye.hasOwnProp(e, "validateStatus") ? r.validateStatus = i(void 0, e.validateStatus) : delete r.validateStatus), r;
}
const k$ = ["content-type", "content-length"];
function b$(e, n, r) {
  if (r !== "content-only") {
    e.set(n);
    return;
  }
  Object.entries(n).forEach(([i, a]) => {
    k$.includes(i.toLowerCase()) && e.set(i, a);
  });
}
const x$ = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
);
function Ww(e) {
  const n = zi({}, e), r = (h) => ye.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const d = r("auth"), m = r("baseURL"), u = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Ut.from(l), n.url = zw(
    Hw(m, f, u, n),
    r("params"),
    r("paramsSerializer")
  ), d) {
    const h = ye.getSafeProp(d, "username") || "", k = ye.getSafeProp(d, "password") || "";
    l.set(
      "Authorization",
      "Basic " + btoa(h + ":" + (k ? x$(k) : ""))
    );
  }
  if (ye.isFormData(i) && (Rt.hasStandardBrowserEnv || Rt.hasStandardBrowserWebWorkerEnv || ye.isReactNative(i) ? l.setContentType(void 0) : ye.isFunction(i.getHeaders) && b$(l, i.getHeaders(), r("formDataHeaderPolicy"))), Rt.hasStandardBrowserEnv && (ye.isFunction(a) && (a = a(n)), a === !0 || a == null && u$(n.url))) {
    const k = o && s && m$.read(s);
    k && l.set(o, k);
  }
  return n;
}
const _$ = typeof XMLHttpRequest < "u", S$ = _$ && function(e) {
  return new Promise(function(r, i) {
    const a = Ww(e);
    let o = a.data;
    const s = Ut.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, k, F;
    function j() {
      k && k(), F && F(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let N = new XMLHttpRequest();
    N.open(a.method.toUpperCase(), a.url, !0), N.timeout = a.timeout;
    function x() {
      if (!N)
        return;
      const D = Ut.from(
        "getAllResponseHeaders" in N && N.getAllResponseHeaders()
      ), C = {
        data: !l || l === "text" || l === "json" ? N.responseText : N.response,
        status: N.status,
        statusText: N.statusText,
        headers: D,
        config: e,
        request: N
      };
      qw(
        function(A) {
          r(A), j();
        },
        function(A) {
          i(A), j();
        },
        C
      ), N = null;
    }
    "onloadend" in N ? N.onloadend = x : N.onreadystatechange = function() {
      !N || N.readyState !== 4 || N.status === 0 && !(N.responseURL && N.responseURL.startsWith("file:")) || setTimeout(x);
    }, N.onabort = function() {
      N && (i(new ln("Request aborted", ln.ECONNABORTED, e, N)), j(), N = null);
    }, N.onerror = function(I) {
      const C = I && I.message ? I.message : "Network Error", w = new ln(C, ln.ERR_NETWORK, e, N);
      w.event = I || null, i(w), j(), N = null;
    }, N.ontimeout = function() {
      let I = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const C = a.transitional || _y;
      a.timeoutErrorMessage && (I = a.timeoutErrorMessage), i(
        new ln(
          I,
          C.clarifyTimeoutError ? ln.ETIMEDOUT : ln.ECONNABORTED,
          e,
          N
        )
      ), j(), N = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in N && ye.forEach(Pw(s), function(I, C) {
      N.setRequestHeader(C, I);
    }), ye.isUndefined(a.withCredentials) || (N.withCredentials = !!a.withCredentials), l && l !== "json" && (N.responseType = a.responseType), m && ([h, F] = Qs(m, !0), N.addEventListener("progress", h)), d && N.upload && ([f, k] = Qs(d), N.upload.addEventListener("progress", f), N.upload.addEventListener("loadend", k)), (a.cancelToken || a.signal) && (u = (D) => {
      N && (i(!D || D.type ? new Vo(null, e, N) : D), N.abort(), j(), N = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const g = l$(a.url);
    if (g && !Rt.protocols.includes(g)) {
      i(
        new ln(
          "Unsupported protocol " + g + ":",
          ln.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    N.send(o || null);
  });
}, N$ = (e, n) => {
  if (e = e ? e.filter(Boolean) : [], !n && !e.length)
    return;
  const r = new AbortController();
  let i = !1;
  const a = function(d) {
    if (!i) {
      i = !0, s();
      const m = d instanceof Error ? d : this.reason;
      r.abort(
        m instanceof ln ? m : new Vo(m instanceof Error ? m.message : m)
      );
    }
  };
  let o = n && setTimeout(() => {
    o = null, a(new ln(`timeout of ${n}ms exceeded`, ln.ETIMEDOUT));
  }, n);
  const s = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((d) => {
      d.unsubscribe ? d.unsubscribe(a) : d.removeEventListener("abort", a);
    }), e = null);
  };
  e.forEach((d) => d.addEventListener("abort", a));
  const { signal: l } = r;
  return l.unsubscribe = () => ye.asap(s), l;
}, j$ = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, w$ = async function* (e, n) {
  for await (const r of C$(e))
    yield* j$(r, n);
}, C$ = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, pv = (e, n, r, i) => {
  const a = w$(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream(
    {
      async pull(d) {
        try {
          const { done: m, value: u } = await a.next();
          if (m) {
            l(), d.close();
            return;
          }
          let f = u.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          d.enqueue(new Uint8Array(u));
        } catch (m) {
          throw l(m), m;
        }
      },
      cancel(d) {
        return l(d), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, Xs = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, F$ = (e, n, r) => n + 2 < r && Xs(e.charCodeAt(n + 1)) && Xs(e.charCodeAt(n + 2));
function I$(e) {
  if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
  const n = e.indexOf(",");
  if (n < 0) return 0;
  const r = e.slice(5, n), i = e.slice(n + 1);
  if (/;base64/i.test(r)) {
    let s = i.length;
    const l = i.length;
    for (let k = 0; k < l; k++)
      if (i.charCodeAt(k) === 37 && k + 2 < l) {
        const F = i.charCodeAt(k + 1), j = i.charCodeAt(k + 2);
        Xs(F) && Xs(j) && (s -= 2, k += 2);
      }
    let d = 0, m = l - 1;
    const u = (k) => k >= 2 && i.charCodeAt(k - 2) === 37 && // '%'
    i.charCodeAt(k - 1) === 51 && // '3'
    (i.charCodeAt(k) === 68 || i.charCodeAt(k) === 100);
    m >= 0 && (i.charCodeAt(m) === 61 ? (d++, m--) : u(m) && (d++, m -= 3)), d === 1 && m >= 0 && (i.charCodeAt(m) === 61 || u(m)) && d++;
    const h = Math.floor(s / 4) * 3 - (d || 0);
    return h > 0 ? h : 0;
  }
  let o = 0;
  for (let s = 0, l = i.length; s < l; s++) {
    const d = i.charCodeAt(s);
    if (d === 37 && F$(i, s, l))
      o += 1, s += 2;
    else if (d < 128)
      o += 1;
    else if (d < 2048)
      o += 2;
    else if (d >= 55296 && d <= 56319 && s + 1 < l) {
      const m = i.charCodeAt(s + 1);
      m >= 56320 && m <= 57343 ? (o += 4, s++) : o += 3;
    } else
      o += 3;
  }
  return o;
}
const Ny = "1.18.0", fv = 64 * 1024, { isFunction: Zo } = ye, E$ = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
), hv = (e) => {
  if (!ye.isString(e))
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, yv = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, $$ = (e) => {
  const n = e.indexOf("://");
  let r = e;
  return n !== -1 && (r = r.slice(n + 3)), r.includes("@") || r.includes(":");
}, T$ = (e) => {
  const n = ye.global !== void 0 && ye.global !== null ? ye.global : globalThis, { ReadableStream: r, TextEncoder: i } = n;
  e = ye.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: n.Request,
      Response: n.Response
    },
    e
  );
  const { fetch: a, Request: o, Response: s } = e, l = a ? Zo(a) : typeof fetch == "function", d = Zo(o), m = Zo(s);
  if (!l)
    return !1;
  const u = l && Zo(r), f = l && (typeof i == "function" ? /* @__PURE__ */ ((x) => (g) => x.encode(g))(new i()) : async (x) => new Uint8Array(await new o(x).arrayBuffer())), h = d && u && yv(() => {
    let x = !1;
    const g = new o(Rt.origin, {
      body: new r(),
      method: "POST",
      get duplex() {
        return x = !0, "half";
      }
    }), D = g.headers.has("Content-Type");
    return g.body != null && g.body.cancel(), x && !D;
  }), k = m && u && yv(() => ye.isReadableStream(new s("").body)), F = {
    stream: k && ((x) => x.body)
  };
  l && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((x) => {
    !F[x] && (F[x] = (g, D) => {
      let I = g && g[x];
      if (I)
        return I.call(g);
      throw new ln(
        `Response type '${x}' is not supported`,
        ln.ERR_NOT_SUPPORT,
        D
      );
    });
  });
  const j = async (x) => {
    if (x == null)
      return 0;
    if (ye.isBlob(x))
      return x.size;
    if (ye.isSpecCompliantForm(x))
      return (await new o(Rt.origin, {
        method: "POST",
        body: x
      }).arrayBuffer()).byteLength;
    if (ye.isArrayBufferView(x) || ye.isArrayBuffer(x))
      return x.byteLength;
    if (ye.isURLSearchParams(x) && (x = x + ""), ye.isString(x))
      return (await f(x)).byteLength;
  }, N = async (x, g) => {
    const D = ye.toFiniteNumber(x.getContentLength());
    return D ?? j(g);
  };
  return async (x) => {
    let {
      url: g,
      method: D,
      data: I,
      signal: C,
      cancelToken: w,
      timeout: A,
      onDownloadProgress: q,
      onUploadProgress: Y,
      responseType: te,
      headers: K,
      withCredentials: J = "same-origin",
      fetchOptions: R,
      maxContentLength: B,
      maxBodyLength: ne
    } = Ww(x);
    const Ne = ye.isNumber(B) && B > -1, ue = ye.isNumber(ne) && ne > -1, oe = (Fe) => ye.hasOwnProp(x, Fe) ? x[Fe] : void 0;
    let pe = a || fetch;
    te = te ? (te + "").toLowerCase() : "text";
    let z = N$(
      [C, w && w.toAbortSignal()],
      A
    ), ke = null;
    const $e = z && z.unsubscribe && (() => {
      z.unsubscribe();
    });
    let H, Ge = null;
    const sn = () => new ln(
      "Request body larger than maxBodyLength limit",
      ln.ERR_BAD_REQUEST,
      x,
      ke
    );
    try {
      let Fe;
      const Ue = oe("auth");
      if (Ue) {
        const ce = ye.getSafeProp(Ue, "username") || "", Se = ye.getSafeProp(Ue, "password") || "";
        Fe = {
          username: ce,
          password: Se
        };
      }
      if ($$(g)) {
        const ce = new URL(g, Rt.origin);
        if (!Fe && (ce.username || ce.password)) {
          const Se = hv(ce.username), Le = hv(ce.password);
          Fe = {
            username: Se,
            password: Le
          };
        }
        (ce.username || ce.password) && (ce.username = "", ce.password = "", g = ce.href);
      }
      if (Fe && (K.delete("authorization"), K.set(
        "Authorization",
        "Basic " + btoa(E$((Fe.username || "") + ":" + (Fe.password || "")))
      )), Ne && typeof g == "string" && g.startsWith("data:") && I$(g) > B)
        throw new ln(
          "maxContentLength size of " + B + " exceeded",
          ln.ERR_BAD_RESPONSE,
          x,
          ke
        );
      if (ue && D !== "get" && D !== "head") {
        const ce = await j(I);
        if (typeof ce == "number" && isFinite(ce) && (H = ce, ce > ne))
          throw sn();
      }
      const Pe = ue && (ye.isReadableStream(I) || ye.isStream(I)), Be = (ce, Se, Le) => pv(
        ce,
        fv,
        (Re) => {
          if (ue && Re > ne)
            throw Ge = sn();
          Se && Se(Re);
        },
        Le
      );
      if (h && D !== "get" && D !== "head" && (Y || Pe)) {
        if (H = H ?? await N(K, I), H !== 0 || Pe) {
          let ce = new o(g, {
            method: "POST",
            body: I,
            duplex: "half"
          }), Se;
          if (ye.isFormData(I) && (Se = ce.headers.get("content-type")) && K.setContentType(Se), ce.body) {
            const [Le, Re] = Y && cv(
              H,
              Qs(dv(Y))
            ) || [];
            I = Be(ce.body, Le, Re);
          }
        }
      } else if (Pe && !d && u && D !== "get" && D !== "head")
        I = Be(I);
      else if (Pe && d && !h && D !== "get" && D !== "head")
        throw new ln(
          "Stream request bodies are not supported by the current fetch implementation",
          ln.ERR_NOT_SUPPORT,
          x,
          ke
        );
      ye.isString(J) || (J = J ? "include" : "omit");
      const Ae = d && "credentials" in o.prototype;
      if (ye.isFormData(I)) {
        const ce = K.getContentType();
        ce && /^multipart\/form-data/i.test(ce) && !/boundary=/i.test(ce) && K.delete("content-type");
      }
      K.set("User-Agent", "axios/" + Ny, !1);
      const Qe = {
        ...R,
        signal: z,
        method: D.toUpperCase(),
        headers: Pw(K.normalize()),
        body: I,
        duplex: "half",
        credentials: Ae ? J : void 0
      };
      ke = d && new o(g, Qe);
      let Ce = await (d ? pe(ke, R) : pe(g, Qe));
      const Me = Ut.from(Ce.headers);
      if (Ne) {
        const ce = ye.toFiniteNumber(Me.getContentLength());
        if (ce != null && ce > B)
          throw new ln(
            "maxContentLength size of " + B + " exceeded",
            ln.ERR_BAD_RESPONSE,
            x,
            ke
          );
      }
      const nn = k && (te === "stream" || te === "response");
      if (k && Ce.body && (q || Ne || nn && $e)) {
        const ce = {};
        ["status", "statusText", "headers"].forEach((T) => {
          ce[T] = Ce[T];
        });
        const Se = ye.toFiniteNumber(Me.getContentLength()), [Le, Re] = q && cv(
          Se,
          Qs(dv(q), !0)
        ) || [];
        let gn = 0;
        const Q = (T) => {
          if (Ne && (gn = T, gn > B))
            throw new ln(
              "maxContentLength size of " + B + " exceeded",
              ln.ERR_BAD_RESPONSE,
              x,
              ke
            );
          Le && Le(T);
        };
        Ce = new s(
          pv(Ce.body, fv, Q, () => {
            Re && Re(), $e && $e();
          }),
          ce
        );
      }
      te = te || "text";
      let le = await F[ye.findKey(F, te) || "text"](
        Ce,
        x
      );
      if (Ne && !k && !nn) {
        let ce;
        if (le != null && (typeof le.byteLength == "number" ? ce = le.byteLength : typeof le.size == "number" ? ce = le.size : typeof le == "string" && (ce = typeof i == "function" ? new i().encode(le).byteLength : le.length)), typeof ce == "number" && ce > B)
          throw new ln(
            "maxContentLength size of " + B + " exceeded",
            ln.ERR_BAD_RESPONSE,
            x,
            ke
          );
      }
      return !nn && $e && $e(), await new Promise((ce, Se) => {
        qw(ce, Se, {
          data: le,
          headers: Ut.from(Ce.headers),
          status: Ce.status,
          statusText: Ce.statusText,
          config: x,
          request: ke
        });
      });
    } catch (Fe) {
      if ($e && $e(), z && z.aborted && z.reason instanceof ln) {
        const Ue = z.reason;
        throw Ue.config = x, ke && (Ue.request = ke), Fe !== Ue && (Ue.cause = Fe), Ue;
      }
      throw Ge ? (ke && !Ge.request && (Ge.request = ke), Ge) : Fe instanceof ln ? (ke && !Fe.request && (Fe.request = ke), Fe) : Fe && Fe.name === "TypeError" && /Load failed|fetch/i.test(Fe.message) ? Object.assign(
        new ln(
          "Network Error",
          ln.ERR_NETWORK,
          x,
          ke,
          Fe && Fe.response
        ),
        {
          cause: Fe.cause || Fe
        }
      ) : ln.from(Fe, Fe && Fe.code, x, ke, Fe && Fe.response);
    }
  };
}, O$ = /* @__PURE__ */ new Map(), Kw = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, d, m, u = O$;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : T$(n)), u = m;
  return m;
};
Kw();
const jy = {
  http: WE,
  xhr: S$,
  fetch: {
    get: Kw
  }
};
ye.forEach(jy, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: n });
  }
});
const gv = (e) => `- ${e}`, D$ = (e) => ye.isFunction(e) || e === null || e === !1;
function P$(e, n) {
  e = ye.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !D$(i) && (a = jy[(l = String(i)).toLowerCase()], a === void 0))
      throw new ln(`Unknown adapter '${l}'`);
    if (a && (ye.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(gv).join(`
`) : " " + gv(s[0]) : "as no adapter specified";
    throw new ln(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const Gw = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: P$,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: jy
};
function ic(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Vo(null, e);
}
function vv(e) {
  return ic(e), e.headers = Ut.from(e.headers), e.data = rc.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Gw.getAdapter(e.adapter || Lo.adapter, e)(e).then(
    function(i) {
      ic(e), e.response = i;
      try {
        i.data = rc.call(e, e.transformResponse, i);
      } finally {
        delete e.response;
      }
      return i.headers = Ut.from(i.headers), i;
    },
    function(i) {
      if (!Bw(i) && (ic(e), i && i.response)) {
        e.response = i.response;
        try {
          i.response.data = rc.call(
            e,
            e.transformResponse,
            i.response
          );
        } finally {
          delete e.response;
        }
        i.response.headers = Ut.from(i.response.headers);
      }
      return Promise.reject(i);
    }
  );
}
const $l = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  $l[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const kv = {};
$l.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + Ny + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new ln(
        a(s, " has been removed" + (r ? " in " + r : "")),
        ln.ERR_DEPRECATED
      );
    return r && !kv[s] && (kv[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
$l.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function R$(e, n, r) {
  if (typeof e != "object")
    throw new ln("options must be an object", ln.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new ln(
          "option " + o + " must be " + d,
          ln.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new ln("Unknown option " + o, ln.ERR_BAD_OPTION);
  }
}
const Rs = {
  assertOptions: R$,
  validators: $l
}, zt = Rs.validators;
let Oi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new sv(),
      response: new sv()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), d = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(d) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = zi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Rs.assertOptions(
      i,
      {
        silentJSONParsing: zt.transitional(zt.boolean),
        forcedJSONParsing: zt.transitional(zt.boolean),
        clarifyTimeoutError: zt.transitional(zt.boolean),
        legacyInterceptorReqResOrdering: zt.transitional(zt.boolean),
        advertiseZstdAcceptEncoding: zt.transitional(zt.boolean),
        validateStatusUndefinedResolves: zt.transitional(zt.boolean)
      },
      !1
    ), a != null && (ye.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Rs.assertOptions(
      a,
      {
        encode: zt.function,
        serialize: zt.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Rs.assertOptions(
      r,
      {
        baseUrl: zt.spelling("baseURL"),
        withXsrfToken: zt.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ye.merge(o.common, o[r.method]);
    o && ye.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (F) => {
      delete o[F];
    }), r.headers = Ut.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(j) {
      if (typeof j.runWhen == "function" && j.runWhen(r) === !1)
        return;
      d = d && j.synchronous;
      const N = r.transitional || _y;
      N && N.legacyInterceptorReqResOrdering ? l.unshift(j.fulfilled, j.rejected) : l.push(j.fulfilled, j.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(j) {
      m.push(j.fulfilled, j.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const F = [vv.bind(this), void 0];
      for (F.unshift(...l), F.push(...m), h = F.length, u = Promise.resolve(r); f < h; )
        u = u.then(F[f++], F[f++]);
      return u;
    }
    h = l.length;
    let k = r;
    for (; f < h; ) {
      const F = l[f++], j = l[f++];
      try {
        k = F(k);
      } catch (N) {
        j.call(this, N);
        break;
      }
    }
    try {
      u = vv.call(this, k);
    } catch (F) {
      return Promise.reject(F);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = zi(this.defaults, n);
    const r = Hw(n.baseURL, n.url, n.allowAbsoluteUrls, n);
    return zw(r, n.params, n.paramsSerializer);
  }
};
ye.forEach(["delete", "get", "head", "options"], function(n) {
  Oi.prototype[n] = function(r, i) {
    return this.request(
      zi(i || {}, {
        method: n,
        url: r,
        data: i && ye.hasOwnProp(i, "data") ? i.data : void 0
      })
    );
  };
});
ye.forEach(["post", "put", "patch", "query"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        zi(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  Oi.prototype[n] = r(), n !== "query" && (Oi.prototype[n + "Form"] = r(!0));
});
let A$ = class Yw {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new Vo(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new Yw(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function L$(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function V$(e) {
  return ye.isObject(e) && e.isAxiosError === !0;
}
const Fh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Fh).forEach(([e, n]) => {
  Fh[n] = e;
});
function Jw(e) {
  const n = new Oi(e), r = ww(Oi.prototype.request, n);
  return ye.extend(r, Oi.prototype, n, { allOwnKeys: !0 }), ye.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return Jw(zi(e, a));
  }, r;
}
const kt = Jw(Lo);
kt.Axios = Oi;
kt.CanceledError = Vo;
kt.CancelToken = A$;
kt.isCancel = Bw;
kt.VERSION = Ny;
kt.toFormData = El;
kt.AxiosError = ln;
kt.Cancel = kt.CanceledError;
kt.all = function(n) {
  return Promise.all(n);
};
kt.spread = L$;
kt.isAxiosError = V$;
kt.mergeConfig = zi;
kt.AxiosHeaders = Ut;
kt.formToJSON = (e) => Mw(ye.isHTMLForm(e) ? new FormData(e) : e);
kt.getAdapter = Gw.getAdapter;
kt.HttpStatusCode = Fh;
kt.default = kt;
const {
  Axios: M8,
  AxiosError: B8,
  CanceledError: q8,
  isCancel: H8,
  CancelToken: W8,
  VERSION: K8,
  all: G8,
  Cancel: Y8,
  isAxiosError: z$,
  spread: J8,
  toFormData: Q8,
  AxiosHeaders: X8,
  HttpStatusCode: Z8,
  formToJSON: eY,
  getAdapter: nY,
  mergeConfig: tY,
  create: rY
} = kt;
class U$ {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const bv = new U$();
function M$(e, n) {
  return xv(e), xv(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function xv(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const B$ = Object.prototype.toString;
function q$(e, n) {
  return B$.call(e) === `[object ${n}]`;
}
function H$(e) {
  return q$(e, "Object");
}
function W$(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const ko = "8.36.0", ri = globalThis;
function wy(e, n, r) {
  const i = r || ri, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[ko] = a[ko] || {};
  return o[e] || (o[e] = n());
}
const Qw = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, K$ = "Sentry Logger ", _v = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Sv = {};
function Xw(e) {
  if (!("console" in ri))
    return e();
  const n = ri.console, r = {}, i = Object.keys(Sv);
  i.forEach((a) => {
    const o = Sv[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function G$() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Qw ? _v.forEach((r) => {
    n[r] = (...i) => {
      e && Xw(() => {
        ri.console[r](`${K$}[${r}]:`, ...i);
      });
    };
  }) : _v.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const As = wy("logger", G$);
function Y$(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Qw && As.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const Zw = 1e3;
function Cy() {
  return Date.now() / Zw;
}
function J$() {
  const { performance: e } = ri;
  if (!e || !e.now)
    return Cy;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / Zw;
}
const Q$ = J$();
(() => {
  const { performance: e } = ri;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function la() {
  const e = ri, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function Nv() {
  return {
    traceId: la(),
    spanId: la().substring(16)
  };
}
function Fy() {
  return Iy(ri), ri;
}
function Iy(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || ko, n[ko] = n[ko] || {};
}
function X$(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || Q$(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : la()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Ih = "_sentrySpan";
function jv(e, n) {
  n ? Y$(e, Ih, n) : delete e[Ih];
}
function wv(e) {
  return e[Ih];
}
const Z$ = 100;
class Ey {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Nv();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Ey();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, jv(n, wv(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && X$(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof ya ? [r.getScopeData(), r.getRequestSession()] : H$(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, jv(this, void 0), this._attachments = [], this._propagationContext = Nv(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : Z$;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Cy(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: wv(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : la();
    if (!this._client)
      return As.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : la();
    if (!this._client)
      return As.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : la();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (As.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const ya = Ey;
function eT() {
  return wy("defaultCurrentScope", () => new ya());
}
function nT() {
  return wy("defaultIsolationScope", () => new ya());
}
class tT {
  constructor(n, r) {
    let i;
    n ? i = n : i = new ya();
    let a;
    r ? a = r : a = new ya(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return W$(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function ga() {
  const e = Fy(), n = Iy(e);
  return n.stack = n.stack || new tT(eT(), nT());
}
function rT(e) {
  return ga().withScope(e);
}
function iT(e, n) {
  const r = ga();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Cv(e) {
  return ga().withScope(() => e(ga().getIsolationScope()));
}
function aT() {
  return {
    withIsolationScope: Cv,
    withScope: rT,
    withSetScope: iT,
    withSetIsolationScope: (e, n) => Cv(n),
    getCurrentScope: () => ga().getScope(),
    getIsolationScope: () => ga().getIsolationScope()
  };
}
function eC(e) {
  const n = Iy(e);
  return n.acs ? n.acs : aT();
}
function $y() {
  const e = Fy();
  return eC(e).getCurrentScope();
}
function nC() {
  const e = Fy();
  return eC(e).getIsolationScope();
}
function oT() {
  return $y().getClient();
}
function sT(e) {
  if (e)
    return lT(e) ? { captureContext: e } : dT(e) ? {
      captureContext: e
    } : e;
}
function lT(e) {
  return e instanceof ya || typeof e == "function";
}
const cT = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function dT(e) {
  return Object.keys(e).some((n) => cT.includes(n));
}
function Fv(e, n) {
  return $y().captureException(e, sT(n));
}
function uT(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return $y().captureMessage(e, r, i);
}
function mT(e, n) {
  nC().setContext(e, n);
}
const pT = 100;
function Ci(e, n) {
  const r = oT(), i = nC();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = pT } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Cy(), ...e }, d = a ? Xw(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var Oo;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Oo || (Oo = {}));
function ca(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const fT = $o.backendDomain ? {
  "backend-domain": $o.backendDomain
} : void 0;
function Ls() {
  const e = new URLSearchParams({
    noToken: "true",
    ...fT
  }).toString();
  document.location.href = `${$o.url.logIn}?${e}`;
}
const ac = "authData", oc = 30, hT = 600, sc = 5;
class yT {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= sc || this.clientServerTimeDiff <= -sc ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + hT, a = ca(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > sc) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(ac, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(ac), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(ac);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - oc;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = ca(n), i = r.exp - oc;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - oc - this.estimatedServerTime()) * 1e3;
  }
}
const $t = new yT();
async function gT(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? ca(o).exp : "None", l = await Tl.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? ca(m).exp : "None", h = u ? ca(u).exp : "None", k = typeof s == "number" ? d - s : "Unknown", F = typeof f == "number" ? d - f : "Unknown", j = typeof h == "number" ? d - h : "Unknown", N = e.response.headers["x-dixa-rid"];
      mT("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: k,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: F,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: j,
        xDixaRid: N,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    uT("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Oo.Platform,
        domain: n
      }
    });
  }
}
const lc = /* @__PURE__ */ new Map(), vT = 3;
function kT(e) {
  e.interceptors.response.use((n) => (lc.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case Eh.Unauthorized:
          if (!Tl.isRefreshTokenExpired() && n.config) {
            Ci({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = lc.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= vT)
              return lc.set(n.config.url, i + 1), e(n.config);
          }
          gT(n), console.error("401 unauthorized interceptor"), Ls();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const tC = kt.create();
kT(tC);
const Jr = console.log;
async function Iv(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class bT extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function xT(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const _T = 5;
class ST {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      $t.setAuthData(r);
    else {
      const i = $t.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new bT("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = $t.getAccessToken();
    if (!n)
      return {};
    const r = ca(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return $t.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = $t.getAuthData();
    return r ? $t.isAccessTokenExpired() ? (Ci({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && $t.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return $t.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return $t.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return $t.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = $t.getAuthData();
    return n ? $t.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!bv.isElectron())
      return !0;
    const n = await bv.getVersion();
    return M$(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = _T) {
    try {
      return await tC.post(`${$o.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Jr("AUTH", "Network connection offline - waiting..."), Ci({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await Iv(5);
    n && (Jr("AUTH", "Network connection restored"), Ci({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = xT(this.retryCount);
    return Jr("AUTH", `Retrying in ${i} seconds`), await Iv(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if ($t.isRefreshTokenExpired(r))
      return Jr("AUTH", "Refresh token expired"), Ci({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), $t.removeAuthData(), Ls(), null;
    if (z$(n)) {
      if (n.message === "timeout exceeded")
        return Jr("AUTH", "Timeout exceeded"), Ci({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Jr("AUTH", "Network error"), Ci({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Jr("AUTH", "Refresh token invalid (401)"), $t.removeAuthData(), Ls(), null;
      Fv(n, {
        level: "error",
        tags: {
          team: Oo.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Jr("AUTH", "Retries exhausted, logging out"), Fv(n, {
      level: "error",
      tags: {
        team: Oo.Platform,
        errorSource: "authManager.refresh"
      }
    }), $t.removeAuthData(), Ls(), null) : (Jr("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return $t.accessTokenExpiresInMs();
  }
}
const Tl = new ST();
var Eh;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Eh || (Eh = {}));
const NT = new gy((e, n) => new Sw((r) => {
  Tl.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), jT = new gy(
  (e, n) => new Sw((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Tl.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...eI($o.url.partnerIntegrations) && d?.access_token && nI(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), wT = new AbortController(), rC = (e) => new II({
  queryDeduplication: !1,
  cache: new EI(),
  link: gy.from([
    NT,
    jT,
    $I({
      uri: `${e}/graphql`,
      fetch: RI,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: wT.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), CT = ({
  configuration: e,
  children: n
}) => {
  const r = Yn(
    () => rC(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Ke.jsx(TI, { client: r, children: n });
};
function FT() {
  try {
    return OI(), !0;
  } catch {
    return !1;
  }
}
const IT = ({
  configuration: e,
  children: n
}) => FT() ? n : /* @__PURE__ */ Ke.jsx(CT, { configuration: e, children: n }), ET = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Ke.jsx(DI, { children: (o) => /* @__PURE__ */ Ke.jsx(
  tI,
  {
    value: {
      useMutation: oI(e, n),
      useQuery: aI(e, n),
      useLazyQuery: iI(e, n),
      executeQuery: rI(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), iC = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Ke.jsx(IT, { configuration: r, children: s ? /* @__PURE__ */ Ke.jsx(
    ET,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, $T = "_unmatchedHeader_qcj19_1", TT = {
  unmatchedHeader: $T
};
var zo = (e) => e.type === "checkbox", $i = (e) => e instanceof Date, Gt = (e) => e == null;
const aC = (e) => typeof e == "object";
var gt = (e) => !Gt(e) && !Array.isArray(e) && aC(e) && !$i(e), oC = (e) => gt(e) && e.target ? zo(e.target) ? e.target.checked : e.target.value : e, OT = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, sC = (e, n) => e.has(OT(n)), DT = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return gt(n) && n.hasOwnProperty("isPrototypeOf");
}, Ty = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Dt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Ty && (e instanceof Blob || i)) && (r || gt(e)))
    if (n = r ? [] : {}, !r && !DT(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Dt(e[a]));
  else
    return e;
  return n;
}
var Ol = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ft = (e) => e === void 0, rn = (e, n, r) => {
  if (!n || !gt(e))
    return r;
  const i = Ol(n.split(/[,[\].]+?/)).reduce((a, o) => Gt(a) ? a : a[o], e);
  return ft(i) || i === e ? ft(e[n]) ? r : e[n] : i;
}, sr = (e) => typeof e == "boolean", Oy = (e) => /^\w*$/.test(e), lC = (e) => Ol(e.replace(/["|']|\]/g, "").split(/\.|\[/)), it = (e, n, r) => {
  let i = -1;
  const a = Oy(n) ? [n] : lC(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = gt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Zs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, jr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Qr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, cC = qe.createContext(null), Dr = () => qe.useContext(cC), Dy = (e) => {
  const { children: n, ...r } = e;
  return qe.createElement(cC.Provider, { value: r }, n);
};
var dC = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== jr.all && (n._proxyFormState[s] = !i || jr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function PT(e) {
  const n = Dr(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = qe.useState(r._formState), d = qe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = qe.useRef(a);
  return m.current = a, qe.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), qe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), qe.useMemo(() => dC(s, r, d.current, !1), [s, r]);
}
var Mr = (e) => typeof e == "string", uC = (e, n, r, i, a) => Mr(e) ? (i && n.watch.add(e), rn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), rn(r, o))) : (i && (n.watchAll = !0), r);
function pi(e) {
  const n = Dr(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = qe.useRef(i), d = qe.useRef(a);
  l.current = i, qe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(uC(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = qe.useState(r._getWatch(i, a));
  return qe.useEffect(() => r._removeUnmounted()), m;
}
function Py(e) {
  const n = Dr(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = sC(a._names.array, r), l = pi({
    control: a,
    name: r,
    defaultValue: rn(a._formValues, r, rn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = PT({
    control: a,
    name: r,
    exact: !0
  }), m = qe.useRef(e), u = qe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...sr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = qe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!rn(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!rn(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!rn(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!rn(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => rn(d.errors, r)
    }
  }), [d, r]), h = qe.useCallback((N) => u.current.onChange({
    target: {
      value: oC(N),
      name: r
    },
    type: Zs.CHANGE
  }), [r]), k = qe.useCallback(() => u.current.onBlur({
    target: {
      value: rn(a._formValues, r),
      name: r
    },
    type: Zs.BLUR
  }), [r, a._formValues]), F = qe.useCallback((N) => {
    const x = rn(a._fields, r);
    x && N && (x._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (g) => N.setCustomValidity(g),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), j = qe.useMemo(() => ({
    name: r,
    value: l,
    ...sr(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: k,
    ref: F
  }), [r, i, d.disabled, h, k, F, l]);
  return qe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...sr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const x = (g, D) => {
      const I = rn(a._fields, g);
      I && I._f && (I._f.mount = D);
    };
    if (x(r, !0), N) {
      const g = Dt(rn(a._options.defaultValues, r));
      it(a._defaultValues, r, g), ft(rn(a._formValues, r)) && it(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : x(r, !1);
    };
  }, [r, a, s, o]), qe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), qe.useMemo(() => ({
    field: j,
    formState: d,
    fieldState: f
  }), [j, d, f]);
}
const xt = (e) => e.render(Py(e));
var RT = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, bo = (e) => Array.isArray(e) ? e : [e], Ev = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, $h = (e) => Gt(e) || !aC(e);
function di(e, n) {
  if ($h(e) || $h(n))
    return e === n;
  if ($i(e) && $i(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if ($i(o) && $i(s) || gt(o) && gt(s) || Array.isArray(o) && Array.isArray(s) ? !di(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Wt = (e) => gt(e) && !Object.keys(e).length, Ry = (e) => e.type === "file", wr = (e) => typeof e == "function", el = (e) => {
  if (!Ty)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, mC = (e) => e.type === "select-multiple", Ay = (e) => e.type === "radio", AT = (e) => Ay(e) || zo(e), cc = (e) => el(e) && e.isConnected;
function LT(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ft(e) ? i++ : e[n[i++]];
  return e;
}
function VT(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ft(e[n]))
      return !1;
  return !0;
}
function St(e, n) {
  const r = Array.isArray(n) ? n : Oy(n) ? [n] : lC(n), i = r.length === 1 ? e : LT(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (gt(i) && Wt(i) || Array.isArray(i) && VT(i)) && St(e, r.slice(0, -1)), e;
}
var pC = (e) => {
  for (const n in e)
    if (wr(e[n]))
      return !0;
  return !1;
};
function nl(e, n = {}) {
  const r = Array.isArray(e);
  if (gt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || gt(e[i]) && !pC(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, nl(e[i], n[i])) : Gt(e[i]) || (n[i] = !0);
  return n;
}
function fC(e, n, r) {
  const i = Array.isArray(e);
  if (gt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || gt(e[a]) && !pC(e[a]) ? ft(n) || $h(r[a]) ? r[a] = Array.isArray(e[a]) ? nl(e[a], []) : { ...nl(e[a]) } : fC(e[a], Gt(n) ? {} : n[a], r[a]) : r[a] = !di(e[a], n[a]);
  return r;
}
var Aa = (e, n) => fC(e, n, nl(n));
const $v = {
  value: !1,
  isValid: !1
}, Tv = { value: !0, isValid: !0 };
var hC = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ft(e[0].attributes.value) ? ft(e[0].value) || e[0].value === "" ? Tv : { value: e[0].value, isValid: !0 } : Tv
    ) : $v;
  }
  return $v;
}, yC = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ft(e) ? e : n ? e === "" ? NaN : e && +e : r && Mr(e) ? new Date(e) : i ? i(e) : e;
const Ov = {
  isValid: !1,
  value: null
};
var gC = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Ov) : Ov;
function Dv(e) {
  const n = e.ref;
  return Ry(n) ? n.files : Ay(n) ? gC(e.refs).value : mC(n) ? [...n.selectedOptions].map(({ value: r }) => r) : zo(n) ? hC(e.refs).value : yC(ft(n.value) ? e.ref.value : n.value, e);
}
var zT = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = rn(n, o);
    s && it(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, tl = (e) => e instanceof RegExp, La = (e) => ft(e) ? e : tl(e) ? e.source : gt(e) ? tl(e.value) ? e.value.source : e.value : e, Pv = (e) => ({
  isOnSubmit: !e || e === jr.onSubmit,
  isOnBlur: e === jr.onBlur,
  isOnChange: e === jr.onChange,
  isOnAll: e === jr.all,
  isOnTouch: e === jr.onTouched
});
const Rv = "AsyncFunction";
var UT = (e) => !!e && !!e.validate && !!(wr(e.validate) && e.validate.constructor.name === Rv || gt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Rv)), MT = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Av = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const xo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = rn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (xo(l, n))
          break;
      } else if (gt(l) && xo(l, n))
        break;
    }
  }
};
function Lv(e, n, r) {
  const i = rn(e, r);
  if (i || Oy(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = rn(n, o), l = rn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var BT = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Wt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || jr.all));
}, qT = (e, n, r) => !e || !n || e === n || bo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), HT = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, WT = (e, n) => !Ol(rn(e, n)).length && St(e, n), KT = (e, n, r) => {
  const i = bo(rn(e, r));
  return it(i, "root", n[r]), it(e, r, i), e;
}, Vs = (e) => Mr(e);
function Vv(e, n, r = "validate") {
  if (Vs(e) || Array.isArray(e) && e.every(Vs) || sr(e) && !e)
    return {
      type: r,
      message: Vs(e) ? e : "",
      ref: n
    };
}
var Yi = (e) => gt(e) && !tl(e) ? e : {
  value: e,
  message: ""
}, zv = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: k, validate: F, name: j, valueAsNumber: N, mount: x } = e._f, g = rn(r, j);
  if (!x || n.has(j))
    return {};
  const D = l ? l[0] : s, I = (J) => {
    a && D.reportValidity && (D.setCustomValidity(sr(J) ? "" : J || ""), D.reportValidity());
  }, C = {}, w = Ay(s), A = zo(s), q = w || A, Y = (N || Ry(s)) && ft(s.value) && ft(g) || el(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, te = RT.bind(null, j, i, C), K = (J, R, B, ne = Qr.maxLength, Ne = Qr.minLength) => {
    const ue = J ? R : B;
    C[j] = {
      type: J ? ne : Ne,
      message: ue,
      ref: s,
      ...te(J ? ne : Ne, ue)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!q && (Y || Gt(g)) || sr(g) && !g || A && !hC(l).isValid || w && !gC(l).isValid)) {
    const { value: J, message: R } = Vs(d) ? { value: !!d, message: d } : Yi(d);
    if (J && (C[j] = {
      type: Qr.required,
      message: R,
      ref: D,
      ...te(Qr.required, R)
    }, !i))
      return I(R), C;
  }
  if (!Y && (!Gt(f) || !Gt(h))) {
    let J, R;
    const B = Yi(h), ne = Yi(f);
    if (!Gt(g) && !isNaN(g)) {
      const Ne = s.valueAsNumber || g && +g;
      Gt(B.value) || (J = Ne > B.value), Gt(ne.value) || (R = Ne < ne.value);
    } else {
      const Ne = s.valueAsDate || new Date(g), ue = (z) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + z), oe = s.type == "time", pe = s.type == "week";
      Mr(B.value) && g && (J = oe ? ue(g) > ue(B.value) : pe ? g > B.value : Ne > new Date(B.value)), Mr(ne.value) && g && (R = oe ? ue(g) < ue(ne.value) : pe ? g < ne.value : Ne < new Date(ne.value));
    }
    if ((J || R) && (K(!!J, B.message, ne.message, Qr.max, Qr.min), !i))
      return I(C[j].message), C;
  }
  if ((m || u) && !Y && (Mr(g) || o && Array.isArray(g))) {
    const J = Yi(m), R = Yi(u), B = !Gt(J.value) && g.length > +J.value, ne = !Gt(R.value) && g.length < +R.value;
    if ((B || ne) && (K(B, J.message, R.message), !i))
      return I(C[j].message), C;
  }
  if (k && !Y && Mr(g)) {
    const { value: J, message: R } = Yi(k);
    if (tl(J) && !g.match(J) && (C[j] = {
      type: Qr.pattern,
      message: R,
      ref: s,
      ...te(Qr.pattern, R)
    }, !i))
      return I(R), C;
  }
  if (F) {
    if (wr(F)) {
      const J = await F(g, r), R = Vv(J, D);
      if (R && (C[j] = {
        ...R,
        ...te(Qr.validate, R.message)
      }, !i))
        return I(R.message), C;
    } else if (gt(F)) {
      let J = {};
      for (const R in F) {
        if (!Wt(J) && !i)
          break;
        const B = Vv(await F[R](g, r), D, R);
        B && (J = {
          ...B,
          ...te(R, B.message)
        }, I(B.message), i && (C[j] = J));
      }
      if (!Wt(J) && (C[j] = {
        ref: D,
        ...J
      }, !i))
        return C;
    }
  }
  return I(!0), C;
};
const GT = {
  mode: jr.onSubmit,
  reValidateMode: jr.onChange,
  shouldFocusError: !0
};
function YT(e = {}) {
  let n = {
    ...GT,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: wr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = gt(n.defaultValues) || gt(n.values) ? Dt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Dt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Ev(),
    state: Ev()
  }, k = Pv(n.mode), F = Pv(n.reValidateMode), j = n.criteriaMode === jr.all, N = (T) => (U) => {
    clearTimeout(m), m = setTimeout(T, U);
  }, x = async (T) => {
    if (!n.disabled && (u.isValid || f.isValid || T)) {
      const U = n.resolver ? Wt((await Y()).errors) : await K(i, !0);
      U !== r.isValid && h.state.next({
        isValid: U
      });
    }
  }, g = (T, U) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((T || Array.from(l.mount)).forEach((X) => {
      X && (U ? it(r.validatingFields, X, U) : St(r.validatingFields, X));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Wt(r.validatingFields)
    }));
  }, D = (T, U = [], X, ae, V = !0, G = !0) => {
    if (ae && X && !n.disabled) {
      if (s.action = !0, G && Array.isArray(rn(i, T))) {
        const fe = X(rn(i, T), ae.argA, ae.argB);
        V && it(i, T, fe);
      }
      if (G && Array.isArray(rn(r.errors, T))) {
        const fe = X(rn(r.errors, T), ae.argA, ae.argB);
        V && it(r.errors, T, fe), WT(r.errors, T);
      }
      if ((u.touchedFields || f.touchedFields) && G && Array.isArray(rn(r.touchedFields, T))) {
        const fe = X(rn(r.touchedFields, T), ae.argA, ae.argB);
        V && it(r.touchedFields, T, fe);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Aa(a, o)), h.state.next({
        name: T,
        isDirty: R(T, U),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      it(o, T, U);
  }, I = (T, U) => {
    it(r.errors, T, U), h.state.next({
      errors: r.errors
    });
  }, C = (T) => {
    r.errors = T, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, w = (T, U, X, ae) => {
    const V = rn(i, T);
    if (V) {
      const G = rn(o, T, ft(X) ? rn(a, T) : X);
      ft(G) || ae && ae.defaultChecked || U ? it(o, T, U ? G : Dv(V._f)) : Ne(T, G), s.mount && x();
    }
  }, A = (T, U, X, ae, V) => {
    let G = !1, fe = !1;
    const _e = {
      name: T
    };
    if (!n.disabled) {
      if (!X || ae) {
        (u.isDirty || f.isDirty) && (fe = r.isDirty, r.isDirty = _e.isDirty = R(), G = fe !== _e.isDirty);
        const Te = di(rn(a, T), U);
        fe = !!rn(r.dirtyFields, T), Te ? St(r.dirtyFields, T) : it(r.dirtyFields, T, !0), _e.dirtyFields = r.dirtyFields, G = G || (u.dirtyFields || f.dirtyFields) && fe !== !Te;
      }
      if (X) {
        const Te = rn(r.touchedFields, T);
        Te || (it(r.touchedFields, T, X), _e.touchedFields = r.touchedFields, G = G || (u.touchedFields || f.touchedFields) && Te !== X);
      }
      G && V && h.state.next(_e);
    }
    return G ? _e : {};
  }, q = (T, U, X, ae) => {
    const V = rn(r.errors, T), G = (u.isValid || f.isValid) && sr(U) && r.isValid !== U;
    if (n.delayError && X ? (d = N(() => I(T, X)), d(n.delayError)) : (clearTimeout(m), d = null, X ? it(r.errors, T, X) : St(r.errors, T)), (X ? !di(V, X) : V) || !Wt(ae) || G) {
      const fe = {
        ...ae,
        ...G && sr(U) ? { isValid: U } : {},
        errors: r.errors,
        name: T
      };
      r = {
        ...r,
        ...fe
      }, h.state.next(fe);
    }
  }, Y = async (T) => {
    g(T, !0);
    const U = await n.resolver(o, n.context, zT(T || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(T), U;
  }, te = async (T) => {
    const { errors: U } = await Y(T);
    if (T)
      for (const X of T) {
        const ae = rn(U, X);
        ae ? it(r.errors, X, ae) : St(r.errors, X);
      }
    else
      r.errors = U;
    return U;
  }, K = async (T, U, X = {
    valid: !0
  }) => {
    for (const ae in T) {
      const V = T[ae];
      if (V) {
        const { _f: G, ...fe } = V;
        if (G) {
          const _e = l.array.has(G.name), Te = V._f && UT(V._f);
          Te && u.validatingFields && g([ae], !0);
          const tn = await zv(V, l.disabled, o, j, n.shouldUseNativeValidation && !U, _e);
          if (Te && u.validatingFields && g([ae]), tn[G.name] && (X.valid = !1, U))
            break;
          !U && (rn(tn, G.name) ? _e ? KT(r.errors, tn, G.name) : it(r.errors, G.name, tn[G.name]) : St(r.errors, G.name));
        }
        !Wt(fe) && await K(fe, U, X);
      }
    }
    return X.valid;
  }, J = () => {
    for (const T of l.unMount) {
      const U = rn(i, T);
      U && (U._f.refs ? U._f.refs.every((X) => !cc(X)) : !cc(U._f.ref)) && Be(T);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (T, U) => !n.disabled && (T && U && it(o, T, U), !di($e(), a)), B = (T, U, X) => uC(T, l, {
    ...s.mount ? o : ft(U) ? a : Mr(T) ? { [T]: U } : U
  }, X, U), ne = (T) => Ol(rn(s.mount ? o : a, T, n.shouldUnregister ? rn(a, T, []) : [])), Ne = (T, U, X = {}) => {
    const ae = rn(i, T);
    let V = U;
    if (ae) {
      const G = ae._f;
      G && (!G.disabled && it(o, T, yC(U, G)), V = el(G.ref) && Gt(U) ? "" : U, mC(G.ref) ? [...G.ref.options].forEach((fe) => fe.selected = V.includes(fe.value)) : G.refs ? zo(G.ref) ? G.refs.length > 1 ? G.refs.forEach((fe) => (!fe.defaultChecked || !fe.disabled) && (fe.checked = Array.isArray(V) ? !!V.find((_e) => _e === fe.value) : V === fe.value)) : G.refs[0] && (G.refs[0].checked = !!V) : G.refs.forEach((fe) => fe.checked = fe.value === V) : Ry(G.ref) ? G.ref.value = "" : (G.ref.value = V, G.ref.type || h.state.next({
        name: T,
        values: Dt(o)
      })));
    }
    (X.shouldDirty || X.shouldTouch) && A(T, V, X.shouldTouch, X.shouldDirty, !0), X.shouldValidate && ke(T);
  }, ue = (T, U, X) => {
    for (const ae in U) {
      const V = U[ae], G = `${T}.${ae}`, fe = rn(i, G);
      (l.array.has(T) || gt(V) || fe && !fe._f) && !$i(V) ? ue(G, V, X) : Ne(G, V, X);
    }
  }, oe = (T, U, X = {}) => {
    const ae = rn(i, T), V = l.array.has(T), G = Dt(U);
    it(o, T, G), V ? (h.array.next({
      name: T,
      values: Dt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && X.shouldDirty && h.state.next({
      name: T,
      dirtyFields: Aa(a, o),
      isDirty: R(T, G)
    })) : ae && !ae._f && !Gt(G) ? ue(T, G, X) : Ne(T, G, X), Av(T, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? T : void 0,
      values: Dt(o)
    });
  }, pe = async (T) => {
    s.mount = !0;
    const U = T.target;
    let X = U.name, ae = !0;
    const V = rn(i, X), G = (fe) => {
      ae = Number.isNaN(fe) || $i(fe) && isNaN(fe.getTime()) || di(fe, rn(o, X, fe));
    };
    if (V) {
      let fe, _e;
      const Te = U.type ? Dv(V._f) : oC(T), tn = T.type === Zs.BLUR || T.type === Zs.FOCUS_OUT, vn = !MT(V._f) && !n.resolver && !rn(r.errors, X) && !V._f.deps || HT(tn, rn(r.touchedFields, X), r.isSubmitted, F, k), on = Av(X, l, tn);
      it(o, X, Te), tn ? (V._f.onBlur && V._f.onBlur(T), d && d(0)) : V._f.onChange && V._f.onChange(T);
      const pn = A(X, Te, tn), In = !Wt(pn) || on;
      if (!tn && h.state.next({
        name: X,
        type: T.type,
        values: Dt(o)
      }), vn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? tn && x() : tn || x()), In && h.state.next({ name: X, ...on ? {} : pn });
      if (!tn && on && h.state.next({ ...r }), n.resolver) {
        const { errors: _n } = await Y([X]);
        if (G(Te), ae) {
          const En = Lv(r.errors, i, X), en = Lv(_n, i, En.name || X);
          fe = en.error, X = en.name, _e = Wt(_n);
        }
      } else
        g([X], !0), fe = (await zv(V, l.disabled, o, j, n.shouldUseNativeValidation))[X], g([X]), G(Te), ae && (fe ? _e = !1 : (u.isValid || f.isValid) && (_e = await K(i, !0)));
      ae && (V._f.deps && ke(V._f.deps), q(X, _e, fe, pn));
    }
  }, z = (T, U) => {
    if (rn(r.errors, U) && T.focus)
      return T.focus(), 1;
  }, ke = async (T, U = {}) => {
    let X, ae;
    const V = bo(T);
    if (n.resolver) {
      const G = await te(ft(T) ? T : V);
      X = Wt(G), ae = T ? !V.some((fe) => rn(G, fe)) : X;
    } else T ? (ae = (await Promise.all(V.map(async (G) => {
      const fe = rn(i, G);
      return await K(fe && fe._f ? { [G]: fe } : fe);
    }))).every(Boolean), !(!ae && !r.isValid) && x()) : ae = X = await K(i);
    return h.state.next({
      ...!Mr(T) || (u.isValid || f.isValid) && X !== r.isValid ? {} : { name: T },
      ...n.resolver || !T ? { isValid: X } : {},
      errors: r.errors
    }), U.shouldFocus && !ae && xo(i, z, T ? V : l.mount), ae;
  }, $e = (T) => {
    const U = {
      ...s.mount ? o : a
    };
    return ft(T) ? U : Mr(T) ? rn(U, T) : T.map((X) => rn(U, X));
  }, H = (T, U) => ({
    invalid: !!rn((U || r).errors, T),
    isDirty: !!rn((U || r).dirtyFields, T),
    error: rn((U || r).errors, T),
    isValidating: !!rn(r.validatingFields, T),
    isTouched: !!rn((U || r).touchedFields, T)
  }), Ge = (T) => {
    T && bo(T).forEach((U) => St(r.errors, U)), h.state.next({
      errors: T ? r.errors : {}
    });
  }, sn = (T, U, X) => {
    const ae = (rn(i, T, { _f: {} })._f || {}).ref, V = rn(r.errors, T) || {}, { ref: G, message: fe, type: _e, ...Te } = V;
    it(r.errors, T, {
      ...Te,
      ...U,
      ref: ae
    }), h.state.next({
      name: T,
      errors: r.errors,
      isValid: !1
    }), X && X.shouldFocus && ae && ae.focus && ae.focus();
  }, Fe = (T, U) => wr(T) ? h.state.subscribe({
    next: (X) => T(B(void 0, U), X)
  }) : B(T, U, !0), Ue = (T) => h.state.subscribe({
    next: (U) => {
      qT(T.name, U.name, T.exact) && BT(U, T.formState || u, Re, T.reRenderRoot) && T.callback({
        values: { ...o },
        ...r,
        ...U
      });
    }
  }).unsubscribe, Pe = (T) => (s.mount = !0, f = {
    ...f,
    ...T.formState
  }, Ue({
    ...T,
    formState: f
  })), Be = (T, U = {}) => {
    for (const X of T ? bo(T) : l.mount)
      l.mount.delete(X), l.array.delete(X), U.keepValue || (St(i, X), St(o, X)), !U.keepError && St(r.errors, X), !U.keepDirty && St(r.dirtyFields, X), !U.keepTouched && St(r.touchedFields, X), !U.keepIsValidating && St(r.validatingFields, X), !n.shouldUnregister && !U.keepDefaultValue && St(a, X);
    h.state.next({
      values: Dt(o)
    }), h.state.next({
      ...r,
      ...U.keepDirty ? { isDirty: R() } : {}
    }), !U.keepIsValid && x();
  }, Ae = ({ disabled: T, name: U }) => {
    (sr(T) && s.mount || T || l.disabled.has(U)) && (T ? l.disabled.add(U) : l.disabled.delete(U));
  }, Qe = (T, U = {}) => {
    let X = rn(i, T);
    const ae = sr(U.disabled) || sr(n.disabled);
    return it(i, T, {
      ...X || {},
      _f: {
        ...X && X._f ? X._f : { ref: { name: T } },
        name: T,
        mount: !0,
        ...U
      }
    }), l.mount.add(T), X ? Ae({
      disabled: sr(U.disabled) ? U.disabled : n.disabled,
      name: T
    }) : w(T, !0, U.value), {
      ...ae ? { disabled: U.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!U.required,
        min: La(U.min),
        max: La(U.max),
        minLength: La(U.minLength),
        maxLength: La(U.maxLength),
        pattern: La(U.pattern)
      } : {},
      name: T,
      onChange: pe,
      onBlur: pe,
      ref: (V) => {
        if (V) {
          Qe(T, U), X = rn(i, T);
          const G = ft(V.value) && V.querySelectorAll && V.querySelectorAll("input,select,textarea")[0] || V, fe = AT(G), _e = X._f.refs || [];
          if (fe ? _e.find((Te) => Te === G) : G === X._f.ref)
            return;
          it(i, T, {
            _f: {
              ...X._f,
              ...fe ? {
                refs: [
                  ..._e.filter(cc),
                  G,
                  ...Array.isArray(rn(a, T)) ? [{}] : []
                ],
                ref: { type: G.type, name: T }
              } : { ref: G }
            }
          }), w(T, !1, void 0, G);
        } else
          X = rn(i, T, {}), X._f && (X._f.mount = !1), (n.shouldUnregister || U.shouldUnregister) && !(sC(l.array, T) && s.action) && l.unMount.add(T);
      }
    };
  }, Ce = () => n.shouldFocusError && xo(i, z, l.mount), Me = (T) => {
    sr(T) && (h.state.next({ disabled: T }), xo(i, (U, X) => {
      const ae = rn(i, X);
      ae && (U.disabled = ae._f.disabled || T, Array.isArray(ae._f.refs) && ae._f.refs.forEach((V) => {
        V.disabled = ae._f.disabled || T;
      }));
    }, 0, !1));
  }, nn = (T, U) => async (X) => {
    let ae;
    X && (X.preventDefault && X.preventDefault(), X.persist && X.persist());
    let V = Dt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: G, values: fe } = await Y();
      r.errors = G, V = fe;
    } else
      await K(i);
    if (l.disabled.size)
      for (const G of l.disabled)
        it(V, G, void 0);
    if (St(r.errors, "root"), Wt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await T(V, X);
      } catch (G) {
        ae = G;
      }
    } else
      U && await U({ ...r.errors }, X), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Wt(r.errors) && !ae,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), ae)
      throw ae;
  }, le = (T, U = {}) => {
    rn(i, T) && (ft(U.defaultValue) ? oe(T, Dt(rn(a, T))) : (oe(T, U.defaultValue), it(a, T, Dt(U.defaultValue))), U.keepTouched || St(r.touchedFields, T), U.keepDirty || (St(r.dirtyFields, T), r.isDirty = U.defaultValue ? R(T, Dt(rn(a, T))) : R()), U.keepError || (St(r.errors, T), u.isValid && x()), h.state.next({ ...r }));
  }, ce = (T, U = {}) => {
    const X = T ? Dt(T) : a, ae = Dt(X), V = Wt(T), G = V ? a : ae;
    if (U.keepDefaultValues || (a = X), !U.keepValues) {
      if (U.keepDirtyValues) {
        const fe = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Aa(a, o))
        ]);
        for (const _e of Array.from(fe))
          rn(r.dirtyFields, _e) ? it(G, _e, rn(o, _e)) : oe(_e, rn(G, _e));
      } else {
        if (Ty && ft(T))
          for (const fe of l.mount) {
            const _e = rn(i, fe);
            if (_e && _e._f) {
              const Te = Array.isArray(_e._f.refs) ? _e._f.refs[0] : _e._f.ref;
              if (el(Te)) {
                const tn = Te.closest("form");
                if (tn) {
                  tn.reset();
                  break;
                }
              }
            }
          }
        for (const fe of l.mount)
          oe(fe, rn(G, fe));
      }
      o = Dt(G), h.array.next({
        values: { ...G }
      }), h.state.next({
        values: { ...G }
      });
    }
    l = {
      mount: U.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!U.keepIsValid || !!U.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: U.keepSubmitCount ? r.submitCount : 0,
      isDirty: V ? !1 : U.keepDirty ? r.isDirty : !!(U.keepDefaultValues && !di(T, a)),
      isSubmitted: U.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: V ? {} : U.keepDirtyValues ? U.keepDefaultValues && o ? Aa(a, o) : r.dirtyFields : U.keepDefaultValues && T ? Aa(a, T) : U.keepDirty ? r.dirtyFields : {},
      touchedFields: U.keepTouched ? r.touchedFields : {},
      errors: U.keepErrors ? r.errors : {},
      isSubmitSuccessful: U.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Se = (T, U) => ce(wr(T) ? T(o) : T, U), Le = (T, U = {}) => {
    const X = rn(i, T), ae = X && X._f;
    if (ae) {
      const V = ae.refs ? ae.refs[0] : ae.ref;
      V.focus && (V.focus(), U.shouldSelect && wr(V.select) && V.select());
    }
  }, Re = (T) => {
    r = {
      ...r,
      ...T
    };
  }, Q = {
    control: {
      register: Qe,
      unregister: Be,
      getFieldState: H,
      handleSubmit: nn,
      setError: sn,
      _subscribe: Ue,
      _runSchema: Y,
      _getWatch: B,
      _getDirty: R,
      _setValid: x,
      _setFieldArray: D,
      _setDisabledField: Ae,
      _setErrors: C,
      _getFieldArray: ne,
      _reset: ce,
      _resetDefaultValues: () => wr(n.defaultValues) && n.defaultValues().then((T) => {
        Se(T, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: J,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(T) {
        s = T;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(T) {
        l = T;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(T) {
        n = {
          ...n,
          ...T
        };
      }
    },
    subscribe: Pe,
    trigger: ke,
    register: Qe,
    handleSubmit: nn,
    watch: Fe,
    setValue: oe,
    getValues: $e,
    reset: Se,
    resetField: le,
    clearErrors: Ge,
    unregister: Be,
    setError: sn,
    setFocus: Le,
    getFieldState: H
  };
  return {
    ...Q,
    formControl: Q
  };
}
function mt(e = {}) {
  const n = qe.useRef(void 0), r = qe.useRef(void 0), [i, a] = qe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: wr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: wr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : YT(e),
    formState: i
  }, e.formControl && e.defaultValues && !wr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, qe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), qe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), qe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), qe.useEffect(() => {
    e.values && !di(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), qe.useEffect(() => {
    e.errors && !Wt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), qe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), qe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = dC(i, o), n.current;
}
var es = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function vC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var dc = { exports: {} }, Va = {}, Uv;
function JT() {
  if (Uv) return Va;
  Uv = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Va.Fragment = r, Va.jsx = s, Va.jsxs = s, Va;
}
var ns = {}, Mv;
function QT() {
  return Mv || (Mv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    ns.Fragment = i, ns.jsx = Un, ns.jsxs = Kn;
  })()), ns;
}
var Bv;
function XT() {
  return Bv || (Bv = 1, process.env.NODE_ENV === "production" ? dc.exports = JT() : dc.exports = QT()), dc.exports;
}
var Di = XT();
function ZT(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var uc, qv;
function hi() {
  if (qv) return uc;
  qv = 1;
  var e = Array.isArray;
  return uc = e, uc;
}
var mc, Hv;
function kC() {
  if (Hv) return mc;
  Hv = 1;
  var e = typeof es == "object" && es && es.Object === Object && es;
  return mc = e, mc;
}
var pc, Wv;
function Wr() {
  if (Wv) return pc;
  Wv = 1;
  var e = kC(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return pc = r, pc;
}
var fc, Kv;
function Uo() {
  if (Kv) return fc;
  Kv = 1;
  var e = Wr(), n = e.Symbol;
  return fc = n, fc;
}
var hc, Gv;
function eO() {
  if (Gv) return hc;
  Gv = 1;
  var e = Uo(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return hc = o, hc;
}
var yc, Yv;
function nO() {
  if (Yv) return yc;
  Yv = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return yc = r, yc;
}
var gc, Jv;
function Na() {
  if (Jv) return gc;
  Jv = 1;
  var e = Uo(), n = eO(), r = nO(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return gc = s, gc;
}
var vc, Qv;
function Ui() {
  if (Qv) return vc;
  Qv = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return vc = e, vc;
}
var kc, Xv;
function Ly() {
  if (Xv) return kc;
  Xv = 1;
  var e = Na(), n = Ui(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return kc = i, kc;
}
var bc, Zv;
function tO() {
  if (Zv) return bc;
  Zv = 1;
  var e = hi(), n = Ly(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return bc = a, bc;
}
var xc, ek;
function ja() {
  if (ek) return xc;
  ek = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return xc = e, xc;
}
var _c, nk;
function bC() {
  if (nk) return _c;
  nk = 1;
  var e = Na(), n = ja(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return _c = s, _c;
}
var Sc, tk;
function rO() {
  if (tk) return Sc;
  tk = 1;
  var e = Wr(), n = e["__core-js_shared__"];
  return Sc = n, Sc;
}
var Nc, rk;
function iO() {
  if (rk) return Nc;
  rk = 1;
  var e = rO(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Nc = r, Nc;
}
var jc, ik;
function xC() {
  if (ik) return jc;
  ik = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return jc = r, jc;
}
var wc, ak;
function aO() {
  if (ak) return wc;
  ak = 1;
  var e = bC(), n = iO(), r = ja(), i = xC(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var k = e(h) ? u : o;
    return k.test(i(h));
  }
  return wc = f, wc;
}
var Cc, ok;
function oO() {
  if (ok) return Cc;
  ok = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Cc = e, Cc;
}
var Fc, sk;
function Mi() {
  if (sk) return Fc;
  sk = 1;
  var e = aO(), n = oO();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Fc = r, Fc;
}
var Ic, lk;
function Dl() {
  if (lk) return Ic;
  lk = 1;
  var e = Mi(), n = e(Object, "create");
  return Ic = n, Ic;
}
var Ec, ck;
function sO() {
  if (ck) return Ec;
  ck = 1;
  var e = Dl();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Ec = n, Ec;
}
var $c, dk;
function lO() {
  if (dk) return $c;
  dk = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return $c = e, $c;
}
var Tc, uk;
function cO() {
  if (uk) return Tc;
  uk = 1;
  var e = Dl(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Tc = a, Tc;
}
var Oc, mk;
function dO() {
  if (mk) return Oc;
  mk = 1;
  var e = Dl(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Oc = i, Oc;
}
var Dc, pk;
function uO() {
  if (pk) return Dc;
  pk = 1;
  var e = Dl(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Dc = r, Dc;
}
var Pc, fk;
function mO() {
  if (fk) return Pc;
  fk = 1;
  var e = sO(), n = lO(), r = cO(), i = dO(), a = uO();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Pc = o, Pc;
}
var Rc, hk;
function pO() {
  if (hk) return Rc;
  hk = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Rc = e, Rc;
}
var Ac, yk;
function _C() {
  if (yk) return Ac;
  yk = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return Ac = e, Ac;
}
var Lc, gk;
function Pl() {
  if (gk) return Lc;
  gk = 1;
  var e = _C();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return Lc = n, Lc;
}
var Vc, vk;
function fO() {
  if (vk) return Vc;
  vk = 1;
  var e = Pl(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return Vc = i, Vc;
}
var zc, kk;
function hO() {
  if (kk) return zc;
  kk = 1;
  var e = Pl();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return zc = n, zc;
}
var Uc, bk;
function yO() {
  if (bk) return Uc;
  bk = 1;
  var e = Pl();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return Uc = n, Uc;
}
var Mc, xk;
function gO() {
  if (xk) return Mc;
  xk = 1;
  var e = Pl();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Mc = n, Mc;
}
var Bc, _k;
function Rl() {
  if (_k) return Bc;
  _k = 1;
  var e = pO(), n = fO(), r = hO(), i = yO(), a = gO();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Bc = o, Bc;
}
var qc, Sk;
function Vy() {
  if (Sk) return qc;
  Sk = 1;
  var e = Mi(), n = Wr(), r = e(n, "Map");
  return qc = r, qc;
}
var Hc, Nk;
function vO() {
  if (Nk) return Hc;
  Nk = 1;
  var e = mO(), n = Rl(), r = Vy();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return Hc = i, Hc;
}
var Wc, jk;
function kO() {
  if (jk) return Wc;
  jk = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return Wc = e, Wc;
}
var Kc, wk;
function Al() {
  if (wk) return Kc;
  wk = 1;
  var e = kO();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return Kc = n, Kc;
}
var Gc, Ck;
function bO() {
  if (Ck) return Gc;
  Ck = 1;
  var e = Al();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Gc = n, Gc;
}
var Yc, Fk;
function xO() {
  if (Fk) return Yc;
  Fk = 1;
  var e = Al();
  function n(r) {
    return e(this, r).get(r);
  }
  return Yc = n, Yc;
}
var Jc, Ik;
function _O() {
  if (Ik) return Jc;
  Ik = 1;
  var e = Al();
  function n(r) {
    return e(this, r).has(r);
  }
  return Jc = n, Jc;
}
var Qc, Ek;
function SO() {
  if (Ek) return Qc;
  Ek = 1;
  var e = Al();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return Qc = n, Qc;
}
var Xc, $k;
function SC() {
  if ($k) return Xc;
  $k = 1;
  var e = vO(), n = bO(), r = xO(), i = _O(), a = SO();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Xc = o, Xc;
}
var Zc, Tk;
function NO() {
  if (Tk) return Zc;
  Tk = 1;
  var e = SC(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Zc = r, Zc;
}
var ed, Ok;
function jO() {
  if (Ok) return ed;
  Ok = 1;
  var e = NO(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return ed = r, ed;
}
var nd, Dk;
function wO() {
  if (Dk) return nd;
  Dk = 1;
  var e = jO(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return nd = i, nd;
}
var td, Pk;
function NC() {
  if (Pk) return td;
  Pk = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return td = e, td;
}
var rd, Rk;
function CO() {
  if (Rk) return rd;
  Rk = 1;
  var e = Uo(), n = NC(), r = hi(), i = Ly(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return rd = s, rd;
}
var id, Ak;
function FO() {
  if (Ak) return id;
  Ak = 1;
  var e = CO();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return id = n, id;
}
var ad, Lk;
function wa() {
  if (Lk) return ad;
  Lk = 1;
  var e = hi(), n = tO(), r = wO(), i = FO();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return ad = a, ad;
}
var od, Vk;
function Ll() {
  if (Vk) return od;
  Vk = 1;
  var e = Ly();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return od = n, od;
}
var sd, zk;
function jC() {
  if (zk) return sd;
  zk = 1;
  var e = wa(), n = Ll();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return sd = r, sd;
}
var ld, Uk;
function wC() {
  if (Uk) return ld;
  Uk = 1;
  var e = Mi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return ld = n, ld;
}
var cd, Mk;
function CC() {
  if (Mk) return cd;
  Mk = 1;
  var e = wC();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return cd = n, cd;
}
var dd, Bk;
function zy() {
  if (Bk) return dd;
  Bk = 1;
  var e = CC(), n = _C(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return dd = a, dd;
}
var ud, qk;
function Uy() {
  if (qk) return ud;
  qk = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return ud = r, ud;
}
var md, Hk;
function IO() {
  if (Hk) return md;
  Hk = 1;
  var e = zy(), n = wa(), r = Uy(), i = ja(), a = Ll();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, k = s; k != null && ++u < f; ) {
      var F = a(l[u]), j = d;
      if (F === "__proto__" || F === "constructor" || F === "prototype")
        return s;
      if (u != h) {
        var N = k[F];
        j = m ? m(N, F, k) : void 0, j === void 0 && (j = i(N) ? N : r(l[u + 1]) ? [] : {});
      }
      e(k, F, j), k = k[F];
    }
    return s;
  }
  return md = o, md;
}
var pd, Wk;
function EO() {
  if (Wk) return pd;
  Wk = 1;
  var e = jC(), n = IO(), r = wa();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return pd = i, pd;
}
var fd, Kk;
function $O() {
  if (Kk) return fd;
  Kk = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return fd = e, fd;
}
var hd, Gk;
function TO() {
  if (Gk) return hd;
  Gk = 1;
  var e = Na(), n = Ui(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return hd = i, hd;
}
var yd, Yk;
function My() {
  if (Yk) return yd;
  Yk = 1;
  var e = TO(), n = Ui(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return yd = o, yd;
}
var gd, Jk;
function By() {
  if (Jk) return gd;
  Jk = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return gd = n, gd;
}
var vd, Qk;
function OO() {
  if (Qk) return vd;
  Qk = 1;
  var e = wa(), n = My(), r = hi(), i = Uy(), a = By(), o = Ll();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var k = o(d[u]);
      if (!(h = l != null && m(l, k)))
        break;
      l = l[k];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(k, f) && (r(l) || n(l)));
  }
  return vd = s, vd;
}
var kd, Xk;
function DO() {
  if (Xk) return kd;
  Xk = 1;
  var e = $O(), n = OO();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return kd = r, kd;
}
var bd, Zk;
function PO() {
  if (Zk) return bd;
  Zk = 1;
  var e = EO(), n = DO();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return bd = r, bd;
}
var xd, eb;
function qy() {
  if (eb) return xd;
  eb = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return xd = e, xd;
}
var _d, nb;
function RO() {
  if (nb) return _d;
  nb = 1;
  var e = Uo(), n = My(), r = hi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return _d = a, _d;
}
var Sd, tb;
function AO() {
  if (tb) return Sd;
  tb = 1;
  var e = qy(), n = RO();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return Sd = r, Sd;
}
var Nd, rb;
function LO() {
  if (rb) return Nd;
  rb = 1;
  var e = AO();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Nd = n, Nd;
}
var jd, ib;
function VO() {
  if (ib) return jd;
  ib = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return jd = e, jd;
}
var wd, ab;
function zO() {
  if (ab) return wd;
  ab = 1;
  var e = VO(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return wd = r, wd;
}
var Cd, ob;
function UO() {
  if (ob) return Cd;
  ob = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Cd = e, Cd;
}
var Fd, sb;
function FC() {
  if (sb) return Fd;
  sb = 1;
  function e(n) {
    return n;
  }
  return Fd = e, Fd;
}
var Id, lb;
function MO() {
  if (lb) return Id;
  lb = 1;
  var e = UO(), n = wC(), r = FC(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Id = i, Id;
}
var Ed, cb;
function BO() {
  if (cb) return Ed;
  cb = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Ed = i, Ed;
}
var $d, db;
function qO() {
  if (db) return $d;
  db = 1;
  var e = MO(), n = BO(), r = n(e);
  return $d = r, $d;
}
var Td, ub;
function IC() {
  if (ub) return Td;
  ub = 1;
  var e = LO(), n = zO(), r = qO();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Td = i, Td;
}
var Od, mb;
function HO() {
  if (mb) return Od;
  mb = 1;
  var e = PO(), n = IC(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Od = r, Od;
}
var WO = HO();
const EC = /* @__PURE__ */ vC(WO), KO = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function $C(e) {
  const n = EC(e, KO);
  return {
    controller: Py(n),
    controllerProps: n
  };
}
const GO = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function TC(e) {
  const { controller: n, controllerProps: r } = $C(e), i = {
    ...EC(e, GO),
    required: ZT(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Dd, pb;
function YO() {
  if (pb) return Dd;
  pb = 1;
  var e = Rl();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Dd = n, Dd;
}
var Pd, fb;
function JO() {
  if (fb) return Pd;
  fb = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return Pd = e, Pd;
}
var Rd, hb;
function QO() {
  if (hb) return Rd;
  hb = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Rd = e, Rd;
}
var Ad, yb;
function XO() {
  if (yb) return Ad;
  yb = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return Ad = e, Ad;
}
var Ld, gb;
function ZO() {
  if (gb) return Ld;
  gb = 1;
  var e = Rl(), n = Vy(), r = SC(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return Ld = a, Ld;
}
var Vd, vb;
function eD() {
  if (vb) return Vd;
  vb = 1;
  var e = Rl(), n = YO(), r = JO(), i = QO(), a = XO(), o = ZO();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, Vd = s, Vd;
}
var zd, kb;
function nD() {
  if (kb) return zd;
  kb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return zd = e, zd;
}
var Ud, bb;
function Mo() {
  if (bb) return Ud;
  bb = 1;
  var e = zy(), n = CC();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return Ud = r, Ud;
}
var Md, xb;
function tD() {
  if (xb) return Md;
  xb = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Md = e, Md;
}
var zs = { exports: {} }, Bd, _b;
function rD() {
  if (_b) return Bd;
  _b = 1;
  function e() {
    return !1;
  }
  return Bd = e, Bd;
}
zs.exports;
var Sb;
function OC() {
  return Sb || (Sb = 1, (function(e, n) {
    var r = Wr(), i = rD(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(zs, zs.exports)), zs.exports;
}
var qd, Nb;
function iD() {
  if (Nb) return qd;
  Nb = 1;
  var e = Na(), n = By(), r = Ui(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", k = "[object Set]", F = "[object String]", j = "[object WeakMap]", N = "[object ArrayBuffer]", x = "[object DataView]", g = "[object Float32Array]", D = "[object Float64Array]", I = "[object Int8Array]", C = "[object Int16Array]", w = "[object Int32Array]", A = "[object Uint8Array]", q = "[object Uint8ClampedArray]", Y = "[object Uint16Array]", te = "[object Uint32Array]", K = {};
  K[g] = K[D] = K[I] = K[C] = K[w] = K[A] = K[q] = K[Y] = K[te] = !0, K[i] = K[a] = K[N] = K[o] = K[x] = K[s] = K[l] = K[d] = K[m] = K[u] = K[f] = K[h] = K[k] = K[F] = K[j] = !1;
  function J(R) {
    return r(R) && n(R.length) && !!K[e(R)];
  }
  return qd = J, qd;
}
var Hd, jb;
function Hy() {
  if (jb) return Hd;
  jb = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return Hd = e, Hd;
}
var Us = { exports: {} };
Us.exports;
var wb;
function Wy() {
  return wb || (wb = 1, (function(e, n) {
    var r = kC(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(Us, Us.exports)), Us.exports;
}
var Wd, Cb;
function aD() {
  if (Cb) return Wd;
  Cb = 1;
  var e = iD(), n = Hy(), r = Wy(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return Wd = a, Wd;
}
var Kd, Fb;
function DC() {
  if (Fb) return Kd;
  Fb = 1;
  var e = tD(), n = My(), r = hi(), i = OC(), a = Uy(), o = aD(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), k = !f && !h && i(m), F = !f && !h && !k && o(m), j = f || h || k || F, N = j ? e(m.length, String) : [], x = N.length;
    for (var g in m)
      (u || l.call(m, g)) && !(j && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      k && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      F && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, x))) && N.push(g);
    return N;
  }
  return Kd = d, Kd;
}
var Gd, Ib;
function Ky() {
  if (Ib) return Gd;
  Ib = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Gd = n, Gd;
}
var Yd, Eb;
function PC() {
  if (Eb) return Yd;
  Eb = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Yd = e, Yd;
}
var Jd, $b;
function oD() {
  if ($b) return Jd;
  $b = 1;
  var e = PC(), n = e(Object.keys, Object);
  return Jd = n, Jd;
}
var Qd, Tb;
function sD() {
  if (Tb) return Qd;
  Tb = 1;
  var e = Ky(), n = oD(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return Qd = a, Qd;
}
var Xd, Ob;
function RC() {
  if (Ob) return Xd;
  Ob = 1;
  var e = bC(), n = By();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Xd = r, Xd;
}
var Zd, Db;
function Gy() {
  if (Db) return Zd;
  Db = 1;
  var e = DC(), n = sD(), r = RC();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return Zd = i, Zd;
}
var eu, Pb;
function lD() {
  if (Pb) return eu;
  Pb = 1;
  var e = Mo(), n = Gy();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return eu = r, eu;
}
var nu, Rb;
function cD() {
  if (Rb) return nu;
  Rb = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return nu = e, nu;
}
var tu, Ab;
function dD() {
  if (Ab) return tu;
  Ab = 1;
  var e = ja(), n = Ky(), r = cD(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return tu = o, tu;
}
var ru, Lb;
function Yy() {
  if (Lb) return ru;
  Lb = 1;
  var e = DC(), n = dD(), r = RC();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return ru = i, ru;
}
var iu, Vb;
function uD() {
  if (Vb) return iu;
  Vb = 1;
  var e = Mo(), n = Yy();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return iu = r, iu;
}
var Ms = { exports: {} };
Ms.exports;
var zb;
function mD() {
  return zb || (zb = 1, (function(e, n) {
    var r = Wr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(Ms, Ms.exports)), Ms.exports;
}
var au, Ub;
function pD() {
  if (Ub) return au;
  Ub = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return au = e, au;
}
var ou, Mb;
function fD() {
  if (Mb) return ou;
  Mb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return ou = e, ou;
}
var su, Bb;
function AC() {
  if (Bb) return su;
  Bb = 1;
  function e() {
    return [];
  }
  return su = e, su;
}
var lu, qb;
function Jy() {
  if (qb) return lu;
  qb = 1;
  var e = fD(), n = AC(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return lu = o, lu;
}
var cu, Hb;
function hD() {
  if (Hb) return cu;
  Hb = 1;
  var e = Mo(), n = Jy();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return cu = r, cu;
}
var du, Wb;
function Qy() {
  if (Wb) return du;
  Wb = 1;
  var e = PC(), n = e(Object.getPrototypeOf, Object);
  return du = n, du;
}
var uu, Kb;
function LC() {
  if (Kb) return uu;
  Kb = 1;
  var e = qy(), n = Qy(), r = Jy(), i = AC(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return uu = o, uu;
}
var mu, Gb;
function yD() {
  if (Gb) return mu;
  Gb = 1;
  var e = Mo(), n = LC();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return mu = r, mu;
}
var pu, Yb;
function VC() {
  if (Yb) return pu;
  Yb = 1;
  var e = qy(), n = hi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return pu = r, pu;
}
var fu, Jb;
function gD() {
  if (Jb) return fu;
  Jb = 1;
  var e = VC(), n = Jy(), r = Gy();
  function i(a) {
    return e(a, r, n);
  }
  return fu = i, fu;
}
var hu, Qb;
function zC() {
  if (Qb) return hu;
  Qb = 1;
  var e = VC(), n = LC(), r = Yy();
  function i(a) {
    return e(a, r, n);
  }
  return hu = i, hu;
}
var yu, Xb;
function vD() {
  if (Xb) return yu;
  Xb = 1;
  var e = Mi(), n = Wr(), r = e(n, "DataView");
  return yu = r, yu;
}
var gu, Zb;
function kD() {
  if (Zb) return gu;
  Zb = 1;
  var e = Mi(), n = Wr(), r = e(n, "Promise");
  return gu = r, gu;
}
var vu, ex;
function bD() {
  if (ex) return vu;
  ex = 1;
  var e = Mi(), n = Wr(), r = e(n, "Set");
  return vu = r, vu;
}
var ku, nx;
function xD() {
  if (nx) return ku;
  nx = 1;
  var e = Mi(), n = Wr(), r = e(n, "WeakMap");
  return ku = r, ku;
}
var bu, tx;
function Xy() {
  if (tx) return bu;
  tx = 1;
  var e = vD(), n = Vy(), r = kD(), i = bD(), a = xD(), o = Na(), s = xC(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", k = s(e), F = s(n), j = s(r), N = s(i), x = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != m || i && g(new i()) != u || a && g(new a()) != f) && (g = function(D) {
    var I = o(D), C = I == d ? D.constructor : void 0, w = C ? s(C) : "";
    if (w)
      switch (w) {
        case k:
          return h;
        case F:
          return l;
        case j:
          return m;
        case N:
          return u;
        case x:
          return f;
      }
    return I;
  }), bu = g, bu;
}
var xu, rx;
function _D() {
  if (rx) return xu;
  rx = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return xu = r, xu;
}
var _u, ix;
function SD() {
  if (ix) return _u;
  ix = 1;
  var e = Wr(), n = e.Uint8Array;
  return _u = n, _u;
}
var Su, ax;
function Zy() {
  if (ax) return Su;
  ax = 1;
  var e = SD();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Su = n, Su;
}
var Nu, ox;
function ND() {
  if (ox) return Nu;
  ox = 1;
  var e = Zy();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Nu = n, Nu;
}
var ju, sx;
function jD() {
  if (sx) return ju;
  sx = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return ju = n, ju;
}
var wu, lx;
function wD() {
  if (lx) return wu;
  lx = 1;
  var e = Uo(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return wu = i, wu;
}
var Cu, cx;
function CD() {
  if (cx) return Cu;
  cx = 1;
  var e = Zy();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Cu = n, Cu;
}
var Fu, dx;
function FD() {
  if (dx) return Fu;
  dx = 1;
  var e = Zy(), n = ND(), r = jD(), i = wD(), a = CD(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", k = "[object ArrayBuffer]", F = "[object DataView]", j = "[object Float32Array]", N = "[object Float64Array]", x = "[object Int8Array]", g = "[object Int16Array]", D = "[object Int32Array]", I = "[object Uint8Array]", C = "[object Uint8ClampedArray]", w = "[object Uint16Array]", A = "[object Uint32Array]";
  function q(Y, te, K) {
    var J = Y.constructor;
    switch (te) {
      case k:
        return e(Y);
      case o:
      case s:
        return new J(+Y);
      case F:
        return n(Y, K);
      case j:
      case N:
      case x:
      case g:
      case D:
      case I:
      case C:
      case w:
      case A:
        return a(Y, K);
      case l:
        return new J();
      case d:
      case f:
        return new J(Y);
      case m:
        return r(Y);
      case u:
        return new J();
      case h:
        return i(Y);
    }
  }
  return Fu = q, Fu;
}
var Iu, ux;
function ID() {
  if (ux) return Iu;
  ux = 1;
  var e = ja(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Iu = r, Iu;
}
var Eu, mx;
function ED() {
  if (mx) return Eu;
  mx = 1;
  var e = ID(), n = Qy(), r = Ky();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Eu = i, Eu;
}
var $u, px;
function $D() {
  if (px) return $u;
  px = 1;
  var e = Xy(), n = Ui(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return $u = i, $u;
}
var Tu, fx;
function TD() {
  if (fx) return Tu;
  fx = 1;
  var e = $D(), n = Hy(), r = Wy(), i = r && r.isMap, a = i ? n(i) : e;
  return Tu = a, Tu;
}
var Ou, hx;
function OD() {
  if (hx) return Ou;
  hx = 1;
  var e = Xy(), n = Ui(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Ou = i, Ou;
}
var Du, yx;
function DD() {
  if (yx) return Du;
  yx = 1;
  var e = OD(), n = Hy(), r = Wy(), i = r && r.isSet, a = i ? n(i) : e;
  return Du = a, Du;
}
var Pu, gx;
function PD() {
  if (gx) return Pu;
  gx = 1;
  var e = eD(), n = nD(), r = zy(), i = lD(), a = uD(), o = mD(), s = pD(), l = hD(), d = yD(), m = gD(), u = zC(), f = Xy(), h = _D(), k = FD(), F = ED(), j = hi(), N = OC(), x = TD(), g = ja(), D = DD(), I = Gy(), C = Yy(), w = 1, A = 2, q = 4, Y = "[object Arguments]", te = "[object Array]", K = "[object Boolean]", J = "[object Date]", R = "[object Error]", B = "[object Function]", ne = "[object GeneratorFunction]", Ne = "[object Map]", ue = "[object Number]", oe = "[object Object]", pe = "[object RegExp]", z = "[object Set]", ke = "[object String]", $e = "[object Symbol]", H = "[object WeakMap]", Ge = "[object ArrayBuffer]", sn = "[object DataView]", Fe = "[object Float32Array]", Ue = "[object Float64Array]", Pe = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Qe = "[object Uint8Array]", Ce = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", nn = "[object Uint32Array]", le = {};
  le[Y] = le[te] = le[Ge] = le[sn] = le[K] = le[J] = le[Fe] = le[Ue] = le[Pe] = le[Be] = le[Ae] = le[Ne] = le[ue] = le[oe] = le[pe] = le[z] = le[ke] = le[$e] = le[Qe] = le[Ce] = le[Me] = le[nn] = !0, le[R] = le[B] = le[H] = !1;
  function ce(Se, Le, Re, gn, Q, T) {
    var U, X = Le & w, ae = Le & A, V = Le & q;
    if (Re && (U = Q ? Re(Se, gn, Q, T) : Re(Se)), U !== void 0)
      return U;
    if (!g(Se))
      return Se;
    var G = j(Se);
    if (G) {
      if (U = h(Se), !X)
        return s(Se, U);
    } else {
      var fe = f(Se), _e = fe == B || fe == ne;
      if (N(Se))
        return o(Se, X);
      if (fe == oe || fe == Y || _e && !Q) {
        if (U = ae || _e ? {} : F(Se), !X)
          return ae ? d(Se, a(U, Se)) : l(Se, i(U, Se));
      } else {
        if (!le[fe])
          return Q ? Se : {};
        U = k(Se, fe, X);
      }
    }
    T || (T = new e());
    var Te = T.get(Se);
    if (Te)
      return Te;
    T.set(Se, U), D(Se) ? Se.forEach(function(on) {
      U.add(ce(on, Le, Re, on, Se, T));
    }) : x(Se) && Se.forEach(function(on, pn) {
      U.set(pn, ce(on, Le, Re, pn, Se, T));
    });
    var tn = V ? ae ? u : m : ae ? C : I, vn = G ? void 0 : tn(Se);
    return n(vn || Se, function(on, pn) {
      vn && (pn = on, on = Se[pn]), r(U, pn, ce(on, Le, Re, pn, Se, T));
    }), U;
  }
  return Pu = ce, Pu;
}
var Ru, vx;
function RD() {
  if (vx) return Ru;
  vx = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Ru = e, Ru;
}
var Au, kx;
function AD() {
  if (kx) return Au;
  kx = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return Au = e, Au;
}
var Lu, bx;
function LD() {
  if (bx) return Lu;
  bx = 1;
  var e = jC(), n = AD();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return Lu = r, Lu;
}
var Vu, xx;
function VD() {
  if (xx) return Vu;
  xx = 1;
  var e = wa(), n = RD(), r = LD(), i = Ll(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return Vu = s, Vu;
}
var zu, _x;
function zD() {
  if (_x) return zu;
  _x = 1;
  var e = Na(), n = Qy(), r = Ui(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return zu = m, zu;
}
var Uu, Sx;
function UD() {
  if (Sx) return Uu;
  Sx = 1;
  var e = zD();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return Uu = n, Uu;
}
var Mu, Nx;
function MD() {
  if (Nx) return Mu;
  Nx = 1;
  var e = NC(), n = PD(), r = VD(), i = wa(), a = Mo(), o = UD(), s = IC(), l = zC(), d = 1, m = 2, u = 4, f = s(function(h, k) {
    var F = {};
    if (h == null)
      return F;
    var j = !1;
    k = e(k, function(x) {
      return x = i(x, h), j || (j = x.length > 1), x;
    }), a(h, l(h), F), j && (F = n(F, d | m | u, o));
    for (var N = k.length; N--; )
      r(F, k[N]);
    return F;
  });
  return Mu = f, Mu;
}
MD();
const _r = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = TC(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ Di.jsx(He, { ...a, children: /* @__PURE__ */ Di.jsx(
    ni,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: He.getStatus(a.meta),
      children: e
    }
  ) });
};
var BD = FC();
const qD = /* @__PURE__ */ vC(BD), xn = ({
  transformValue: e = qD,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = $C(a);
  return /* @__PURE__ */ Di.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Di.jsx(
      Io,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Di.jsx(bw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, An = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = TC(e);
  return /* @__PURE__ */ Di.jsx(He, { ...i, children: /* @__PURE__ */ Di.jsx(
    dr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: He.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_10dvk_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_10dvk_59{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_10dvk_69{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_10dvk_69:last-child:not(:only-child){border-bottom:none}._collapsible_10dvk_78{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_10dvk_78:hover,._collapsibleIsOpen_10dvk_86{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_10dvk_89{cursor:pointer}._collapsibleIconTrue_10dvk_92{color:var(--dixa-color-green-500)}._collapsibleIconFalse_10dvk_95{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Bu = { exports: {} }, za = {}, jx;
function HD() {
  if (jx) return za;
  jx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return za.Fragment = r, za.jsx = s, za.jsxs = s, za;
}
var ts = {}, wx;
function WD() {
  return wx || (wx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    ts.Fragment = i, ts.jsx = Un, ts.jsxs = Kn;
  })()), ts;
}
var Cx;
function KD() {
  return Cx || (Cx = 1, process.env.NODE_ENV === "production" ? Bu.exports = HD() : Bu.exports = WD()), Bu.exports;
}
var re = KD();
const GD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, YD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, JD = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": GD,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": YD
};
function UC(e) {
  return JD[e] ?? {};
}
const QD = UC(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), XD = UC(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), ZD = "_copyIcon_10dvk_54", eP = "_list_10dvk_59", nP = "_listItem_10dvk_69", tP = "_collapsible_10dvk_78", rP = "_collapsibleIsOpen_10dvk_86", iP = "_collapsibleHeader_10dvk_89", aP = "_collapsibleIconTrue_10dvk_92", oP = "_collapsibleIconFalse_10dvk_95", Mn = {
  copyIcon: ZD,
  list: eP,
  listItem: nP,
  collapsible: tP,
  collapsibleIsOpen: rP,
  collapsibleHeader: iP,
  collapsibleIconTrue: aP,
  collapsibleIconFalse: oP
}, sP = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = me(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ re.jsxs(
    b,
    {
      className: dt(Mn.collapsible, {
        [Mn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ re.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Mn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ re.jsx($.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ re.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ re.jsxs(Xe, { className: Mn.list, children: [
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: Qn(d).format(jt) })
          ] }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: Qn(m).format(jt) })
          ] }) })
        ] })
      ]
    }
  );
}, lP = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ re.jsx(Bn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ re.jsx(
      $.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ re.jsx(sP, { app: r, openByDefault: i === 0 }, i))
  ] });
}, cP = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ re.jsx(re.Fragment, { children: /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ re.jsx(Xe, { className: Mn.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ re.jsx(
      Xe.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ re.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: i }),
          Li(a)
        ] })
      },
      o
    )) })
  ] }) });
}, dP = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ re.jsx(re.Fragment, { children: /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ re.jsx(Xe, { className: Mn.list, children: r.map((a, o) => /* @__PURE__ */ re.jsx(
      Xe.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ re.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ re.jsx(
            Ze,
            {
              content: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ re.jsx(b, { children: `First ${Qn(a?.first).format(
                  jt
                )}` }),
                /* @__PURE__ */ re.jsx(b, { children: `Last ${Qn(a?.last).format(
                  jt
                )}` })
              ] }),
              children: /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, rl = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ re.jsx(Ze, { content: n ? null : l(), children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(ve, { size: 14, name: o(), color: s() }) }) });
}, uP = "_wrapper_1xucg_1", mP = "_externalLink_1xucg_7", qu = {
  wrapper: uP,
  externalLink: mP
}, pP = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Jt(), { isCopied: i, copy: a } = Jt(), { isCopied: o, copy: s } = Jt(), { isCopied: l, copy: d } = Jt(), { isCopied: m, copy: u } = Jt();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: k,
    last_name: F,
    home_city: j,
    country: N,
    email: x,
    phone: g,
    dob: D,
    created_at: I,
    email_subscribe: C,
    push_subscribe: w
  } = e, A = 14, q = `${k || ""} ${F || ""}`.trim() || "A customer has no name", Y = `${j ? `${j} /` : ""} ${N || ""}`.trim(), te = D ? Qn(D).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ re.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ re.jsxs(b, { className: qu.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: qu.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-2", children: q }),
          te && /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    I && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: Qn(I).format(jt) })
    ] }),
    Y && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ve, { size: A, name: "map-pin" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: Y })
      ] }),
      /* @__PURE__ */ re.jsx(Ze, { content: "Copy location", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        ve,
        {
          size: A,
          name: o ? "done" : "copy",
          onClick: () => s(Y),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    x && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ve, { size: A, name: "mail" }),
        /* @__PURE__ */ re.jsx("span", { className: qu.externalLink, children: x })
      ] }),
      /* @__PURE__ */ re.jsx(Ze, { content: "Copy email", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        ve,
        {
          size: A,
          name: n ? "done" : "copy",
          onClick: () => r(x),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    g && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ve, { size: A, name: "phone" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: g })
      ] }),
      /* @__PURE__ */ re.jsx(Ze, { content: "Copy phone number", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        ve,
        {
          size: A,
          name: i ? "done" : "copy",
          onClick: () => a(g),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ve, { size: A, name: "user" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ re.jsxs($.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ re.jsx(Ze, { content: "Copy Braze ID", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        ve,
        {
          size: A,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ve, { size: A, name: "tag" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ re.jsxs($.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ re.jsx(Ze, { content: "Copy External ID", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        ve,
        {
          size: A,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    C && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ve, { size: A, name: "sync" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ re.jsx(rl, { state: C })
    ] }),
    w && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ve, { size: A, name: "bell" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ re.jsx(rl, { isPush: !0, state: w })
    ] })
  ] }) });
}, fP = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = me(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ re.jsxs(
    b,
    {
      className: dt(Mn.collapsible, {
        [Mn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ re.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Mn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ re.jsx($.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ re.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ re.jsxs(Xe, { className: Mn.list, children: [
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ re.jsx(
              ve,
              {
                size: a,
                className: dt({
                  [Mn.collapsibleIconTrue]: d,
                  [Mn.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ re.jsx(Ze, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Ze, { content: "For iOS", children: /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, hP = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ re.jsx(Bn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ re.jsx(
      $.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ re.jsx(fP, { device: r, openByDefault: i === 0 }, i))
  ] });
}, Ua = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, rs = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = Fn(), { useMutation: a } = yn(), [o, s] = me(!1), [l] = a(
    XD,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: Ua[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ re.jsx(Ze, { content: Ua[n].tooltipContent, children: /* @__PURE__ */ re.jsx(
    et,
    {
      variant: "secondary",
      color: Ua[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ re.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(
          rl,
          {
            noTooltip: !0,
            state: Ua[n].parameter
          }
        ),
        Ua[n].label
      ] })
    }
  ) });
}, yP = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ re.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ re.jsx(Xe, { className: Mn.list, children: /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ve, { size: 14, name: "sync" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ re.jsx(rl, { state: a })
    ] }) }) }),
    /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
        /* @__PURE__ */ re.jsx(
          rs,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ re.jsx(
          rs,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ re.jsx(
        rs,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ re.jsx(
        rs,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, gP = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ re.jsx(re.Fragment, { children: /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ re.jsx(Xe, { className: Mn.list, children: r.map((a, o) => /* @__PURE__ */ re.jsx(
      Xe.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ re.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ re.jsx(
            Ze,
            {
              content: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ re.jsx(b, { children: `First ${Qn(a?.first).format(
                  jt
                )}` }),
                /* @__PURE__ */ re.jsx(b, { children: `Last ${Qn(a?.last).format(
                  jt
                )}` })
              ] }),
              children: /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, vP = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = Fn(), { useMutation: i } = yn(), [a, o] = me(), [s, l] = me(!1), [d, m] = me(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, k = n.updateEmailSubscriptionState ?? !1, F = n.displayCustomAttributes ?? !1, j = n.displayCustomEvents ?? !1, N = n.displayPuchases ?? !1, x = n.displayDevices ?? !1, g = n.displayApps ?? !1, D = !h && !k && !F && !j && !N, [I, { error: C }] = i(
    QD,
    {
      onError: () => {
      },
      onCompleted: (A) => {
        const q = A?.Braze?.exportUserDetails?.users?.[0];
        q ? (o(q), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), w = async () => {
    u || f ? await I({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (Je(() => {
    async function A() {
      m(!0), await w();
    }
    A().finally(() => m(!1));
  }, [u, f]), C) {
    const A = C.graphQLErrors;
    return xl({ errors: A }) ? /* @__PURE__ */ re.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : _l({ errors: A }) ? /* @__PURE__ */ re.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ re.jsx(Tn, { error: C });
  }
  return d ? /* @__PURE__ */ re.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ re.jsx(hn, {}) }) : D ? /* @__PURE__ */ re.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ re.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ re.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ re.jsx(pP, { customerDetails: a }),
        k && !!a && /* @__PURE__ */ re.jsx(
          yP,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await w()
          }
        ),
        F && !!a && /* @__PURE__ */ re.jsx(cP, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ re.jsx(dP, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ re.jsx(gP, { customerDetails: a }),
        x && !!a && /* @__PURE__ */ re.jsx(hP, { devices: a?.devices }),
        g && !!a && /* @__PURE__ */ re.jsx(lP, { apps: a?.apps })
      ]
    }
  );
}, il = [
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "brazeApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "updateEmailSubscriptionState",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomAttributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomEvents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    // Yeah, there is a typo 😅 We need to stick with it now, since customers
    // might have used it in the past..
    key: "displayPuchases",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDevices",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayApps",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], kP = {
  enabled: !1,
  name: "",
  brazeApiKey: "",
  ...Sl([], il)
}, bP = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: kP
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: "BRAZE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: il,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: I, renderConditionsForSubmit: C } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (q) => hr(q, {
    fieldDefinitions: il,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), A = s.watch("name");
  return /* @__PURE__ */ re.jsxs(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ re.jsx(yr, { cause: h }),
        /* @__PURE__ */ re.jsxs(nt, { children: [
          /* @__PURE__ */ re.jsx(Z, { children: /* @__PURE__ */ re.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(
            An,
            {
              name: "apiHostName",
              label: "API endpoint",
              control: s.control,
              rules: {
                required: "API endpoint is required",
                validate: (q) => bl(q) || !0
              },
              componentProps: {
                placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(
            Er,
            {
              name: "brazeApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display customer details", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display the button to change the email subscription state", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "updateEmailSubscriptionState",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display a list of custom attributes", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "displayCustomAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display a list of custom events", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "displayCustomEvents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display a list of purchases", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "displayPuchases",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display customer devices", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "displayDevices",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display customer apps", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "displayApps",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ re.jsx(Z, { children: a({
            value: D,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ re.jsx(
          gr,
          {
            integrationType: "BRAZE",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
function xP() {
  var e = $r(!1), n = yt(function() {
    return e.current;
  }, []);
  return Je(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var _P = function(e) {
  e === void 0 && (e = {});
  var n = me(e), r = n[0], i = n[1], a = yt(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, SP = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, Fx = function(e) {
  return xI(SP, e);
}, Hu, Ix;
function NP() {
  return Ix || (Ix = 1, Hu = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), Hu;
}
var Wu, Ex;
function jP() {
  if (Ex) return Wu;
  Ex = 1;
  var e = NP(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, k = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(j) {
        if (j.stopPropagation(), s.format)
          if (j.preventDefault(), typeof j.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var N = n[s.format] || n.default;
            window.clipboardData.setData(N, o);
          } else
            j.clipboardData.clearData(), j.clipboardData.setData(s.format, o);
        s.onCopy && (j.preventDefault(), s.onCopy(j.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var F = document.execCommand("copy");
      if (!F)
        throw new Error("copy command was unsuccessful");
      k = !0;
    } catch (j) {
      l && console.error("unable to copy using execCommand: ", j), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), k = !0;
      } catch (N) {
        l && console.error("unable to copy using clipboardData: ", N), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return k;
  }
  return Wu = a, Wu;
}
var wP = jP();
const CP = /* @__PURE__ */ vy(wP);
var MC = function() {
  var e = xP(), n = _P({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = yt(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = CP(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function FP(e, n) {
  n === void 0 && (n = 0);
  var r = $r(!1), i = $r(), a = $r(e), o = yt(function() {
    return r.current;
  }, []), s = yt(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = yt(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return Je(function() {
    a.current = e;
  }, [e]), Je(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function yi(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = FP(e, n), a = i[0], o = i[1], s = i[2];
  return Je(s, r), [a, o];
}
var IP = function(e) {
  Je(e, []);
}, EP = function(e, n) {
  var r = $r(function() {
  });
  Je(function() {
    r.current = e;
  }), Je(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, $P = function(e) {
  e === void 0 && (e = {});
  var n = me(e), r = n[0], i = n[1], a = Yn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return ec(ec({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = AI(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = ec({ get: yt(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, TP = function(e) {
  var n = $r(e);
  n.current = e, IP(function() {
    return function() {
      return n.current();
    };
  });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ku = { exports: {} }, Ma = {}, $x;
function OP() {
  if ($x) return Ma;
  $x = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ma.Fragment = r, Ma.jsx = s, Ma.jsxs = s, Ma;
}
var is = {}, Tx;
function DP() {
  return Tx || (Tx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    is.Fragment = i, is.jsx = Un, is.jsxs = Kn;
  })()), is;
}
var Ox;
function PP() {
  return Ox || (Ox = 1, process.env.NODE_ENV === "production" ? Ku.exports = OP() : Ku.exports = DP()), Ku.exports;
}
var xe = PP();
const RP = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, AP = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, LP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, VP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, zP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, UP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, MP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, BP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, qP = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": LP,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": VP,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": zP,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": RP,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": AP,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": UP,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": MP,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": BP
};
function Ca(e) {
  return qP[e] ?? {};
}
const HP = Ca(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), WP = Ca(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), KP = Ca(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Dx = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, kr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, GP = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), Px = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, Th = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ xe.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ xe.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function YP({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = me(
    []
  ), [o, s] = me([]), [l, d] = me([]), [m, u] = me([]), [f, h] = me(), { showNotification: k, showModal: F, executeQuery: j } = yn(), { track: N } = Fn(), {
    loading: x,
    data: g,
    error: D,
    store: I
  } = fy(e ?? null), C = g?.github?.issues || [], w = g?.github?.pullRequests || [], [A, q] = me(!1), [Y, te] = me();
  Je(
    () => h(D || Y || void 0),
    [D, Y]
  ), Je(
    () => {
      !x && (C?.length || w?.length) ? (a(C), s(w), J(C, w)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  );
  const K = async (pe, z) => {
    await I(pe).then(() => {
      k({
        icon: "check-circle-filled",
        severity: "success",
        title: z.success.title,
        text: z.success.text
      });
    }).catch((ke) => {
      k({
        title: z.error.title,
        text: `${z.error.text} ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, J = (pe, z) => {
    if (!pe?.length && !z?.length) {
      d([]), u([]);
      return;
    }
    const ke = (pe || []).map(
      (Ge) => j(WP, {
        owner: Ge.owner,
        repositoryName: Ge.repository,
        issueNumber: Ge.number
      })
    ), $e = (z || []).map(
      (Ge) => j(KP, {
        owner: Ge.owner,
        repositoryName: Ge.repository,
        prNumber: Ge.number
      })
    ), H = [...ke, ...$e];
    q(!0), Promise.all(H).then((Ge) => {
      const sn = [], Fe = [];
      Ge.forEach((Ue) => {
        const Pe = Ue?.data?.GitHub;
        if (!Pe) {
          d([]), u([]);
          return;
        }
        Object.keys(Pe).forEach((Be) => {
          if (Be.startsWith("repository")) {
            const Ae = Pe[Be];
            Object.keys(Ae).forEach((Qe) => {
              const Ce = Ae[Qe], Me = {
                number: Ce?.number,
                owner: Ce?.repository?.owner?.login,
                repository: Ce?.repository?.name
              };
              Qe.startsWith("issue") && sn.push({
                ...Ce,
                type: "ISSUE",
                key: Me
              }), Qe.startsWith("pullRequest") && Fe.push({
                ...Ce,
                type: "PR",
                key: Me
              });
            });
          }
        });
      }), d(sn), u(Fe);
    }).catch(te).finally(() => {
      q(!1);
    });
  }, R = ({ key: pe, type: z }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = g && (C.length || w.length) ? g : r, $e = z === "ISSUE" ? "issues" : "pullRequests";
    ke.github[$e] = Array.from(
      new Set(ke.github[$e]).add(pe)
    ), K(ke, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${kr(
          pe
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${kr(pe)} failed. Please try again.`
      }
    });
  }, B = async ({ key: pe, type: z }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = g && (C.length || w.length) ? g : r, $e = z === "ISSUE" ? "issues" : "pullRequests";
    ke.github[$e] = Array.from(
      new Set(ke.github[$e]).add(pe)
    ), await I(ke).catch((H) => {
      k({
        title: "Linking failed",
        text: `Linking ${pe} failed. Please try again. ${H.message && " (" + H.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ne = ({ key: pe, type: z }) => {
    N("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const ke = z === "ISSUE" ? "issue" : "pull request";
    F({
      headline: `Unlink ${ke} ${kr(pe)}?`,
      text: `You are about to unlink the ${ke} ${kr(
        pe
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${ke}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const $e = z === "ISSUE" ? "issues" : "pullRequests";
        if (!g)
          return;
        const H = {
          ...g,
          github: {
            ...g?.github,
            [$e]: g?.github?.[$e].filter(
              (Ge) => Ge.number !== pe.number || Ge.owner !== pe.owner || Ge.repository !== pe.repository
            )
          }
        };
        N("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), K(H, {
          success: {
            title: `GitHub ${ke} unlinked`,
            text: `You unlinked the GitHub ${ke} ${kr(
              pe
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${kr(pe)} failed.`
          }
        });
      },
      onCancel: () => {
        N("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, Ne = () => {
    N("github:unlink:all:clicked", {
      githubOrganization: n
    }), F({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        N("github:unlink:all:confirmed", {
          githubOrganization: n
        }), K(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        N("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ue = C.filter(
    (pe) => !i?.includes(pe)
  ) || [], oe = w.filter(
    (pe) => !o?.includes(pe)
  ) || [];
  return {
    linkGithubItem: R,
    linkGithubItemQuietly: B,
    unlinkGithubItem: ne,
    loadGithubItems: J,
    removeDanglingGithubItemLinks: () => {
      const pe = {
        ...g,
        github: {
          ...g?.github,
          issues: C.filter(
            (z) => !ue.includes(z)
          ) || [],
          pullRequests: w.filter(
            (z) => !oe.includes(z)
          ) || []
        }
      };
      I(pe);
    },
    unlinkAllGithubItems: Ne,
    isLoadingGithubItemLinks: x,
    danglingIssueLinks: ue,
    danglingPullRequestLinks: oe,
    isLoadingGithubItems: A,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const JP = "_contentWrapper_1vx3c_1", QP = "_contentWrapperHeadline_1vx3c_4", XP = "_contentWrapperBody_1vx3c_11", ZP = "_contentWrapperAssigneeIcon_1vx3c_15", eR = "_contentWrapperStatusTag_1vx3c_20", Xr = {
  contentWrapper: JP,
  contentWrapperHeadline: QP,
  contentWrapperBody: XP,
  contentWrapperAssigneeIcon: ZP,
  contentWrapperStatusTag: eR
}, BC = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
  e && /* @__PURE__ */ xe.jsxs(lt, { className: Xr.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(lt, { className: Xr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ xe.jsx(lt, { className: Xr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ xe.jsxs(lt, { className: Xr.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(lt, { className: Xr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ xe.jsx(lt, { className: Xr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ xe.jsxs(lt, { margin: "100 0", children: [
        /* @__PURE__ */ xe.jsx(
          "img",
          {
            className: Xr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ xe.jsx(lt, { className: Xr.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ xe.jsx(
      Jn,
      {
        className: Xr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), nR = "_collapse_1bdjy_1", tR = "_collapseHeader_1bdjy_10", rR = "_collapseHeaderKey_1bdjy_31", iR = "_collapseHeaderKeyIcon_1bdjy_36", aR = "_collapseHeaderKeyLink_1bdjy_41", oR = "_collapseHeaderIcon_1bdjy_44", sR = "_collapseHeaderTitle_1bdjy_49", lR = "_collapseContent_1bdjy_57", cR = "_collapseContentButtonSpacer_1bdjy_60", dR = "_collapseContentButtonLink_1bdjy_63", Pr = {
  collapse: nR,
  collapseHeader: tR,
  collapseHeaderKey: rR,
  collapseHeaderKeyIcon: iR,
  collapseHeaderKeyLink: aR,
  collapseHeaderIcon: oR,
  collapseHeaderTitle: sR,
  collapseContent: lR,
  collapseContentButtonSpacer: cR,
  collapseContentButtonLink: dR
}, uR = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = me(i), { track: s } = Fn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ xe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: k,
      repository: F,
      type: j,
      state: N,
      assignees: x,
      labels: g
    } = d, D = a[m];
    return /* @__PURE__ */ xe.jsxs(
      xr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: D,
        className: Pr.collapse,
        children: [
          /* @__PURE__ */ xe.jsx(xr.Header, { className: Pr.collapseHeader, children: /* @__PURE__ */ xe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ xe.jsx(lt, { children: /* @__PURE__ */ xe.jsxs(lt, { as: "span", className: Pr.collapseHeaderKey, children: [
                  Th(
                    j,
                    N,
                    Pr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ xe.jsxs(
                    "a",
                    {
                      href: Dx(f),
                      className: Pr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (I) => {
                        I.stopPropagation();
                      },
                      children: [
                        kr(f),
                        /* @__PURE__ */ xe.jsx(
                          ve,
                          {
                            className: Pr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ xe.jsx(lt, { className: Pr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ xe.jsx(xr.Content, { className: Pr.collapseContent, children: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ xe.jsx(
              BC,
              {
                description: k,
                assignees: x,
                labels: g
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              et,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Pr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: F?.owner.login,
                    repository: d.repository.name
                  },
                  type: j
                }),
                children: [
                  "Unlink ",
                  Px(j)
                ]
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              Lt,
              {
                slotEnd: /* @__PURE__ */ xe.jsx(ve, { name: "external-link" }),
                variant: "tertiary",
                className: Pr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(Dx(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  Px(j),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ xe.jsx(xe.Fragment, {}) });
}, mR = "_result_1uaom_1", pR = "_resultName_1uaom_21", fR = "_resultItemIcon_1uaom_29", hR = "_resultDescription_1uaom_34", yR = "_resultLinkIcon_1uaom_46", gR = "_tooltip_1uaom_55", vR = "_tooltipName_1uaom_61", kR = "_tooltipTag_1uaom_71", Zr = {
  result: mR,
  resultName: pR,
  resultItemIcon: fR,
  resultDescription: hR,
  resultLinkIcon: yR,
  tooltip: gR,
  tooltipName: vR,
  tooltipTag: kR
}, bR = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = me(!1);
  return /* @__PURE__ */ xe.jsx(
    Ze,
    {
      className: Zr.tooltip,
      content: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ xe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ xe.jsxs(lt, { as: "span", className: Zr.tooltipName, children: [
                Th(a, o, Zr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ xe.jsx(Jn, { className: Zr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ xe.jsx(
          BC,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ xe.jsxs(
        "button",
        {
          className: Zr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ xe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsxs(lt, { as: "span", className: Zr.resultName, children: [
                    Th(a, o, Zr.resultItemIcon),
                    kr(r)
                  ] }) }),
                  /* @__PURE__ */ xe.jsx(lt, { className: Zr.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ xe.jsx(
              ve,
              {
                className: Zr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, xR = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ xe.jsx(
  Lt,
  {
    slotEnd: /* @__PURE__ */ xe.jsx(ve, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), al = "[a-zA-z0-9_.-]+", qC = "[0-9]+", _R = new RegExp(
  `(${al})/(${al})/(?:issues|pull)/(${qC})`,
  "i"
), Rx = new RegExp(`^${_R.source}$`), Ax = new RegExp(
  `https://github.com/(${al})/(${al})/(?:issues|pull)/(${qC})`,
  "i"
), SR = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Yn(() => r?.map((w) => w.id) || [], [r]), o = Yn(() => i?.map((w) => w.id) || [], [i]), [s, l] = me([]), { useLazyQuery: d } = yn(), [m, u] = me(), [f, { loading: h, error: k, data: F, networkStatus: j }] = d(HP, {
    notifyOnNetworkStatusChange: !0
  });
  yi(
    () => {
      !h && m && j === rr.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), Je(() => {
    let w = F?.GitHub?.issues?.nodes || [], A = F?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (w = w.filter((q) => !a.includes(q.id))), o.length > 0 && (A = A.filter(
      (q) => !o.includes(q.id)
    )), l([
      ...w.map((q) => ({
        ...q,
        type: "ISSUE",
        key: {
          number: q.number,
          owner: q.repository.owner.login,
          repository: q.repository.name
        }
      })),
      ...A.map((q) => ({
        ...q,
        type: "PR",
        key: {
          number: q.number,
          owner: q.repository.owner.login,
          repository: q.repository.name
        }
      }))
    ]);
  }, [F, a, o]);
  function N(w) {
    const A = w?.trim();
    if (Rx.test(A)) {
      const [q, Y, te, K] = A.match(Rx) || [];
      return Y !== n ? void 0 : {
        owner: n,
        repository: te,
        number: parseInt(K)
      };
    }
    if (Ax.test(A)) {
      const [q, Y, te, K] = A.match(Ax) || [];
      return Y !== n ? void 0 : {
        owner: n,
        repository: te,
        number: parseInt(K)
      };
    }
  }
  const x = (w) => {
    e({
      key: GP(w),
      type: w.type
    }), u(void 0);
  }, g = (w) => {
    const A = N(w);
    u(
      A ? `org:${A.owner} repo:${A.repository} ${A.number}` : `org:${n} ${w}`
    );
  }, D = () => {
    u(void 0);
  }, I = ({ className: w, searched: A }) => /* @__PURE__ */ xe.jsx(
    xR,
    {
      className: w,
      searched: A,
      githubOrganization: n
    }
  ), C = ({ item: w, onSelect: A }) => /* @__PURE__ */ xe.jsx(bR, { item: w, onSelect: A });
  return !h && k ? /* @__PURE__ */ xe.jsx(Tn, { error: k }) : /* @__PURE__ */ xe.jsx(
    Tr,
    {
      items: s?.map((w) => ({ name: w.title, ...w })),
      loading: h,
      onSearch: g,
      onSelect: x,
      onClear: D,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: I,
      itemComponent: C,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, NR = "_itemButton_3sxfy_1", jR = "_result_3sxfy_6", wR = "_resultName_3sxfy_30", CR = "_resultCheckIcon_3sxfy_38", FR = "_resultAssigneeIcon_3sxfy_41", Ba = {
  itemButton: NR,
  result: jR,
  resultName: wR,
  resultCheckIcon: CR,
  resultAssigneeIcon: FR
}, HC = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ xe.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ xe.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: Ba.itemButton,
        children: /* @__PURE__ */ xe.jsxs(b, { className: Ba.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ xe.jsx(lt, { margin: "100 0", children: /* @__PURE__ */ xe.jsx(
            "img",
            {
              className: Ba.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ xe.jsx(lt, { className: Ba.resultName, children: e.name }),
          n && /* @__PURE__ */ xe.jsx(lt, { className: Ba.resultCheckIcon, children: /* @__PURE__ */ xe.jsx(ve, { name: "done" }) })
        ] })
      }
    )
  }
), IR = Ca(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), ER = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = yn(), [o, s] = me([]), [l, d] = me(""), m = 2, [u, { loading: f, error: h, data: k, networkStatus: F }] = a(
    IR,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return yi(
    () => {
      !f && l && l.length >= m && F === rr.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Je(() => {
    const j = k?.GitHub?.organization?.teams || { edges: [] }, N = [];
    j?.edges?.forEach((x) => {
      const g = x?.node?.members?.edges;
      (g?.length || 0) > 0 && g?.forEach((D) => {
        const I = D?.node;
        I && (I?.id && N.find((C) => C.id === I.id) || N.push(I));
      });
    }), s(
      N.sort((x, g) => {
        const D = x.name?.toLowerCase() || x.login?.toLowerCase(), I = g.name?.toLowerCase() || g.login?.toLowerCase();
        return D.localeCompare(I, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [k]), !f && h ? /* @__PURE__ */ xe.jsx(Tn, { error: h }) : /* @__PURE__ */ xe.jsx(
    Tr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: j, name: N, login: x, avatarUrl: g }) => ({
        id: j,
        name: N || x,
        iconUrl: g
      })) || [],
      loading: f,
      onSearch: (j) => d(j),
      onChange: (j, N) => {
        const x = j.id;
        i ? (N && !n.find(
          (g) => g.id === x
        ) && n.push(j), N || (n = n.filter(
          (g) => g.id !== x
        ))) : n = N ? [j] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: j, onSelect: N, checked: x }) => /* @__PURE__ */ xe.jsx(
        HC,
        {
          item: j,
          checked: x,
          onSelectItem: N
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, $R = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ xe.jsx(dr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ xe.jsx(
        Tr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ xe.jsx(
        Nl,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ xe.jsx(dr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ xe.jsx(
        Tr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ xe.jsx(dr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ xe.jsx(Nh, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ xe.jsx(
        ER,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ xe.jsx(xe.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, TR = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ xe.jsx(xe.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ xe.jsx(
  xt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ xe.jsx(
      He,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: $R({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), OR = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ xe.jsxs($.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ xe.jsxs($.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ xe.jsx(ve, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ xe.jsx(He, { label: "GitHub issue link", children: /* @__PURE__ */ xe.jsx(
          dr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, DR = "_modalBody_1hk1o_1", PR = "_modalBodyFormFields_1hk1o_4", Gu = {
  modalBody: DR,
  modalBodyFormFields: PR
}, RR = Ca(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), AR = Ca(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), LR = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], VR = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = yn(), { track: d } = Fn(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: k
  } = mt(), [F, j] = me(""), [N, x] = me([]), [g, D] = me(), [I, C] = me(!1), [w, A] = me(!1), [q, Y] = MC(), [
    te,
    {
      loading: K,
      error: J,
      networkStatus: R
    }
  ] = s(RR, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: ($e) => {
      x(
        $e.GitHub.search?.edges?.map((H) => H?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), x([]);
    }
  });
  yi(
    () => {
      !K && F && R === rr.ready ? te({
        variables: {
          query: F,
          maxResults: 10
        }
      }) : x([]);
    },
    500,
    [F]
  );
  const [B, { error: ne }] = l(
    AR,
    {
      onError: ($e) => {
        C(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", $e);
      },
      onCompleted: ($e) => {
        C(!1);
        const H = $e.GitHub.createIssue?.issue;
        D(H), o({
          title: "Success",
          text: `GitHub issue '${H.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: H.repository.name,
          number: H.number
        });
      }
    }
  ), Ne = ($e) => {
    j(`org:${a} ${$e}`);
  }, ue = ($e, H) => {
    H($e), j("");
  }, oe = () => {
    j("");
  }, pe = ($e) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), C(!0), B({
      variables: {
        input: {
          repositoryId: $e.repository.id,
          title: $e.title,
          body: $e.body,
          assigneeIds: $e.assignees?.length > 0 ? $e.assignees.map((H) => H.id) : void 0
        }
      }
    });
  };
  Je(() => {
    const $e = w ? window.setTimeout(() => A(!1), 2e3) : void 0;
    return () => window.clearTimeout($e);
  }, [w]);
  const z = () => {
    j(""), x([]), D(void 0), C(!1), A(!1);
  }, ke = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), z(), h(), n();
  };
  return /* @__PURE__ */ xe.jsxs(
    wt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: ke,
      children: [
        /* @__PURE__ */ xe.jsx(
          Ct,
          {
            title: g ? "Issue creation successful" : "Create new GitHub issue",
            onClose: ke
          }
        ),
        /* @__PURE__ */ xe.jsxs(Ft, { className: Gu.modalBody, children: [
          !K && J && /* @__PURE__ */ xe.jsx(Tn, { error: J }),
          !I && ne && /* @__PURE__ */ xe.jsx(Tn, { error: ne }),
          g ? /* @__PURE__ */ xe.jsx(
            OR,
            {
              createdIssue: g,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: w,
              setIssueLinkCopied: A,
              copyToClipboard: Y
            }
          ) : /* @__PURE__ */ xe.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(pe),
              children: /* @__PURE__ */ xe.jsxs(nt, { children: [
                /* @__PURE__ */ xe.jsx(Z, { children: /* @__PURE__ */ xe.jsx(He, { label: "Repository", required: !0, children: /* @__PURE__ */ xe.jsx(
                  xt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: $e, value: H } }) => /* @__PURE__ */ xe.jsx(
                      Tr,
                      {
                        className: Gu.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: K,
                        onSearch: Ne,
                        onSelect: (Ge) => ue(Ge, $e),
                        onClear: oe,
                        selectedItems: [H],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: J ? "No repositories found" : "No repositories available",
                        items: N || [],
                        itemComponent: ({ item: Ge, onSelect: sn, checked: Fe }) => /* @__PURE__ */ xe.jsx(
                          HC,
                          {
                            item: Ge,
                            checked: Fe,
                            onSelectItem: sn
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ xe.jsx(Z, { className: Gu.modalBodyFormFields, children: /* @__PURE__ */ xe.jsx(
                  TR,
                  {
                    control: m,
                    errors: f,
                    getValues: k,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: LR
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ xe.jsx(
          Et,
          {
            confirmOnClick: g ? ke : u(pe),
            confirmProps: {
              isLoading: I,
              loadingIndicator: /* @__PURE__ */ xe.jsx(hn, { size: 16 })
            },
            confirmName: g ? "Close" : "Save",
            cancelOnClick: g ? void 0 : ke
          }
        )
      ]
    }
  );
}, zR = "_wrapper_19v8w_1", UR = "_inputWrapper_19v8w_6", MR = "_buttonLink_19v8w_19", BR = "_noItemsFound_19v8w_23", qR = "_createIssueButton_19v8w_28", Ji = {
  wrapper: zR,
  inputWrapper: UR,
  buttonLink: MR,
  noItemsFound: BR,
  createIssueButton: qR
}, HR = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me(!1), { track: a } = Fn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: k,
    danglingIssueLinks: F,
    danglingPullRequestLinks: j,
    isLoadingGithubItems: N,
    issues: x,
    pullRequests: g,
    error: D
  } = YP({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), I = (Y) => d({ key: Y, type: "ISSUE" }), C = !(!!x?.length).valueOf() && !(!!g?.length).valueOf() && !(!!F?.length).valueOf() && !(!!j?.length).valueOf(), w = !k && !N && !!F?.length && !!j?.length && !!n?.showDanglingLinks, A = n?.enableCreateIssue, q = !!x?.length || !!g?.length;
  return !N && D ? /* @__PURE__ */ xe.jsx(Tn, { error: D, retry: () => u() }) : /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
    /* @__PURE__ */ xe.jsxs(b, { className: Ji.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ xe.jsxs(b, { className: Ji.inputWrapper, flexDirection: "column", children: [
        A && /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
          /* @__PURE__ */ xe.jsx(
            et,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Ji.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ xe.jsx("div", { className: Ji.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ xe.jsx(
          SR,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: x,
            linkedPullRequests: g
          }
        )
      ] }),
      N ? /* @__PURE__ */ xe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ xe.jsx(hn, { "data-testid": "github-widget-item-spinner" }) }) : q ? /* @__PURE__ */ xe.jsx(
        uR,
        {
          items: [...x, ...g],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ xe.jsx($.Paragraph, { align: "center", className: Ji.noItemsFound, children: "No linked items found." }),
      w && /* @__PURE__ */ xe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ xe.jsx($.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ xe.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              F.map((Y) => /* @__PURE__ */ xe.jsx(
                Jn,
                {
                  onDelete: () => m({
                    key: Y,
                    type: "ISSUE"
                  }),
                  children: kr(Y)
                },
                kr(Y)
              )),
              j.map((Y) => /* @__PURE__ */ xe.jsx(
                Jn,
                {
                  onDelete: () => m({ key: Y, type: "PR" }),
                  children: kr(Y)
                },
                kr(Y)
              ))
            ] }),
            /* @__PURE__ */ xe.jsx(
              et,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && q && /* @__PURE__ */ xe.jsx(
        et,
        {
          variant: "secondary",
          disabled: C,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ xe.jsx(
        Lt,
        {
          slotEnd: /* @__PURE__ */ xe.jsx(ve, { name: "external-link" }),
          variant: "tertiary",
          className: Ji.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ xe.jsx(
      VR,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: I,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, Oh = [
  {
    key: "githubOrganization",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], bi = "GITHUB", WR = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, KR = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: WR
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: F
  } = ur({
    integrationId: e,
    integrationType: bi,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: D
  } = mr({
    integrationId: e,
    fieldDefinitions: Oh,
    form: l,
    onMisconfigured: F
  }), { renderConditions: I, setRenderConditions: C, renderConditionsForSubmit: w } = pr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), A = (Y) => hr(Y, {
    fieldDefinitions: Oh,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: w
  }), q = l.watch("name");
  return /* @__PURE__ */ xe.jsxs(
    fr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        k && /* @__PURE__ */ xe.jsx(yr, { cause: k }),
        /* @__PURE__ */ xe.jsxs(nt, { children: [
          /* @__PURE__ */ xe.jsx(Z, { children: /* @__PURE__ */ xe.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ xe.jsx(
            xn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(
            An,
            {
              name: "githubOrganization",
              label: "GitHub organization or user",
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(He, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ xe.jsx(
            xn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(He, { label: "Show unresolved links to GitHub items", children: /* @__PURE__ */ xe.jsx(
            xn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(He, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ xe.jsx(
            xn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ xe.jsx(
            fi,
            {
              configuration: n,
              integrationId: e,
              integrationType: bi,
              label: "Authorize with OAuth"
            }
          ),
          o && I !== null && /* @__PURE__ */ xe.jsx(Z, { children: o({
            value: I,
            onChange: C,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ xe.jsx(
          gr,
          {
            integrationType: bi,
            integrationId: e,
            widgetName: q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ xe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ xe.jsx(
                ve,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ xe.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  bi,
                  " integration, all links between Dixa and ",
                  bi,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ xe.jsxs($.Paragraph, { children: [
                  "All data in ",
                  bi,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ xe.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  bi,
                  " ",
                  'integration "',
                  q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Yu = { exports: {} }, qa = {}, Lx;
function GR() {
  if (Lx) return qa;
  Lx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return qa.Fragment = r, qa.jsx = s, qa.jsxs = s, qa;
}
var as = {}, Vx;
function YR() {
  return Vx || (Vx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    as.Fragment = i, as.jsx = Un, as.jsxs = Kn;
  })()), as;
}
var zx;
function JR() {
  return zx || (zx = 1, process.env.NODE_ENV === "production" ? Yu.exports = GR() : Yu.exports = YR()), Yu.exports;
}
var we = JR(), go = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(go || {}), Fi = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(Fi || {}), Xt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Xt || {});
const QR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, XR = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": QR
};
function ZR(e) {
  return XR[e] ?? {};
}
const eA = ZR(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Ux = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, WC = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, nA = "_listItem_16pij_4", tA = "_clickableIcon_16pij_15", Do = {
  listItem: nA,
  clickableIcon: tA
}, KC = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = me(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ we.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ we.jsx(ve, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ we.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: Do.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ we.jsx(
              ve,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ we.jsx(Xe, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: k } = l, F = l.currency ?? r;
      return /* @__PURE__ */ we.jsx(
        Xe.Item,
        {
          contentLeft: /* @__PURE__ */ we.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { children: u }),
            /* @__PURE__ */ we.jsx($.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ we.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: WC(f / 100, F) })
          ] }),
          contentRight: h && /* @__PURE__ */ we.jsx(xa, { src: h, alt: m ?? "Product image" }),
          className: Do.listItem
        },
        `item-${d}-${k}`
      );
    }) })
  ] }) });
}, rA = "_boxWrapper_89s7l_1", iA = "_trackButton_89s7l_10", Mx = {
  boxWrapper: rA,
  trackButton: iA
}, aA = {
  [Xt.StepUnknown]: "Unknown",
  [Xt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Xt.StepPreparedByMerchant]: "Prepared by merchant",
  [Xt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Xt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Xt.StepOnRoute]: "On route",
  [Xt.StepDeliveredToPickupPoint]: "At pickup point",
  [Xt.StepDeliveredToConsumer]: "Delivered to customer",
  [Xt.StepDeliveredToMerchant]: "Returned to merchant",
  [Xt.StepReturnRequested]: "Return requested",
  [Xt.StepSentBack]: "Sent back",
  [Xt.StepTerminated]: "Terminated",
  [Xt.StepAwaitingSupplier]: "Awaiting supplier"
}, oA = {
  [Fi.Delivery]: "Home delivery",
  [Fi.Pickup]: "Pickup point",
  [Fi.Instore]: "In-store pickup",
  [Fi.Mailbox]: "Mailbox",
  [Fi.Inwarehouse]: "Warehouse",
  [Fi.Unknown]: "Unknown"
}, sA = {
  [go.Outbound]: "From merchant to customer",
  [go.Return]: "Return from customer to merchant",
  [go.Unspecified]: "Unspecified",
  [go.UnknownDirectionType]: "Unknown"
}, lA = (e) => e ? aA[e] ?? e : "", cA = (e) => e ? oA[e] ?? e : "", dA = (e) => e ? sA[e] ?? e : "", uA = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, mA = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = Jt();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, k = m || l || i, F = a?.filter((I) => I?.time !== ""), j = lA(F?.[0]?.step), N = cA(u), x = dA(f), g = uA(e.location?.address), D = 14;
  return /* @__PURE__ */ we.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Mx.boxWrapper,
      children: [
        /* @__PURE__ */ we.jsx($.Heading, { variant: "heading-4", children: k }),
        /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(
              ve,
              {
                size: D,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Ze, { content: "Copy tracking ID", children: /* @__PURE__ */ we.jsx(
            ve,
            {
              size: D,
              name: n ? "done" : "copy",
              className: Do.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        j && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        x && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: x })
          ] })
        ] }),
        h && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ we.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
              Ux(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: Ux(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "info", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        g && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: g })
          ] })
        ] }),
        /* @__PURE__ */ we.jsx(KC, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ we.jsxs(
          Lt,
          {
            variant: "secondary",
            className: Mx.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ we.jsx(ve, { name: "external-link" }),
            children: [
              "Track on ",
              k ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, pA = "_order_135ze_1", fA = "_orderIsOpen_135ze_9", hA = "_orderHeader_135ze_12", Ju = {
  order: pA,
  orderIsOpen: fA,
  orderHeader: hA
}, Bx = "No order number found", yA = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = me(n), { isCopied: a, copy: o } = Jt(), { isCopied: s, copy: l } = Jt();
  if (!e)
    return null;
  const { cart: d, parcels: m, sender_name: u, tos_id: f } = e, h = e.external_id?.trim(), k = d?.currency || "", F = d?.prices?.total?.price ?? 0, j = WC(F / 100, k), N = 14, x = u && u.trim() !== "" ? u : "unknown sender";
  return /* @__PURE__ */ we.jsxs(
    b,
    {
      className: dt(Ju.order, {
        [Ju.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ we.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ju.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsxs($.Paragraph, { variant: "4", children: [
                  "From ",
                  x
                ] }),
                h ? /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: /* @__PURE__ */ we.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: Bx })
              ] }),
              /* @__PURE__ */ we.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ we.jsx(ve, { size: N, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ we.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: Bx }) })
              ] })
            ] }),
            h && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Ze, { content: "Copy order number", children: /* @__PURE__ */ we.jsx(
              ve,
              {
                size: N,
                name: s ? "done" : "copy",
                className: Do.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ we.jsx(
                ve,
                {
                  size: N,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Ze, { content: "Copy tracking ID", children: /* @__PURE__ */ we.jsx(
              ve,
              {
                size: N,
                name: a ? "done" : "copy",
                className: Do.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          u && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(ve, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", children: u })
            ] })
          ] }),
          /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(ve, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", children: j })
            ] })
          ] }),
          /* @__PURE__ */ we.jsx(
            KC,
            {
              openByDefault: !0,
              title: "Order items",
              items: d?.items?.map((g) => g),
              currency: d?.currency
            }
          ),
          m && /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ we.jsx($.Heading, { variant: "heading-4", children: "Parcels" }),
              m.length > 0 && /* @__PURE__ */ we.jsx(Bn, { variant: "success", size: "small", children: m.length })
            ] }),
            m.length === 0 && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            m.map((g, D) => /* @__PURE__ */ we.jsx(
              mA,
              {
                parcel: g
              },
              `parcel-${D}-${g?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, gA = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, qx = (e) => {
  let n = 1 / 0;
  for (const r of e?.parcels ?? [])
    for (const i of r?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, vA = (e) => [...e].sort(
  (n, r) => qx(r) - qx(n)
), kA = ({
  customerEmail: e
}) => {
  const { useQuery: n } = yn(), [r, i] = me([]), a = !e, { data: o, loading: s, error: l } = n(eA, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? sI({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? pw({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return Je(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      vA(
        gA(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ we.jsx(hn, {}) }) : m || !d && !l ? /* @__PURE__ */ we.jsx($.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ we.jsx($.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ we.jsx(Tn, { error: l }) : /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx($.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ we.jsx(Bn, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ we.jsx(
      yA,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, bA = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ we.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ we.jsx(kA, { customerEmail: n })
    }
  );
}, Dh = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], xA = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, _A = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: xA
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: Dh,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: I, renderConditionsForSubmit: C } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (q) => hr(q, {
    fieldDefinitions: Dh,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), A = s.watch("name");
  return /* @__PURE__ */ we.jsxs(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ we.jsx(yr, { cause: h }),
        /* @__PURE__ */ we.jsxs(nt, { children: [
          /* @__PURE__ */ we.jsx(Z, { children: /* @__PURE__ */ we.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ we.jsx(
            xn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3, children: /* @__PURE__ */ we.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3 }),
          /* @__PURE__ */ we.jsx(Z, { span: 3, children: /* @__PURE__ */ we.jsx(He, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ we.jsx(
            xn,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3 }),
          /* @__PURE__ */ we.jsx(Z, { span: 3, children: /* @__PURE__ */ we.jsx(
            An,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3 }),
          /* @__PURE__ */ we.jsx(Z, { span: 3, children: /* @__PURE__ */ we.jsx(
            Er,
            {
              name: "ingridApiToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ we.jsx(Z, { children: a({
            value: D,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ we.jsx(
          gr,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_1wiub_54{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1wiub_54:hover,._result_1wiub_54:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1wiub_74{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_1wiub_82{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_1wiub_87{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1wiub_99{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1wiub_108{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_1wiub_114{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_1wiub_121{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1wiub_126{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_1wiub_131{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_1wiub_139{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_1wiub_143{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Qu = { exports: {} }, Ha = {}, Hx;
function SA() {
  if (Hx) return Ha;
  Hx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ha.Fragment = r, Ha.jsx = s, Ha.jsxs = s, Ha;
}
var os = {}, Wx;
function NA() {
  return Wx || (Wx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    os.Fragment = i, os.jsx = Un, os.jsxs = Kn;
  })()), os;
}
var Kx;
function jA() {
  return Kx || (Kx = 1, process.env.NODE_ENV === "production" ? Qu.exports = SA() : Qu.exports = NA()), Qu.exports;
}
var he = jA();
const eg = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => eg(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, wA = "_jiraCode_h30p6_1", CA = "_jiraCodeInline_h30p6_8", Xu = {
  jiraCode: wA,
  jiraCodeInline: CA
}, GC = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ he.jsx(he.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ he.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ he.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ he.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ he.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ he.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ he.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ he.jsx("pre", { children: /* @__PURE__ */ he.jsx("code", { className: Xu.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ he.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ he.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ he.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ he.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ he.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ he.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ he.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ he.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ he.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ he.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ he.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ he.jsx("code", { className: dt(Xu.jiraCode, Xu.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, ol = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = me(!1);
  return !e || i ? /* @__PURE__ */ he.jsx(ve, { size: r, name: "question", className: n }) : /* @__PURE__ */ he.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, FA = "_collapse_m2gjh_1", IA = "_collapseHeader_m2gjh_10", EA = "_collapseHeaderLink_m2gjh_31", $A = "_collapseHeaderStatus_m2gjh_40", TA = "_collapseHeaderTitle_m2gjh_51", OA = "_collapseContent_m2gjh_59", DA = "_collapseContentHeadline_m2gjh_62", PA = "_collapseContentButtonSpacer_m2gjh_68", RA = "_collapseContentButtonLink_m2gjh_71", AA = "_collapseContentStatusTag_m2gjh_74", LA = "_collapseContentDescription_m2gjh_77", Nr = {
  collapse: FA,
  collapseHeader: IA,
  collapseHeaderLink: EA,
  collapseHeaderStatus: $A,
  collapseHeaderTitle: TA,
  collapseContent: OA,
  collapseContentHeadline: DA,
  collapseContentButtonSpacer: PA,
  collapseContentButtonLink: RA,
  collapseContentStatusTag: AA,
  collapseContentDescription: LA
}, YC = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, VA = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = me(i), { track: s } = Fn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ he.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, k = YC({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), F = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ he.jsxs(
      xr,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: F,
        className: Nr.collapse,
        children: [
          /* @__PURE__ */ he.jsx(xr.Header, { className: Nr.collapseHeader, children: /* @__PURE__ */ he.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ he.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ he.jsx(ol, { width: 16, iconUrl: k }),
                    /* @__PURE__ */ he.jsx(
                      "a",
                      {
                        className: Nr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (j) => {
                          j.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ he.jsx(ve, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ he.jsx("span", { className: Nr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ he.jsx(Jn, { className: Nr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ he.jsx("div", { className: Nr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ he.jsx(xr.Content, { className: Nr.collapseContent, children: /* @__PURE__ */ he.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ he.jsx("div", { className: Nr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ he.jsx(lt, { className: Nr.collapseContentDescription, children: u ? eg(u, GC) : "" }),
            /* @__PURE__ */ he.jsx(
              et,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Nr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ he.jsx(
              Lt,
              {
                slotEnd: /* @__PURE__ */ he.jsx(ve, { name: "external-link" }),
                variant: "tertiary",
                className: Nr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ he.jsx(he.Fragment, {}) });
}, zA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, UA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, MA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, BA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, qA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, HA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, WA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, KA = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': zA,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": UA,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": MA,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": BA,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': qA,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': HA,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": WA
};
function Bi(e) {
  return KA[e] ?? {};
}
const JC = Bi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), GA = Bi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), YA = Bi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), JA = Bi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), QA = Bi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), XA = Bi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), ZA = Bi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), ng = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), e2 = new RegExp(`^${ng.source}$`), n2 = new RegExp(`/${ng.source}$`), Gx = new RegExp(
  `.+?[&?]selectedIssue=(${ng.source})[&?]?.*`
);
function QC(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = me([]), [o, s] = me([]), [l, d] = me(), { track: m } = Fn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: k } = yn(), {
    loading: F,
    data: j,
    error: N,
    store: x
  } = fy(e ?? null), [
    g,
    { loading: D, error: I, data: C }
  ] = h(JC, {
    notifyOnNetworkStatusChange: !0
  });
  Je(() => {
    const oe = C?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    oe?.length && (s(oe), a(oe.map((pe) => pe?.key).filter(Boolean)));
  }, [C]), Je(
    () => d(N || I || void 0),
    [N, I]
  ), Je(
    () => {
      F || J();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [j?.jira?.issues, F]
  );
  const w = async (oe, pe) => {
    await x(oe).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: pe.success.title,
        text: pe.success.text
      });
    }).catch((z) => {
      u({
        title: pe.error.title,
        text: `${pe.error.text} ${z.message && " (" + z.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [A] = k(GA, {
    onError: (oe) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${oe.message && " (" + oe.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), q = (oe, pe) => {
    const z = window.location.href, ke = pe ? z.replace(
      e?.toString() ?? "",
      pe?.toString()
    ) : z, $e = pe ? `# ${pe}` : `# ${e}`;
    A({
      variables: {
        issueKey: oe,
        title: $e,
        url: ke,
        globalId: `system=${ke}`
      }
    });
  }, [Y] = k(YA, {
    onError: (oe) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${oe.message && " (" + oe.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), te = (oe) => {
    const pe = window.location.href;
    Y({
      variables: {
        issueKey: oe,
        globalId: `system=${pe}`
      }
    });
  }, K = (oe) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: oe
  }), J = () => {
    j && j.jira?.issues?.length > 0 ? g({
      variables: {
        jql: `key in (${j?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, R = async (oe, pe) => {
    m("jira:issue:link:clicked", K(oe));
    const z = j?.jira?.issues ? j : r;
    z.jira.issues = Array.from(
      new Set(z.jira.issues).add(oe)
    ), await x(z, pe?.toString()).then(() => q(oe, pe)).catch((ke) => {
      u({
        title: "Linking failed",
        text: `Linking ${oe} failed. Please try again. ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (oe) => {
    m("jira:issue:link:clicked", K(oe));
    const pe = j?.jira?.issues ? j : r;
    pe.jira.issues = Array.from(
      new Set(pe.jira.issues).add(oe)
    ), w(pe, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${oe} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${oe} failed. Please try again.`
      }
    }).then(() => q(oe));
  }, ne = (oe) => {
    m("jira:issue:unlink:clicked", K(oe)), f({
      headline: `Unlink issue ${oe}?`,
      text: `You are about to unlink the issue ${oe}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", K(oe));
        const pe = {
          ...j,
          jira: {
            ...j?.jira,
            issues: j?.jira?.issues.filter((z) => z !== oe) || []
          }
        };
        w(pe, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${oe}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${oe} failed.`
          }
        }).then(() => te(oe));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", K(oe))
    });
  }, Ne = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((oe) => oe?.key && te(oe.key)), w(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, ue = j?.jira?.issues?.filter(
    (oe) => !i?.includes(oe)
  ) || [];
  return {
    linkIssue: B,
    linkIssueQuietly: R,
    unlinkIssue: ne,
    loadIssues: J,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const oe = {
        ...j,
        jira: {
          ...j?.jira,
          issues: j?.jira?.issues.filter(
            (pe) => !ue.includes(pe)
          ) || []
        }
      };
      x(oe);
    },
    unlinkAllIssues: Ne,
    maybeExtractIssueKey: (oe) => {
      const pe = oe.replace(/\s/g, "");
      if (e2.test(pe))
        return pe;
      if (Gx.test(oe))
        return oe.match(Gx)?.[1];
      if (oe.startsWith(n) && n2.test(oe))
        return oe.substring(oe.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: F,
    danglingIssueLinks: ue,
    isLoadingIssues: D,
    issues: o,
    error: l
  };
}
function t2(e = !1, n) {
  const [r, i] = me(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const r2 = "_result_1wiub_54", i2 = "_resultName_1wiub_74", a2 = "_resultNameIcon_1wiub_82", o2 = "_resultDescription_1wiub_87", s2 = "_resultLinkIcon_1wiub_99", l2 = "_tooltip_1wiub_108", c2 = "_tooltipContent_1wiub_114", d2 = "_tooltipName_1wiub_121", u2 = "_tooltipNameIcon_1wiub_126", m2 = "_tooltipDescription_1wiub_131", p2 = "_tooltipSummary_1wiub_139", f2 = "_tooltipTag_1wiub_143", vr = {
  result: r2,
  resultName: i2,
  resultNameIcon: a2,
  resultDescription: o2,
  resultLinkIcon: s2,
  tooltip: l2,
  tooltipContent: c2,
  tooltipName: d2,
  tooltipNameIcon: u2,
  tooltipDescription: m2,
  tooltipSummary: p2,
  tooltipTag: f2
}, h2 = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = me(!1), h = YC({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ he.jsx(
    Ze,
    {
      disabled: i,
      className: vr.tooltip,
      content: /* @__PURE__ */ he.jsxs("div", { className: vr.tooltipContent, children: [
        /* @__PURE__ */ he.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ he.jsxs("span", { className: vr.tooltipName, children: [
                /* @__PURE__ */ he.jsx(
                  ol,
                  {
                    width: 16,
                    iconUrl: h,
                    className: vr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ he.jsx(Jn, { className: vr.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ he.jsx("div", { className: vr.tooltipSummary, children: m }),
        d && /* @__PURE__ */ he.jsx("div", { className: vr.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ he.jsxs(
        "button",
        {
          ...a,
          className: vr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ he.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ he.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ he.jsxs("span", { className: vr.resultName, children: [
                    /* @__PURE__ */ he.jsx(
                      ol,
                      {
                        width: 16,
                        iconUrl: h,
                        className: vr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ he.jsx("div", { className: vr.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ he.jsx(
              ve,
              {
                className: vr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, y2 = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ he.jsx(
  Lt,
  {
    slotEnd: /* @__PURE__ */ he.jsx(ve, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), g2 = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = yn(), [o, s] = me([]), [l, d] = me(""), [m, { loading: u, error: f, data: h, networkStatus: k }] = a(JC, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: F } = QC(null, n);
  yi(
    () => {
      !u && l && k === rr.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), Je(() => {
    const I = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      I.map((C) => ({
        id: C?.key ?? "",
        name: C?.key ?? "",
        description: C?.fields.summary,
        status: C?.fields.status,
        issuetype: C?.fields.issuetype,
        text: C?.fields.description ? eg(C?.fields.description, GC) : /* @__PURE__ */ he.jsx(he.Fragment, {})
      }))
    );
  }, [h]);
  const j = (I) => {
    e(I.id), d("");
  }, N = (I) => {
    const C = I.trim(), w = F(C);
    if (w) {
      const A = w.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${A}'`);
    } else C !== "" && d(
      `text ~ '${C}'${r ? " and project = " + r : ""}`
    );
  }, x = () => {
    d("");
  }, g = (I) => /* @__PURE__ */ he.jsx(y2, { ...I, jiraInstanceUrl: n }), D = (I) => /* @__PURE__ */ he.jsx(
    h2,
    {
      ...I,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ he.jsx(Tn, { error: f }) : /* @__PURE__ */ he.jsx(
    Tr,
    {
      items: o,
      loading: u,
      onSearch: N,
      onSelect: j,
      onClear: x,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: g,
      itemComponent: D,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, v2 = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = me(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return Je(() => {
    r(i);
  }, [i]), /* @__PURE__ */ he.jsx(
    Tr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, k2 = "_itemButton_1hl53_1", b2 = "_result_1hl53_6", x2 = "_resultIcon_1hl53_26", _2 = "_resultName_1hl53_30", S2 = "_resultCheckIcon_1hl53_38", Wa = {
  itemButton: k2,
  result: b2,
  resultIcon: x2,
  resultName: _2,
  resultCheckIcon: S2
}, Ph = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ he.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ he.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: Wa.itemButton,
          children: /* @__PURE__ */ he.jsxs(b, { className: Wa.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ he.jsx(
              ol,
              {
                width: 36,
                iconUrl: o || "",
                className: Wa.resultIcon
              }
            ),
            /* @__PURE__ */ he.jsx(lt, { className: Wa.resultName, children: e.name }),
            n && /* @__PURE__ */ he.jsx(lt, { className: Wa.resultCheckIcon, children: /* @__PURE__ */ he.jsx(ve, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, N2 = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = yn(), [o, s] = me([]), [l, d] = me(), m = 2, [u, { loading: f, error: h, data: k, networkStatus: F }] = a(ZA, {
    notifyOnNetworkStatusChange: !0
  });
  return yi(
    () => {
      !f && l && l.length >= m && F === rr.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Je(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((j) => {
      if (j?.data?.Jira.findUsers?.length === 1) {
        const N = j?.data?.Jira?.findUsers[0];
        r(N.accountId), s([
          {
            id: N.accountId,
            name: N.displayName
          }
        ]);
      }
    });
  }, []), Je(() => {
    const j = k?.Jira?.findUsers || [];
    s(
      j.filter(({ active: N }) => N).map(({ accountId: N, displayName: x, avatarUrls: g, active: D }) => ({
        id: N,
        name: x,
        avatarUrls: g,
        active: D
      }))
    );
  }, [k]), !f && h ? /* @__PURE__ */ he.jsx(Tn, { error: h }) : /* @__PURE__ */ he.jsx(
    Tr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (j) => d(j),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: j, onSelect: N, checked: x }) => /* @__PURE__ */ he.jsx(
        Ph,
        {
          item: j,
          checked: x,
          onSelectItem: N,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, Yx = ({
  field: e
}) => {
  const [n, r] = me(!1), [i, a] = MC();
  return Je(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ he.jsx(b, { children: /* @__PURE__ */ he.jsx(ve, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ he.jsx($.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ he.jsx(Ze, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ he.jsx(
      ir,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, j2 = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ he.jsx(Yx, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ he.jsx(dr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ he.jsx(Nh, { onChange: n, value: r }) : /* @__PURE__ */ he.jsx(dr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ he.jsx(Nh, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ he.jsx(dr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ he.jsx(
        N2,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ he.jsx(
        Tr,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ he.jsx(v2, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ he.jsx(Yx, { field: e });
  }
}, w2 = ["description", "reporter", "summary"], C2 = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ he.jsx(he.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || w2.includes(o)
).map((o) => /* @__PURE__ */ he.jsx(
  xt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ he.jsx(
      He,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: j2({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), F2 = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ he.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ he.jsxs($.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ he.jsxs(
          $.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ he.jsx(ve, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ he.jsx(He, { label: "Jira issue link", children: /* @__PURE__ */ he.jsx(
        dr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), I2 = "_modalBody_1hk1o_1", E2 = "_modalBodyFormFields_1hk1o_4", Jx = {
  modalBody: I2,
  modalBodyFormFields: E2
}, $2 = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), T2 = (e) => e?.custom?.split(":")?.[1] || null, O2 = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, D2 = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = O2(a, n), l = T2(s) ?? a;
        return r.includes(l) ? i[a] = $2(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, P2 = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = me([]), [m, u] = me(), [f, h] = me(0), [k, F] = me([]), [j, N] = me([]), [x, g] = me(!1), [D, I] = me(!1), [C, w] = me({}), { track: A } = Fn(), { isCopied: q, copyToClipboard: Y } = t2(), te = Yn(() => i?.conversationId, [e]), { useMutation: K, useLazyQuery: J, showNotification: R } = yn(), {
    control: B,
    handleSubmit: ne,
    formState: { errors: Ne },
    reset: ue,
    setValue: oe,
    getValues: pe
  } = mt({
    defaultValues: s
  }), z = j.length > 0, ke = `${a}/browse`, $e = Object.keys(C).length > 0, [H, { loading: Ge, error: sn }] = J(JA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ce) => {
      d(ce.Jira.getAllProjects);
    },
    onError: (ce) => {
      R({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", ce), d([]);
    }
  }), [
    Fe,
    { loading: Ue, error: Pe }
  ] = J(QA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ce) => {
      h(0);
      const Se = ce?.Jira?.getCreateIssueMeta?.projects[0];
      if (Se) {
        const Le = Se?.issuetypes.filter(
          ({ subtask: Re }) => !Re
        );
        F(Le || []), oe(
          "issuetype",
          Le.length > 0 ? Le[0] : void 0
        );
      } else
        R({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), F([]), N([]);
    },
    onError: (ce) => {
      R({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", ce), F([]), N([]), h(0);
    }
  }), [Be, { error: Ae }] = K(
    XA,
    {
      onError: () => {
        g(!1), R({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), A("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (ce) => {
        if (g(!1), ce?.Jira && "key" in ce.Jira.createIssue)
          u(ce?.Jira?.createIssue), R({
            title: "Success",
            text: `Jira issue '${ce.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), A("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: ce.Jira.createIssue.key
          }), te && r(
            ce.Jira.createIssue.key,
            te
          );
        else if ("errorMessages" in ce.Jira.createIssue || "errors" in ce.Jira.createIssue) {
          const Se = ce?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", Se), R({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), Qe = (ce) => {
    g(!0), w({}), Be({
      variables: {
        input: D2(ce, j)
      }
    });
  };
  Je(() => {
    if (e)
      try {
        H();
      } catch (ce) {
        console.warn("Error when fetching initial projects", ce);
      }
  }, [e]), Je(() => {
    const ce = D ? window.setTimeout(() => I(!1), 2e3) : void 0;
    return () => window.clearTimeout(ce);
  }, [D]), Je(() => {
    if (k?.length > 0) {
      oe("issuetype", k[f]);
      const ce = k[f]?.fields?.additionalProperties;
      if (ce?.length > 0) {
        const Se = ce.map(
          ({ value: Q }) => Q
        ), Le = (o ? Se.sort(({ name: Q }, { name: T }) => Q.localeCompare(T)) : Se).sort(
          ({ required: Q }, { required: T }) => Number(T) - Number(Q)
        ), { project: Re, issuetype: gn } = pe();
        ue({ project: Re, issuetype: gn }), N(Le);
      }
    } else
      N([]), oe("issuetype", void 0);
  }, [k, oe, f]), Je(() => {
    if (Ae && Nw(Ae)) {
      if (Ae?.graphQLErrors?.length > 0) {
        const { graphQLErrors: ce } = Ae, Se = ce[0].extensions?.integration?.responseBody;
        try {
          const Le = JSON.parse(Se);
          if (Le?.errors) {
            const Re = Object.keys(Le.errors).reduce(
              (gn, Q) => ({
                ...gn,
                [Q]: {
                  type: "required",
                  message: Le.errors[Q],
                  ref: {
                    name: Q
                  }
                }
              }),
              {}
            );
            w(Re);
          }
        } catch {
        }
      }
    } else
      w({});
  }, [Ae]);
  const Ce = () => {
    d([]), N([]), F([]), u(void 0), h(0), g(!1), w({});
  }, Me = () => {
    Ce(), ue(s), n();
  }, nn = (ce) => {
    ce && Fe({
      variables: {
        projectKey: ce
      }
    });
  }, le = (ce) => {
    const Se = k.map((Le) => Le.id).indexOf(ce);
    h(Se ?? 0);
  };
  return /* @__PURE__ */ he.jsxs(
    wt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Me,
      children: [
        /* @__PURE__ */ he.jsx(
          Ct,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: Me
          }
        ),
        /* @__PURE__ */ he.jsxs(Ft, { className: Jx.modalBody, children: [
          !Ge && sn && /* @__PURE__ */ he.jsx(Tn, { error: sn, retry: H }),
          !Ue && Pe && /* @__PURE__ */ he.jsx(
            Tn,
            {
              error: Pe,
              retry: Fe
            }
          ),
          !x && $e && /* @__PURE__ */ he.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ he.jsx(
            jl,
            {
              variant: "warning",
              description: /* @__PURE__ */ he.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ he.jsx($.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ he.jsx(
                      et,
                      {
                        icon: q ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Y(JSON.stringify(j, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ he.jsx(
            F2,
            {
              createdIssue: m,
              issueBaseLink: ke,
              issueLinkCopied: D,
              setIssueLinkCopied: I,
              copyToClipboard: Y
            }
          ) : /* @__PURE__ */ he.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ne(Qe),
              children: /* @__PURE__ */ he.jsxs(nt, { children: [
                /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(He, { label: "Project", required: !0, children: /* @__PURE__ */ he.jsx(
                  xt,
                  {
                    control: B,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: ce, value: Se } }) => /* @__PURE__ */ he.jsx(
                      Tr,
                      {
                        searchable: !0,
                        loading: Ge,
                        onSelect: (Le) => {
                          nn(Le.key), ce(Le);
                        },
                        selectedItems: [Se],
                        placeholder: "Select Jira project",
                        emptyMessage: sn ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Le, onSelect: Re, checked: gn }) => /* @__PURE__ */ he.jsx(
                          Ph,
                          {
                            item: Le,
                            checked: gn,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(He, { label: "Issue type", required: !0, children: /* @__PURE__ */ he.jsx(
                  xt,
                  {
                    control: B,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: ce, value: Se } }) => /* @__PURE__ */ he.jsx(
                      Tr,
                      {
                        disabled: k.length === 0,
                        loading: Ue,
                        onSelect: (Le) => {
                          le(Le.id), ce(Le);
                        },
                        selectedItems: [Se],
                        placeholder: k.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: Pe ? "No issues found" : "No issues available",
                        items: k,
                        itemComponent: ({ item: Le, onSelect: Re, checked: gn }) => /* @__PURE__ */ he.jsx(
                          Ph,
                          {
                            item: Le,
                            checked: gn,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                z && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ he.jsx(Z, { className: Jx.modalBodyFormFields, children: /* @__PURE__ */ he.jsx(
                  C2,
                  {
                    control: B,
                    errors: { ...Ne, ...C },
                    getValues: pe,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: j
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ he.jsx(
          Et,
          {
            confirmOnClick: m ? Me : ne(Qe),
            confirmProps: {
              disabled: !z,
              isLoading: x,
              loadingIndicator: /* @__PURE__ */ he.jsx(hn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : Me
          }
        )
      ]
    }
  );
}, R2 = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, A2 = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, L2 = "_wrapper_1bylq_1", V2 = "_inputWrapper_1bylq_6", z2 = "_inputSeparator_1bylq_18", U2 = "_buttonLink_1bylq_23", M2 = "_noIssuesFound_1bylq_27", Ka = {
  wrapper: L2,
  inputWrapper: V2,
  inputSeparator: z2,
  buttonLink: U2,
  noIssuesFound: M2
}, B2 = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = Fn(), i = R2(n?.jiraSiteUrl), [a, o] = me(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: k,
    isLoadingIssueLinks: F,
    isLoadingIssues: j,
    issues: N,
    error: x
  } = QC(
    s ? e.conversationId : null,
    i
  ), g = !!n?.enableCreateIssue, D = !!n?.enableSortIssueTypeByLabel, I = !!(N?.length || k?.length), C = !!n?.enableRemoveAllLinks && I, w = !F && !j && k?.length > 0 && !!n?.showDanglingLinks;
  return !j && x ? /* @__PURE__ */ he.jsx(Tn, { error: x, retry: () => f() }) : /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
    /* @__PURE__ */ he.jsxs(b, { className: Ka.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ he.jsxs(b, { className: Ka.inputWrapper, flexDirection: "column", children: [
        g && /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
          /* @__PURE__ */ he.jsx(
            et,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ he.jsx("div", { className: Ka.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ he.jsx(
          g2,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      j ? /* @__PURE__ */ he.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ he.jsx(hn, { "data-testid": "jira-widget-issue-spinner" }) }) : N?.length ? /* @__PURE__ */ he.jsx(
        VA,
        {
          issues: N,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ he.jsx($.Paragraph, { align: "center", className: Ka.noIssuesFound, children: "No linked issues found" }),
      C && N?.length > 0 && /* @__PURE__ */ he.jsx(
        et,
        {
          variant: "secondary",
          disabled: !N?.length && !k?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      w && /* @__PURE__ */ he.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ he.jsx($.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ he.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: k.map((A) => /* @__PURE__ */ he.jsx(Jn, { onDelete: () => m(A), children: A }, A)) }),
            /* @__PURE__ */ he.jsx(
              et,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ he.jsx(
        Lt,
        {
          slotEnd: /* @__PURE__ */ he.jsx(ve, { name: "external-link" }),
          variant: "tertiary",
          className: Ka.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ he.jsx(
      P2,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: D
      }
    )
  ] });
}, Rh = [
  {
    key: "jiraSiteUrl",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  }
], q2 = (e) => {
  const n = A2(e);
  return typeof n == "string" ? n : !0;
}, xi = "JIRA", H2 = {
  enabled: !1,
  name: "",
  jiraSiteUrl: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0,
  enableSortIssueTypeByLabel: !1
}, W2 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: H2
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: F
  } = ur({
    integrationId: e,
    integrationType: xi,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: D
  } = mr({
    integrationId: e,
    fieldDefinitions: Rh,
    form: l,
    onMisconfigured: F
  }), { renderConditions: I, setRenderConditions: C, renderConditionsForSubmit: w } = pr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), A = (Y) => hr(Y, {
    fieldDefinitions: Rh,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: w
  }), q = l.watch("name");
  return /* @__PURE__ */ he.jsxs(
    fr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        k && /* @__PURE__ */ he.jsx(yr, { cause: k }),
        /* @__PURE__ */ he.jsxs(nt, { children: [
          /* @__PURE__ */ he.jsx(Z, { children: /* @__PURE__ */ he.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ he.jsx(
            xn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(
            An,
            {
              name: "jiraSiteUrl",
              label: "Jira site URL",
              control: l.control,
              rules: {
                validate: (Y) => q2(Y)
              },
              componentProps: {
                placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(He, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ he.jsx(
            xn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(He, { label: "Show unresolved links to Jira issues", children: /* @__PURE__ */ he.jsx(
            xn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(He, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ he.jsx(
            xn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(He, { label: "Enable to sort the issue types by label", children: /* @__PURE__ */ he.jsx(
            xn,
            {
              name: "enableSortIssueTypeByLabel",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ he.jsx(
            fi,
            {
              configuration: n,
              integrationId: e,
              integrationType: xi,
              label: "Authorize with OAuth"
            }
          ),
          o && I !== null && /* @__PURE__ */ he.jsx(Z, { children: o({
            value: I,
            onChange: C,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ he.jsx(
          gr,
          {
            integrationType: xi,
            integrationId: e,
            widgetName: q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ he.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ he.jsx(
                ve,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ he.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ he.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  xi,
                  " integration, all links between Dixa and ",
                  xi,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ he.jsxs($.Paragraph, { children: [
                  "All data in ",
                  xi,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ he.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  xi,
                  " ",
                  'integration "',
                  q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_zrl8q_54{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_zrl8q_54:hover,._messageIsOpen_zrl8q_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_zrl8q_65{cursor:pointer}._messageUnattended_zrl8q_68{text-decoration:line-through}._messageLabel_zrl8q_71{color:var(--dixa-typography-color-secondary)}._messageText_zrl8q_74{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_zrl8q_74::-webkit-scrollbar{width:7px;height:7px}._messageText_zrl8q_74::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_zrl8q_74::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_zrl8q_74::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Zu = { exports: {} }, Ga = {}, Qx;
function K2() {
  if (Qx) return Ga;
  Qx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ga.Fragment = r, Ga.jsx = s, Ga.jsxs = s, Ga;
}
var ss = {}, Xx;
function G2() {
  return Xx || (Xx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    ss.Fragment = i, ss.jsx = Un, ss.jsxs = Kn;
  })()), ss;
}
var Zx;
function Y2() {
  return Zx || (Zx = 1, process.env.NODE_ENV === "production" ? Zu.exports = K2() : Zu.exports = G2()), Zu.exports;
}
var ge = Y2();
function J2({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = yn(), [a, o] = me([]), [s] = i(e, n), [l, d] = me(
    []
  );
  return Je(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((F) => {
        const j = setTimeout(F, r);
        d([...l, j]);
      });
      const k = await s({
        variables: h
      });
      u.push(k);
    }
    o(u);
  }, a];
}
var XC = /* @__PURE__ */ ((e) => (e.List = "list", e))(XC || {}), Ah = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(Ah || {}), Lh = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(Lh || {}), Vh = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(Vh || {});
const Q2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, X2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, Z2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, eL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListListResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "created" } }, { kind: "Field", name: { kind: "Name", value: "updated" } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, nL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, tL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, rL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, iL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, aL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, oL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, sL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, lL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, cL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, dL = {
  "\n  query getLists {\n    Klaviyo {\n      get_lists {\n        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {\n          data {\n            type\n            id\n            attributes {\n              name\n              created\n              updated\n            }\n            links {\n              self\n            }\n          }\n          links {\n            self\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": eL,
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": Q2,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": X2,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": nL,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": tL,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": Z2,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": rL,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": iL,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": aL,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": oL,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": sL,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": lL,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": cL
};
function Kr(e) {
  return dL[e] ?? {};
}
const uL = Kr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), mL = Kr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), pL = Kr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), fL = Kr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), hL = Kr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), yL = Kr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), gL = Kr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), vL = Kr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), kL = Kr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function zh(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function e_(e) {
  return zh(e) && e?.attributes?.event_properties?.$message;
}
function bL(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function n_(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function xL(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function _L(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function SL(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function NL(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function jL(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function wL(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function t_(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function CL(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function FL(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const IL = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function EL(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function $L(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function TL({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = yn(), { track: a } = Fn(), [o, s] = me(null), [l, d] = me(
    null
  ), [m, u] = me(null), [f, h] = me(null), [k, F] = me(
    null
  ), [j, N] = me([]), {
    data: x,
    error: g,
    loading: D,
    networkStatus: I
  } = i(pL, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    C,
    {
      data: w,
      error: A,
      loading: q,
      networkStatus: Y
    }
  ] = r(uL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Je(() => {
    if (x && !D && I === rr.ready) {
      const te = xL(x);
      s(
        te.find((K) => K?.attributes?.name === "Received Email")?.id || null
      ), d(
        te.find((K) => K?.attributes?.name === "Opened Email")?.id || null
      ), u(
        te.find((K) => K?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        te.find((K) => K?.attributes?.name === "Bounced Email")?.id || null
      ), F(
        te.find((K) => K?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), F(null);
  }, [x]), Je(() => {
    o && l && m && f && k && !q && Y === rr.ready ? C({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${k}")`,
        pageSize: n
      }
    }) : N([]);
  }, [
    o,
    l,
    m,
    f,
    k
  ]), Je(() => {
    if (!q && w) {
      const te = _L(w), K = NL(
        w
      ).map(
        (ue) => ue?.attributes?.event_properties.$message
      ), J = jL(
        w
      ).map(
        (ue) => ue?.attributes?.event_properties.$message
      );
      te.forEach((ue) => {
        const oe = ue.attributes?.event_properties.$message;
        ue.opened = K.includes(oe), ue.clicked = J.includes(oe);
      });
      const R = SL(w), B = wL(w), ne = [
        ...te,
        ...B,
        ...R
      ].sort((ue, oe) => {
        const pe = n_(ue), z = n_(oe);
        return pe == null && z == null ? 0 : pe == null ? 1 : z == null ? -1 : z - pe;
      }).slice(0, n);
      N(ne);
      const Ne = ne.map((ue) => ue.id);
      a("klaviyo:messages:received", {
        emailsReceived: te.filter(
          (ue) => Ne.includes(ue.id)
        ).length,
        emailsBounced: B.filter(
          (ue) => Ne.includes(ue.id)
        ).length,
        smsReceived: R.filter(
          (ue) => Ne.includes(ue.id)
        ).length,
        total: Ne.length
      });
    } else
      N([]);
  }, [q, w]), Yn(
    () => ({
      receivedMessages: j,
      isLoading: D || q,
      error: g || A
    }),
    [
      j,
      D,
      q,
      g,
      A
    ]
  );
}
function OL({ profileId: e }) {
  const { useQuery: n } = yn(), [r, i] = me(), [a, o] = me(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(hL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  Je(() => {
    l && o(l);
  }, [l]), Je(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Yn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function DL({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = Fn(), { useLazyQuery: i } = yn(), [a, o] = me(), [s, l] = me(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(fL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Je(() => {
    if (!f && m) {
      const k = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, F = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(k, F);
    }
  }, [f, m]);
  const h = (k, F) => {
    const j = k?.data?.length === 1 && k.data[0]?.id || void 0, N = F?.data?.length === 1 && F.data[0]?.id || void 0, x = j || N, g = !j || !N || j === N;
    if (x && g) {
      o(j || N), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), g || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${j}) and phone number ${n} (profile ID ${N}).`
      )
    );
  };
  return Yn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const r_ = 800, PL = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, RL = 3, AL = 1.5, LL = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = RL,
  useDelayRange: a = !1
}) => {
  const o = (A) => Math.floor(Math.random() * (A.max - A.min) + A.min), [s, l] = me(0), [d, m] = me(n || r_), [u, f] = me(r || PL), [h, k] = me(!1), [F, j] = me(!1), N = a || !!r, x = N ? o(u) : n || r_, [g, D] = me(x);
  EP(
    async () => {
      const A = s + 1, q = AL ** A;
      l(A), D(
        (N ? o(u) : d) * q
      ), await e().then(() => {
        j(!0), w();
      });
    },
    h ? g : null
  ), TP(() => w());
  const I = yt(() => {
    l(0), D(x);
  }, [x]), C = yt(
    (A = {}) => {
      const { delay: q, delayRange: Y } = A;
      j(!1), I(), Y && (f(Y), D(o(Y))), q && (m(q), D(q)), k(!0);
    },
    [I]
  ), w = yt(() => {
    k(!1), I();
  }, [I]);
  return Je(() => {
    s >= i && w();
  }, [s, i, w]), Yn(
    () => ({ isRunning: h, isSuccessful: F, start: C, stop: w }),
    [h, F, C, w]
  );
}, VL = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, zL = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function UL({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = yn(), [i, a] = me(), [o, s] = me(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? yL : gL,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: k,
    stop: F
  } = LL({
    query: u,
    useDelayRange: !0
  }), j = m || h;
  return Je(() => {
    if (d)
      if (dI({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const N = VL(d);
          k({
            ...N && {
              delayRange: zL(N)
            }
          });
        }
      } else
        s(d);
  }, [d]), Je(() => {
    if (!m && l?.Klaviyo) {
      let N = {}, x = {};
      n === "lists" && (N = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (x = l?.Klaviyo?.get_segments_for_profile), (N?.data || x?.data) && (F(), a(
        (n === "lists" ? N?.data : x?.data)?.map((g) => ({
          ...g,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Yn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: k,
      isLoading: j,
      error: o,
      networkStatus: f
    }),
    [i, j, o, f, k]
  );
}
const ML = "_notificationText_1polx_1", tg = {
  notificationText: ML
}, Vl = ({ error: e }) => {
  const { track: n } = Fn();
  let r = e;
  if (Nw(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && pw({ error: i[0] }), o = i.length === 1 && lI({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ ge.jsx(Tn, { error: e });
  }
  return /* @__PURE__ */ ge.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ ge.jsx(
    Xe.Item,
    {
      contentLeft: /* @__PURE__ */ ge.jsx(ve, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, BL = "_message_zrl8q_54", qL = "_messageIsOpen_zrl8q_62", HL = "_messageHeader_zrl8q_65", WL = "_messageLabel_zrl8q_71", KL = "_messageText_zrl8q_74", da = {
  message: BL,
  messageIsOpen: qL,
  messageHeader: HL,
  messageLabel: WL,
  messageText: KL
}, GL = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && CL(e.flowMessage);
  return /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
    /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", className: da.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ ge.jsx($.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ ge.jsx(hn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ ge.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ ge.jsx(b, { children: /* @__PURE__ */ ge.jsx(
            $.Paragraph,
            {
              variant: "4",
              className: da.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", className: da.messageText, children: i })
        ]
      }
    )
  ] });
}, YL = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ ge.jsx(ge.Fragment, { children: /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ ge.jsx(b, { children: /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ ge.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, JL = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = me(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = Yn(
    () => () => l ? Qn(l).format(m) : d ? Qn.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", k = f && e.opened, F = f && e.clicked, j = f && o?.event_properties.Subject, N = h && o?.event_properties["Message Name"], x = f ? "mail" : "sms";
  return /* @__PURE__ */ ge.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: dt(da.message, {
        [da.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ ge.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: da.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ ge.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ ge.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ ge.jsx(ve, { size: 16, name: x }),
                  " ",
                  IL(s),
                  u && /* @__PURE__ */ ge.jsx(Bn, { size: "small", variant: "info", children: u })
                ] }),
                j && j,
                N && N
              ] }),
              /* @__PURE__ */ ge.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ ge.jsx(Cl, {}),
          bL(e) && /* @__PURE__ */ ge.jsx(b, { children: /* @__PURE__ */ ge.jsx(Bn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
            /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ ge.jsx(Jn, { children: /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ ge.jsx(
                  ve,
                  {
                    size: 16,
                    color: k ? "green.400" : "red.400",
                    name: k ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ ge.jsx(Jn, { children: /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ ge.jsx(
                  ve,
                  {
                    size: 16,
                    color: F ? "green.400" : "red.400",
                    name: F ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ ge.jsx(GL, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ ge.jsx(YL, { event: e })
        ] })
      ]
    }
  );
}, QL = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, XL = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = me(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = TL({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = J2({
    query: mL,
    options: QL,
    delayMs: 1e3
  }), [m, u] = me([]);
  Je(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((k) => zh(k)).map((k) => e_(k));
      h.length > 0 && (i(!0), l(
        h.map((k) => ({
          messageId: k
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), Je(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && zh(h) && !h.flowMessage) {
          const k = e_(h), F = d.find((N) => (N.data && t_(N.data))?.id === k), j = F?.data && t_(F.data);
          if (j)
            return {
              ...FL(h),
              flowMessage: j
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ ge.jsx(ge.Fragment, { children: f.map((h, k) => h.graphQLErrors ? /* @__PURE__ */ ge.jsx(
    Tn,
    {
      error: h
    },
    `lastMessagesError${k}`
  ) : /* @__PURE__ */ ge.jsx(
    Vl,
    {
      error: h
    },
    `lastMessagesError${k}`
  )) }) : /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
    /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(hn, {}) }) : /* @__PURE__ */ ge.jsx(ge.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ ge.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, k) => /* @__PURE__ */ ge.jsx(
      JL,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: k === 0
      },
      h.id
    )) }) : /* @__PURE__ */ ge.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: tg.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, ZL = "_list_ld0hf_1", eV = "_listItem_ld0hf_4", ti = {
  list: ZL,
  listItem: eV
}, nV = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ ge.jsx(Xe, { className: ti.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ ge.jsx(Xe.Text, { variant: "dense", className: ti.listItem, children: /* @__PURE__ */ ge.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", children: cI(a) }),
          /* @__PURE__ */ ge.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: Li(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, i_ = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = me(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = UL({ profileId: e, query: n });
  Je(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ ge.jsx(Vl, { error: o }) : s ? /* @__PURE__ */ ge.jsx(Xe.Text, { variant: "dense", className: ti.listItem, children: /* @__PURE__ */ ge.jsx(hn, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ ge.jsx(ge.Fragment, { children: u.map(
    ({ attributes: f, type: h }, k) => /* @__PURE__ */ ge.jsx(Xe.Text, { variant: "dense", className: ti.listItem, children: /* @__PURE__ */ ge.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ ge.jsx(Jn, { children: fw(h) })
    ] }) }, k)
  ) }) : r && !a ? /* @__PURE__ */ ge.jsx(Xe.Text, { variant: "dense", className: ti.listItem, children: /* @__PURE__ */ ge.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ ge.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ ge.jsx(ve, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ ge.jsxs($.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ ge.jsx(Ze, { content: "Refresh lists and segments", children: /* @__PURE__ */ ge.jsx(et, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ ge.jsx(Xe.Text, { variant: "dense", className: ti.listItem, children: /* @__PURE__ */ ge.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ ge.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, tV = 0.7, rV = 0.3, iV = (e) => e >= tV ? { variant: "error", label: "High risk" } : e >= rV ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, aV = (e) => /* @__PURE__ */ ge.jsx($.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), oV = (e) => {
  const n = iV(e);
  return /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ ge.jsx(Bn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ ge.jsx($.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, sV = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: aV(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: Li(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: oV(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: Li(o)
      }
    ] : []
  ];
}, lV = ({
  profile: e
}) => {
  const n = sV(e);
  return /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ ge.jsx(Xe, { className: ti.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ ge.jsx(Xe.Text, { variant: "dense", className: ti.listItem, children: /* @__PURE__ */ ge.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ ge.jsx($.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, cV = "_tagHover_kzbzk_1", dV = "_channelUnsubscribed_kzbzk_6", a_ = {
  tagHover: cV,
  channelUnsubscribed: dV
}, o_ = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ ge.jsx(
    Ze,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ ge.jsx(
        Jn,
        {
          className: a_.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ ge.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: dt({
                [a_.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ ge.jsx(hn, { size: 16 }) : /* @__PURE__ */ ge.jsx(ve, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, uV = "_subscriptionError_1qhhx_1", mV = {
  subscriptionError: uV
}, pV = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = me(!1), [d, m] = me(!1), [u, f] = me(), { track: h } = Fn(), [k, F] = $P({
    channel: null,
    request: null
  }), j = EL(n), N = $L(n), x = !!e, { useMutation: g } = yn(), [D] = g(
    vL
  ), [I] = g(
    kL
  ), C = (q) => {
    h("klaviyo:profile:subscribe:clicked", { channel: q }), F.setAll({
      channel: q,
      request: "subscribed"
    }), ((Y) => D({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: Ah.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...Y === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: Lh.Subscribed
                        }
                      }
                    },
                    ...Y === "SMS" && {
                      sms: {
                        marketing: {
                          consent: Lh.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: XC.List,
              id: e
            }
          }
        }
      }
    }))(q).then(
      (Y) => A({
        channel: q,
        mutationResponse: Y,
        isSubscriptionRequest: !0
      })
    ).catch(
      (Y) => A({
        channel: q,
        mutationErrorResponse: Y,
        isSubscriptionRequest: !0
      })
    );
  }, w = (q) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: q }), F.setAll({
      channel: q,
      request: "unsubscribed"
    }), I({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: Ah.Profile,
                attributes: {
                  ...q === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...q === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: Vh.Unsubscribed
                        }
                      }
                    },
                    ...q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: Vh.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (Y) => A({
        channel: q,
        mutationResponse: Y,
        isSubscriptionRequest: !1
      })
    ).catch(
      (Y) => A({
        channel: q,
        mutationErrorResponse: Y,
        isSubscriptionRequest: !1
      })
    );
  }, A = async ({
    channel: q,
    mutationResponse: Y,
    mutationErrorResponse: te,
    isSubscriptionRequest: K
  }) => {
    const J = te?.networkError, R = J ? J?.statusCode : NaN, B = Y?.errors, ne = !!B && hw({
      errors: B
    });
    R === 202 ? (h(
      K ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: q }
    ), await o()) : ne ? (h(
      K ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: q,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${K ? "opt-in" : "opt-out"}.`
    )) : (h(
      K ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: q,
        reason: J?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${K ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return Je(() => {
    if (k.request === "subscribed") {
      const q = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${k.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      k.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(q), F.reset()), k.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(q), F.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ ge.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ ge.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ ge.jsx(
            o_,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: j,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: x,
              handleAction: () => {
                l(!0), f(void 0), j ? w("EMAIL") : C("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ ge.jsx(
            o_,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: N,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: x,
              handleAction: () => {
                m(!0), f(void 0), N ? w("SMS") : C("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ ge.jsx(b, { className: mV.subscriptionError, children: u })
      ] })
    }
  );
}, fV = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: d,
  subscriptionListId: m
}) => {
  const {
    profile: u,
    error: f,
    isLoading: h,
    refetchProfile: k
  } = OL({ profileId: e });
  return f ? /* @__PURE__ */ ge.jsx(Vl, { error: f }) : h ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(hn, {}) }) : !u && !h ? /* @__PURE__ */ ge.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: tg.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ ge.jsxs(Xe, { className: ti.list, children: [
        i && /* @__PURE__ */ ge.jsx(i_, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ ge.jsx(
          i_,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ ge.jsx(
      pV,
      {
        profile: u,
        profileId: e,
        subscriptionListId: m,
        refetchProfile: k,
        email: n,
        phoneNumber: r
      }
    ),
    u && l && /* @__PURE__ */ ge.jsx(lV, { profile: u }),
    u && s && /* @__PURE__ */ ge.jsx(nV, { profile: u }),
    /* @__PURE__ */ ge.jsx(
      XL,
      {
        profileId: e,
        noOfMessagesToShow: d
      }
    )
  ] });
}, hV = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, d = n?.showPredictiveAnalytics, m = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: k,
    error: F
  } = DL({ email: r, phoneNumber: i });
  return _I(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : k ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(hn, {}) }) : F ? /* @__PURE__ */ ge.jsx(Vl, { error: F }) : f ? /* @__PURE__ */ ge.jsx(
    fV,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: d,
      noOfMessagesToShow: m,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ ge.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: tg.notificationText,
      children: "No profile ID found"
    }
  );
}, s_ = [
  { value: "3", label: "The three latest messages" },
  { value: "4", label: "The four latest messages" },
  { value: "5", label: "The five latest messages" }
], yV = ({
  control: e,
  name: n
}) => /* @__PURE__ */ ge.jsx(
  _r,
  {
    name: n,
    control: e,
    label: "Choose how many messages to show",
    rules: { required: "Please choose how many messages to show" },
    componentProps: {
      placeholder: "Select an option",
      equalityFn: (r, i) => r === i,
      getItemTitleByValue: (r) => {
        const i = s_.find(
          (a) => a.value === r
        )?.label;
        return i ? /* @__PURE__ */ ge.jsx($.Paragraph, { children: i }) : null;
      }
    },
    children: s_.map((r) => /* @__PURE__ */ ge.jsx(ut.Item, { value: r.value, children: r.label }, r.value))
  }
), gV = "_settingsWrapper_eleyu_1", vV = {
  settingsWrapper: gV
}, kV = Kr(
  /* GraphQL */
  `
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
          data {
            type
            id
            attributes {
              name
              created
              updated
            }
            links {
              self
            }
          }
          links {
            self
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), l_ = [], bV = ({
  value: e,
  onChange: n
}) => {
  const { useQuery: r } = yn(), [i, a] = me(l_), [o, s] = me(!!e), {
    data: l,
    error: d,
    loading: m
  } = r(kV, {
    skip: !o,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Je(() => {
    e && s(!0);
  }, [e]), Je(() => {
    const u = l?.Klaviyo?.get_lists;
    if (o && u && !m && !d) {
      const f = u?.data?.map(
        (h) => ({
          value: h?.id,
          label: h?.attributes?.name
        })
      ) || l_;
      a(f);
    }
  }, [o, l, m, d]), /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
    /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsxs(
      b,
      {
        gap: "300",
        flexDirection: "column",
        className: vV.settingsWrapper,
        children: [
          /* @__PURE__ */ ge.jsx(He, { label: "Activate re-/subscription list selection", children: /* @__PURE__ */ ge.jsx(
            wl,
            {
              input: {
                name: "subscriptionListId-switch",
                value: "switchValueFromComponent",
                checked: o,
                onChange: () => {
                  const u = !o;
                  u || n(""), s(u);
                }
              }
            }
          ) }),
          o && d && !m && /* @__PURE__ */ ge.jsx(He, { children: /* @__PURE__ */ ge.jsx(Tn, { error: d }) }),
          o && !d && m && /* @__PURE__ */ ge.jsx(He, { children: /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(hn, {}) }) }),
          o && !d && !m && i && /* @__PURE__ */ ge.jsx(He, { label: "Available lists to subscribe to", children: /* @__PURE__ */ ge.jsx(
            ni,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (u) => n(u?.selectedValues?.[0]?.value ?? ""),
              getItemTitleByValue: (u) => u ? /* @__PURE__ */ ge.jsx($.Paragraph, { children: u.label }) : null,
              value: e ? [
                {
                  label: (i || []).find(
                    (u) => u.value === e
                  )?.label,
                  value: e
                }
              ] : [],
              equalityFn: (u, f) => u.value === f.value,
              children: i.map((u) => /* @__PURE__ */ ge.jsx(ut.Item, { value: u, children: u.label }, u.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ ge.jsx(Z, { span: 3 })
  ] });
}, sl = [
  {
    key: "klaviyoApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showProfileLists",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  // Populated by the subscribe-list selector; empty means the feature is off.
  {
    key: "subscriptionListId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "noOfMessagesToShow",
    type: "string",
    secret: !1,
    defaultValue: "5"
  }
], xV = [
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: fi
  }
], _V = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
], em = "KLAVIYO", SV = {
  enabled: !1,
  name: "",
  ...Sl(
    [],
    sl
  )
}, NV = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: SV
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: F
  } = ur({
    integrationId: e,
    integrationType: em,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: D
  } = mr({
    integrationId: e,
    fieldDefinitions: sl,
    form: l,
    onMisconfigured: F
  }), { renderConditions: I, setRenderConditions: C, renderConditionsForSubmit: w } = pr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), A = s || !!D?.additionalProperties?.isUsingOAuth, q = (te) => hr(te, {
    fieldDefinitions: sl,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: w
  }), Y = l.watch("name");
  return /* @__PURE__ */ ge.jsxs(
    fr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: q,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        k && /* @__PURE__ */ ge.jsx(yr, { cause: k }),
        /* @__PURE__ */ ge.jsxs(nt, { children: [
          /* @__PURE__ */ ge.jsx(Z, { children: /* @__PURE__ */ ge.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ge.jsx(
            xn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          !A && /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
            /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(
              Er,
              {
                name: "klaviyoApiKey",
                label: "API key",
                control: l.control,
                isCreationMode: s,
                rules: { required: "API key is required" },
                componentProps: {
                  placeholder: "API key from Klaviyo",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ ge.jsx(Z, { span: 3 })
          ] }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(He, { label: "Show Klaviyo lists for a profile", children: /* @__PURE__ */ ge.jsx(
            xn,
            {
              name: "showProfileLists",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(He, { label: "Show Klaviyo segments for a profile", children: /* @__PURE__ */ ge.jsx(
            xn,
            {
              name: "showProfileSegments",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(He, { label: "Show subscription channels for Klaviyo messages", children: /* @__PURE__ */ ge.jsx(
            xn,
            {
              name: "showSubscriptions",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(He, { label: "Show custom properties for a profile", children: /* @__PURE__ */ ge.jsx(
            xn,
            {
              name: "showCustomProperties",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(He, { label: "Show predictive analytics for a profile", children: /* @__PURE__ */ ge.jsx(
            xn,
            {
              name: "showPredictiveAnalytics",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          !s && /* @__PURE__ */ ge.jsx(
            xt,
            {
              name: "subscriptionListId",
              control: l.control,
              render: ({ field: te }) => /* @__PURE__ */ ge.jsx(
                bV,
                {
                  value: te.value,
                  onChange: te.onChange
                }
              )
            }
          ),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(
            yV,
            {
              name: "noOfMessagesToShow",
              control: l.control
            }
          ) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          A && !s && e && /* @__PURE__ */ ge.jsx(
            fi,
            {
              configuration: n,
              integrationId: e,
              integrationType: em,
              label: "Authorize with OAuth"
            }
          ),
          o && I !== null && /* @__PURE__ */ ge.jsx(Z, { children: o({
            value: I,
            onChange: C,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ ge.jsx(
          gr,
          {
            integrationType: em,
            integrationId: e,
            widgetName: Y,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
function jV(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const wV = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, CV = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, FV = {};
function c_(e, n) {
  return (FV.jsx ? CV : wV).test(e);
}
const IV = /[ \t\n\f\r]/g;
function EV(e) {
  return typeof e == "object" ? e.type === "text" ? d_(e.value) : !1 : d_(e);
}
function d_(e) {
  return e.replace(IV, "") === "";
}
class Bo {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
Bo.prototype.property = {};
Bo.prototype.normal = {};
Bo.prototype.space = null;
function ZC(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new Bo(r, i, n);
}
function Uh(e) {
  return e.toLowerCase();
}
class Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
Sr.prototype.space = null;
Sr.prototype.boolean = !1;
Sr.prototype.booleanish = !1;
Sr.prototype.overloadedBoolean = !1;
Sr.prototype.number = !1;
Sr.prototype.commaSeparated = !1;
Sr.prototype.spaceSeparated = !1;
Sr.prototype.commaOrSpaceSeparated = !1;
Sr.prototype.mustUseProperty = !1;
Sr.prototype.defined = !1;
let $V = 0;
const On = qi(), bt = qi(), e1 = qi(), Ye = qi(), st = qi(), ua = qi(), or = qi();
function qi() {
  return 2 ** ++$V;
}
const Mh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: On,
  booleanish: bt,
  commaOrSpaceSeparated: or,
  commaSeparated: ua,
  number: Ye,
  overloadedBoolean: e1,
  spaceSeparated: st
}, Symbol.toStringTag, { value: "Module" })), nm = Object.keys(Mh);
class rg extends Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), u_(this, "space", a), typeof i == "number")
      for (; ++o < nm.length; ) {
        const s = nm[o];
        u_(this, nm[o], (i & Mh[s]) === Mh[s]);
      }
  }
}
rg.prototype.defined = !0;
function u_(e, n, r) {
  r && (e[n] = r);
}
const TV = {}.hasOwnProperty;
function Fa(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (TV.call(e.properties, i)) {
      const a = e.properties[i], o = new rg(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[Uh(i)] = i, r[Uh(o.attribute)] = i;
    }
  return new Bo(n, r, e.space);
}
const n1 = Fa({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), t1 = Fa({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function r1(e, n) {
  return n in e ? e[n] : n;
}
function i1(e, n) {
  return r1(e, n.toLowerCase());
}
const a1 = Fa({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: i1,
  properties: { xmlns: null, xmlnsXLink: null }
}), o1 = Fa({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: bt,
    ariaAutoComplete: null,
    ariaBusy: bt,
    ariaChecked: bt,
    ariaColCount: Ye,
    ariaColIndex: Ye,
    ariaColSpan: Ye,
    ariaControls: st,
    ariaCurrent: null,
    ariaDescribedBy: st,
    ariaDetails: null,
    ariaDisabled: bt,
    ariaDropEffect: st,
    ariaErrorMessage: null,
    ariaExpanded: bt,
    ariaFlowTo: st,
    ariaGrabbed: bt,
    ariaHasPopup: null,
    ariaHidden: bt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: st,
    ariaLevel: Ye,
    ariaLive: null,
    ariaModal: bt,
    ariaMultiLine: bt,
    ariaMultiSelectable: bt,
    ariaOrientation: null,
    ariaOwns: st,
    ariaPlaceholder: null,
    ariaPosInSet: Ye,
    ariaPressed: bt,
    ariaReadOnly: bt,
    ariaRelevant: null,
    ariaRequired: bt,
    ariaRoleDescription: st,
    ariaRowCount: Ye,
    ariaRowIndex: Ye,
    ariaRowSpan: Ye,
    ariaSelected: bt,
    ariaSetSize: Ye,
    ariaSort: null,
    ariaValueMax: Ye,
    ariaValueMin: Ye,
    ariaValueNow: Ye,
    ariaValueText: null,
    role: null
  }
}), OV = Fa({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: i1,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ua,
    acceptCharset: st,
    accessKey: st,
    action: null,
    allow: null,
    allowFullScreen: On,
    allowPaymentRequest: On,
    allowUserMedia: On,
    alt: null,
    as: null,
    async: On,
    autoCapitalize: null,
    autoComplete: st,
    autoFocus: On,
    autoPlay: On,
    blocking: st,
    capture: null,
    charSet: null,
    checked: On,
    cite: null,
    className: st,
    cols: Ye,
    colSpan: null,
    content: null,
    contentEditable: bt,
    controls: On,
    controlsList: st,
    coords: Ye | ua,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: On,
    defer: On,
    dir: null,
    dirName: null,
    disabled: On,
    download: e1,
    draggable: bt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: On,
    formTarget: null,
    headers: st,
    height: Ye,
    hidden: On,
    high: Ye,
    href: null,
    hrefLang: null,
    htmlFor: st,
    httpEquiv: st,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: On,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: On,
    itemId: null,
    itemProp: st,
    itemRef: st,
    itemScope: On,
    itemType: st,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: On,
    low: Ye,
    manifest: null,
    max: null,
    maxLength: Ye,
    media: null,
    method: null,
    min: null,
    minLength: Ye,
    multiple: On,
    muted: On,
    name: null,
    nonce: null,
    noModule: On,
    noValidate: On,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: On,
    optimum: Ye,
    pattern: null,
    ping: st,
    placeholder: null,
    playsInline: On,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: On,
    referrerPolicy: null,
    rel: st,
    required: On,
    reversed: On,
    rows: Ye,
    rowSpan: Ye,
    sandbox: st,
    scope: null,
    scoped: On,
    seamless: On,
    selected: On,
    shadowRootClonable: On,
    shadowRootDelegatesFocus: On,
    shadowRootMode: null,
    shape: null,
    size: Ye,
    sizes: null,
    slot: null,
    span: Ye,
    spellCheck: bt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ye,
    step: null,
    style: null,
    tabIndex: Ye,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: On,
    useMap: null,
    value: bt,
    width: Ye,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: st,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ye,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ye,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: On,
    // Lists. Use CSS to reduce space between items instead
    declare: On,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ye,
    // `<img>` and `<object>`
    leftMargin: Ye,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ye,
    // `<body>`
    marginWidth: Ye,
    // `<body>`
    noResize: On,
    // `<frame>`
    noHref: On,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: On,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: On,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ye,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: bt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ye,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ye,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: On,
    disableRemotePlayback: On,
    prefix: null,
    property: null,
    results: Ye,
    security: null,
    unselectable: null
  }
}), DV = Fa({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: r1,
  properties: {
    about: or,
    accentHeight: Ye,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ye,
    amplitude: Ye,
    arabicForm: null,
    ascent: Ye,
    attributeName: null,
    attributeType: null,
    azimuth: Ye,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ye,
    by: null,
    calcMode: null,
    capHeight: Ye,
    className: st,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ye,
    diffuseConstant: Ye,
    direction: null,
    display: null,
    dur: null,
    divisor: Ye,
    dominantBaseline: null,
    download: On,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ye,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ye,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ye,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ua,
    g2: ua,
    glyphName: ua,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ye,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ye,
    horizOriginX: Ye,
    horizOriginY: Ye,
    id: null,
    ideographic: Ye,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ye,
    k: Ye,
    k1: Ye,
    k2: Ye,
    k3: Ye,
    k4: Ye,
    kernelMatrix: or,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ye,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ye,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ye,
    overlineThickness: Ye,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ye,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: st,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ye,
    pointsAtY: Ye,
    pointsAtZ: Ye,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: or,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: or,
    rev: or,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: or,
    requiredFeatures: or,
    requiredFonts: or,
    requiredFormats: or,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ye,
    specularExponent: Ye,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ye,
    strikethroughThickness: Ye,
    string: null,
    stroke: null,
    strokeDashArray: or,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ye,
    strokeOpacity: Ye,
    strokeWidth: null,
    style: null,
    surfaceScale: Ye,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: or,
    tabIndex: Ye,
    tableValues: null,
    target: null,
    targetX: Ye,
    targetY: Ye,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: or,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ye,
    underlineThickness: Ye,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ye,
    values: null,
    vAlphabetic: Ye,
    vMathematical: Ye,
    vectorEffect: null,
    vHanging: Ye,
    vIdeographic: Ye,
    version: null,
    vertAdvY: Ye,
    vertOriginX: Ye,
    vertOriginY: Ye,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ye,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), PV = /^data[-\w.:]+$/i, m_ = /-[a-z]/g, RV = /[A-Z]/g;
function AV(e, n) {
  const r = Uh(n);
  let i = n, a = Sr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && PV.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(m_, VV);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!m_.test(o)) {
        let s = o.replace(RV, LV);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = rg;
  }
  return new a(i, n);
}
function LV(e) {
  return "-" + e.toLowerCase();
}
function VV(e) {
  return e.charAt(1).toUpperCase();
}
const zV = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, UV = ZC([t1, n1, a1, o1, OV], "html"), ig = ZC([t1, n1, a1, o1, DV], "svg");
function MV(e) {
  return e.join(" ").trim();
}
var Qi = {}, tm, p_;
function BV() {
  if (p_) return tm;
  p_ = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", k = "declaration";
  tm = function(j, N) {
    if (typeof j != "string")
      throw new TypeError("First argument must be a string");
    if (!j) return [];
    N = N || {};
    var x = 1, g = 1;
    function D(R) {
      var B = R.match(n);
      B && (x += B.length);
      var ne = R.lastIndexOf(d);
      g = ~ne ? R.length - ne : g + R.length;
    }
    function I() {
      var R = { line: x, column: g };
      return function(B) {
        return B.position = new C(R), q(), B;
      };
    }
    function C(R) {
      this.start = R, this.end = { line: x, column: g }, this.source = N.source;
    }
    C.prototype.content = j;
    function w(R) {
      var B = new Error(
        N.source + ":" + x + ":" + g + ": " + R
      );
      if (B.reason = R, B.filename = N.source, B.line = x, B.column = g, B.source = j, !N.silent) throw B;
    }
    function A(R) {
      var B = R.exec(j);
      if (B) {
        var ne = B[0];
        return D(ne), j = j.slice(ne.length), B;
      }
    }
    function q() {
      A(r);
    }
    function Y(R) {
      var B;
      for (R = R || []; B = te(); )
        B !== !1 && R.push(B);
      return R;
    }
    function te() {
      var R = I();
      if (!(m != j.charAt(0) || u != j.charAt(1))) {
        for (var B = 2; f != j.charAt(B) && (u != j.charAt(B) || m != j.charAt(B + 1)); )
          ++B;
        if (B += 2, f === j.charAt(B - 1))
          return w("End of comment missing");
        var ne = j.slice(2, B - 2);
        return g += 2, D(ne), j = j.slice(B), g += 2, R({
          type: h,
          comment: ne
        });
      }
    }
    function K() {
      var R = I(), B = A(i);
      if (B) {
        if (te(), !A(a)) return w("property missing ':'");
        var ne = A(o), Ne = R({
          type: k,
          property: F(B[0].replace(e, f)),
          value: ne ? F(ne[0].replace(e, f)) : f
        });
        return A(s), Ne;
      }
    }
    function J() {
      var R = [];
      Y(R);
      for (var B; B = K(); )
        B !== !1 && (R.push(B), Y(R));
      return R;
    }
    return q(), J();
  };
  function F(j) {
    return j ? j.replace(l, f) : f;
  }
  return tm;
}
var f_;
function qV() {
  if (f_) return Qi;
  f_ = 1;
  var e = Qi && Qi.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Qi, "__esModule", { value: !0 }), Qi.default = r;
  var n = e(BV());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return Qi;
}
var HV = qV();
const h_ = /* @__PURE__ */ vy(HV), WV = h_.default || h_, s1 = l1("end"), ag = l1("start");
function l1(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function KV(e) {
  const n = ag(e), r = s1(e);
  if (n && r)
    return { start: n, end: r };
}
function _o(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? y_(e.position) : "start" in e || "end" in e ? y_(e) : "line" in e || "column" in e ? Bh(e) : "";
}
function Bh(e) {
  return g_(e && e.line) + ":" + g_(e && e.column);
}
function y_(e) {
  return Bh(e && e.start) + "-" + Bh(e && e.end);
}
function g_(e) {
  return e && typeof e == "number" ? e : 1;
}
class Bt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = _o(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Bt.prototype.file = "";
Bt.prototype.name = "";
Bt.prototype.reason = "";
Bt.prototype.message = "";
Bt.prototype.stack = "";
Bt.prototype.column = void 0;
Bt.prototype.line = void 0;
Bt.prototype.ancestors = void 0;
Bt.prototype.cause = void 0;
Bt.prototype.fatal = void 0;
Bt.prototype.place = void 0;
Bt.prototype.ruleId = void 0;
Bt.prototype.source = void 0;
const og = {}.hasOwnProperty, GV = /* @__PURE__ */ new Map(), YV = /[A-Z]/g, JV = /-([a-z])/g, QV = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), XV = /* @__PURE__ */ new Set(["td", "th"]), c1 = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function ZV(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = s3(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = o3(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? ig : UV,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = d1(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function d1(e, n, r) {
  if (n.type === "element")
    return e3(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return n3(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return r3(e, n, r);
  if (n.type === "mdxjsEsm")
    return t3(e, n);
  if (n.type === "root")
    return i3(e, n, r);
  if (n.type === "text")
    return a3(e, n);
}
function e3(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = ig, e.schema = a), e.ancestors.push(n);
  const o = m1(e, n.tagName, !1), s = l3(e, n);
  let l = lg(e, n);
  return QV.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !EV(d) : !0;
  })), u1(e, s, o, n), sg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function n3(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Po(e, n.position);
}
function t3(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Po(e, n.position);
}
function r3(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = ig, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : m1(e, n.name, !0), s = c3(e, n), l = lg(e, n);
  return u1(e, s, o, n), sg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function i3(e, n, r) {
  const i = {};
  return sg(i, lg(e, n)), e.create(n, e.Fragment, i, r);
}
function a3(e, n) {
  return n.value;
}
function u1(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function sg(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function o3(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function s3(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = ag(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function l3(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && og.call(n.properties, a)) {
      const o = d3(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && XV.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function c3(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Po(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Po(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function lg(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : GV;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = d1(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function d3(e, n, r) {
  const i = AV(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? jV(r) : MV(r)), i.property === "style") {
      let a = typeof r == "object" ? r : u3(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = m3(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? zV[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function u3(e, n) {
  const r = {};
  try {
    WV(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Bt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = c1 + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(JV, f3)), r[s] = o;
  }
}
function m1(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = c_(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = c_(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return og.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Po(e);
}
function Po(e, n) {
  const r = new Bt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = c1 + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function m3(e) {
  const n = {};
  let r;
  for (r in e)
    og.call(e, r) && (n[p3(r)] = e[r]);
  return n;
}
function p3(e) {
  let n = e.replace(YV, h3);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function f3(e, n) {
  return n.toUpperCase();
}
function h3(e) {
  return "-" + e.toLowerCase();
}
const rm = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, y3 = {};
function g3(e, n) {
  const r = y3, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return p1(e, i, a);
}
function p1(e, n, r) {
  if (v3(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return v_(e.children, n, r);
  }
  return Array.isArray(e) ? v_(e, n, r) : "";
}
function v_(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = p1(e[a], n, r);
  return i.join("");
}
function v3(e) {
  return !!(e && typeof e == "object");
}
const k_ = document.createElement("i");
function cg(e) {
  const n = "&" + e + ";";
  k_.innerHTML = n;
  const r = k_.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Hr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function br(e, n) {
  return e.length > 0 ? (Hr(e, e.length, 0, n), e) : n;
}
const b_ = {}.hasOwnProperty;
function k3(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    b3(n, e[r]);
  return n;
}
function b3(e, n) {
  let r;
  for (r in n) {
    const a = (b_.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        b_.call(a, s) || (a[s] = []);
        const l = o[s];
        x3(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function x3(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Hr(e, 0, 0, i);
}
function f1(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function ma(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const zr = gi(/[A-Za-z]/), cr = gi(/[\dA-Za-z]/), _3 = gi(/[#-'*+\--9=?A-Z^-~]/);
function qh(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Hh = gi(/\d/), S3 = gi(/[\dA-Fa-f]/), N3 = gi(/[!-/:-@[-`{-~]/);
function $n(e) {
  return e !== null && e < -2;
}
function nr(e) {
  return e !== null && (e < 0 || e === 32);
}
function Xn(e) {
  return e === -2 || e === -1 || e === 32;
}
const j3 = gi(new RegExp("\\p{P}|\\p{S}", "u")), w3 = gi(/\s/);
function gi(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Ia(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && cr(e.charCodeAt(r + 1)) && cr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function ct(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return Xn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return Xn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const C3 = {
  tokenize: F3
};
function F3(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), ct(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return $n(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const I3 = {
  tokenize: E3
}, x_ = {
  tokenize: $3
};
function E3(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(D) {
    if (i < r.length) {
      const I = r[i];
      return n.containerState = I[1], e.attempt(I[0].continuation, d, m)(D);
    }
    return m(D);
  }
  function d(D) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && g();
      const I = n.events.length;
      let C = I, w;
      for (; C--; )
        if (n.events[C][0] === "exit" && n.events[C][1].type === "chunkFlow") {
          w = n.events[C][1].end;
          break;
        }
      x(i);
      let A = I;
      for (; A < n.events.length; )
        n.events[A][1].end = {
          ...w
        }, A++;
      return Hr(n.events, C + 1, 0, n.events.slice(I)), n.events.length = A, m(D);
    }
    return l(D);
  }
  function m(D) {
    if (i === r.length) {
      if (!a)
        return h(D);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return F(D);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(x_, u, f)(D);
  }
  function u(D) {
    return a && g(), x(i), h(D);
  }
  function f(D) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, F(D);
  }
  function h(D) {
    return n.containerState = {}, e.attempt(x_, k, F)(D);
  }
  function k(D) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(D);
  }
  function F(D) {
    if (D === null) {
      a && g(), x(0), e.consume(D);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), j(D);
  }
  function j(D) {
    if (D === null) {
      N(e.exit("chunkFlow"), !0), x(0), e.consume(D);
      return;
    }
    return $n(D) ? (e.consume(D), N(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(D), j);
  }
  function N(D, I) {
    const C = n.sliceStream(D);
    if (I && C.push(null), D.previous = o, o && (o.next = D), o = D, a.defineSkip(D.start), a.write(C), n.parser.lazy[D.start.line]) {
      let w = a.events.length;
      for (; w--; )
        if (
          // The token starts before the line ending…
          a.events[w][1].start.offset < s && // …and either is not ended yet…
          (!a.events[w][1].end || // …or ends after it.
          a.events[w][1].end.offset > s)
        )
          return;
      const A = n.events.length;
      let q = A, Y, te;
      for (; q--; )
        if (n.events[q][0] === "exit" && n.events[q][1].type === "chunkFlow") {
          if (Y) {
            te = n.events[q][1].end;
            break;
          }
          Y = !0;
        }
      for (x(i), w = A; w < n.events.length; )
        n.events[w][1].end = {
          ...te
        }, w++;
      Hr(n.events, q + 1, 0, n.events.slice(A)), n.events.length = w;
    }
  }
  function x(D) {
    let I = r.length;
    for (; I-- > D; ) {
      const C = r[I];
      n.containerState = C[1], C[0].exit.call(n, e);
    }
    r.length = D;
  }
  function g() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function $3(e, n, r) {
  return ct(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function __(e) {
  if (e === null || nr(e) || w3(e))
    return 1;
  if (j3(e))
    return 2;
}
function dg(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const Wh = {
  name: "attention",
  resolveAll: T3,
  tokenize: O3
};
function T3(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          S_(f, -d), S_(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = br(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = br(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = br(m, dg(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = br(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = br(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Hr(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function O3(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = __(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = __(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function S_(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const D3 = {
  name: "autolink",
  tokenize: P3
};
function P3(e, n, r) {
  let i = 0;
  return a;
  function a(k) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(k) {
    return zr(k) ? (e.consume(k), s) : k === 64 ? r(k) : m(k);
  }
  function s(k) {
    return k === 43 || k === 45 || k === 46 || cr(k) ? (i = 1, l(k)) : m(k);
  }
  function l(k) {
    return k === 58 ? (e.consume(k), i = 0, d) : (k === 43 || k === 45 || k === 46 || cr(k)) && i++ < 32 ? (e.consume(k), l) : (i = 0, m(k));
  }
  function d(k) {
    return k === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.exit("autolink"), n) : k === null || k === 32 || k === 60 || qh(k) ? r(k) : (e.consume(k), d);
  }
  function m(k) {
    return k === 64 ? (e.consume(k), u) : _3(k) ? (e.consume(k), m) : r(k);
  }
  function u(k) {
    return cr(k) ? f(k) : r(k);
  }
  function f(k) {
    return k === 46 ? (e.consume(k), i = 0, u) : k === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(k);
  }
  function h(k) {
    if ((k === 45 || cr(k)) && i++ < 63) {
      const F = k === 45 ? h : f;
      return e.consume(k), F;
    }
    return r(k);
  }
}
const zl = {
  partial: !0,
  tokenize: R3
};
function R3(e, n, r) {
  return i;
  function i(o) {
    return Xn(o) ? ct(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || $n(o) ? n(o) : r(o);
  }
}
const h1 = {
  continuation: {
    tokenize: L3
  },
  exit: V3,
  name: "blockQuote",
  tokenize: A3
};
function A3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return Xn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function L3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return Xn(s) ? ct(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(h1, n, r)(s);
  }
}
function V3(e) {
  e.exit("blockQuote");
}
const y1 = {
  name: "characterEscape",
  tokenize: z3
};
function z3(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return N3(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const g1 = {
  name: "characterReference",
  tokenize: U3
};
function U3(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = cr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = S3, u) : (e.enter("characterReferenceValue"), o = 7, s = Hh, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === cr && !cg(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const N_ = {
  partial: !0,
  tokenize: B3
}, j_ = {
  concrete: !0,
  name: "codeFenced",
  tokenize: M3
};
function M3(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: C
  };
  let o = 0, s = 0, l;
  return d;
  function d(w) {
    return m(w);
  }
  function m(w) {
    const A = i.events[i.events.length - 1];
    return o = A && A[1].type === "linePrefix" ? A[2].sliceSerialize(A[1], !0).length : 0, l = w, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(w);
  }
  function u(w) {
    return w === l ? (s++, e.consume(w), u) : s < 3 ? r(w) : (e.exit("codeFencedFenceSequence"), Xn(w) ? ct(e, f, "whitespace")(w) : f(w));
  }
  function f(w) {
    return w === null || $n(w) ? (e.exit("codeFencedFence"), i.interrupt ? n(w) : e.check(N_, j, I)(w)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(w));
  }
  function h(w) {
    return w === null || $n(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(w)) : Xn(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), ct(e, k, "whitespace")(w)) : w === 96 && w === l ? r(w) : (e.consume(w), h);
  }
  function k(w) {
    return w === null || $n(w) ? f(w) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), F(w));
  }
  function F(w) {
    return w === null || $n(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(w)) : w === 96 && w === l ? r(w) : (e.consume(w), F);
  }
  function j(w) {
    return e.attempt(a, I, N)(w);
  }
  function N(w) {
    return e.enter("lineEnding"), e.consume(w), e.exit("lineEnding"), x;
  }
  function x(w) {
    return o > 0 && Xn(w) ? ct(e, g, "linePrefix", o + 1)(w) : g(w);
  }
  function g(w) {
    return w === null || $n(w) ? e.check(N_, j, I)(w) : (e.enter("codeFlowValue"), D(w));
  }
  function D(w) {
    return w === null || $n(w) ? (e.exit("codeFlowValue"), g(w)) : (e.consume(w), D);
  }
  function I(w) {
    return e.exit("codeFenced"), n(w);
  }
  function C(w, A, q) {
    let Y = 0;
    return te;
    function te(ne) {
      return w.enter("lineEnding"), w.consume(ne), w.exit("lineEnding"), K;
    }
    function K(ne) {
      return w.enter("codeFencedFence"), Xn(ne) ? ct(w, J, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ne) : J(ne);
    }
    function J(ne) {
      return ne === l ? (w.enter("codeFencedFenceSequence"), R(ne)) : q(ne);
    }
    function R(ne) {
      return ne === l ? (Y++, w.consume(ne), R) : Y >= s ? (w.exit("codeFencedFenceSequence"), Xn(ne) ? ct(w, B, "whitespace")(ne) : B(ne)) : q(ne);
    }
    function B(ne) {
      return ne === null || $n(ne) ? (w.exit("codeFencedFence"), A(ne)) : q(ne);
    }
  }
}
function B3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const im = {
  name: "codeIndented",
  tokenize: H3
}, q3 = {
  partial: !0,
  tokenize: W3
};
function H3(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), ct(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : $n(m) ? e.attempt(q3, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || $n(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function W3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : $n(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : ct(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : $n(s) ? a(s) : r(s);
  }
}
const K3 = {
  name: "codeText",
  previous: Y3,
  resolve: G3,
  tokenize: J3
};
function G3(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function Y3(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function J3(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : $n(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || $n(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class Q3 {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && Ya(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), Ya(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), Ya(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        Ya(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        Ya(this.left, r.reverse());
      }
  }
}
function Ya(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function v1(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new Q3(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, X3(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Hr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function X3(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, k = r, F = 0, j = 0;
  const N = [j];
  for (; k; ) {
    for (; e.get(++a)[1] !== k; )
      ;
    o.push(a), k._tokenizer || (u = i.sliceStream(k), k.next || u.push(null), f && s.defineSkip(k.start), k._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), k._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = k, k = k.next;
  }
  for (k = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (j = h + 1, N.push(j), k._tokenizer = void 0, k.previous = void 0, k = k.next);
  for (s.events = [], k ? (k._tokenizer = void 0, k.previous = void 0) : N.pop(), h = N.length; h--; ) {
    const x = l.slice(N[h], N[h + 1]), g = o.pop();
    d.push([g, g + x.length - 1]), e.splice(g, 2, x);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[F + d[h][0]] = F + d[h][1], F += d[h][1] - d[h][0] - 1;
  return m;
}
const Z3 = {
  resolve: nz,
  tokenize: tz
}, ez = {
  partial: !0,
  tokenize: rz
};
function nz(e) {
  return v1(e), e;
}
function tz(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : $n(l) ? e.check(ez, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function rz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), ct(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || $n(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function k1(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(x) {
    return x === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(x), e.exit(o), h) : x === null || x === 32 || x === 41 || qh(x) ? r(x) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), j(x));
  }
  function h(x) {
    return x === 62 ? (e.enter(o), e.consume(x), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), k(x));
  }
  function k(x) {
    return x === 62 ? (e.exit("chunkString"), e.exit(l), h(x)) : x === null || x === 60 || $n(x) ? r(x) : (e.consume(x), x === 92 ? F : k);
  }
  function F(x) {
    return x === 60 || x === 62 || x === 92 ? (e.consume(x), k) : k(x);
  }
  function j(x) {
    return !u && (x === null || x === 41 || nr(x)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(x)) : u < m && x === 40 ? (e.consume(x), u++, j) : x === 41 ? (e.consume(x), u--, j) : x === null || x === 32 || x === 40 || qh(x) ? r(x) : (e.consume(x), x === 92 ? N : j);
  }
  function N(x) {
    return x === 40 || x === 41 || x === 92 ? (e.consume(x), j) : j(x);
  }
}
function b1(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(k) {
    return e.enter(i), e.enter(a), e.consume(k), e.exit(a), e.enter(o), u;
  }
  function u(k) {
    return l > 999 || k === null || k === 91 || k === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    k === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(k) : k === 93 ? (e.exit(o), e.enter(a), e.consume(k), e.exit(a), e.exit(i), n) : $n(k) ? (e.enter("lineEnding"), e.consume(k), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(k));
  }
  function f(k) {
    return k === null || k === 91 || k === 93 || $n(k) || l++ > 999 ? (e.exit("chunkString"), u(k)) : (e.consume(k), d || (d = !Xn(k)), k === 92 ? h : f);
  }
  function h(k) {
    return k === 91 || k === 92 || k === 93 ? (e.consume(k), l++, f) : f(k);
  }
}
function x1(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : $n(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), ct(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || $n(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function So(e, n) {
  let r;
  return i;
  function i(a) {
    return $n(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : Xn(a) ? ct(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const iz = {
  name: "definition",
  tokenize: oz
}, az = {
  partial: !0,
  tokenize: sz
};
function oz(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(k) {
    return e.enter("definition"), s(k);
  }
  function s(k) {
    return b1.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(k);
  }
  function l(k) {
    return a = ma(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), k === 58 ? (e.enter("definitionMarker"), e.consume(k), e.exit("definitionMarker"), d) : r(k);
  }
  function d(k) {
    return nr(k) ? So(e, m)(k) : m(k);
  }
  function m(k) {
    return k1(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(k);
  }
  function u(k) {
    return e.attempt(az, f, f)(k);
  }
  function f(k) {
    return Xn(k) ? ct(e, h, "whitespace")(k) : h(k);
  }
  function h(k) {
    return k === null || $n(k) ? (e.exit("definition"), i.parser.defined.push(a), n(k)) : r(k);
  }
}
function sz(e, n, r) {
  return i;
  function i(l) {
    return nr(l) ? So(e, a)(l) : r(l);
  }
  function a(l) {
    return x1(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return Xn(l) ? ct(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || $n(l) ? n(l) : r(l);
  }
}
const lz = {
  name: "hardBreakEscape",
  tokenize: cz
};
function cz(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return $n(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const dz = {
  name: "headingAtx",
  resolve: uz,
  tokenize: mz
};
function uz(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Hr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function mz(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || nr(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || $n(u) ? (e.exit("atxHeading"), n(u)) : Xn(u) ? ct(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || nr(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const pz = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], w_ = ["pre", "script", "style", "textarea"], fz = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: gz,
  tokenize: vz
}, hz = {
  partial: !0,
  tokenize: bz
}, yz = {
  partial: !0,
  tokenize: kz
};
function gz(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function vz(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(H) {
    return u(H);
  }
  function u(H) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(H), f;
  }
  function f(H) {
    return H === 33 ? (e.consume(H), h) : H === 47 ? (e.consume(H), o = !0, j) : H === 63 ? (e.consume(H), a = 3, i.interrupt ? n : z) : zr(H) ? (e.consume(H), s = String.fromCharCode(H), N) : r(H);
  }
  function h(H) {
    return H === 45 ? (e.consume(H), a = 2, k) : H === 91 ? (e.consume(H), a = 5, l = 0, F) : zr(H) ? (e.consume(H), a = 4, i.interrupt ? n : z) : r(H);
  }
  function k(H) {
    return H === 45 ? (e.consume(H), i.interrupt ? n : z) : r(H);
  }
  function F(H) {
    const Ge = "CDATA[";
    return H === Ge.charCodeAt(l++) ? (e.consume(H), l === Ge.length ? i.interrupt ? n : J : F) : r(H);
  }
  function j(H) {
    return zr(H) ? (e.consume(H), s = String.fromCharCode(H), N) : r(H);
  }
  function N(H) {
    if (H === null || H === 47 || H === 62 || nr(H)) {
      const Ge = H === 47, sn = s.toLowerCase();
      return !Ge && !o && w_.includes(sn) ? (a = 1, i.interrupt ? n(H) : J(H)) : pz.includes(s.toLowerCase()) ? (a = 6, Ge ? (e.consume(H), x) : i.interrupt ? n(H) : J(H)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(H) : o ? g(H) : D(H));
    }
    return H === 45 || cr(H) ? (e.consume(H), s += String.fromCharCode(H), N) : r(H);
  }
  function x(H) {
    return H === 62 ? (e.consume(H), i.interrupt ? n : J) : r(H);
  }
  function g(H) {
    return Xn(H) ? (e.consume(H), g) : te(H);
  }
  function D(H) {
    return H === 47 ? (e.consume(H), te) : H === 58 || H === 95 || zr(H) ? (e.consume(H), I) : Xn(H) ? (e.consume(H), D) : te(H);
  }
  function I(H) {
    return H === 45 || H === 46 || H === 58 || H === 95 || cr(H) ? (e.consume(H), I) : C(H);
  }
  function C(H) {
    return H === 61 ? (e.consume(H), w) : Xn(H) ? (e.consume(H), C) : D(H);
  }
  function w(H) {
    return H === null || H === 60 || H === 61 || H === 62 || H === 96 ? r(H) : H === 34 || H === 39 ? (e.consume(H), d = H, A) : Xn(H) ? (e.consume(H), w) : q(H);
  }
  function A(H) {
    return H === d ? (e.consume(H), d = null, Y) : H === null || $n(H) ? r(H) : (e.consume(H), A);
  }
  function q(H) {
    return H === null || H === 34 || H === 39 || H === 47 || H === 60 || H === 61 || H === 62 || H === 96 || nr(H) ? C(H) : (e.consume(H), q);
  }
  function Y(H) {
    return H === 47 || H === 62 || Xn(H) ? D(H) : r(H);
  }
  function te(H) {
    return H === 62 ? (e.consume(H), K) : r(H);
  }
  function K(H) {
    return H === null || $n(H) ? J(H) : Xn(H) ? (e.consume(H), K) : r(H);
  }
  function J(H) {
    return H === 45 && a === 2 ? (e.consume(H), Ne) : H === 60 && a === 1 ? (e.consume(H), ue) : H === 62 && a === 4 ? (e.consume(H), ke) : H === 63 && a === 3 ? (e.consume(H), z) : H === 93 && a === 5 ? (e.consume(H), pe) : $n(H) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(hz, $e, R)(H)) : H === null || $n(H) ? (e.exit("htmlFlowData"), R(H)) : (e.consume(H), J);
  }
  function R(H) {
    return e.check(yz, B, $e)(H);
  }
  function B(H) {
    return e.enter("lineEnding"), e.consume(H), e.exit("lineEnding"), ne;
  }
  function ne(H) {
    return H === null || $n(H) ? R(H) : (e.enter("htmlFlowData"), J(H));
  }
  function Ne(H) {
    return H === 45 ? (e.consume(H), z) : J(H);
  }
  function ue(H) {
    return H === 47 ? (e.consume(H), s = "", oe) : J(H);
  }
  function oe(H) {
    if (H === 62) {
      const Ge = s.toLowerCase();
      return w_.includes(Ge) ? (e.consume(H), ke) : J(H);
    }
    return zr(H) && s.length < 8 ? (e.consume(H), s += String.fromCharCode(H), oe) : J(H);
  }
  function pe(H) {
    return H === 93 ? (e.consume(H), z) : J(H);
  }
  function z(H) {
    return H === 62 ? (e.consume(H), ke) : H === 45 && a === 2 ? (e.consume(H), z) : J(H);
  }
  function ke(H) {
    return H === null || $n(H) ? (e.exit("htmlFlowData"), $e(H)) : (e.consume(H), ke);
  }
  function $e(H) {
    return e.exit("htmlFlow"), n(H);
  }
}
function kz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return $n(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function bz(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(zl, n, r);
  }
}
const xz = {
  name: "htmlText",
  tokenize: _z
};
function _z(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(z) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(z), d;
  }
  function d(z) {
    return z === 33 ? (e.consume(z), m) : z === 47 ? (e.consume(z), C) : z === 63 ? (e.consume(z), D) : zr(z) ? (e.consume(z), q) : r(z);
  }
  function m(z) {
    return z === 45 ? (e.consume(z), u) : z === 91 ? (e.consume(z), o = 0, F) : zr(z) ? (e.consume(z), g) : r(z);
  }
  function u(z) {
    return z === 45 ? (e.consume(z), k) : r(z);
  }
  function f(z) {
    return z === null ? r(z) : z === 45 ? (e.consume(z), h) : $n(z) ? (s = f, ue(z)) : (e.consume(z), f);
  }
  function h(z) {
    return z === 45 ? (e.consume(z), k) : f(z);
  }
  function k(z) {
    return z === 62 ? Ne(z) : z === 45 ? h(z) : f(z);
  }
  function F(z) {
    const ke = "CDATA[";
    return z === ke.charCodeAt(o++) ? (e.consume(z), o === ke.length ? j : F) : r(z);
  }
  function j(z) {
    return z === null ? r(z) : z === 93 ? (e.consume(z), N) : $n(z) ? (s = j, ue(z)) : (e.consume(z), j);
  }
  function N(z) {
    return z === 93 ? (e.consume(z), x) : j(z);
  }
  function x(z) {
    return z === 62 ? Ne(z) : z === 93 ? (e.consume(z), x) : j(z);
  }
  function g(z) {
    return z === null || z === 62 ? Ne(z) : $n(z) ? (s = g, ue(z)) : (e.consume(z), g);
  }
  function D(z) {
    return z === null ? r(z) : z === 63 ? (e.consume(z), I) : $n(z) ? (s = D, ue(z)) : (e.consume(z), D);
  }
  function I(z) {
    return z === 62 ? Ne(z) : D(z);
  }
  function C(z) {
    return zr(z) ? (e.consume(z), w) : r(z);
  }
  function w(z) {
    return z === 45 || cr(z) ? (e.consume(z), w) : A(z);
  }
  function A(z) {
    return $n(z) ? (s = A, ue(z)) : Xn(z) ? (e.consume(z), A) : Ne(z);
  }
  function q(z) {
    return z === 45 || cr(z) ? (e.consume(z), q) : z === 47 || z === 62 || nr(z) ? Y(z) : r(z);
  }
  function Y(z) {
    return z === 47 ? (e.consume(z), Ne) : z === 58 || z === 95 || zr(z) ? (e.consume(z), te) : $n(z) ? (s = Y, ue(z)) : Xn(z) ? (e.consume(z), Y) : Ne(z);
  }
  function te(z) {
    return z === 45 || z === 46 || z === 58 || z === 95 || cr(z) ? (e.consume(z), te) : K(z);
  }
  function K(z) {
    return z === 61 ? (e.consume(z), J) : $n(z) ? (s = K, ue(z)) : Xn(z) ? (e.consume(z), K) : Y(z);
  }
  function J(z) {
    return z === null || z === 60 || z === 61 || z === 62 || z === 96 ? r(z) : z === 34 || z === 39 ? (e.consume(z), a = z, R) : $n(z) ? (s = J, ue(z)) : Xn(z) ? (e.consume(z), J) : (e.consume(z), B);
  }
  function R(z) {
    return z === a ? (e.consume(z), a = void 0, ne) : z === null ? r(z) : $n(z) ? (s = R, ue(z)) : (e.consume(z), R);
  }
  function B(z) {
    return z === null || z === 34 || z === 39 || z === 60 || z === 61 || z === 96 ? r(z) : z === 47 || z === 62 || nr(z) ? Y(z) : (e.consume(z), B);
  }
  function ne(z) {
    return z === 47 || z === 62 || nr(z) ? Y(z) : r(z);
  }
  function Ne(z) {
    return z === 62 ? (e.consume(z), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(z);
  }
  function ue(z) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(z), e.exit("lineEnding"), oe;
  }
  function oe(z) {
    return Xn(z) ? ct(e, pe, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(z) : pe(z);
  }
  function pe(z) {
    return e.enter("htmlTextData"), s(z);
  }
}
const ug = {
  name: "labelEnd",
  resolveAll: wz,
  resolveTo: Cz,
  tokenize: Fz
}, Sz = {
  tokenize: Iz
}, Nz = {
  tokenize: Ez
}, jz = {
  tokenize: $z
};
function wz(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Hr(e, 0, e.length, r), e;
}
function Cz(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = br(l, e.slice(o + 1, o + i + 3)), l = br(l, [["enter", u, n]]), l = br(l, dg(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = br(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = br(l, e.slice(s + 1)), l = br(l, [["exit", d, n]]), Hr(e, o, e.length, l), e;
}
function Fz(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(ma(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(Sz, u, s ? u : f)(h) : h === 91 ? e.attempt(Nz, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(jz, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function Iz(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return nr(f) ? So(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : k1(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return nr(f) ? So(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? x1(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return nr(f) ? So(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function Ez(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return b1.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(ma(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function $z(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const Tz = {
  name: "labelStartImage",
  resolveAll: ug.resolveAll,
  tokenize: Oz
};
function Oz(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const Dz = {
  name: "labelStartLink",
  resolveAll: ug.resolveAll,
  tokenize: Pz
};
function Pz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const am = {
  name: "lineEnding",
  tokenize: Rz
};
function Rz(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), ct(e, n, "linePrefix");
  }
}
const Bs = {
  name: "thematicBreak",
  tokenize: Az
};
function Az(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || $n(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), Xn(m) ? ct(e, l, "whitespace")(m) : l(m));
  }
}
const Zt = {
  continuation: {
    tokenize: Uz
  },
  exit: Bz,
  name: "list",
  tokenize: zz
}, Lz = {
  partial: !0,
  tokenize: qz
}, Vz = {
  partial: !0,
  tokenize: Mz
};
function zz(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(k) {
    const F = i.containerState.type || (k === 42 || k === 43 || k === 45 ? "listUnordered" : "listOrdered");
    if (F === "listUnordered" ? !i.containerState.marker || k === i.containerState.marker : Hh(k)) {
      if (i.containerState.type || (i.containerState.type = F, e.enter(F, {
        _container: !0
      })), F === "listUnordered")
        return e.enter("listItemPrefix"), k === 42 || k === 45 ? e.check(Bs, r, m)(k) : m(k);
      if (!i.interrupt || k === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(k);
    }
    return r(k);
  }
  function d(k) {
    return Hh(k) && ++s < 10 ? (e.consume(k), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? k === i.containerState.marker : k === 41 || k === 46) ? (e.exit("listItemValue"), m(k)) : r(k);
  }
  function m(k) {
    return e.enter("listItemMarker"), e.consume(k), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || k, e.check(
      zl,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(Lz, h, f)
    );
  }
  function u(k) {
    return i.containerState.initialBlankLine = !0, o++, h(k);
  }
  function f(k) {
    return Xn(k) ? (e.enter("listItemPrefixWhitespace"), e.consume(k), e.exit("listItemPrefixWhitespace"), h) : r(k);
  }
  function h(k) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(k);
  }
}
function Uz(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(zl, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, ct(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !Xn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(Vz, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, ct(e, e.attempt(Zt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function Mz(e, n, r) {
  const i = this;
  return ct(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function Bz(e) {
  e.exit(this.containerState.type);
}
function qz(e, n, r) {
  const i = this;
  return ct(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !Xn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const C_ = {
  name: "setextUnderline",
  resolveTo: Hz,
  tokenize: Wz
};
function Hz(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function Wz(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), Xn(m) ? ct(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || $n(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const Kz = {
  tokenize: Gz
};
function Gz(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    zl,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, ct(e, e.attempt(this.parser.constructs.flow, a, e.attempt(Z3, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const Yz = {
  resolveAll: S1()
}, Jz = _1("string"), Qz = _1("text");
function _1(e) {
  return {
    resolveAll: S1(e === "text" ? Xz : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const k = f[h];
          if (!k.previous || k.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function S1(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function Xz(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const Zz = {
  42: Zt,
  43: Zt,
  45: Zt,
  48: Zt,
  49: Zt,
  50: Zt,
  51: Zt,
  52: Zt,
  53: Zt,
  54: Zt,
  55: Zt,
  56: Zt,
  57: Zt,
  62: h1
}, eU = {
  91: iz
}, nU = {
  [-2]: im,
  [-1]: im,
  32: im
}, tU = {
  35: dz,
  42: Bs,
  45: [C_, Bs],
  60: fz,
  61: C_,
  95: Bs,
  96: j_,
  126: j_
}, rU = {
  38: g1,
  92: y1
}, iU = {
  [-5]: am,
  [-4]: am,
  [-3]: am,
  33: Tz,
  38: g1,
  42: Wh,
  60: [D3, xz],
  91: Dz,
  92: [lz, y1],
  93: ug,
  95: Wh,
  96: K3
}, aU = {
  null: [Wh, Yz]
}, oU = {
  null: [42, 95]
}, sU = {
  null: []
}, lU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: oU,
  contentInitial: eU,
  disable: sU,
  document: Zz,
  flow: tU,
  flowInitial: nU,
  insideSpan: aU,
  string: rU,
  text: iU
}, Symbol.toStringTag, { value: "Module" }));
function cU(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: A(C),
    check: A(w),
    consume: g,
    enter: D,
    exit: I,
    interrupt: A(w, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: j,
    events: [],
    now: F,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: k,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(K) {
    return s = br(s, K), N(), s[s.length - 1] !== null ? [] : (q(n, 0), m.events = dg(o, m.events, m), m.events);
  }
  function h(K, J) {
    return uU(k(K), J);
  }
  function k(K) {
    return dU(s, K);
  }
  function F() {
    const {
      _bufferIndex: K,
      _index: J,
      line: R,
      column: B,
      offset: ne
    } = i;
    return {
      _bufferIndex: K,
      _index: J,
      line: R,
      column: B,
      offset: ne
    };
  }
  function j(K) {
    a[K.line] = K.column, te();
  }
  function N() {
    let K;
    for (; i._index < s.length; ) {
      const J = s[i._index];
      if (typeof J == "string")
        for (K = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === K && i._bufferIndex < J.length; )
          x(J.charCodeAt(i._bufferIndex));
      else
        x(J);
    }
  }
  function x(K) {
    u = u(K);
  }
  function g(K) {
    $n(K) ? (i.line++, i.column = 1, i.offset += K === -3 ? 2 : 1, te()) : K !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = K;
  }
  function D(K, J) {
    const R = J || {};
    return R.type = K, R.start = F(), m.events.push(["enter", R, m]), l.push(R), R;
  }
  function I(K) {
    const J = l.pop();
    return J.end = F(), m.events.push(["exit", J, m]), J;
  }
  function C(K, J) {
    q(K, J.from);
  }
  function w(K, J) {
    J.restore();
  }
  function A(K, J) {
    return R;
    function R(B, ne, Ne) {
      let ue, oe, pe, z;
      return Array.isArray(B) ? (
        /* c8 ignore next 1 */
        $e(B)
      ) : "tokenize" in B ? (
        // Looks like a construct.
        $e([
          /** @type {Construct} */
          B
        ])
      ) : ke(B);
      function ke(Fe) {
        return Ue;
        function Ue(Pe) {
          const Be = Pe !== null && Fe[Pe], Ae = Pe !== null && Fe.null, Qe = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Be) ? Be : Be ? [Be] : [],
            ...Array.isArray(Ae) ? Ae : Ae ? [Ae] : []
          ];
          return $e(Qe)(Pe);
        }
      }
      function $e(Fe) {
        return ue = Fe, oe = 0, Fe.length === 0 ? Ne : H(Fe[oe]);
      }
      function H(Fe) {
        return Ue;
        function Ue(Pe) {
          return z = Y(), pe = Fe, Fe.partial || (m.currentConstruct = Fe), Fe.name && m.parser.constructs.disable.null.includes(Fe.name) ? sn() : Fe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            J ? Object.assign(Object.create(m), J) : m,
            d,
            Ge,
            sn
          )(Pe);
        }
      }
      function Ge(Fe) {
        return K(pe, z), ne;
      }
      function sn(Fe) {
        return z.restore(), ++oe < ue.length ? H(ue[oe]) : Ne;
      }
    }
  }
  function q(K, J) {
    K.resolveAll && !o.includes(K) && o.push(K), K.resolve && Hr(m.events, J, m.events.length - J, K.resolve(m.events.slice(J), m)), K.resolveTo && (m.events = K.resolveTo(m.events, m));
  }
  function Y() {
    const K = F(), J = m.previous, R = m.currentConstruct, B = m.events.length, ne = Array.from(l);
    return {
      from: B,
      restore: Ne
    };
    function Ne() {
      i = K, m.previous = J, m.currentConstruct = R, m.events.length = B, l = ne, te();
    }
  }
  function te() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function dU(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function uU(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function mU(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      k3([lU, ...(e || {}).extensions || []])
    ),
    content: a(C3),
    defined: [],
    document: a(I3),
    flow: a(Kz),
    lazy: {},
    string: a(Jz),
    text: a(Qz)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return cU(i, o, l);
    }
  }
}
function pU(e) {
  for (; !v1(e); )
    ;
  return e;
}
const F_ = /[\0\t\n\r]/g;
function fU() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, k;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (F_.lastIndex = f, m = F_.exec(o), h = m && m.index !== void 0 ? m.index : o.length, k = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (k === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), k) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const hU = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function yU(e) {
  return e.replace(hU, gU);
}
function gU(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return f1(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return cg(r) || e;
}
const N1 = {}.hasOwnProperty;
function vU(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), kU(r)(pU(mU(r).document().write(fU()(e, n, !0))));
}
function kU(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Re),
      autolinkProtocol: Y,
      autolinkEmail: Y,
      atxHeading: o(le),
      blockQuote: o(Ae),
      characterEscape: Y,
      characterReference: Y,
      codeFenced: o(Qe),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(Qe, s),
      codeText: o(Ce, s),
      codeTextData: Y,
      data: Y,
      codeFlowValue: Y,
      definition: o(Me),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(nn),
      hardBreakEscape: o(ce),
      hardBreakTrailing: o(ce),
      htmlFlow: o(Se, s),
      htmlFlowData: Y,
      htmlText: o(Se, s),
      htmlTextData: Y,
      image: o(Le),
      label: s,
      link: o(Re),
      listItem: o(Q),
      listItemValue: h,
      listOrdered: o(gn, f),
      listUnordered: o(gn),
      paragraph: o(T),
      reference: H,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(le),
      strong: o(U),
      thematicBreak: o(ae)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: C,
      autolink: d(),
      autolinkEmail: Be,
      autolinkProtocol: Pe,
      blockQuote: d(),
      characterEscapeValue: te,
      characterReferenceMarkerHexadecimal: sn,
      characterReferenceMarkerNumeric: sn,
      characterReferenceValue: Fe,
      characterReference: Ue,
      codeFenced: d(N),
      codeFencedFence: j,
      codeFencedFenceInfo: k,
      codeFencedFenceMeta: F,
      codeFlowValue: te,
      codeIndented: d(x),
      codeText: d(ne),
      codeTextData: te,
      data: te,
      definition: d(),
      definitionDestinationString: I,
      definitionLabelString: g,
      definitionTitleString: D,
      emphasis: d(),
      hardBreakEscape: d(J),
      hardBreakTrailing: d(J),
      htmlFlow: d(R),
      htmlFlowData: te,
      htmlText: d(B),
      htmlTextData: te,
      image: d(ue),
      label: pe,
      labelText: oe,
      lineEnding: K,
      link: d(Ne),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: Ge,
      resourceDestinationString: z,
      resourceTitleString: ke,
      resource: $e,
      setextHeading: d(q),
      setextHeadingLineSequence: A,
      setextHeadingText: w,
      strong: d(),
      thematicBreak: d()
    }
  };
  j1(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(V) {
    let G = {
      type: "root",
      children: []
    };
    const fe = {
      stack: [G],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, _e = [];
    let Te = -1;
    for (; ++Te < V.length; )
      if (V[Te][1].type === "listOrdered" || V[Te][1].type === "listUnordered")
        if (V[Te][0] === "enter")
          _e.push(Te);
        else {
          const tn = _e.pop();
          Te = a(V, tn, Te);
        }
    for (Te = -1; ++Te < V.length; ) {
      const tn = n[V[Te][0]];
      N1.call(tn, V[Te][1].type) && tn[V[Te][1].type].call(Object.assign({
        sliceSerialize: V[Te][2].sliceSerialize
      }, fe), V[Te][1]);
    }
    if (fe.tokenStack.length > 0) {
      const tn = fe.tokenStack[fe.tokenStack.length - 1];
      (tn[1] || I_).call(fe, void 0, tn[0]);
    }
    for (G.position = {
      start: si(V.length > 0 ? V[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: si(V.length > 0 ? V[V.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Te = -1; ++Te < n.transforms.length; )
      G = n.transforms[Te](G) || G;
    return G;
  }
  function a(V, G, fe) {
    let _e = G - 1, Te = -1, tn = !1, vn, on, pn, In;
    for (; ++_e <= fe; ) {
      const _n = V[_e];
      switch (_n[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          _n[0] === "enter" ? Te++ : Te--, In = void 0;
          break;
        }
        case "lineEndingBlank": {
          _n[0] === "enter" && (vn && !In && !Te && !pn && (pn = _e), In = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          In = void 0;
      }
      if (!Te && _n[0] === "enter" && _n[1].type === "listItemPrefix" || Te === -1 && _n[0] === "exit" && (_n[1].type === "listUnordered" || _n[1].type === "listOrdered")) {
        if (vn) {
          let En = _e;
          for (on = void 0; En--; ) {
            const en = V[En];
            if (en[1].type === "lineEnding" || en[1].type === "lineEndingBlank") {
              if (en[0] === "exit") continue;
              on && (V[on][1].type = "lineEndingBlank", tn = !0), en[1].type = "lineEnding", on = En;
            } else if (!(en[1].type === "linePrefix" || en[1].type === "blockQuotePrefix" || en[1].type === "blockQuotePrefixWhitespace" || en[1].type === "blockQuoteMarker" || en[1].type === "listItemIndent")) break;
          }
          pn && (!on || pn < on) && (vn._spread = !0), vn.end = Object.assign({}, on ? V[on][1].start : _n[1].end), V.splice(on || _e, 0, ["exit", vn, _n[2]]), _e++, fe++;
        }
        if (_n[1].type === "listItemPrefix") {
          const En = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, _n[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          vn = En, V.splice(_e, 0, ["enter", En, _n[2]]), _e++, fe++, pn = void 0, In = !0;
        }
      }
    }
    return V[G][1]._spread = tn, fe;
  }
  function o(V, G) {
    return fe;
    function fe(_e) {
      l.call(this, V(_e), _e), G && G.call(this, _e);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(V, G, fe) {
    this.stack[this.stack.length - 1].children.push(V), this.stack.push(V), this.tokenStack.push([G, fe || void 0]), V.position = {
      start: si(G.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(V) {
    return G;
    function G(fe) {
      V && V.call(this, fe), m.call(this, fe);
    }
  }
  function m(V, G) {
    const fe = this.stack.pop(), _e = this.tokenStack.pop();
    if (_e)
      _e[0].type !== V.type && (G ? G.call(this, V, _e[0]) : (_e[1] || I_).call(this, V, _e[0]));
    else throw new Error("Cannot close `" + V.type + "` (" + _o({
      start: V.start,
      end: V.end
    }) + "): it’s not open");
    fe.position.end = si(V.end);
  }
  function u() {
    return g3(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(V) {
    if (this.data.expectingFirstListItemValue) {
      const G = this.stack[this.stack.length - 2];
      G.start = Number.parseInt(this.sliceSerialize(V), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function k() {
    const V = this.resume(), G = this.stack[this.stack.length - 1];
    G.lang = V;
  }
  function F() {
    const V = this.resume(), G = this.stack[this.stack.length - 1];
    G.meta = V;
  }
  function j() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function N() {
    const V = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = V.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function x() {
    const V = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = V.replace(/(\r?\n|\r)$/g, "");
  }
  function g(V) {
    const G = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.label = G, fe.identifier = ma(this.sliceSerialize(V)).toLowerCase();
  }
  function D() {
    const V = this.resume(), G = this.stack[this.stack.length - 1];
    G.title = V;
  }
  function I() {
    const V = this.resume(), G = this.stack[this.stack.length - 1];
    G.url = V;
  }
  function C(V) {
    const G = this.stack[this.stack.length - 1];
    if (!G.depth) {
      const fe = this.sliceSerialize(V).length;
      G.depth = fe;
    }
  }
  function w() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function A(V) {
    const G = this.stack[this.stack.length - 1];
    G.depth = this.sliceSerialize(V).codePointAt(0) === 61 ? 1 : 2;
  }
  function q() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Y(V) {
    const fe = this.stack[this.stack.length - 1].children;
    let _e = fe[fe.length - 1];
    (!_e || _e.type !== "text") && (_e = X(), _e.position = {
      start: si(V.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, fe.push(_e)), this.stack.push(_e);
  }
  function te(V) {
    const G = this.stack.pop();
    G.value += this.sliceSerialize(V), G.position.end = si(V.end);
  }
  function K(V) {
    const G = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const fe = G.children[G.children.length - 1];
      fe.position.end = si(V.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(G.type) && (Y.call(this, V), te.call(this, V));
  }
  function J() {
    this.data.atHardBreak = !0;
  }
  function R() {
    const V = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = V;
  }
  function B() {
    const V = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = V;
  }
  function ne() {
    const V = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = V;
  }
  function Ne() {
    const V = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const G = this.data.referenceType || "shortcut";
      V.type += "Reference", V.referenceType = G, delete V.url, delete V.title;
    } else
      delete V.identifier, delete V.label;
    this.data.referenceType = void 0;
  }
  function ue() {
    const V = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const G = this.data.referenceType || "shortcut";
      V.type += "Reference", V.referenceType = G, delete V.url, delete V.title;
    } else
      delete V.identifier, delete V.label;
    this.data.referenceType = void 0;
  }
  function oe(V) {
    const G = this.sliceSerialize(V), fe = this.stack[this.stack.length - 2];
    fe.label = yU(G), fe.identifier = ma(G).toLowerCase();
  }
  function pe() {
    const V = this.stack[this.stack.length - 1], G = this.resume(), fe = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, fe.type === "link") {
      const _e = V.children;
      fe.children = _e;
    } else
      fe.alt = G;
  }
  function z() {
    const V = this.resume(), G = this.stack[this.stack.length - 1];
    G.url = V;
  }
  function ke() {
    const V = this.resume(), G = this.stack[this.stack.length - 1];
    G.title = V;
  }
  function $e() {
    this.data.inReference = void 0;
  }
  function H() {
    this.data.referenceType = "collapsed";
  }
  function Ge(V) {
    const G = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.label = G, fe.identifier = ma(this.sliceSerialize(V)).toLowerCase(), this.data.referenceType = "full";
  }
  function sn(V) {
    this.data.characterReferenceType = V.type;
  }
  function Fe(V) {
    const G = this.sliceSerialize(V), fe = this.data.characterReferenceType;
    let _e;
    fe ? (_e = f1(G, fe === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : _e = cg(G);
    const Te = this.stack[this.stack.length - 1];
    Te.value += _e;
  }
  function Ue(V) {
    const G = this.stack.pop();
    G.position.end = si(V.end);
  }
  function Pe(V) {
    te.call(this, V);
    const G = this.stack[this.stack.length - 1];
    G.url = this.sliceSerialize(V);
  }
  function Be(V) {
    te.call(this, V);
    const G = this.stack[this.stack.length - 1];
    G.url = "mailto:" + this.sliceSerialize(V);
  }
  function Ae() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Qe() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ce() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Me() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function nn() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function le() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function ce() {
    return {
      type: "break"
    };
  }
  function Se() {
    return {
      type: "html",
      value: ""
    };
  }
  function Le() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Re() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function gn(V) {
    return {
      type: "list",
      ordered: V.type === "listOrdered",
      start: null,
      spread: V._spread,
      children: []
    };
  }
  function Q(V) {
    return {
      type: "listItem",
      spread: V._spread,
      checked: null,
      children: []
    };
  }
  function T() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function U() {
    return {
      type: "strong",
      children: []
    };
  }
  function X() {
    return {
      type: "text",
      value: ""
    };
  }
  function ae() {
    return {
      type: "thematicBreak"
    };
  }
}
function si(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function j1(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? j1(e, i) : bU(e, i);
  }
}
function bU(e, n) {
  let r;
  for (r in n)
    if (N1.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function I_(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + _o({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + _o({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + _o({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function xU(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return vU(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function _U(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function SU(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function NU(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function jU(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function wU(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function CU(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Ia(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function FU(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function IU(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function w1(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function EU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return w1(e, n);
  const a = { src: Ia(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function $U(e, n) {
  const r = { src: Ia(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function TU(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function OU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return w1(e, n);
  const a = { href: Ia(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function DU(e, n) {
  const r = { href: Ia(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function PU(e, n, r) {
  const i = e.all(n), a = r ? RU(r) : C1(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function RU(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = C1(r[i]);
  }
  return n;
}
function C1(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function AU(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function LU(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function VU(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function zU(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function UU(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = ag(n.children[1]), d = s1(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function MU(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, k = s ? s[d] : void 0;
    k && (h.align = k);
    let F = { type: "element", tagName: o, properties: h, children: [] };
    f && (F.children = e.all(f), e.patch(f, F), F = e.applyData(f, F)), m.push(F);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function BU(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const E_ = 9, $_ = 32;
function qU(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      T_(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(T_(n.slice(a), a > 0, !1)), o.join("");
}
function T_(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === E_ || o === $_; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === E_ || o === $_; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function HU(e, n) {
  const r = { type: "text", value: qU(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function WU(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const KU = {
  blockquote: _U,
  break: SU,
  code: NU,
  delete: jU,
  emphasis: wU,
  footnoteReference: CU,
  heading: FU,
  html: IU,
  imageReference: EU,
  image: $U,
  inlineCode: TU,
  linkReference: OU,
  link: DU,
  listItem: PU,
  list: AU,
  paragraph: LU,
  // @ts-expect-error: root is different, but hard to type.
  root: VU,
  strong: zU,
  table: UU,
  tableCell: BU,
  tableRow: MU,
  text: HU,
  thematicBreak: WU,
  toml: ls,
  yaml: ls,
  definition: ls,
  footnoteDefinition: ls
};
function ls() {
}
const F1 = -1, Ul = 0, ll = 1, cl = 2, mg = 3, pg = 4, fg = 5, hg = 6, I1 = 7, E1 = 8, O_ = typeof self == "object" ? self : globalThis, GU = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Ul:
      case F1:
        return r(s, a);
      case ll: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case cl: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case mg:
        return r(new Date(s), a);
      case pg: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case fg: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case hg: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case I1: {
        const { name: l, message: d } = s;
        return r(new O_[l](d), a);
      }
      case E1:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new O_[o](s), a);
  };
  return i;
}, D_ = (e) => GU(/* @__PURE__ */ new Map(), e)(0), Xi = "", { toString: YU } = {}, { keys: JU } = Object, Ja = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Ul, n];
  const r = YU.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [ll, Xi];
    case "Object":
      return [cl, Xi];
    case "Date":
      return [mg, Xi];
    case "RegExp":
      return [pg, Xi];
    case "Map":
      return [fg, Xi];
    case "Set":
      return [hg, Xi];
  }
  return r.includes("Array") ? [ll, r] : r.includes("Error") ? [I1, r] : [cl, r];
}, cs = ([e, n]) => e === Ul && (n === "function" || n === "symbol"), QU = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = Ja(s);
    switch (l) {
      case Ul: {
        let u = s;
        switch (d) {
          case "bigint":
            l = E1, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([F1], s);
        }
        return a([l, u], s);
      }
      case ll: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case cl: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of JU(s))
          (e || !cs(Ja(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case mg:
        return a([l, s.toISOString()], s);
      case pg: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case fg: {
        const u = [], f = a([l, u], s);
        for (const [h, k] of s)
          (e || !(cs(Ja(h)) || cs(Ja(k)))) && u.push([o(h), o(k)]);
        return f;
      }
      case hg: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !cs(Ja(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, P_ = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return QU(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, dl = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? D_(P_(e, n)) : structuredClone(e)
) : (e, n) => D_(P_(e, n));
function XU(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function ZU(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function eM(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || XU, i = e.options.footnoteBackLabel || ZU, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = Ia(f.toLowerCase());
    let k = 0;
    const F = [], j = e.footnoteCounts.get(f);
    for (; j !== void 0 && ++k <= j; ) {
      F.length > 0 && F.push({ type: "text", value: " " });
      let g = typeof r == "string" ? r : r(d, k);
      typeof g == "string" && (g = { type: "text", value: g }), F.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (k > 1 ? "-" + k : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, k),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(g) ? g : [g]
      });
    }
    const N = u[u.length - 1];
    if (N && N.type === "element" && N.tagName === "p") {
      const g = N.children[N.children.length - 1];
      g && g.type === "text" ? g.value += " " : N.children.push({ type: "text", value: " " }), N.children.push(...F);
    } else
      u.push(...F);
    const x = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, x), l.push(x);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...dl(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const $1 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return iM;
    if (typeof e == "function")
      return Ml(e);
    if (typeof e == "object")
      return Array.isArray(e) ? nM(e) : tM(e);
    if (typeof e == "string")
      return rM(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function nM(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = $1(e[r]);
  return Ml(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function tM(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Ml(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function rM(e) {
  return Ml(n);
  function n(r) {
    return r && r.type === e;
  }
}
function Ml(e) {
  return n;
  function n(r, i, a) {
    return !!(aM(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function iM() {
  return !0;
}
function aM(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const T1 = [], oM = !0, R_ = !1, sM = "skip";
function lM(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = $1(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const k = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (k ? "<" + k + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let k = T1, F, j, N;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (k = cM(r(d, u)), k[0] === R_))
        return k;
      if ("children" in d && d.children) {
        const x = (
          /** @type {UnistParent} */
          d
        );
        if (x.children && k[0] !== sM)
          for (j = (i ? x.children.length : -1) + s, N = u.concat(x); j > -1 && j < x.children.length; ) {
            const g = x.children[j];
            if (F = l(g, j, N)(), F[0] === R_)
              return F;
            j = typeof F[1] == "number" ? F[1] : j + s;
          }
      }
      return k;
    }
  }
}
function cM(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [oM, e] : e == null ? T1 : [e];
}
function O1(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), lM(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const Kh = {}.hasOwnProperty, dM = {};
function uM(e, n) {
  const r = n || dM, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...KU, ...r.handlers }, l = {
    all: m,
    applyData: pM,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: mM,
    wrap: hM
  };
  return O1(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, k = l.handlers[h];
    if (Kh.call(l.handlers, h) && k)
      return k(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: j, ...N } = u, x = dl(N);
        return x.children = l.all(u), x;
      }
      return dl(u);
    }
    return (l.options.unknownHandler || fM)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let k = -1;
      for (; ++k < h.length; ) {
        const F = l.one(h[k], u);
        if (F) {
          if (k && h[k - 1].type === "break" && (!Array.isArray(F) && F.type === "text" && (F.value = A_(F.value)), !Array.isArray(F) && F.type === "element")) {
            const j = F.children[0];
            j && j.type === "text" && (j.value = A_(j.value));
          }
          Array.isArray(F) ? f.push(...F) : f.push(F);
        }
      }
    }
    return f;
  }
}
function mM(e, n) {
  e.position && (n.position = KV(e));
}
function pM(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, dl(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function fM(e, n) {
  const r = n.data || {}, i = "value" in n && !(Kh.call(r, "hProperties") || Kh.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function hM(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function A_(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function L_(e, n) {
  const r = uM(e, n), i = r.one(e, void 0), a = eM(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function yM(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      L_(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      L_(r, { file: i, ...e || n })
    );
  };
}
function V_(e) {
  if (e)
    throw e;
}
var om, z_;
function gM() {
  if (z_) return om;
  z_ = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return om = function d() {
    var m, u, f, h, k, F, j = arguments[0], N = 1, x = arguments.length, g = !1;
    for (typeof j == "boolean" && (g = j, j = arguments[1] || {}, N = 2), (j == null || typeof j != "object" && typeof j != "function") && (j = {}); N < x; ++N)
      if (m = arguments[N], m != null)
        for (u in m)
          f = l(j, u), h = l(m, u), j !== h && (g && h && (o(h) || (k = a(h))) ? (k ? (k = !1, F = f && a(f) ? f : []) : F = f && o(f) ? f : {}, s(j, { name: u, newValue: d(g, F, h) })) : typeof h < "u" && s(j, { name: u, newValue: h }));
    return j;
  }, om;
}
var vM = gM();
const sm = /* @__PURE__ */ vy(vM);
function Gh(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function kM() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? bM(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function bM(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Lr = { basename: xM, dirname: _M, extname: SM, join: NM, sep: "/" };
function xM(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  qo(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function _M(e) {
  if (qo(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function SM(e) {
  qo(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function NM(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    qo(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : jM(r);
}
function jM(e) {
  qo(e);
  const n = e.codePointAt(0) === 47;
  let r = wM(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function wM(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function qo(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const CM = { cwd: FM };
function FM() {
  return "/";
}
function Yh(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function IM(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Yh(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return EM(e);
}
function EM(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const lm = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class D1 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? Yh(n) ? r = { path: n } : typeof n == "string" || $M(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : CM.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < lm.length; ) {
      const o = lm[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      lm.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Lr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    dm(n, "basename"), cm(n, "basename"), this.path = Lr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Lr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    U_(this.basename, "dirname"), this.path = Lr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Lr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (cm(n, "extname"), U_(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Lr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    Yh(n) && (n = IM(n)), dm(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Lr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    dm(n, "stem"), cm(n, "stem"), this.path = Lr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Bt(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function cm(e, n) {
  if (e && e.includes(Lr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Lr.sep + "`"
    );
}
function dm(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function U_(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function $M(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const TM = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), OM = {}.hasOwnProperty;
class yg extends TM {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = kM();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new yg()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(sm(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (pm("data", this.frozen), this.namespace[n] = r, this) : OM.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (pm("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = ds(n), i = this.parser || this.Parser;
    return um("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), um("process", this.parser || this.Parser), mm("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = ds(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const k = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), F = i.stringify(k, h);
        RM(F) ? h.value = F : h.result = F, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), um("processSync", this.parser || this.Parser), mm("processSync", this.compiler || this.Compiler), this.process(n, a), B_("processSync", "process", r), i;
    function a(o, s) {
      r = !0, V_(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    M_(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = ds(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const k = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(k) : i(void 0, k, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), B_("runSync", "run", i), a;
    function o(s, l) {
      V_(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = ds(r), a = this.compiler || this.Compiler;
    return mm("stringify", a), M_(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (pm("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = sm(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [k, ...F] = u;
        const j = i[h][1];
        Gh(j) && Gh(k) && (k = sm(!0, j, k)), i[h] = [m, k, ...F];
      }
    }
  }
}
const DM = new yg().freeze();
function um(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function mm(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function pm(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function M_(e) {
  if (!Gh(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function B_(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function ds(e) {
  return PM(e) ? e : new D1(e);
}
function PM(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function RM(e) {
  return typeof e == "string" || AM(e);
}
function AM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const LM = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", q_ = [], H_ = { allowDangerousHtml: !0 }, VM = /^(https?|ircs?|mailto|xmpp)$/i, zM = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function UM(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || q_, d = e.remarkPlugins || q_, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...H_ } : H_, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || MM, k = DM().use(xU).use(d).use(yM, m).use(l), F = new D1();
  typeof i == "string" && (F.value = i);
  for (const g of zM)
    Object.hasOwn(e, g.from) && ("" + g.from + (g.to ? "use `" + g.to + "` instead" : "remove it") + LM + g.id, void 0);
  const j = k.parse(F);
  let N = k.runSync(j, F);
  return a && (N = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      N.type === "root" ? N.children : [N]
    )
  }), O1(N, x), ZV(N, {
    Fragment: Ke.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Ke.jsx,
    jsxs: Ke.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function x(g, D, I) {
    if (g.type === "raw" && I && typeof D == "number")
      return u ? I.children.splice(D, 1) : I.children[D] = { type: "text", value: g.value }, D;
    if (g.type === "element") {
      let C;
      for (C in rm)
        if (Object.hasOwn(rm, C) && Object.hasOwn(g.properties, C)) {
          const w = g.properties[C], A = rm[C];
          (A === null || A.includes(g.tagName)) && (g.properties[C] = h(String(w || ""), C, g));
        }
    }
    if (g.type === "element") {
      let C = n ? !n.includes(g.tagName) : s ? s.includes(g.tagName) : !1;
      if (!C && r && typeof D == "number" && (C = !r(g, D, I)), C && I && typeof D == "number")
        return f && g.children ? I.children.splice(D, 1, ...g.children) : I.children.splice(D, 1), D;
    }
  }
}
function MM(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    VM.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var fm = { exports: {} }, Qa = {}, W_;
function BM() {
  if (W_) return Qa;
  W_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Qa.Fragment = r, Qa.jsx = s, Qa.jsxs = s, Qa;
}
var us = {}, K_;
function qM() {
  return K_ || (K_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    us.Fragment = i, us.jsx = Un, us.jsxs = Kn;
  })()), us;
}
var G_;
function HM() {
  return G_ || (G_ = 1, process.env.NODE_ENV === "production" ? fm.exports = BM() : fm.exports = qM()), fm.exports;
}
var se = HM();
const WM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, KM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, GM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, YM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, JM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, QM = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": WM,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": KM,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": GM,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": YM,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": JM
};
function Ho(e) {
  return QM[e] ?? {};
}
const XM = Ho(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), ZM = Ho(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), ms = ({
  title: e,
  children: n
}) => /* @__PURE__ */ se.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ se.jsx($.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), e4 = "_issueAvatar_kc0sw_1", n4 = "_issueField_kc0sw_9", t4 = "_issueDescription_kc0sw_12", ps = {
  issueAvatar: e4,
  issueField: n4,
  issueDescription: t4
}, P1 = ({ issue: e }) => /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
  /* @__PURE__ */ se.jsx(ms, { title: "Assignee", children: /* @__PURE__ */ se.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: ps.issueAvatar,
      children: [
        /* @__PURE__ */ se.jsx(
          yy,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ se.jsx($.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ se.jsx(ms, { title: "Team", children: /* @__PURE__ */ se.jsx(
    $.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: ps.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ se.jsx(ms, { title: "Project", children: /* @__PURE__ */ se.jsx(
    $.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: ps.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ se.jsx(ms, { title: "Description", children: /* @__PURE__ */ se.jsx(UM, { className: ps.issueDescription, children: e.description }) })
] }), r4 = /* @__PURE__ */ se.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ se.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ se.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ se.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), i4 = /* @__PURE__ */ se.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ se.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ se.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ se.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), a4 = /* @__PURE__ */ se.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ se.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ se.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ se.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), o4 = /* @__PURE__ */ se.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ se.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ se.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ se.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), s4 = /* @__PURE__ */ se.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ se.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), R1 = {
  0: r4,
  1: s4,
  2: o4,
  3: a4,
  4: i4
}, l4 = (e) => e in R1, ul = ({ priority: e }) => l4(e) ? R1[e] : /* @__PURE__ */ se.jsx(Jn, { "data-testid": "defaultPriorityTag", children: e }), c4 = (e, n) => /* @__PURE__ */ se.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ se.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), d4 = (e, n) => /* @__PURE__ */ se.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ se.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ se.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), u4 = (e, n) => /* @__PURE__ */ se.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ se.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ se.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), m4 = (e, n) => /* @__PURE__ */ se.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ se.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), p4 = (e, n) => /* @__PURE__ */ se.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ se.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), f4 = (e, n) => /* @__PURE__ */ se.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ se.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), Jh = {
  backlog: (e, n) => c4(e, n),
  unstarted: (e, n) => d4(e, n),
  started: (e, n) => u4(e, n),
  done: (e, n) => m4(e, n),
  canceled: (e, n) => p4(e, n),
  completed: (e, n) => f4(e, n)
}, h4 = (e) => e in Jh, ml = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => h4(e) ? Jh[e](n, r) : Jh.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), y4 = "_wrapper_e0qj3_1", g4 = "_resultTitle_e0qj3_21", v4 = "_resultTooltipTitle_e0qj3_28", k4 = "_resultLinkIcon_e0qj3_31", Xa = {
  wrapper: y4,
  resultTitle: g4,
  resultTooltipTitle: v4,
  resultLinkIcon: k4
}, b4 = ({
  issue: e
}) => {
  const [n, r] = me(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = hy(wI()), o = yt(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ se.jsx(
    Ze,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ se.jsxs(b, { flexDirection: "column", gap: "300", className: Xa.wrapper, children: [
        /* @__PURE__ */ se.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ se.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ se.jsx(
              ml,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ se.jsx($.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ se.jsx(ul, { priority: e.priority })
          ] }),
          /* @__PURE__ */ se.jsx(Jn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ se.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ se.jsx(
            $.Heading,
            {
              variant: "heading-3",
              className: Xa.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ se.jsx(P1, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ se.jsx(
        ut.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: Xa.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ se.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ se.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ se.jsx(
                    ml,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ se.jsx($.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ se.jsx(ul, { priority: e.priority })
                ] }),
                /* @__PURE__ */ se.jsx($.Paragraph, { variant: "4", className: Xa.resultTitle, children: e.title }),
                n && /* @__PURE__ */ se.jsx(
                  ve,
                  {
                    className: Xa.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, x4 = "_loader_13xpk_1", _4 = "_dropdown_13xpk_8", S4 = "_loadMore_13xpk_13", hm = {
  loader: x4,
  dropdown: _4,
  loadMore: S4
}, N4 = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = me(), [a, o] = me([]), [s, l] = me(""), [d, m] = me(!1), { useLazyQuery: u } = yn(), [f, { data: h, loading: k, networkStatus: F }] = u(
    XM,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  yi(
    () => {
      !k && s !== "" && F === rr.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), Je(() => {
    k || o([]);
  }, [s]), Je(() => {
    if (h && Object.keys(h).length > 0) {
      const N = h.Linear.searchIssues.edges.map(
        ({ node: I }) => I
      ), x = a.filter(
        (I) => !n.find((C) => C.id === I.id)
      ), g = x.filter(
        (I) => !N.find(
          (C) => C.id === I.id
        )
      ), D = N.filter(
        (I) => !n.find((C) => C.id === I.id)
      );
      n.length > 0 ? o(
        d ? [...g, ...D] : D
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...x, ...N] : N
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const j = () => {
    !k && s !== "" && F === rr.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ se.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ se.jsxs(
    ni,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (N) => N?.title,
      onChange: (N) => e(N.selectedValues[0]),
      dropdownProps: { className: hm.dropdown },
      filter: {
        value: s,
        onChange: (N) => {
          const x = N.target.value;
          l(x);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((N) => /* @__PURE__ */ se.jsx(b4, { issue: N }, N.id)),
        r?.hasNextPage && !k && s !== "" && a.length && /* @__PURE__ */ se.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => j(),
            className: hm.loadMore,
            children: /* @__PURE__ */ se.jsx($.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        k && s !== "" && /* @__PURE__ */ se.jsx(b, { justifyContent: "center", className: hm.loader, children: /* @__PURE__ */ se.jsx(hn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ se.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ se.jsx($.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !k && /* @__PURE__ */ se.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ se.jsx($.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, j4 = "_collapse_su0f9_1", w4 = "_collapseHeader_su0f9_8", C4 = "_collapseContent_su0f9_31", F4 = "_url_su0f9_35", I4 = "_externalLink_su0f9_51", E4 = "_emptyState_su0f9_55", li = {
  collapse: j4,
  collapseHeader: w4,
  collapseContent: C4,
  url: F4,
  externalLink: I4,
  emptyState: E4
}, $4 = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = me(s), { track: m } = Fn();
  return n ? /* @__PURE__ */ se.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ se.jsx(hn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ se.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ se.jsx(
          $.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: li.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ se.jsx(
          Lt,
          {
            slotEnd: /* @__PURE__ */ se.jsx(ve, { name: "external-link" }),
            variant: "tertiary",
            className: li.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ se.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ se.jsxs(
            xr,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: li.collapse,
              children: [
                /* @__PURE__ */ se.jsx(xr.Header, { className: li.collapseHeader, children: /* @__PURE__ */ se.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ se.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ se.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ se.jsx(Ze, { content: /* @__PURE__ */ se.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ se.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ se.jsx(
                        ml,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ se.jsxs(
                        $.ExternalLink,
                        {
                          className: li.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ se.jsx(ve, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ se.jsx(Ze, { content: /* @__PURE__ */ se.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ se.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ se.jsx(ul, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ se.jsx(Jn, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ se.jsx(xr.Content, { className: li.collapseContent, children: /* @__PURE__ */ se.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ se.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ se.jsx(Jn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ se.jsx(P1, { issue: u }),
                  /* @__PURE__ */ se.jsx(
                    et,
                    {
                      slotStart: /* @__PURE__ */ se.jsx(ve, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ se.jsxs(
                    Lt,
                    {
                      slotEnd: /* @__PURE__ */ se.jsx(ve, { name: "external-link" }),
                      variant: "tertiary",
                      className: li.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ se.jsx(
          et,
          {
            slotStart: /* @__PURE__ */ se.jsx(ve, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ se.jsx(
          Lt,
          {
            slotEnd: /* @__PURE__ */ se.jsx(ve, { name: "external-link" }),
            variant: "tertiary",
            className: li.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, T4 = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, A1 = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => A1(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, O4 = "_modalBody_iv3ua_1", D4 = "_error_iv3ua_5", P4 = "_dropdown_iv3ua_16", Zi = {
  modalBody: O4,
  error: D4,
  dropdown: P4
}, R4 = Ho(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), A4 = Ho(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), L4 = Ho(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), V4 = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = yn(), { control: m, handleSubmit: u, reset: f } = mt(), [h, k] = me([]), [F, j] = me(), [N, x] = me([]), [g, D] = me(), [I, C] = me([]), [w, A] = me(), [q, Y] = me([]), [te, K] = me(), [J, R] = me([]), [B, ne] = me(), [Ne, ue] = me(!1), { useMutation: oe } = yn(), { track: pe } = Fn(), [z, { loading: ke }] = oe(
    R4,
    {
      onError: () => {
        ue(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ce) => {
        const Me = {
          identifier: Ce.Linear?.issueCreate?.issue?.identifier,
          url: Ce.Linear?.issueCreate?.issue?.url
        };
        Ce.Linear && Ce.Linear?.issueCreate?.issue?.id && (a(Ce.Linear?.issueCreate?.issue?.id), Be(Me), ue(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ce.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), pe("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    $e,
    { data: H, loading: Ge, error: sn }
  ] = l(A4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ce) => {
      const Me = Ce.Linear.teams.edges.map(
        ({ node: nn }) => nn
      );
      k(Me), Y(Ce.Linear.issuePriorityValues), s(`${G4}${Ce.Linear.organization.urlKey}`);
    }
  }), [Fe, { data: Ue, loading: Pe }] = l(L4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ce) => {
      const Me = Ce?.Linear?.team?.projects?.edges?.map(
        ({ node: ce }) => ce
      );
      x(Me);
      const nn = Ce?.Linear?.team?.states?.edges?.map(
        ({ node: ce }) => ce
      );
      C(nn);
      const le = Ce?.Linear?.team?.templates?.edges?.map(
        ({ node: ce }) => ce
      );
      R(
        le.filter(
          (ce) => ce.type === "issue"
        )
      );
    }
  }), Be = (Ce) => {
    r(!1), D(void 0), j(void 0), A(void 0), K(void 0), ne(void 0), Ce && (e(Ce), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Ae = (Ce) => {
    H && !Ge && (z({
      variables: {
        issueTitle: Ce.title,
        issueDescription: Ce?.description,
        teamId: Ce.team.id,
        projectId: Ce?.project?.id,
        statusId: Ce?.status?.id,
        priority: Ce?.priority?.priority
      }
    }), ue(!0));
  };
  Je(() => {
    n && $e();
  }, [n]);
  const Qe = () => {
    pe("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ se.jsxs(
    wt,
    {
      isOpen: n,
      onClose: () => {
        Qe(), Be();
      },
      children: [
        /* @__PURE__ */ se.jsx(
          Ct,
          {
            title: "Create new Linear issue",
            onClose: () => {
              Qe(), Be();
            }
          }
        ),
        /* @__PURE__ */ se.jsx(
          Ft,
          {
            className: Zi.modalBody,
            "data-testid": "createIssueModalBody",
            children: sn ? /* @__PURE__ */ se.jsx(Tn, { error: sn }) : /* @__PURE__ */ se.jsx("form", { onSubmit: u(Ae), id: "issueCreationForm", children: /* @__PURE__ */ se.jsxs(nt, { children: [
              /* @__PURE__ */ se.jsx(Z, { span: 3, children: /* @__PURE__ */ se.jsx(
                xt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ce, onChange: Me },
                    fieldState: { error: nn }
                  }) => /* @__PURE__ */ se.jsx(
                    He,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: nn?.message ?? null
                      },
                      children: /* @__PURE__ */ se.jsx(
                        ni,
                        {
                          dropdownProps: { className: Zi.dropdown },
                          placeholder: "Select Linear team",
                          className: dt({ [Zi.error]: nn }),
                          getItemTitleByValue: (le) => le?.name,
                          onChange: (le) => {
                            D(void 0), A(void 0), K(void 0), ne(void 0), j(le.selectedValues[0]), Fe({
                              variables: { teamId: le.selectedValues[0].id }
                            }), Me(le.selectedValues[0]);
                          },
                          value: F ? [Ce] : void 0,
                          children: h?.map((le) => /* @__PURE__ */ se.jsx(
                            ut.Item,
                            {
                              value: le,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ se.jsx($.Paragraph, { children: le.name })
                            },
                            le.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ se.jsx(Z, { span: 3, children: /* @__PURE__ */ se.jsx(
                xt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Ce, onChange: Me } }) => {
                    const nn = Pe ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ se.jsx(He, { label: "Project", children: /* @__PURE__ */ se.jsx(
                      ni,
                      {
                        dropdownProps: { className: Zi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (le) => le?.name,
                        disabled: F === void 0,
                        placeholder: F ? "Select Linear project" : "Select a Team first",
                        onChange: (le) => {
                          D(le.selectedValues[0]), Me(le.selectedValues[0]);
                        },
                        value: g ? [Ce] : nn,
                        children: /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
                          Pe && /* @__PURE__ */ se.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ se.jsx(hn, { size: 24 })
                            }
                          ),
                          Ue && !Pe && N.map((le) => /* @__PURE__ */ se.jsx(
                            ut.Item,
                            {
                              value: le,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ se.jsx($.Paragraph, { children: le.name })
                            },
                            le.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ se.jsx(Z, { span: 6, children: /* @__PURE__ */ se.jsx(He, { label: "Template", children: /* @__PURE__ */ se.jsx(
                ni,
                {
                  clearable: !0,
                  dropdownProps: { className: Zi.dropdown },
                  disabled: !F || Pe,
                  placeholder: F ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ce) => Ce?.name,
                  onChange: (Ce) => {
                    if (Ce.selectedValues.length > 0) {
                      ne(Ce.selectedValues[0]);
                      const Me = JSON.parse(
                        Ce.selectedValues[0].templateData
                      ), nn = q.filter(
                        (Le) => Le.priority === Me.priority
                      );
                      K(
                        nn ? nn[0] : void 0
                      );
                      const le = I.filter(
                        (Le) => Le.id === Me.stateId
                      );
                      A(
                        le ? le[0] : void 0
                      );
                      const ce = N.filter(
                        (Le) => Le.id === Me.projectId
                      );
                      D(
                        ce ? ce[0] : void 0
                      );
                      const Se = Me.description;
                      f({
                        title: Me?.title,
                        priority: nn[0],
                        status: le[0],
                        project: ce[0],
                        description: Se ? A1(Se, T4) : "",
                        team: F
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: F
                      }), D(void 0), K(void 0), A(void 0), ne(void 0);
                  },
                  value: B ? [B] : void 0,
                  children: J?.map((Ce) => /* @__PURE__ */ se.jsx(
                    ut.Item,
                    {
                      value: Ce,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ se.jsx($.Paragraph, { children: Ce.name })
                    },
                    Ce.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ se.jsx(Z, { span: 6, children: /* @__PURE__ */ se.jsx(
                xt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ce, value: Me },
                    fieldState: { error: nn }
                  }) => /* @__PURE__ */ se.jsx(
                    tr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Me || "",
                        onChange: Ce
                      },
                      meta: {
                        error: nn?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ se.jsx(Z, { span: 3, children: /* @__PURE__ */ se.jsx(
                xt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Ce, onChange: Me } }) => {
                    const nn = Pe ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ se.jsx(He, { label: "Status", children: /* @__PURE__ */ se.jsx(
                      ni,
                      {
                        dropdownProps: { className: Zi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (le) => le?.name,
                        disabled: F === void 0,
                        placeholder: F ? "Select Issue status" : "Select a Team first",
                        onChange: (le) => {
                          A(le.selectedValues[0]), Me(le.selectedValues[0]);
                        },
                        value: w ? [Ce] : nn,
                        children: /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
                          Pe && /* @__PURE__ */ se.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ se.jsx(hn, { size: 24 })
                            }
                          ),
                          Ue && !Pe && I.map((le) => /* @__PURE__ */ se.jsx(
                            ut.Item,
                            {
                              value: le,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ se.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ se.jsx(
                                      ml,
                                      {
                                        type: le.type,
                                        color: le.color,
                                        name: le.name
                                      }
                                    ),
                                    /* @__PURE__ */ se.jsx($.Paragraph, { children: le.name })
                                  ]
                                }
                              )
                            },
                            le.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ se.jsx(Z, { span: 3, children: /* @__PURE__ */ se.jsx(
                xt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Ce, onChange: Me } }) => {
                    const nn = Ge ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ se.jsx(He, { label: "Priority", children: /* @__PURE__ */ se.jsx(
                      ni,
                      {
                        clearable: !0,
                        getItemTitleByValue: (le) => le?.label,
                        disabled: F === void 0,
                        placeholder: F ? "Select Issue priority" : "Select a Team first",
                        onChange: (le) => {
                          K(le.selectedValues[0]), Me(le.selectedValues[0]);
                        },
                        value: te ? [Ce] : nn,
                        children: /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
                          Pe && /* @__PURE__ */ se.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ se.jsx(hn, { size: 24 })
                            }
                          ),
                          H && !Ge && q.map((le) => /* @__PURE__ */ se.jsx(
                            ut.Item,
                            {
                              value: le,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ se.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ se.jsx(
                                      ul,
                                      {
                                        priority: le.priority
                                      }
                                    ),
                                    /* @__PURE__ */ se.jsx($.Paragraph, { children: le.label })
                                  ]
                                }
                              )
                            },
                            le.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ se.jsx(Z, { children: /* @__PURE__ */ se.jsx(
                xt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Ce, value: Me },
                    fieldState: { error: nn }
                  }) => /* @__PURE__ */ se.jsx(
                    NI,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Me || "",
                        onChange: Ce
                      },
                      meta: {
                        error: nn?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ se.jsx(
          Et,
          {
            confirmOnClick: u(Ae),
            confirmProps: {
              disabled: ke || !H,
              isLoading: Ne || Ge || Pe,
              loadingIndicator: /* @__PURE__ */ se.jsx(hn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              Qe(), Be();
            }
          }
        )
      ]
    }
  );
}, z4 = "_modalWrapper_4kh9u_1", U4 = "_copyButton_4kh9u_6", M4 = "_copyWrapper_4kh9u_15", B4 = "_copyField_4kh9u_24", q4 = "_externalLink_4kh9u_47", H4 = "_externalLinkIcon_4kh9u_52", W4 = "_textWrapper_4kh9u_56", _i = {
  modalWrapper: z4,
  copyButton: U4,
  copyWrapper: M4,
  copyField: B4,
  externalLink: q4,
  externalLinkIcon: H4,
  textWrapper: W4
}, K4 = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ se.jsxs(
  wt,
  {
    isOpen: !!n && e,
    className: _i.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ se.jsx(
        Ct,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ se.jsx(Ft, { children: /* @__PURE__ */ se.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ se.jsxs($.Paragraph, { className: _i.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ se.jsxs(
                $.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: _i.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ se.jsx(ve, { name: "external-link", className: _i.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ se.jsx(He, { label: "Linear issue link", children: /* @__PURE__ */ se.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: _i.copyWrapper,
                children: [
                  /* @__PURE__ */ se.jsx(
                    dr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: _i.copyField
                    }
                  ),
                  /* @__PURE__ */ se.jsx(
                    jI,
                    {
                      className: _i.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ se.jsx(
        Et,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), G4 = "https://linear.app/", Y4 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me([]), [a, o] = me([]), [s, l] = me(!1), [d, m] = me(!1), [u, f] = me(!1), [h, k] = me(), { useLazyQuery: F } = yn(), [j, N] = me(""), x = n?.enableCreateIssue, g = !!n?.enableUnlinkAll, { track: D } = Fn(), {
    loading: I,
    data: C,
    error: w,
    store: A
  } = fy(e?.conversationId ?? null), [
    q,
    {
      data: Y,
      loading: te,
      networkStatus: K,
      error: J
    }
  ] = F(ZM, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Je(() => {
    !I && !w && C && C?.linear?.issues?.length > 0 ? (o(C.linear.issues), q({
      variables: {
        linkedIssues: C.linear.issues
      }
    })) : !I && !w && (i([]), o([]));
  }, [C, I, w]), Je(() => {
    Y && Y?.Linear && !te && K === rr.ready && Object.keys(Y).length > 0 && i(Y.Linear.issues?.edges?.map(({ node: ue }) => ue));
  }, [Y, te, K]);
  const R = (ue) => {
    ue && ue?.team?.organization?.urlKey && D("linear:link:issue:clicked", {
      linearInstanceUrl: j,
      linearIssueKey: ue.id
    });
    const oe = (pe) => pe.id === ue?.id;
    r.some((pe) => pe && oe(pe)) || (C && a.length === 0 && o([]), A({
      linear: {
        issues: [...a, ue.id]
      }
    }));
  }, B = (ue) => {
    const oe = C?.linear.issues.filter((pe) => pe !== ue) || [];
    D("linear:unlink:issue:clicked", {
      linearInstanceUrl: j,
      linearIssueKey: ue
    }), i(r.filter(({ id: pe }) => pe !== ue)), o(oe), A({
      linear: {
        issues: oe
      }
    });
  }, ne = () => {
    l(!1), i([]), o([]), A({
      linear: {
        issues: []
      }
    });
  }, Ne = I || te || !C && !w || (C?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !I && !te && (J || w) ? /* @__PURE__ */ se.jsx(Tn, { error: J || w }) : /* @__PURE__ */ se.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ se.jsxs(
      wt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ se.jsx(
            Ct,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ se.jsx(Ft, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ se.jsx(
            Et,
            {
              confirmOnClick: () => ne(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ se.jsx(
      V4,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (ue) => m(ue),
        setIsCreationSuccessfulModalOpen: (ue) => f(ue),
        addToLinkedIssueIds: (ue) => {
          A({
            linear: {
              issues: [...a, ue]
            }
          });
        },
        setCreatedIssue: (ue) => k(ue),
        organizationUrl: j,
        setOrganizationUrl: (ue) => N(ue)
      }
    ),
    /* @__PURE__ */ se.jsx(
      K4,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (ue) => f(ue),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ se.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          x && /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
            /* @__PURE__ */ se.jsx(
              et,
              {
                variant: "primary",
                onClick: () => {
                  D("linear:create:new:issue:clicked", {
                    linearInstanceUrl: j
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ se.jsx($.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ se.jsx(N4, { handleSelect: R, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ se.jsx(
      $4,
      {
        linkedIssues: r,
        isLoading: Ne,
        handleUnlinkIssue: B,
        showUnlinkAllModal: (ue) => l(ue),
        showUnlinkAllButton: g,
        organizationUrl: j
      }
    )
  ] });
}, Qh = [
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Si = "LINEAR", J4 = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, Q4 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: J4
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: F
  } = ur({
    integrationId: e,
    integrationType: Si,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: D
  } = mr({
    integrationId: e,
    fieldDefinitions: Qh,
    form: l,
    onMisconfigured: F
  }), { renderConditions: I, setRenderConditions: C, renderConditionsForSubmit: w } = pr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), A = (Y) => hr(Y, {
    fieldDefinitions: Qh,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: w
  }), q = l.watch("name");
  return /* @__PURE__ */ se.jsxs(
    fr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        k && /* @__PURE__ */ se.jsx(yr, { cause: k }),
        /* @__PURE__ */ se.jsxs(nt, { children: [
          /* @__PURE__ */ se.jsx(Z, { children: /* @__PURE__ */ se.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ se.jsx(
            xn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(Z, { span: 3, children: /* @__PURE__ */ se.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ se.jsx(Z, { span: 3 }),
          /* @__PURE__ */ se.jsx(Z, { span: 3, children: /* @__PURE__ */ se.jsx(He, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ se.jsx(
            xn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(Z, { span: 3 }),
          /* @__PURE__ */ se.jsx(Z, { span: 3, children: /* @__PURE__ */ se.jsx(He, { label: 'Enable the "Unlink all" button', children: /* @__PURE__ */ se.jsx(
            xn,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ se.jsx(
            fi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Si,
              label: "Authorize with OAuth"
            }
          ),
          o && I !== null && /* @__PURE__ */ se.jsx(Z, { children: o({
            value: I,
            onChange: C,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ se.jsx(
          gr,
          {
            integrationType: Si,
            integrationId: e,
            widgetName: q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ se.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ se.jsx(
                ve,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ se.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ se.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Si,
                  " integration, all links between Dixa and ",
                  Si,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ se.jsxs($.Paragraph, { children: [
                  "All data in ",
                  Si,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ se.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Si,
                  " ",
                  'integration "',
                  q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ym = { exports: {} }, Za = {}, Y_;
function X4() {
  if (Y_) return Za;
  Y_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Za.Fragment = r, Za.jsx = s, Za.jsxs = s, Za;
}
var fs = {}, J_;
function Z4() {
  return J_ || (J_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    fs.Fragment = i, fs.jsx = Un, fs.jsxs = Kn;
  })()), fs;
}
var Q_;
function e5() {
  return Q_ || (Q_ = 1, process.env.NODE_ENV === "production" ? ym.exports = X4() : ym.exports = Z4()), ym.exports;
}
var Ee = e5();
const n5 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, t5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, r5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, i5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, a5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, o5 = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": n5,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": t5,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": r5,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": i5,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": a5
};
function Bl(e) {
  return o5[e] ?? {};
}
const s5 = Bl(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), l5 = Bl(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), c5 = Bl(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), d5 = Bl(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function gm(e = !1, n) {
  const [r, i] = me(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const u5 = "_wrapper_27vny_1", m5 = "_copyIcon_27vny_12", eo = {
  wrapper: u5,
  copyIcon: m5
}, p5 = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = gm(), { isCopied: i, copy: a } = gm(), { isCopied: o, copy: s } = gm();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: k,
    enrolled_at: F,
    referral_url: j
  } = e, N = f ? Qn(f).isSame(Date.now(), "day") : !1, { name: x, first_name: g, last_name: D } = m ?? {}, I = x ?? (`${g} ${D}`.trim() || "A customer has no name"), C = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ Ee.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ee.jsxs(b, { className: eo.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: eo.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Ee.jsx($.Heading, { variant: "heading-2", children: I }),
          N && /* @__PURE__ */ Ee.jsx($.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsx($.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Ee.jsx($.Paragraph, { variant: "4", color: "secondary", children: Qn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    k && /* @__PURE__ */ Ee.jsx(b, { gap: "200", children: /* @__PURE__ */ Ee.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Qn(F).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ee.jsx(ve, { size: l, name: "mail" }),
        /* @__PURE__ */ Ee.jsx($.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ Ee.jsx(Ze, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Ee.jsx(
        ve,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: eo.copyIcon
        }
      ) })
    ] }),
    C && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ee.jsx(ve, { size: l, name: "link" }),
        /* @__PURE__ */ Ee.jsx(Ze, { content: "Shopify shop", children: /* @__PURE__ */ Ee.jsx(
          $.ExternalLink,
          {
            href: C,
            target: "_blank",
            rel: "noreferrer",
            children: C.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Ee.jsx(Ze, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Ee.jsx(
        ve,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(C),
          className: eo.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ee.jsx(ve, { size: l, name: "external-link" }),
        /* @__PURE__ */ Ee.jsx(Ze, { content: "Referral link", children: /* @__PURE__ */ Ee.jsx(
          $.ExternalLink,
          {
            href: j,
            target: "_blank",
            rel: "noreferrer",
            children: j.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Ee.jsx(Ze, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Ee.jsx(
        ve,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: eo.copyIcon
        }
      ) })
    ] })
  ] }) });
}, f5 = "_list_1q5b5_5", h5 = "_listItem_1q5b5_8", y5 = "_listItemEdit_1q5b5_15", g5 = "_notificationText_1q5b5_19", va = {
  list: f5,
  listItem: h5,
  listItemEdit: y5,
  notificationText: g5
}, v5 = "_modalBody_1clhs_1", k5 = {
  modalBody: v5
}, b5 = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Fn(), [d, m] = me(n), [u, f] = me(""), [h, k] = me(), [F, { loading: j }] = o(
    c5,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), K();
      }
    }
  ), [N, { loading: x }] = o(d5), g = j || x, D = !!h, I = n === d ? "Change the value to update the points" : "", C = isNaN(d), w = C ? "Points can not be empty" : "", A = d > n && d - n > 1e6, q = A ? "Points can not exceed 1,000,000" : "", Y = () => {
    if (!r) {
      k(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && F({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((J) => {
      const R = J?.networkError;
      (R ? R?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), K()) : (l("loyaltylion:add:points:failed"), k(["Failed to add points, try again later."]));
    }), d < n && N({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((J) => {
      J.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), K()) : "errors" in J && (l("loyaltylion:remove:points:failed"), k(
        J.errors?.map((R) => R.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), k(["Failed to remove points, try again later."]);
    });
  }, te = () => {
    C && m(n), f(""), i();
  }, K = () => {
    a(), te();
  };
  return /* @__PURE__ */ Ee.jsxs(
    wt,
    {
      isOpen: e,
      onClose: te,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Ee.jsx(Ct, { title: "Change points", onClose: te }),
        /* @__PURE__ */ Ee.jsxs(Ft, { className: k5.modalBody, children: [
          /* @__PURE__ */ Ee.jsxs(nt, { children: [
            /* @__PURE__ */ Ee.jsx(Z, { span: 6, children: /* @__PURE__ */ Ee.jsx(
              tr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: q || w,
                  warning: I
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (J) => m(J?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Ee.jsx(Z, { span: 6, children: /* @__PURE__ */ Ee.jsx(
              tr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (J) => f(J?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !g && D && /* @__PURE__ */ Ee.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Ee.jsx(Xe, { children: h?.map((J, R) => /* @__PURE__ */ Ee.jsx(
            Xe.Item,
            {
              variant: "dense",
              title: J,
              contentLeft: /* @__PURE__ */ Ee.jsx(
                ve,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            R
          )) }) })
        ] }),
        /* @__PURE__ */ Ee.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => Y(),
            confirmProps: {
              isLoading: g,
              disabled: C || A || n === d,
              loadingIndicator: /* @__PURE__ */ Ee.jsx(hn, { size: 16 })
            },
            cancelOnClick: te
          }
        )
      ]
    }
  );
}, x5 = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Ee.jsx(Xe.Text, { variant: "dense", className: va.listItem, children: /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(ve, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Ee.jsx($.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ Ee.jsx(Ze, { content: "Edit points", children: /* @__PURE__ */ Ee.jsx(
        ve,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: va.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ Ee.jsx(Bn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, _5 = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = me(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsx($.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Ee.jsx(Xe, { className: va.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: k }) => /* @__PURE__ */ Ee.jsx(
      x5,
      {
        points: f,
        label: h,
        setIsModalOpen: k
      },
      u
    )) }),
    /* @__PURE__ */ Ee.jsx(
      b5,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, S5 = "_reward_1wxia_1", N5 = {
  reward: S5
}, j5 = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Ee.jsx(b, { gap: "100", flexDirection: "column", className: N5.reward, children: /* @__PURE__ */ Ee.jsx(Ze, { content: a ?? "No description", children: /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Ee.jsx(ve, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Ee.jsxs(Bn, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(ve, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Ee.jsx(
        $.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, w5 = ({ customer: e }) => {
  const { useQuery: n } = yn(), [r, i] = me(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(l5, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (Je(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return ba({ errors: d }) ? /* @__PURE__ */ Ee.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: va.notificationText,
        children: "No rewards found"
      }
    ) : hw({ errors: d }) ? /* @__PURE__ */ Ee.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: va.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ Ee.jsx(Tn, { error: s });
  }
  return /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsx($.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ee.jsx(hn, {}) }) : /* @__PURE__ */ Ee.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ Ee.jsx(j5, { reward: d }, d.id)) })
  ] });
}, C5 = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Ee.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ee.jsx(Jn, { children: /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(
        ve,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ Ee.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ee.jsx(Jn, { children: /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(ve, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Ee.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ee.jsx(Ze, { content: "Insights segment", children: /* @__PURE__ */ Ee.jsx(Jn, { children: /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(ve, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, F5 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = yn(), { track: i } = Fn(), [a, o] = me(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: k,
    data: F,
    refetch: j
  } = r(s5, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return Je(() => {
    if (F && !h) {
      const N = (F?.LoyaltyLion?.getCustomers).customers;
      N && N.length > 0 && (o(N[0]), i("loyaltylion:customer:received"));
    }
  }, [F, h]), s?.email ? k ? ba({
    errors: k.graphQLErrors
  }) ? /* @__PURE__ */ Ee.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: va.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Ee.jsx(Tn, { error: k }) : h ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ee.jsx(hn, {}) }) : f ? /* @__PURE__ */ Ee.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Ee.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Ee.jsxs(Ee.Fragment, { children: [
        l && /* @__PURE__ */ Ee.jsx(p5, { customer: a }),
        d && /* @__PURE__ */ Ee.jsx(C5, { customer: a }),
        m && /* @__PURE__ */ Ee.jsx(
          _5,
          {
            customer: a,
            refetchCustomerData: j
          }
        ),
        u && /* @__PURE__ */ Ee.jsx(w5, { customer: a })
      ] }) : /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Ee.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, Xh = [
  {
    key: "basicAuthorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], X_ = "LOYALTYLION", I5 = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, E5 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: I5
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: X_,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: Xh,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: I, renderConditionsForSubmit: C } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (q) => hr(q, {
    fieldDefinitions: Xh,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), A = s.watch("name");
  return /* @__PURE__ */ Ee.jsxs(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ Ee.jsx(yr, { cause: h }),
        /* @__PURE__ */ Ee.jsxs(nt, { children: [
          /* @__PURE__ */ Ee.jsx(Z, { children: /* @__PURE__ */ Ee.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ee.jsx(
            xn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3, children: /* @__PURE__ */ Ee.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3, children: /* @__PURE__ */ Ee.jsx(
            uI,
            {
              name: "basicAuthorization",
              label: "LoyaltyLion authorization",
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3, children: /* @__PURE__ */ Ee.jsx(He, { label: "Show customer summary", children: /* @__PURE__ */ Ee.jsx(
            xn,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3, children: /* @__PURE__ */ Ee.jsx(He, { label: "Show tags", children: /* @__PURE__ */ Ee.jsx(
            xn,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3, children: /* @__PURE__ */ Ee.jsx(He, { label: "Show points balance", children: /* @__PURE__ */ Ee.jsx(
            xn,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3, children: /* @__PURE__ */ Ee.jsx(He, { label: "Show available rewards", children: /* @__PURE__ */ Ee.jsx(
            xn,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ Ee.jsx(Z, { children: a({
            value: D,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Ee.jsx(
          gr,
          {
            integrationType: X_,
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var vm = { exports: {} }, no = {}, Z_;
function $5() {
  if (Z_) return no;
  Z_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return no.Fragment = r, no.jsx = s, no.jsxs = s, no;
}
var hs = {}, eS;
function T5() {
  return eS || (eS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    hs.Fragment = i, hs.jsx = Un, hs.jsxs = Kn;
  })()), hs;
}
var nS;
function O5() {
  return nS || (nS = 1, process.env.NODE_ENV === "production" ? vm.exports = $5() : vm.exports = T5()), vm.exports;
}
var fn = O5();
const D5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, P5 = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": D5
};
function R5(e) {
  return P5[e] ?? {};
}
function tS(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, i = Array(n); r < n; r++) i[r] = e[r];
  return i;
}
function A5(e) {
  if (Array.isArray(e)) return e;
}
function L5(e, n) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var i, a, o, s, l = [], d = !0, m = !1;
    try {
      if (o = (r = r.call(e)).next, n !== 0) for (; !(d = (i = o.call(r)).done) && (l.push(i.value), l.length !== n); d = !0) ;
    } catch (u) {
      m = !0, a = u;
    } finally {
      try {
        if (!d && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (m) throw a;
      }
    }
    return l;
  }
}
function V5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function z5(e, n) {
  return A5(e) || L5(e, n) || U5(e, n) || V5();
}
function U5(e, n) {
  if (e) {
    if (typeof e == "string") return tS(e, n);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? tS(e, n) : void 0;
  }
}
const L1 = Object.entries, rS = Object.setPrototypeOf, M5 = Object.isFrozen, B5 = Object.getPrototypeOf, q5 = Object.getOwnPropertyDescriptor;
let At = Object.freeze, Vt = Object.seal, aa = Object.create, V1 = typeof Reflect < "u" && Reflect, Zh = V1.apply, ey = V1.construct;
At || (At = function(e) {
  return e;
});
Vt || (Vt = function(e) {
  return e;
});
Zh || (Zh = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
ey || (ey = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const to = _t(Array.prototype.forEach), H5 = _t(Array.prototype.lastIndexOf), iS = _t(Array.prototype.pop), ea = _t(Array.prototype.push), W5 = _t(Array.prototype.splice), ui = Array.isArray, vo = _t(String.prototype.toLowerCase), km = _t(String.prototype.toString), aS = _t(String.prototype.match), ro = _t(String.prototype.replace), oS = _t(String.prototype.indexOf), K5 = _t(String.prototype.trim), G5 = _t(Number.prototype.toString), Y5 = _t(Boolean.prototype.toString), sS = typeof BigInt > "u" ? null : _t(BigInt.prototype.toString), lS = typeof Symbol > "u" ? null : _t(Symbol.prototype.toString), It = _t(Object.prototype.hasOwnProperty), io = _t(Object.prototype.toString), Tt = _t(RegExp.prototype.test), Ni = J5(TypeError);
function _t(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return Zh(e, n, i);
  };
}
function J5(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return ey(e, r);
  };
}
function Wn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : vo;
  if (rS && rS(e, null), !ui(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (M5(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function Q5(e) {
  for (let n = 0; n < e.length; n++)
    It(e, n) || (e[n] = null);
  return e;
}
function Ht(e) {
  const n = aa(null);
  for (const i of L1(e)) {
    var r = z5(i, 2);
    const a = r[0], o = r[1];
    It(e, a) && (ui(o) ? n[a] = Q5(o) : o && typeof o == "object" && o.constructor === Object ? n[a] = Ht(o) : n[a] = o);
  }
  return n;
}
function X5(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return G5(e);
    case "boolean":
      return Y5(e);
    case "bigint":
      return sS ? sS(e) : "0";
    case "symbol":
      return lS ? lS(e) : "Symbol()";
    case "undefined":
      return io(e);
    case "function":
    case "object": {
      if (e === null)
        return io(e);
      const n = e, r = Ar(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : io(i);
      }
      return io(e);
    }
    default:
      return io(e);
  }
}
function Ar(e, n) {
  for (; e !== null; ) {
    const i = q5(e, n);
    if (i) {
      if (i.get)
        return _t(i.get);
      if (typeof i.value == "function")
        return _t(i.value);
    }
    e = B5(e);
  }
  function r() {
    return null;
  }
  return r;
}
function Z5(e) {
  try {
    return Tt(e, ""), !0;
  } catch {
    return !1;
  }
}
const cS = At(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), bm = At(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), xm = At(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), eB = At(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), _m = At(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), nB = At(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), dS = At(["#text"]), uS = At(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Sm = At(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), mS = At(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), ys = At(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), tB = Vt(/{{[\w\W]*|^[\w\W]*}}/g), rB = Vt(/<%[\w\W]*|^[\w\W]*%>/g), iB = Vt(/\${[\w\W]*/g), aB = Vt(/^data-[\-\w.\u00B7-\uFFFF]+$/), oB = Vt(/^aria-[\-\w]+$/), pS = Vt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), sB = Vt(/^(?:\w+script|data):/i), lB = Vt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), cB = Vt(/^html$/i), dB = Vt(/^[a-z][.\w]*(-[.\w]+)+$/i), fS = Vt(/<[/\w!]/g), uB = Vt(/<[/\w]/g), mB = Vt(/<\/no(script|embed|frames)/i), pB = Vt(/\/>/i), Rr = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, fB = function() {
  return typeof window > "u" ? null : window;
}, hB = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, hS = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, ci = function(e, n, r, i) {
  return It(e, n) && ui(e[n]) ? Wn(i.base ? Ht(i.base) : {}, e[n], i.transform) : r;
};
function z1() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : fB();
  const n = (W) => z1(W);
  if (n.version = "3.4.11", n.removed = [], !e || !e.document || e.document.nodeType !== Rr.document || !e.Element)
    return n.isSupported = !1, n;
  let r = e.document;
  const i = r, a = i.currentScript;
  e.DocumentFragment;
  const o = e.HTMLTemplateElement, s = e.Node, l = e.Element, d = e.NodeFilter;
  e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
  const u = e.DOMParser, f = e.trustedTypes, h = l.prototype, k = Ar(h, "cloneNode"), F = Ar(h, "remove"), j = Ar(h, "nextSibling"), N = Ar(h, "childNodes"), x = Ar(h, "parentNode"), g = Ar(h, "shadowRoot"), D = Ar(h, "attributes"), I = s && s.prototype ? Ar(s.prototype, "nodeType") : null, C = s && s.prototype ? Ar(s.prototype, "nodeName") : null;
  if (typeof o == "function") {
    const W = r.createElement("template");
    W.content && W.content.ownerDocument && (r = W.content.ownerDocument);
  }
  let w, A = "", q, Y = !1, te = 0;
  const K = function() {
    if (te > 0)
      throw Ni('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, J = function(W) {
    K(), te++;
    try {
      return w.createHTML(W);
    } finally {
      te--;
    }
  }, R = function(W) {
    K(), te++;
    try {
      return w.createScriptURL(W);
    } finally {
      te--;
    }
  }, B = function() {
    return Y || (q = hB(f, a), Y = !0), q;
  }, ne = r, Ne = ne.implementation, ue = ne.createNodeIterator, oe = ne.createDocumentFragment, pe = ne.getElementsByTagName, z = i.importNode;
  let ke = hS();
  n.isSupported = typeof L1 == "function" && typeof x == "function" && Ne && Ne.createHTMLDocument !== void 0;
  const $e = tB, H = rB, Ge = iB, sn = aB, Fe = oB, Ue = sB, Pe = lB, Be = dB;
  let Ae = pS, Qe = null;
  const Ce = Wn({}, [...cS, ...bm, ...xm, ..._m, ...dS]);
  let Me = null;
  const nn = Wn({}, [...uS, ...Sm, ...mS, ...ys]);
  let le = Object.seal(aa(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), ce = null, Se = null;
  const Le = Object.seal(aa(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Re = !0, gn = !0, Q = !1, T = !0, U = !1, X = !0, ae = !1, V = !1, G = null, fe = null, _e = !1, Te = !1, tn = !1, vn = !1, on = !0, pn = !1;
  const In = "user-content-";
  let _n = !0, En = !1, en = {}, kn = null;
  const Ve = Wn({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let dn = null;
  const un = Wn({}, ["audio", "video", "img", "source", "image", "track"]);
  let jn = null;
  const qn = Wn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Nn = "http://www.w3.org/1998/Math/MathML", Rn = "http://www.w3.org/2000/svg", bn = "http://www.w3.org/1999/xhtml";
  let Sn = bn, Ln = !1, Vn = null;
  const Cn = Wn({}, [Nn, Rn, bn], km), wn = At(["mi", "mo", "mn", "ms", "mtext"]);
  let zn = Wn({}, wn);
  const Hn = At(["annotation-xml"]);
  let Un = Wn({}, Hn);
  const Kn = Wn({}, ["title", "style", "font", "a", "script"]);
  let t = null;
  const c = ["application/xhtml+xml", "text/html"], p = "text/html";
  let y = null, E = null;
  const O = r.createElement("form"), S = function(W) {
    return W instanceof RegExp || W instanceof Function;
  }, _ = function() {
    let W = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (E && E === W)
      return;
    (!W || typeof W != "object") && (W = {}), W = Ht(W), t = // eslint-disable-next-line unicorn/prefer-includes
    c.indexOf(W.PARSER_MEDIA_TYPE) === -1 ? p : W.PARSER_MEDIA_TYPE, y = t === "application/xhtml+xml" ? km : vo, Qe = ci(W, "ALLOWED_TAGS", Ce, {
      transform: y
    }), Me = ci(W, "ALLOWED_ATTR", nn, {
      transform: y
    }), Vn = ci(W, "ALLOWED_NAMESPACES", Cn, {
      transform: km
    }), jn = ci(W, "ADD_URI_SAFE_ATTR", qn, {
      transform: y,
      base: qn
    }), dn = ci(W, "ADD_DATA_URI_TAGS", un, {
      transform: y,
      base: un
    }), kn = ci(W, "FORBID_CONTENTS", Ve, {
      transform: y
    }), ce = ci(W, "FORBID_TAGS", Ht({}), {
      transform: y
    }), Se = ci(W, "FORBID_ATTR", Ht({}), {
      transform: y
    }), en = It(W, "USE_PROFILES") ? W.USE_PROFILES && typeof W.USE_PROFILES == "object" ? Ht(W.USE_PROFILES) : W.USE_PROFILES : !1, Re = W.ALLOW_ARIA_ATTR !== !1, gn = W.ALLOW_DATA_ATTR !== !1, Q = W.ALLOW_UNKNOWN_PROTOCOLS || !1, T = W.ALLOW_SELF_CLOSE_IN_ATTR !== !1, U = W.SAFE_FOR_TEMPLATES || !1, X = W.SAFE_FOR_XML !== !1, ae = W.WHOLE_DOCUMENT || !1, Te = W.RETURN_DOM || !1, tn = W.RETURN_DOM_FRAGMENT || !1, vn = W.RETURN_TRUSTED_TYPE || !1, _e = W.FORCE_BODY || !1, on = W.SANITIZE_DOM !== !1, pn = W.SANITIZE_NAMED_PROPS || !1, _n = W.KEEP_CONTENT !== !1, En = W.IN_PLACE || !1, Ae = Z5(W.ALLOWED_URI_REGEXP) ? W.ALLOWED_URI_REGEXP : pS, Sn = typeof W.NAMESPACE == "string" ? W.NAMESPACE : bn, zn = It(W, "MATHML_TEXT_INTEGRATION_POINTS") && W.MATHML_TEXT_INTEGRATION_POINTS && typeof W.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Ht(W.MATHML_TEXT_INTEGRATION_POINTS) : Wn({}, wn), Un = It(W, "HTML_INTEGRATION_POINTS") && W.HTML_INTEGRATION_POINTS && typeof W.HTML_INTEGRATION_POINTS == "object" ? Ht(W.HTML_INTEGRATION_POINTS) : Wn({}, Hn);
    const Oe = It(W, "CUSTOM_ELEMENT_HANDLING") && W.CUSTOM_ELEMENT_HANDLING && typeof W.CUSTOM_ELEMENT_HANDLING == "object" ? Ht(W.CUSTOM_ELEMENT_HANDLING) : aa(null);
    if (le = aa(null), It(Oe, "tagNameCheck") && S(Oe.tagNameCheck) && (le.tagNameCheck = Oe.tagNameCheck), It(Oe, "attributeNameCheck") && S(Oe.attributeNameCheck) && (le.attributeNameCheck = Oe.attributeNameCheck), It(Oe, "allowCustomizedBuiltInElements") && typeof Oe.allowCustomizedBuiltInElements == "boolean" && (le.allowCustomizedBuiltInElements = Oe.allowCustomizedBuiltInElements), Vt(le), U && (gn = !1), tn && (Te = !0), en && (Qe = Wn({}, dS), Me = aa(null), en.html === !0 && (Wn(Qe, cS), Wn(Me, uS)), en.svg === !0 && (Wn(Qe, bm), Wn(Me, Sm), Wn(Me, ys)), en.svgFilters === !0 && (Wn(Qe, xm), Wn(Me, Sm), Wn(Me, ys)), en.mathMl === !0 && (Wn(Qe, _m), Wn(Me, mS), Wn(Me, ys))), Le.tagCheck = null, Le.attributeCheck = null, It(W, "ADD_TAGS") && (typeof W.ADD_TAGS == "function" ? Le.tagCheck = W.ADD_TAGS : ui(W.ADD_TAGS) && (Qe === Ce && (Qe = Ht(Qe)), Wn(Qe, W.ADD_TAGS, y))), It(W, "ADD_ATTR") && (typeof W.ADD_ATTR == "function" ? Le.attributeCheck = W.ADD_ATTR : ui(W.ADD_ATTR) && (Me === nn && (Me = Ht(Me)), Wn(Me, W.ADD_ATTR, y))), It(W, "ADD_URI_SAFE_ATTR") && ui(W.ADD_URI_SAFE_ATTR) && Wn(jn, W.ADD_URI_SAFE_ATTR, y), It(W, "FORBID_CONTENTS") && ui(W.FORBID_CONTENTS) && (kn === Ve && (kn = Ht(kn)), Wn(kn, W.FORBID_CONTENTS, y)), It(W, "ADD_FORBID_CONTENTS") && ui(W.ADD_FORBID_CONTENTS) && (kn === Ve && (kn = Ht(kn)), Wn(kn, W.ADD_FORBID_CONTENTS, y)), _n && (Qe["#text"] = !0), ae && Wn(Qe, ["html", "head", "body"]), Qe.table && (Wn(Qe, ["tbody"]), delete ce.tbody), W.TRUSTED_TYPES_POLICY) {
      if (typeof W.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Ni('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof W.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Ni('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const We = w;
      w = W.TRUSTED_TYPES_POLICY;
      try {
        A = J("");
      } catch (cn) {
        throw w = We, cn;
      }
    } else W.TRUSTED_TYPES_POLICY === null ? (w = void 0, A = "") : (w === void 0 && (w = B()), w && typeof A == "string" && (A = J("")));
    At && At(W), E = W;
  }, ee = Wn({}, [...bm, ...xm, ...eB]), L = Wn({}, [..._m, ...nB]), M = function(W, Oe, We) {
    return Oe.namespaceURI === bn ? W === "svg" : Oe.namespaceURI === Nn ? W === "svg" && (We === "annotation-xml" || zn[We]) : !!ee[W];
  }, de = function(W, Oe, We) {
    return Oe.namespaceURI === bn ? W === "math" : Oe.namespaceURI === Rn ? W === "math" && Un[We] : !!L[W];
  }, ze = function(W, Oe, We) {
    return Oe.namespaceURI === Rn && !Un[We] || Oe.namespaceURI === Nn && !zn[We] ? !1 : !L[W] && (Kn[W] || !ee[W]);
  }, De = function(W) {
    let Oe = x(W);
    (!Oe || !Oe.tagName) && (Oe = {
      namespaceURI: Sn,
      tagName: "template"
    });
    const We = vo(W.tagName), cn = vo(Oe.tagName);
    return Vn[W.namespaceURI] ? W.namespaceURI === Rn ? M(We, Oe, cn) : W.namespaceURI === Nn ? de(We, Oe, cn) : W.namespaceURI === bn ? ze(We, Oe, cn) : !!(t === "application/xhtml+xml" && Vn[W.namespaceURI]) : !1;
  }, ie = function(W) {
    ea(n.removed, {
      element: W
    });
    try {
      x(W).removeChild(W);
    } catch {
      if (F(W), !x(W))
        throw Ni("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, mn = function(W) {
    const Oe = N(W);
    if (Oe) {
      const cn = [];
      to(Oe, (Pn) => {
        ea(cn, Pn);
      }), to(cn, (Pn) => {
        try {
          F(Pn);
        } catch {
        }
      });
    }
    const We = D(W);
    if (We)
      for (let cn = We.length - 1; cn >= 0; --cn) {
        const Pn = We[cn], tt = Pn && Pn.name;
        if (typeof tt == "string")
          try {
            W.removeAttribute(tt);
          } catch {
          }
      }
  }, Dn = function(W, Oe) {
    try {
      ea(n.removed, {
        attribute: Oe.getAttributeNode(W),
        from: Oe
      });
    } catch {
      ea(n.removed, {
        attribute: null,
        from: Oe
      });
    }
    if (Oe.removeAttribute(W), W === "is")
      if (Te || tn)
        try {
          ie(Oe);
        } catch {
        }
      else
        try {
          Oe.setAttribute(W, "");
        } catch {
        }
  }, Gn = function(W) {
    const Oe = D(W);
    if (Oe)
      for (let We = Oe.length - 1; We >= 0; --We) {
        const cn = Oe[We], Pn = cn && cn.name;
        if (!(typeof Pn != "string" || Me[y(Pn)]))
          try {
            W.removeAttribute(Pn);
          } catch {
          }
      }
  }, GF = function(W) {
    const Oe = [W];
    for (; Oe.length > 0; ) {
      const We = Oe.pop();
      (I ? I(We) : We.nodeType) === Rr.element && Gn(We);
      const cn = N(We);
      if (cn)
        for (let Pn = cn.length - 1; Pn >= 0; --Pn)
          Oe.push(cn[Pn]);
    }
  }, Wg = function(W) {
    let Oe = null, We = null;
    if (_e)
      W = "<remove></remove>" + W;
    else {
      const tt = aS(W, /^[\r\n\t ]+/);
      We = tt && tt[0];
    }
    t === "application/xhtml+xml" && Sn === bn && (W = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + W + "</body></html>");
    const cn = w ? J(W) : W;
    if (Sn === bn)
      try {
        Oe = new u().parseFromString(cn, t);
      } catch {
      }
    if (!Oe || !Oe.documentElement) {
      Oe = Ne.createDocument(Sn, "template", null);
      try {
        Oe.documentElement.innerHTML = Ln ? A : cn;
      } catch {
      }
    }
    const Pn = Oe.body || Oe.documentElement;
    return W && We && Pn.insertBefore(r.createTextNode(We), Pn.childNodes[0] || null), Sn === bn ? pe.call(Oe, ae ? "html" : "body")[0] : ae ? Oe.documentElement : Pn;
  }, Kg = function(W) {
    return ue.call(
      W.ownerDocument || W,
      W,
      // eslint-disable-next-line no-bitwise
      d.SHOW_ELEMENT | d.SHOW_COMMENT | d.SHOW_TEXT | d.SHOW_PROCESSING_INSTRUCTION | d.SHOW_CDATA_SECTION,
      null
    );
  }, Yo = function(W) {
    return W = ro(W, $e, " "), W = ro(W, H, " "), W = ro(W, Ge, " "), W;
  }, Xl = function(W) {
    var Oe;
    W.normalize();
    const We = ue.call(
      W.ownerDocument || W,
      W,
      // eslint-disable-next-line no-bitwise
      d.SHOW_TEXT | d.SHOW_COMMENT | d.SHOW_CDATA_SECTION | d.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let cn = We.nextNode();
    for (; cn; )
      cn.data = Yo(cn.data), cn = We.nextNode();
    const Pn = (Oe = W.querySelectorAll) === null || Oe === void 0 ? void 0 : Oe.call(W, "template");
    Pn && to(Pn, (tt) => {
      Ki(tt.content) && Xl(tt.content);
    });
  }, Jo = function(W) {
    const Oe = C ? C(W) : null;
    return typeof Oe != "string" || y(Oe) !== "form" ? !1 : typeof W.nodeName != "string" || typeof W.textContent != "string" || typeof W.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    W.attributes !== D(W) || typeof W.removeAttribute != "function" || typeof W.setAttribute != "function" || typeof W.namespaceURI != "string" || typeof W.insertBefore != "function" || typeof W.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    W.nodeType !== I(W) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    W.childNodes !== N(W);
  }, Ki = function(W) {
    if (!I || typeof W != "object" || W === null)
      return !1;
    try {
      return I(W) === Rr.documentFragment;
    } catch {
      return !1;
    }
  }, Oa = function(W) {
    if (!I || typeof W != "object" || W === null)
      return !1;
    try {
      return typeof I(W) == "number";
    } catch {
      return !1;
    }
  };
  function Yr(W, Oe, We) {
    W.length !== 0 && to(W, (cn) => {
      cn.call(n, Oe, We, E);
    });
  }
  const YF = function(W, Oe) {
    return !!(X && W.hasChildNodes() && !Oa(W.firstElementChild) && Tt(fS, W.textContent) && Tt(fS, W.innerHTML) || X && W.namespaceURI === bn && Oe === "style" && Oa(W.firstElementChild) || W.nodeType === Rr.processingInstruction || X && W.nodeType === Rr.comment && Tt(uB, W.data));
  }, JF = function(W, Oe) {
    if (!ce[Oe] && Jg(Oe) && (le.tagNameCheck instanceof RegExp && Tt(le.tagNameCheck, Oe) || le.tagNameCheck instanceof Function && le.tagNameCheck(Oe)))
      return !1;
    if (_n && !kn[Oe]) {
      const We = x(W), cn = N(W);
      if (cn && We) {
        const Pn = cn.length;
        for (let tt = Pn - 1; tt >= 0; --tt) {
          const rt = En ? cn[tt] : k(cn[tt], !0);
          We.insertBefore(rt, j(W));
        }
      }
    }
    return ie(W), !0;
  }, Gg = function(W) {
    if (Yr(ke.beforeSanitizeElements, W, null), Jo(W))
      return ie(W), !0;
    const Oe = y(C ? C(W) : W.nodeName);
    if (Yr(ke.uponSanitizeElement, W, {
      tagName: Oe,
      allowedTags: Qe
    }), YF(W, Oe))
      return ie(W), !0;
    if (ce[Oe] || !(Le.tagCheck instanceof Function && Le.tagCheck(Oe)) && !Qe[Oe])
      return JF(W, Oe);
    if ((I ? I(W) : W.nodeType) === Rr.element && !De(W) || (Oe === "noscript" || Oe === "noembed" || Oe === "noframes") && Tt(mB, W.innerHTML))
      return ie(W), !0;
    if (U && W.nodeType === Rr.text) {
      const We = Yo(W.textContent);
      W.textContent !== We && (ea(n.removed, {
        element: W.cloneNode()
      }), W.textContent = We);
    }
    return Yr(ke.afterSanitizeElements, W, null), !1;
  }, Yg = function(W, Oe, We) {
    if (Se[Oe] || on && (Oe === "id" || Oe === "name") && (We in r || We in O))
      return !1;
    const cn = Me[Oe] || Le.attributeCheck instanceof Function && Le.attributeCheck(Oe, W);
    if (!(gn && Tt(sn, Oe)) && !(Re && Tt(Fe, Oe))) {
      if (cn) {
        if (!jn[Oe] && !Tt(Ae, ro(We, Pe, "")) && !((Oe === "src" || Oe === "xlink:href" || Oe === "href") && W !== "script" && oS(We, "data:") === 0 && dn[W]) && !(Q && !Tt(Ue, ro(We, Pe, ""))) && We)
          return !1;
      } else if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        !(Jg(W) && (le.tagNameCheck instanceof RegExp && Tt(le.tagNameCheck, W) || le.tagNameCheck instanceof Function && le.tagNameCheck(W)) && (le.attributeNameCheck instanceof RegExp && Tt(le.attributeNameCheck, Oe) || le.attributeNameCheck instanceof Function && le.attributeNameCheck(Oe, W)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        Oe === "is" && le.allowCustomizedBuiltInElements && (le.tagNameCheck instanceof RegExp && Tt(le.tagNameCheck, We) || le.tagNameCheck instanceof Function && le.tagNameCheck(We)))
      ) return !1;
    }
    return !0;
  }, QF = Wn({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), Jg = function(W) {
    return !QF[vo(W)] && Tt(Be, W);
  }, XF = function(W, Oe, We, cn) {
    if (w && typeof f == "object" && typeof f.getAttributeType == "function" && !We)
      switch (f.getAttributeType(W, Oe)) {
        case "TrustedHTML":
          return J(cn);
        case "TrustedScriptURL":
          return R(cn);
      }
    return cn;
  }, ZF = function(W, Oe, We, cn) {
    try {
      We ? W.setAttributeNS(We, Oe, cn) : W.setAttribute(Oe, cn), Jo(W) ? ie(W) : iS(n.removed);
    } catch {
      Dn(Oe, W);
    }
  }, Qg = function(W) {
    Yr(ke.beforeSanitizeAttributes, W, null);
    const Oe = W.attributes;
    if (!Oe || Jo(W))
      return;
    const We = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Me,
      forceKeepAttr: void 0
    };
    let cn = Oe.length;
    const Pn = y(W.nodeName);
    for (; cn--; ) {
      const tt = Oe[cn], rt = tt.name, ki = tt.namespaceURI, ai = tt.value, Qt = y(rt), oi = ai;
      let qt = rt === "value" ? oi : K5(oi);
      if (We.attrName = Qt, We.attrValue = qt, We.keepAttr = !0, We.forceKeepAttr = void 0, Yr(ke.uponSanitizeAttribute, W, We), qt = We.attrValue, pn && (Qt === "id" || Qt === "name") && oS(qt, In) !== 0 && (Dn(rt, W), qt = In + qt), X && Tt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, qt)) {
        Dn(rt, W);
        continue;
      }
      if (Qt === "attributename" && aS(qt, "href")) {
        Dn(rt, W);
        continue;
      }
      if (!We.forceKeepAttr) {
        if (!We.keepAttr) {
          Dn(rt, W);
          continue;
        }
        if (!T && Tt(pB, qt)) {
          Dn(rt, W);
          continue;
        }
        if (U && (qt = Yo(qt)), !Yg(Pn, Qt, qt)) {
          Dn(rt, W);
          continue;
        }
        qt = XF(Pn, Qt, ki, qt), qt !== oi && ZF(W, rt, ki, qt);
      }
    }
    Yr(ke.afterSanitizeAttributes, W, null);
  }, Qo = function(W) {
    let Oe = null;
    const We = Kg(W);
    for (Yr(ke.beforeSanitizeShadowDOM, W, null); Oe = We.nextNode(); )
      if (Yr(ke.uponSanitizeShadowNode, Oe, null), Gg(Oe), Qg(Oe), Ki(Oe.content) && Qo(Oe.content), (I ? I(Oe) : Oe.nodeType) === Rr.element) {
        const cn = g(Oe);
        Ki(cn) && (Zl(cn), Qo(cn));
      }
    Yr(ke.afterSanitizeShadowDOM, W, null);
  }, Zl = function(W) {
    const Oe = [{
      node: W,
      shadow: null
    }];
    for (; Oe.length > 0; ) {
      const We = Oe.pop();
      if (We.shadow) {
        Qo(We.shadow);
        continue;
      }
      const cn = We.node, Pn = (I ? I(cn) : cn.nodeType) === Rr.element, tt = N(cn);
      if (tt)
        for (let rt = tt.length - 1; rt >= 0; --rt)
          Oe.push({
            node: tt[rt],
            shadow: null
          });
      if (Pn) {
        const rt = C ? C(cn) : null;
        if (typeof rt == "string" && y(rt) === "template") {
          const ki = cn.content;
          Ki(ki) && Oe.push({
            node: ki,
            shadow: null
          });
        }
      }
      if (Pn) {
        const rt = g(cn);
        Ki(rt) && Oe.push({
          node: null,
          shadow: rt
        }, {
          node: rt,
          shadow: null
        });
      }
    }
  };
  return n.sanitize = function(W) {
    let Oe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, We = null, cn = null, Pn = null, tt = null;
    if (Ln = !W, Ln && (W = "<!-->"), typeof W != "string" && !Oa(W) && (W = X5(W), typeof W != "string"))
      throw Ni("dirty is not a string, aborting");
    if (!n.isSupported)
      return W;
    V ? (Qe = G, Me = fe) : _(Oe), (ke.uponSanitizeElement.length > 0 || ke.uponSanitizeAttribute.length > 0) && (Qe = Ht(Qe)), ke.uponSanitizeAttribute.length > 0 && (Me = Ht(Me)), n.removed = [];
    const rt = En && typeof W != "string" && Oa(W);
    if (rt) {
      const Qt = C ? C(W) : W.nodeName;
      if (typeof Qt == "string") {
        const oi = y(Qt);
        if (!Qe[oi] || ce[oi])
          throw Ni("root node is forbidden and cannot be sanitized in-place");
      }
      if (Jo(W))
        throw Ni("root node is clobbered and cannot be sanitized in-place");
      try {
        Zl(W);
      } catch (oi) {
        throw mn(W), oi;
      }
    } else if (Oa(W))
      We = Wg("<!---->"), cn = We.ownerDocument.importNode(W, !0), cn.nodeType === Rr.element && cn.nodeName === "BODY" || cn.nodeName === "HTML" ? We = cn : We.appendChild(cn), Zl(cn);
    else {
      if (!Te && !U && !ae && // eslint-disable-next-line unicorn/prefer-includes
      W.indexOf("<") === -1)
        return w && vn ? J(W) : W;
      if (We = Wg(W), !We)
        return Te ? null : vn ? A : "";
    }
    We && _e && ie(We.firstChild);
    const ki = Kg(rt ? W : We);
    try {
      for (; Pn = ki.nextNode(); )
        Gg(Pn), Qg(Pn), Ki(Pn.content) && Qo(Pn.content);
    } catch (Qt) {
      throw rt && mn(W), Qt;
    }
    if (rt)
      return to(n.removed, (Qt) => {
        Qt.element && GF(Qt.element);
      }), U && Xl(W), W;
    if (Te) {
      if (U && Xl(We), tn)
        for (tt = oe.call(We.ownerDocument); We.firstChild; )
          tt.appendChild(We.firstChild);
      else
        tt = We;
      return (Me.shadowroot || Me.shadowrootmode) && (tt = z.call(i, tt, !0)), tt;
    }
    let ai = ae ? We.outerHTML : We.innerHTML;
    return ae && Qe["!doctype"] && We.ownerDocument && We.ownerDocument.doctype && We.ownerDocument.doctype.name && Tt(cB, We.ownerDocument.doctype.name) && (ai = "<!DOCTYPE " + We.ownerDocument.doctype.name + `>
` + ai), U && (ai = Yo(ai)), w && vn ? J(ai) : ai;
  }, n.setConfig = function() {
    let W = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _(W), V = !0, G = Qe, fe = Me;
  }, n.clearConfig = function() {
    E = null, V = !1, G = null, fe = null, w = q, A = "";
  }, n.isValidAttribute = function(W, Oe, We) {
    E || _({});
    const cn = y(W), Pn = y(Oe);
    return Yg(cn, Pn, We);
  }, n.addHook = function(W, Oe) {
    typeof Oe == "function" && It(ke, W) && ea(ke[W], Oe);
  }, n.removeHook = function(W, Oe) {
    if (It(ke, W)) {
      if (Oe !== void 0) {
        const We = H5(ke[W], Oe);
        return We === -1 ? void 0 : W5(ke[W], We, 1)[0];
      }
      return iS(ke[W]);
    }
  }, n.removeHooks = function(W) {
    It(ke, W) && (ke[W] = []);
  }, n.removeAllHooks = function() {
    ke = hS();
  }, n;
}
var yB = z1();
const gB = "_messageContainer_1rxr4_1", vB = "_chip_1rxr4_7", kB = "_chipLabel_1rxr4_10", bB = "_chipValue_1rxr4_13", gs = {
  messageContainer: gB,
  chip: vB,
  chipLabel: kB,
  chipValue: bB
}, yS = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, xB = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  Je(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ fn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ fn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ fn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ fn.jsx(Ze, { content: "Conversation Attributes", children: /* @__PURE__ */ fn.jsx(
        yy,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ fn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ fn.jsx(Jn, { className: gs.chip, children: /* @__PURE__ */ fn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ fn.jsxs(lt, { className: gs.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ fn.jsx(lt, { className: gs.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ fn.jsx(
      b,
      {
        className: gs.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? yS[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? yS[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ fn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ fn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ fn.jsx($.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ fn.jsx($.Paragraph, { variant: "4", children: /* @__PURE__ */ fn.jsx(CI, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ fn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: yB.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ fn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ fn.jsx(
      FI,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ fn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, _B = "_conversation_1draa_1", SB = "_conversationSubLine_1draa_9", NB = "_modal_1draa_14", Nm = {
  conversation: _B,
  conversationSubLine: SB,
  modal: NB
}, jB = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), wB = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), CB = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = me(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ fn.jsxs(b, { className: Nm.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ fn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ fn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ fn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ fn.jsx($.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ fn.jsx(Bn, { size: "small", variant: "info", children: Qn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ fn.jsx(
          $.Heading,
          {
            variant: "heading-4",
            className: Nm.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ fn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ fn.jsx(Jn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ fn.jsx(Ze, { content: "Show conversation preview", children: /* @__PURE__ */ fn.jsx(
        ir,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ fn.jsxs(
      wt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Nm.modal,
        children: [
          /* @__PURE__ */ fn.jsx(
            Ct,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ fn.jsx(Ft, { children: /* @__PURE__ */ fn.jsx(
            xB,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: jB(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: wB(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, FB = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = me(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Yn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ fn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ fn.jsx(
      CB,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ fn.jsxs(
      et,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, IB = R5(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), EB = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = yn(), { data: l, loading: d, error: m } = s(IB, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return Je(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ fn.jsx(Tn, { error: m }) : d ? /* @__PURE__ */ fn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ fn.jsx(hn, {}) }) : r?.length === 0 ? /* @__PURE__ */ fn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ fn.jsx(
    FB,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, ny = [
  {
    key: "miurosClientId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], jm = "MIUROS", $B = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, TB = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: $B
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: F
  } = ur({
    integrationId: e,
    integrationType: jm,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: D
  } = mr({
    integrationId: e,
    fieldDefinitions: ny,
    form: l,
    onMisconfigured: F
  }), { renderConditions: I, setRenderConditions: C, renderConditionsForSubmit: w } = pr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), A = (Y) => hr(Y, {
    fieldDefinitions: ny,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: w
  }), q = l.watch("name");
  return /* @__PURE__ */ fn.jsxs(
    fr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        k && /* @__PURE__ */ fn.jsx(yr, { cause: k }),
        /* @__PURE__ */ fn.jsxs(nt, { children: [
          /* @__PURE__ */ fn.jsx(Z, { children: /* @__PURE__ */ fn.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ fn.jsx(
            xn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3, children: /* @__PURE__ */ fn.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3, children: /* @__PURE__ */ fn.jsx(
            An,
            {
              name: "miurosClientId",
              label: "Authorization: Client ID",
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3, children: /* @__PURE__ */ fn.jsx(
            Er,
            {
              name: "miurosClientSecret",
              label: "Authorization: Client secret",
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3, children: /* @__PURE__ */ fn.jsx(
            An,
            {
              name: "amountOfConversationsToShow",
              label: "Number of conversation to show before the fold",
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (Y) => !Number.isNaN(Number.parseInt(Y, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ fn.jsx(
            fi,
            {
              configuration: n,
              integrationId: e,
              integrationType: jm,
              label: "Authorize"
            }
          ),
          o && I !== null && /* @__PURE__ */ fn.jsx(Z, { children: o({
            value: I,
            onChange: C,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ fn.jsx(
          gr,
          {
            integrationType: jm,
            integrationId: e,
            widgetName: q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var wm = { exports: {} }, ao = {}, gS;
function OB() {
  if (gS) return ao;
  gS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ao.Fragment = r, ao.jsx = s, ao.jsxs = s, ao;
}
var vs = {}, vS;
function DB() {
  return vS || (vS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    vs.Fragment = i, vs.jsx = Un, vs.jsxs = Kn;
  })()), vs;
}
var kS;
function PB() {
  return kS || (kS = 1, process.env.NODE_ENV === "production" ? wm.exports = OB() : wm.exports = DB()), wm.exports;
}
var Ie = PB();
const RB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, AB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, LB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, VB = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": RB,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": AB,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": LB
};
function gg(e) {
  return VB[e] ?? {};
}
const zB = gg(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), UB = gg(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), MB = gg(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function ty(e = !1, n) {
  const [r, i] = me(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const BB = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, U1 = "DD MMM YYYY @ HH:mm", qB = "_list_2c4dq_1", HB = "_listItem_2c4dq_4", WB = "_copyIcon_2c4dq_12", Pi = {
  list: qB,
  listItem: HB,
  copyIcon: WB
}, ry = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = ty(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: k,
    country_code: F
  } = e ?? {}, j = `${d} ${m}`.trim() || void 0, N = `${h} ${k}`.trim() || void 0, x = [j, u, f, N, F].filter(
    Boolean
  );
  return /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ie.jsx(ve, { size: l, name: n }),
      i ? /* @__PURE__ */ Ie.jsx(hn, { size: l }) : /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: x.map((g, D) => /* @__PURE__ */ Ie.jsx(lt, { children: g }, D)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Ie.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Ie.jsx(Ze, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Ie.jsx(
        ve,
        {
          size: l,
          name: "exclamation",
          className: Pi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Ie.jsx(Ze, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Ie.jsx(
        ve,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(x.join(", ")),
          className: Pi.copyIcon
        }
      ) })
    ] })
  ] });
}, KB = "_wrapper_1nher_1", GB = {
  wrapper: KB
}, YB = ({
  customer: e,
  store: n
}) => {
  const { track: r } = Fn(), { isCopied: i, copy: a } = ty(), { isCopied: o, copy: s } = ty(), { useQuery: l } = yn(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(UB, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, k = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, F = (h?.addresses?.length ?? 0) > 1;
  if (Je(() => {
    k && r("recharge:profile:received");
  }, [k, r]), u)
    return /* @__PURE__ */ Ie.jsx(Tn, { error: u });
  if (!e)
    return null;
  const {
    id: j,
    phone: N,
    email: x,
    first_name: g,
    last_name: D,
    created_at: I,
    has_valid_payment_method: C
  } = e, w = 14, A = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${j}` : null, q = `${g || ""} ${D || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ie.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ie.jsxs(b, { className: GB.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsx($.Heading, { variant: "heading-2", children: q }),
    I && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: Qn(I).format(U1) })
    ] }),
    x && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ie.jsx(ve, { size: w, name: "mail" }),
        /* @__PURE__ */ Ie.jsx($.ExternalLink, { href: `mailto:${x}`, children: x })
      ] }),
      /* @__PURE__ */ Ie.jsx(Ze, { content: "Copy email", children: /* @__PURE__ */ Ie.jsx(
        ve,
        {
          size: w,
          name: i ? "done" : "copy",
          onClick: () => a(x),
          className: Pi.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ie.jsx(ve, { size: w, name: "phone" }),
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: N })
      ] }),
      /* @__PURE__ */ Ie.jsx(Ze, { content: "Copy phone number", children: /* @__PURE__ */ Ie.jsx(
        ve,
        {
          size: w,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: Pi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Ie.jsx(
      ry,
      {
        address: k,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: F
      }
    ),
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ie.jsx(ve, { size: w, name: "credit-card" }),
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Ie.jsx(
        ve,
        {
          size: w,
          name: C ? "check-circle" : "close-circle-filled",
          color: C ? "green.500" : "red.500"
        }
      )
    ] }),
    A && /* @__PURE__ */ Ie.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Ie.jsx(ve, { size: w, name: "external-link" }),
      /* @__PURE__ */ Ie.jsx(
        $.ExternalLink,
        {
          href: A,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, JB = "_order_1dlaa_1", QB = "_orderIsOpen_1dlaa_9", XB = "_orderHeader_1dlaa_12", ZB = "_note_1dlaa_16", ks = {
  order: JB,
  orderIsOpen: QB,
  orderHeader: XB,
  note: ZB
}, eq = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = Fn(), [a, o] = me(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: k,
    total_price: F,
    is_prepaid: j
  } = e, N = 14, x = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, g = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Ie.jsxs(
    b,
    {
      className: dt(ks.order, {
        [ks.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ie.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ks.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Ie.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Ie.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: Qn(f).format(U1) }) }),
                /* @__PURE__ */ Ie.jsxs($.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Ie.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ Ie.jsx(Ze, { content: "Note", children: /* @__PURE__ */ Ie.jsx(
            $.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: ks.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ie.jsx(ve, { size: N, name: "activity" }),
            /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: BB(l) })
            ] })
          ] }),
          /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ie.jsx(ve, { size: N, name: "credit-card" }),
            /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: j ? "Yes" : "No" })
            ] })
          ] }),
          g && /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ie.jsx(ve, { size: N, name: "cog" }),
            /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: g })
            ] })
          ] }),
          /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ie.jsx(ve, { size: N, name: "chart-bar" }),
            /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ie.jsxs($.Paragraph, { variant: "4", children: [
                F,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Ie.jsx(
            ry,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Ie.jsx(
            ry,
            {
              address: k,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          x && /* @__PURE__ */ Ie.jsx(
            Lt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(x, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Ie.jsx(ve, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, nq = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = Fn(), { useQuery: i } = yn(), {
    loading: a,
    error: o,
    data: s
  } = i(MB, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Ie.jsx(Tn, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ie.jsx($.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Ie.jsx(Bn, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Ie.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ie.jsx(hn, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ Ie.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Ie.jsx($.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ Ie.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ Ie.jsx(
        eq,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ Ie.jsx(
        Lt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Ie.jsx(ve, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, tq = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsx($.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Ie.jsxs(Xe, { className: Pi.list, children: [
      /* @__PURE__ */ Ie.jsx(Xe.Text, { variant: "dense", className: Pi.listItem, children: /* @__PURE__ */ Ie.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Ie.jsx(Xe.Text, { variant: "dense", className: Pi.listItem, children: /* @__PURE__ */ Ie.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, rq = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = yn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(zB, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const k = m.graphQLErrors;
    return xl({ errors: k }) ? /* @__PURE__ */ Ie.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : _l({ errors: k }) ? /* @__PURE__ */ Ie.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ie.jsx(Tn, { error: m });
  }
  return d ? /* @__PURE__ */ Ie.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ie.jsx(hn, {}) }) : f ? l ? /* @__PURE__ */ Ie.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Ie.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Ie.jsx(YB, { customer: f, store: h }),
        o && /* @__PURE__ */ Ie.jsx(tq, { customer: f }),
        s && /* @__PURE__ */ Ie.jsx(nq, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Ie.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, iy = [
  {
    key: "rechargeAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], iq = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, aq = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: iq
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: iy,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: I, renderConditionsForSubmit: C } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (q) => hr(q, {
    fieldDefinitions: iy,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), A = s.watch("name");
  return /* @__PURE__ */ Ie.jsxs(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ Ie.jsx(yr, { cause: h }),
        /* @__PURE__ */ Ie.jsxs(nt, { children: [
          /* @__PURE__ */ Ie.jsx(Z, { children: /* @__PURE__ */ Ie.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ie.jsx(
            xn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3, children: /* @__PURE__ */ Ie.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3, children: /* @__PURE__ */ Ie.jsx(
            Er,
            {
              name: "rechargeAccessToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3, children: /* @__PURE__ */ Ie.jsx(He, { label: "Displays details of a customer", children: /* @__PURE__ */ Ie.jsx(
            xn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3, children: /* @__PURE__ */ Ie.jsx(He, { label: "Displays the subscription overview", children: /* @__PURE__ */ Ie.jsx(
            xn,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3, children: /* @__PURE__ */ Ie.jsx(He, { label: "Displays the last 5 orders", children: /* @__PURE__ */ Ie.jsx(
            xn,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ Ie.jsx(Z, { children: a({
            value: D,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Ie.jsx(
          gr,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._wrapper_l5y5y_54{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_l5y5y_59{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_l5y5y_67{text-align:center}._inputSeparator_l5y5y_71{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_l5y5y_76{color:var(--dixa-typography-color-link)}._noIssuesFound_l5y5y_80{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._list_l5y5y_85{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_l5y5y_95{background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_l5y5y_95:last-child{box-shadow:none}._listItemHighlighted_l5y5y_103{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._listItemEdit_l5y5y_106{cursor:pointer}._fullWidth_l5y5y_110{width:100%}._boxWrapper_l5y5y_114{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._clickableIcon_l5y5y_120{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._list_rxh85_1{padding:0;overflow-y:auto;max-height:230px}._listItem_rxh85_6{cursor:pointer;font-size:var(--dixa-typography-size-100);background-color:transparent;padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_rxh85_6:last-child{box-shadow:none}._listItemHighlighted_rxh85_16{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._modalBody_1clhs_1{width:400px}._reward_1gmba_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1gmba_1:hover{border-color:var(--dixa-color-neutral-400)}._clickable_1gmba_10{cursor:pointer}._voucherCode_1gmba_14{font-family:monospace}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Cm = { exports: {} }, oo = {}, bS;
function oq() {
  if (bS) return oo;
  bS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return oo.Fragment = r, oo.jsx = s, oo.jsxs = s, oo;
}
var bs = {}, xS;
function sq() {
  return xS || (xS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    bs.Fragment = i, bs.jsx = Un, bs.jsxs = Kn;
  })()), bs;
}
var _S;
function lq() {
  return _S || (_S = 1, process.env.NODE_ENV === "production" ? Cm.exports = oq() : Cm.exports = sq()), Cm.exports;
}
var be = lq(), M1 = /* @__PURE__ */ ((e) => (e.CustomAction = "custom_action", e.FacebookLike = "facebook_like", e.FacebookShare = "facebook_share", e.InstagramFollow = "instagram_follow", e.Manual = "manual", e.ReferralComplete = "referral_complete", e.TiktokFollow = "tiktok_follow", e.TwitterFollow = "twitter_follow", e.TwitterShare = "twitter_share", e.VisitUrl = "visit_url", e))(M1 || {}), pa = /* @__PURE__ */ ((e) => (e.Excluded = "excluded", e.Guest = "guest", e.Member = "member", e))(pa || {});
const cq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "adjustCustomerPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "RivoLoyalty_adjust_customer_points_request_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "adjust_customer_points" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, dq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "return_customer" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_identifier" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "StringValue", value: "lifetime_earnings_tally,next_vip_tier", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "accepts_marketing" } }, { kind: "Field", name: { kind: "Name", value: "orders_count" } }, { kind: "Field", name: { kind: "Name", value: "verified_email" } }, { kind: "Field", name: { kind: "Name", value: "total_spent" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_status" } }, { kind: "Field", name: { kind: "Name", value: "points_tally" } }, { kind: "Field", name: { kind: "Name", value: "credits_tally" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }] } }, { kind: "Field", name: { kind: "Name", value: "points_expire_at" } }, { kind: "Field", name: { kind: "Name", value: "next_vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }, { kind: "Field", name: { kind: "Name", value: "to_spend_or_earn" } }] } }, { kind: "Field", name: { kind: "Name", value: "lifetime_earnings_tally" } }] } }] } }] } }] } }] } }] }, uq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFavoriteProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_customer_favorite_products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "data_source" }, value: { kind: "EnumValue", value: "shopify" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "product_id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "handle" } }] } }] } }] } }] } }] }, mq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPointsRedemptions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_points_redemptions" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "used_at" } }, { kind: "Field", name: { kind: "Name", value: "refunded_at" } }, { kind: "Field", name: { kind: "Name", value: "revoked_at" } }] } }] } }] } }] } }] } }] }, pq = {
  "\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n": cq,
  '\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: "lifetime_earnings_tally,next_vip_tier"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n': dq,
  "\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n": uq,
  "\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n": mq
};
function ql(e) {
  return pq[e] ?? {};
}
const fq = ql(
  /* GraphQL */
  `
  query getCustomer($email: String!) {
    RivoLoyalty {
      return_customer(
        customer_identifier: $email
        fields: "lifetime_earnings_tally,next_vip_tier"
      ) {
        data {
          attributes {
            id
            email
            first_name
            last_name
            accepts_marketing
            orders_count
            verified_email
            total_spent
            loyalty_status
            points_tally
            credits_tally
            vip_tier {
              name
              threshold
            }
            points_expire_at
            next_vip_tier {
              name
              threshold
              to_spend_or_earn
            }
            lifetime_earnings_tally
          }
        }
      }
    }
  }
`
), hq = ql(
  /* GraphQL */
  `
  query getFavoriteProducts($customerId: String!) {
    RivoLoyalty {
      list_customer_favorite_products(
        customer_id: $customerId
        data_source: shopify
      ) {
        data {
          product_id
          title
          handle
        }
      }
    }
  }
`
), yq = ql(
  /* GraphQL */
  `
  query getPointsRedemptions($customerId: String!) {
    RivoLoyalty {
      list_points_redemptions(
        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId
      ) {
        data {
          id
          attributes {
            points_amount
            name
            code
            expires_at
            used_at
            refunded_at
            revoked_at
          }
        }
      }
    }
  }
`
), gq = ql(
  /* GraphQL */
  `
  mutation adjustCustomerPoints(
    $input: RivoLoyalty_adjust_customer_points_request_Input
  ) {
    RivoLoyalty {
      adjust_customer_points(input: $input)
    }
  }
`
), vq = "_list_l5y5y_85", kq = "_listItem_l5y5y_95", bq = "_listItemHighlighted_l5y5y_103", xq = "_listItemEdit_l5y5y_106", _q = "_clickableIcon_l5y5y_120", Cr = {
  list: vq,
  listItem: kq,
  listItemHighlighted: bq,
  listItemEdit: xq,
  clickableIcon: _q
}, vg = "rivoLoyaltyShopifyApiHostName", B1 = "https://admin.shopify.com";
function q1(e) {
  return e.split(".")[0];
}
const Sq = "_wrapper_1xucg_1", SS = {
  wrapper: Sq
}, Nq = ({
  customerDetails: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { track: r } = Fn(), { isCopied: i, copy: a } = Jt(), { attributes: o } = e, {
    first_name: s,
    last_name: l,
    email: d,
    verified_email: m
  } = o, u = 14, f = `${s || ""} ${l || ""}`.trim() || "No name found for customer";
  return /* @__PURE__ */ be.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ be.jsxs(b, { className: SS.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ be.jsx(
      b,
      {
        justifyContent: "space-between",
        className: SS.block,
        alignItems: "center",
        children: /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-2", children: f })
      }
    ),
    d && /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ be.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ be.jsx(ve, { size: u, name: "mail" }),
        /* @__PURE__ */ be.jsx($.ExternalLink, { href: `mailto:${d}`, children: d }),
        /* @__PURE__ */ be.jsx(
          Ze,
          {
            content: m ? "Verified email" : "Email is not verified",
            children: /* @__PURE__ */ be.jsx(b, { alignItems: "center", children: /* @__PURE__ */ be.jsx(
              ve,
              {
                size: u,
                color: m ? "green.500" : "red.500",
                name: m ? "check-circle" : "exclamation"
              }
            ) })
          }
        )
      ] }),
      /* @__PURE__ */ be.jsx(Ze, { content: "Copy Email", children: /* @__PURE__ */ be.jsx(
        ve,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: Cr.clickableIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ be.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ be.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx(ve, { size: u, name: "sign-in" }),
        /* @__PURE__ */ be.jsx($.Paragraph, { variant: "2", children: "Marketing consent" })
      ] }),
      /* @__PURE__ */ be.jsx(
        ve,
        {
          name: o.accepts_marketing ? "check-circle-filled" : "close-circle-filled",
          color: o.accepts_marketing ? "green.500" : "neutral.500"
        }
      )
    ] }),
    /* @__PURE__ */ be.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ be.jsx(ve, { size: u, name: "external-link" }),
      /* @__PURE__ */ be.jsx(
        $.ExternalLink,
        {
          href: jq(n, o.id),
          target: "_blank",
          rel: "noreferrer",
          onClick: () => {
            r("rivoloyalty:customer:clicked", {});
          },
          children: "View customer in Rivo Loyalty"
        }
      )
    ] })
  ] }) });
};
function jq(e, n) {
  const r = q1(e);
  return `${B1}/store/${r}/apps/rivo-loyalty/customers/${n}`;
}
const wq = "_list_rxh85_1", Cq = "_listItem_rxh85_6", NS = {
  list: wq,
  listItem: Cq
}, Fq = ({
  customerId: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { useQuery: r } = yn(), {
    loading: i,
    error: a,
    data: o
  } = r(hq, {
    skip: !e,
    variables: {
      customerId: e?.toString()
    }
  }), s = !i && o ? o.RivoLoyalty?.list_customer_favorite_products?.data ?? [] : [], l = 14, d = () => a ? /* @__PURE__ */ be.jsx(Tn, { error: a }) : i ? /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ be.jsx(hn, {}) }) : s.length === 0 ? /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No favorite products found." }) : /* @__PURE__ */ be.jsx(Xe, { className: NS.list, children: s.map((m) => /* @__PURE__ */ be.jsxs(
    b,
    {
      alignItems: "center",
      gap: "200",
      className: NS.listItem,
      children: [
        /* @__PURE__ */ be.jsx(ve, { size: l, name: "external-link" }),
        /* @__PURE__ */ be.jsx(
          $.ExternalLink,
          {
            href: Iq(
              n,
              m.product_id
            ),
            target: "_blank",
            rel: "noreferrer",
            children: m.title
          }
        )
      ]
    },
    m.product_id
  )) });
  return /* @__PURE__ */ be.jsx(be.Fragment, { children: /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-3", children: "Favorite products" }),
    d()
  ] }) });
};
function Iq(e, n) {
  const r = q1(e);
  return `${B1}/store/${r}/products/${n}`;
}
const Eq = "_modalBody_1clhs_1", $q = {
  modalBody: Eq
};
function Tq(e, n) {
  if (isNaN(e))
    return "Points can not be empty";
  if (e < n.min)
    return `Points cannot be below ${n.min}`;
  if (e > n.max)
    return `Points can not exceed ${n.max}`;
}
function Oq(e, n) {
  if (e === n)
    return "Change the value to update the points";
}
const Dq = M1, xs = {
  addPoints: {
    successEventName: "rivoloyalty:points:add:succeeded",
    successEventText: "Added points successfully",
    failEventName: "rivoloyalty:points:add:failed",
    failEventText: "Failed to add points, try again later."
  },
  removePoints: {
    successEventName: "rivoloyalty:points:remove:succeeded",
    successEventText: "Removed points successfully",
    failEventName: "rivoloyalty:points:remove:failed",
    failEventText: "Failed to remove points, try again later."
  }
}, Pq = ({
  customerIdentifier: e,
  isOpen: n,
  points: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Fn(), [d, m] = me(r), [u, f] = me(""), [h, k] = me(!0), [F, j] = me(), N = {
    min: 0,
    max: 1e5
  }, [x, { loading: g }] = o(
    gq,
    {
      onCompleted: () => {
        const te = d > r ? xs.addPoints : xs.removePoints;
        s({
          title: "Success",
          text: te.successEventText,
          icon: "check-circle-filled",
          severity: "success"
        }), l(te.successEventName), Y();
      }
    }
  ), D = () => {
    m(r), f(""), k(!0), j(void 0);
  };
  Je(() => {
    n && D();
  }, [n]);
  const I = !!F, C = Tq(d, N), w = Oq(r, d), A = () => {
    if (d !== r) {
      const te = d > r ? xs.addPoints : xs.removePoints, K = !h;
      x({
        variables: {
          input: {
            // eslint-disable-next-line camelcase
            points_amount: d - r,
            // eslint-disable-next-line camelcase
            ...u && { internal_note: u },
            // eslint-disable-next-line camelcase
            customer_identifier: e?.toString(),
            source: Dq.Manual,
            // eslint-disable-next-line camelcase
            skip_email: K
          }
        }
      }).catch(() => {
        l(te.failEventName), j([te.failEventText]);
      });
    }
  }, q = () => {
    D(), i();
  }, Y = () => {
    a(), q();
  };
  return /* @__PURE__ */ be.jsxs(
    wt,
    {
      isOpen: n,
      onClose: q,
      "data-testid": "rivo-loyalty-change-points-modal",
      children: [
        /* @__PURE__ */ be.jsx(Ct, { title: "Change points", onClose: q }),
        /* @__PURE__ */ be.jsxs(Ft, { className: $q.modalBody, children: [
          /* @__PURE__ */ be.jsxs(nt, { children: [
            /* @__PURE__ */ be.jsx(Z, { span: 6, "data-testid": "rivo-loyalty-points-input", children: /* @__PURE__ */ be.jsx(
              tr,
              {
                label: "New points balance",
                type: "number",
                placeholder: "Insert points balance",
                min: N.min,
                max: N.max,
                meta: {
                  error: C,
                  warning: w
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (te) => m(te?.target.valueAsNumber ?? 0)
                }
              }
            ) }),
            /* @__PURE__ */ be.jsx(Z, { span: 6, children: /* @__PURE__ */ be.jsx(
              tr,
              {
                label: "Internal note",
                placeholder: "Insert an internal note (optional)",
                input: {
                  name: "internalNote",
                  value: u,
                  onChange: (te) => f(te?.target.value ?? "")
                }
              }
            ) }),
            /* @__PURE__ */ be.jsx(Z, { span: 6, children: /* @__PURE__ */ be.jsx(He, { label: "Notify the customer by email", children: /* @__PURE__ */ be.jsx(
              wl,
              {
                input: {
                  name: "sendEmail",
                  value: "sendEmail",
                  checked: h,
                  onChange: () => k(!h)
                }
              }
            ) }) })
          ] }),
          !g && I && /* @__PURE__ */ be.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ be.jsx(Xe, { children: F?.map((te, K) => /* @__PURE__ */ be.jsx(
            Xe.Item,
            {
              variant: "dense",
              title: te,
              contentLeft: /* @__PURE__ */ be.jsx(
                ve,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            K
          )) }) })
        ] }),
        /* @__PURE__ */ be.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => A(),
            confirmProps: {
              isLoading: g,
              loadingIndicator: /* @__PURE__ */ be.jsx(hn, { size: 16 }),
              disabled: !!(C || w)
            },
            cancelOnClick: q
          }
        )
      ]
    }
  );
}, na = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = gw(n);
  return /* @__PURE__ */ be.jsx(
    Xe.Text,
    {
      variant: "dense",
      className: dt(Cr.listItem, {
        [Cr.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ be.jsx(Ze, { content: r, children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: e }),
        a ? n : Li(n)
      ] }) })
    }
  );
}, jS = {
  [pa.Guest]: {
    name: "Guest",
    tooltip: "Customers who can participate in your loyalty program without creating a full account. They can earn and redeem points through email verification or one-time codes.",
    badgeColor: "info"
  },
  [pa.Member]: {
    name: "Member",
    tooltip: "Customers who have activated their loyalty membership and have full access to all program features, including account dashboards and advanced features.",
    badgeColor: "success"
  },
  [pa.Excluded]: {
    name: "Excluded",
    tooltip: "Customers who have been excluded from the loyalty program (typically through the “Rivo Excluded” tag or manual exclusion).",
    badgeColor: "warning"
  }
}, Rq = ({
  customer: e,
  allowAdjustLoyaltyPoints: n,
  refetchCustomerData: r
}) => {
  const { attributes: i } = e, a = i.loyalty_status ? jS[i.loyalty_status] : jS[pa.Guest], o = a?.name === pa.Excluded, s = i.lifetime_earnings_tally ?? 0, l = i.total_spent ?? 0, d = Math.trunc(i.points_tally ?? 0), m = i.next_vip_tier, u = i.next_vip_tier?.to_spend_or_earn ?? 0, f = m?.name ?? "None", [h, k] = me(!1), F = 10, j = () => /* @__PURE__ */ be.jsx(
    Xe.Text,
    {
      variant: "dense",
      className: dt(Cr.listItem),
      children: /* @__PURE__ */ be.jsx(Ze, { content: a.tooltip, children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: "Loyalty status" }),
        /* @__PURE__ */ be.jsx(Bn, { variant: a.badgeColor, size: "small", children: a.name })
      ] }) })
    }
  ), N = () => o ? j() : /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
    /* @__PURE__ */ be.jsx(
      Xe.Text,
      {
        variant: "dense",
        className: dt(
          Cr.listItem,
          Cr.listItemHighlighted,
          {
            [Cr.listItemEdit]: n
          }
        ),
        onClick: () => n ? k(!0) : void 0,
        children: /* @__PURE__ */ be.jsx(Ze, { content: "The current balance of loyalty points for the customer.", children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: "Points balance" }),
          /* @__PURE__ */ be.jsxs(
            b,
            {
              alignItems: "center",
              justifyContent: "space-between",
              gap: "100",
              children: [
                n && /* @__PURE__ */ be.jsx(
                  ve,
                  {
                    name: "pen",
                    size: F,
                    "aria-label": "Edit points"
                  }
                ),
                /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: Li(d) })
              ]
            }
          )
        ] }) })
      }
    ),
    u != null && f && /* @__PURE__ */ be.jsx(
      na,
      {
        description: `Points until ${f} tier`,
        tooltip: `Loyalty points until the customer advances to ${f} tier`,
        content: u.toFixed(2)
      }
    ),
    /* @__PURE__ */ be.jsx(
      na,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: i.points_expire_at ?? "No expiry"
      }
    ),
    /* @__PURE__ */ be.jsx(
      na,
      {
        description: "Total points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: s?.toFixed(2)
      }
    ),
    /* @__PURE__ */ be.jsx(
      na,
      {
        description: "Total points spent",
        tooltip: "The total number of loyalty points spent by the customer.",
        content: l.toFixed(2)
      }
    ),
    j(),
    /* @__PURE__ */ be.jsx(
      na,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: i.vip_tier?.name ?? "None"
      }
    ),
    /* @__PURE__ */ be.jsx(
      na,
      {
        description: "Next VIP tier",
        tooltip: "The name of the customer's next VIP tier status.",
        content: f
      }
    )
  ] });
  return /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
    /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-3", children: "Loyalty" }),
      /* @__PURE__ */ be.jsx(Xe, { className: Cr.list, children: N() })
    ] }),
    /* @__PURE__ */ be.jsx(
      Pq,
      {
        customerIdentifier: i.id,
        isOpen: h,
        points: d,
        onClose: () => k(!1),
        refetchCustomerData: r
      }
    )
  ] });
}, Aq = ({
  ordersCount: e
}) => /* @__PURE__ */ be.jsx(be.Fragment, { children: /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-3", children: "Orders overview" }),
  /* @__PURE__ */ be.jsx(Xe, { className: Cr.list, children: /* @__PURE__ */ be.jsx(Xe.Text, { variant: "dense", className: Cr.listItem, children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: "Total orders" }),
    /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: e ?? 0 })
  ] }) }) })
] }) }), Lq = "_reward_1gmba_1", Vq = "_voucherCode_1gmba_14", wS = {
  reward: Lq,
  voucherCode: Vq
}, zq = ({
  pointsRedemption: e
}) => {
  const { isCopied: n, copy: r } = Jt(), {
    name: i,
    code: a,
    points_amount: o
  } = e.attributes;
  return /* @__PURE__ */ be.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ be.jsxs(b, { gap: "100", flexDirection: "column", className: wS.reward, children: [
    /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ be.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx(ve, { name: "star", size: 12, color: "neutral.500" }),
        i
      ] }),
      /* @__PURE__ */ be.jsxs(Bn, { size: "small", variant: "info", children: [
        o ?? 0,
        " points"
      ] })
    ] }),
    /* @__PURE__ */ be.jsxs(
      b,
      {
        gap: "100",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ be.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ be.jsx(ve, { size: 14, name: "tag" }),
            /* @__PURE__ */ be.jsx(b, { children: /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", className: wS.voucherCode, children: a }) })
          ] }),
          /* @__PURE__ */ be.jsx(Ze, { content: "Copy reward code", children: /* @__PURE__ */ be.jsx(
            ve,
            {
              size: 14,
              name: n ? "done" : "copy",
              className: Cr.clickableIcon,
              onClick: () => r(a)
            }
          ) })
        ]
      }
    )
  ] }) });
}, Uq = ({
  customer: e
}) => {
  const { useQuery: n } = yn(), {
    loading: r,
    error: i,
    data: a
  } = n(yq, {
    skip: !e,
    variables: {
      customerId: e.attributes.id.toString()
    }
  }), o = (!r && e && a ? a?.RivoLoyalty?.list_points_redemptions?.data ?? [] : []).filter(
    ({ attributes: l }) => Mq({
      usedAt: l.used_at,
      revokedAt: l.revoked_at,
      refundedAt: l.refunded_at
    }) === "Issued"
  ), s = () => i ? /* @__PURE__ */ be.jsx(Tn, { error: i }) : r ? /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ be.jsx(hn, {}) }) : o.length > 0 ? /* @__PURE__ */ be.jsx(b, { gap: "200", flexDirection: "column", children: o.map((l) => /* @__PURE__ */ be.jsx(
    zq,
    {
      pointsRedemption: l
    },
    l.id
  )) }) : /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No loyalty rewards found." });
  return /* @__PURE__ */ be.jsx(be.Fragment, { children: /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-3", children: "Available rewards" }),
    s()
  ] }) });
};
function Mq(e) {
  return e.usedAt ? "Used" : e.revokedAt ? "Revoked" : e.refundedAt ? "Refunded" : "Issued";
}
const Bq = (e) => {
  const { conversationContext: n, settings: r } = e, {
    rivoLoyaltyShowOrders: i,
    rivoLoyaltyShowLoyalty: a,
    rivoLoyaltyAdjustLoyaltyPoints: o,
    rivoLoyaltyShowFavoriteProducts: s,
    rivoLoyaltyShowPointsRedemptions: l
  } = r, d = r[vg].toString(), { useQuery: m } = yn(), { track: u } = Fn(), [f, h] = me(!1), k = n?.customer?.email, {
    loading: F,
    error: j,
    data: N,
    refetch: x
  } = m(fq, {
    skip: !k,
    variables: {
      email: k
    }
  }), g = !F && N ? N.RivoLoyalty?.return_customer?.data : void 0;
  Je(() => {
    !F && g && !f && (u("rivoloyalty:customer:received"), h(!0));
  }, [F, g]);
  const D = () => /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (j) {
    const I = j.graphQLErrors;
    return ba({ errors: I }) ? D() : xl({ errors: I }) ? /* @__PURE__ */ be.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : _l({ errors: I }) ? /* @__PURE__ */ be.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Rivo Loyalty. Please contact your administrator."
      }
    ) : /* @__PURE__ */ be.jsx(Tn, { error: j });
  }
  return F ? /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ be.jsx(hn, {}) }) : !k || !g ? D() : /* @__PURE__ */ be.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ be.jsx(
          Nq,
          {
            customerDetails: g,
            rivoLoyaltyShopifyApiHostName: d
          }
        ),
        i && /* @__PURE__ */ be.jsx(
          Aq,
          {
            ordersCount: g.attributes?.orders_count ?? 0
          }
        ),
        a && /* @__PURE__ */ be.jsx(
          Rq,
          {
            customer: g,
            refetchCustomerData: x,
            allowAdjustLoyaltyPoints: !!o
          }
        ),
        s && /* @__PURE__ */ be.jsx(
          Fq,
          {
            customerId: g.attributes.id,
            rivoLoyaltyShopifyApiHostName: d
          }
        ),
        l && /* @__PURE__ */ be.jsx(Uq, { customer: g })
      ]
    }
  );
};
var Wo = (e) => e.type === "checkbox", Ti = (e) => e instanceof Date, Yt = (e) => e == null;
const H1 = (e) => typeof e == "object";
var vt = (e) => !Yt(e) && !Array.isArray(e) && H1(e) && !Ti(e), W1 = (e) => vt(e) && e.target ? Wo(e.target) ? e.target.checked : e.target.value : e, qq = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, K1 = (e, n) => e.has(qq(n)), Hq = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return vt(n) && n.hasOwnProperty("isPrototypeOf");
}, kg = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Pt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(kg && (e instanceof Blob || i)) && (r || vt(e)))
    if (n = r ? [] : {}, !r && !Hq(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Pt(e[a]));
  else
    return e;
  return n;
}
var Hl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ht = (e) => e === void 0, an = (e, n, r) => {
  if (!n || !vt(e))
    return r;
  const i = Hl(n.split(/[,[\].]+?/)).reduce((a, o) => Yt(a) ? a : a[o], e);
  return ht(i) || i === e ? ht(e[n]) ? r : e[n] : i;
}, lr = (e) => typeof e == "boolean", bg = (e) => /^\w*$/.test(e), G1 = (e) => Hl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), at = (e, n, r) => {
  let i = -1;
  const a = bg(n) ? [n] : G1(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = vt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const pl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Fr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ei = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Wq = qe.createContext(null), xg = () => qe.useContext(Wq);
var Y1 = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Fr.all && (n._proxyFormState[s] = !i || Fr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function Kq(e) {
  const n = xg(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = qe.useState(r._formState), d = qe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = qe.useRef(a);
  return m.current = a, qe.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), qe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), qe.useMemo(() => Y1(s, r, d.current, !1), [s, r]);
}
var Br = (e) => typeof e == "string", J1 = (e, n, r, i, a) => Br(e) ? (i && n.watch.add(e), an(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), an(r, o))) : (i && (n.watchAll = !0), r);
function Gq(e) {
  const n = xg(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = qe.useRef(i), d = qe.useRef(a);
  l.current = i, qe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(J1(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = qe.useState(r._getWatch(i, a));
  return qe.useEffect(() => r._removeUnmounted()), m;
}
function Yq(e) {
  const n = xg(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = K1(a._names.array, r), l = Gq({
    control: a,
    name: r,
    defaultValue: an(a._formValues, r, an(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = Kq({
    control: a,
    name: r,
    exact: !0
  }), m = qe.useRef(e), u = qe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...lr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = qe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!an(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!an(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!an(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!an(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => an(d.errors, r)
    }
  }), [d, r]), h = qe.useCallback((N) => u.current.onChange({
    target: {
      value: W1(N),
      name: r
    },
    type: pl.CHANGE
  }), [r]), k = qe.useCallback(() => u.current.onBlur({
    target: {
      value: an(a._formValues, r),
      name: r
    },
    type: pl.BLUR
  }), [r, a._formValues]), F = qe.useCallback((N) => {
    const x = an(a._fields, r);
    x && N && (x._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (g) => N.setCustomValidity(g),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), j = qe.useMemo(() => ({
    name: r,
    value: l,
    ...lr(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: k,
    ref: F
  }), [r, i, d.disabled, h, k, F, l]);
  return qe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...lr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const x = (g, D) => {
      const I = an(a._fields, g);
      I && I._f && (I._f.mount = D);
    };
    if (x(r, !0), N) {
      const g = Pt(an(a._options.defaultValues, r));
      at(a._defaultValues, r, g), ht(an(a._formValues, r)) && at(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : x(r, !1);
    };
  }, [r, a, s, o]), qe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), qe.useMemo(() => ({
    field: j,
    formState: d,
    fieldState: f
  }), [j, d, f]);
}
var Jq = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, No = (e) => Array.isArray(e) ? e : [e], CS = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, ay = (e) => Yt(e) || !H1(e);
function mi(e, n) {
  if (ay(e) || ay(n))
    return e === n;
  if (Ti(e) && Ti(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Ti(o) && Ti(s) || vt(o) && vt(s) || Array.isArray(o) && Array.isArray(s) ? !mi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Kt = (e) => vt(e) && !Object.keys(e).length, _g = (e) => e.type === "file", Ir = (e) => typeof e == "function", fl = (e) => {
  if (!kg)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, Q1 = (e) => e.type === "select-multiple", Sg = (e) => e.type === "radio", Qq = (e) => Sg(e) || Wo(e), Fm = (e) => fl(e) && e.isConnected;
function Xq(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ht(e) ? i++ : e[n[i++]];
  return e;
}
function Zq(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ht(e[n]))
      return !1;
  return !0;
}
function Nt(e, n) {
  const r = Array.isArray(n) ? n : bg(n) ? [n] : G1(n), i = r.length === 1 ? e : Xq(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (vt(i) && Kt(i) || Array.isArray(i) && Zq(i)) && Nt(e, r.slice(0, -1)), e;
}
var X1 = (e) => {
  for (const n in e)
    if (Ir(e[n]))
      return !0;
  return !1;
};
function hl(e, n = {}) {
  const r = Array.isArray(e);
  if (vt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || vt(e[i]) && !X1(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, hl(e[i], n[i])) : Yt(e[i]) || (n[i] = !0);
  return n;
}
function Z1(e, n, r) {
  const i = Array.isArray(e);
  if (vt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || vt(e[a]) && !X1(e[a]) ? ht(n) || ay(r[a]) ? r[a] = Array.isArray(e[a]) ? hl(e[a], []) : { ...hl(e[a]) } : Z1(e[a], Yt(n) ? {} : n[a], r[a]) : r[a] = !mi(e[a], n[a]);
  return r;
}
var so = (e, n) => Z1(e, n, hl(n));
const FS = {
  value: !1,
  isValid: !1
}, IS = { value: !0, isValid: !0 };
var eF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ht(e[0].attributes.value) ? ht(e[0].value) || e[0].value === "" ? IS : { value: e[0].value, isValid: !0 } : IS
    ) : FS;
  }
  return FS;
}, nF = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ht(e) ? e : n ? e === "" ? NaN : e && +e : r && Br(e) ? new Date(e) : i ? i(e) : e;
const ES = {
  isValid: !1,
  value: null
};
var tF = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, ES) : ES;
function $S(e) {
  const n = e.ref;
  return _g(n) ? n.files : Sg(n) ? tF(e.refs).value : Q1(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Wo(n) ? eF(e.refs).value : nF(ht(n.value) ? e.ref.value : n.value, e);
}
var e6 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = an(n, o);
    s && at(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, yl = (e) => e instanceof RegExp, lo = (e) => ht(e) ? e : yl(e) ? e.source : vt(e) ? yl(e.value) ? e.value.source : e.value : e, TS = (e) => ({
  isOnSubmit: !e || e === Fr.onSubmit,
  isOnBlur: e === Fr.onBlur,
  isOnChange: e === Fr.onChange,
  isOnAll: e === Fr.all,
  isOnTouch: e === Fr.onTouched
});
const OS = "AsyncFunction";
var n6 = (e) => !!e && !!e.validate && !!(Ir(e.validate) && e.validate.constructor.name === OS || vt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === OS)), t6 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), DS = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const jo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = an(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (jo(l, n))
          break;
      } else if (vt(l) && jo(l, n))
        break;
    }
  }
};
function PS(e, n, r) {
  const i = an(e, r);
  if (i || bg(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = an(n, o), l = an(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var r6 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Kt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Fr.all));
}, i6 = (e, n, r) => !e || !n || e === n || No(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), a6 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, o6 = (e, n) => !Hl(an(e, n)).length && Nt(e, n), s6 = (e, n, r) => {
  const i = No(an(e, r));
  return at(i, "root", n[r]), at(e, r, i), e;
}, qs = (e) => Br(e);
function RS(e, n, r = "validate") {
  if (qs(e) || Array.isArray(e) && e.every(qs) || lr(e) && !e)
    return {
      type: r,
      message: qs(e) ? e : "",
      ref: n
    };
}
var ta = (e) => vt(e) && !yl(e) ? e : {
  value: e,
  message: ""
}, AS = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: k, validate: F, name: j, valueAsNumber: N, mount: x } = e._f, g = an(r, j);
  if (!x || n.has(j))
    return {};
  const D = l ? l[0] : s, I = (J) => {
    a && D.reportValidity && (D.setCustomValidity(lr(J) ? "" : J || ""), D.reportValidity());
  }, C = {}, w = Sg(s), A = Wo(s), q = w || A, Y = (N || _g(s)) && ht(s.value) && ht(g) || fl(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, te = Jq.bind(null, j, i, C), K = (J, R, B, ne = ei.maxLength, Ne = ei.minLength) => {
    const ue = J ? R : B;
    C[j] = {
      type: J ? ne : Ne,
      message: ue,
      ref: s,
      ...te(J ? ne : Ne, ue)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!q && (Y || Yt(g)) || lr(g) && !g || A && !eF(l).isValid || w && !tF(l).isValid)) {
    const { value: J, message: R } = qs(d) ? { value: !!d, message: d } : ta(d);
    if (J && (C[j] = {
      type: ei.required,
      message: R,
      ref: D,
      ...te(ei.required, R)
    }, !i))
      return I(R), C;
  }
  if (!Y && (!Yt(f) || !Yt(h))) {
    let J, R;
    const B = ta(h), ne = ta(f);
    if (!Yt(g) && !isNaN(g)) {
      const Ne = s.valueAsNumber || g && +g;
      Yt(B.value) || (J = Ne > B.value), Yt(ne.value) || (R = Ne < ne.value);
    } else {
      const Ne = s.valueAsDate || new Date(g), ue = (z) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + z), oe = s.type == "time", pe = s.type == "week";
      Br(B.value) && g && (J = oe ? ue(g) > ue(B.value) : pe ? g > B.value : Ne > new Date(B.value)), Br(ne.value) && g && (R = oe ? ue(g) < ue(ne.value) : pe ? g < ne.value : Ne < new Date(ne.value));
    }
    if ((J || R) && (K(!!J, B.message, ne.message, ei.max, ei.min), !i))
      return I(C[j].message), C;
  }
  if ((m || u) && !Y && (Br(g) || o && Array.isArray(g))) {
    const J = ta(m), R = ta(u), B = !Yt(J.value) && g.length > +J.value, ne = !Yt(R.value) && g.length < +R.value;
    if ((B || ne) && (K(B, J.message, R.message), !i))
      return I(C[j].message), C;
  }
  if (k && !Y && Br(g)) {
    const { value: J, message: R } = ta(k);
    if (yl(J) && !g.match(J) && (C[j] = {
      type: ei.pattern,
      message: R,
      ref: s,
      ...te(ei.pattern, R)
    }, !i))
      return I(R), C;
  }
  if (F) {
    if (Ir(F)) {
      const J = await F(g, r), R = RS(J, D);
      if (R && (C[j] = {
        ...R,
        ...te(ei.validate, R.message)
      }, !i))
        return I(R.message), C;
    } else if (vt(F)) {
      let J = {};
      for (const R in F) {
        if (!Kt(J) && !i)
          break;
        const B = RS(await F[R](g, r), D, R);
        B && (J = {
          ...B,
          ...te(R, B.message)
        }, I(B.message), i && (C[j] = J));
      }
      if (!Kt(J) && (C[j] = {
        ref: D,
        ...J
      }, !i))
        return C;
    }
  }
  return I(!0), C;
};
const l6 = {
  mode: Fr.onSubmit,
  reValidateMode: Fr.onChange,
  shouldFocusError: !0
};
function c6(e = {}) {
  let n = {
    ...l6,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Ir(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = vt(n.defaultValues) || vt(n.values) ? Pt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Pt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: CS(),
    state: CS()
  }, k = TS(n.mode), F = TS(n.reValidateMode), j = n.criteriaMode === Fr.all, N = (Q) => (T) => {
    clearTimeout(m), m = setTimeout(Q, T);
  }, x = async (Q) => {
    if (!n.disabled && (u.isValid || f.isValid || Q)) {
      const T = n.resolver ? Kt((await Y()).errors) : await K(i, !0);
      T !== r.isValid && h.state.next({
        isValid: T
      });
    }
  }, g = (Q, T) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((Q || Array.from(l.mount)).forEach((U) => {
      U && (T ? at(r.validatingFields, U, T) : Nt(r.validatingFields, U));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Kt(r.validatingFields)
    }));
  }, D = (Q, T = [], U, X, ae = !0, V = !0) => {
    if (X && U && !n.disabled) {
      if (s.action = !0, V && Array.isArray(an(i, Q))) {
        const G = U(an(i, Q), X.argA, X.argB);
        ae && at(i, Q, G);
      }
      if (V && Array.isArray(an(r.errors, Q))) {
        const G = U(an(r.errors, Q), X.argA, X.argB);
        ae && at(r.errors, Q, G), o6(r.errors, Q);
      }
      if ((u.touchedFields || f.touchedFields) && V && Array.isArray(an(r.touchedFields, Q))) {
        const G = U(an(r.touchedFields, Q), X.argA, X.argB);
        ae && at(r.touchedFields, Q, G);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = so(a, o)), h.state.next({
        name: Q,
        isDirty: R(Q, T),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      at(o, Q, T);
  }, I = (Q, T) => {
    at(r.errors, Q, T), h.state.next({
      errors: r.errors
    });
  }, C = (Q) => {
    r.errors = Q, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, w = (Q, T, U, X) => {
    const ae = an(i, Q);
    if (ae) {
      const V = an(o, Q, ht(U) ? an(a, Q) : U);
      ht(V) || X && X.defaultChecked || T ? at(o, Q, T ? V : $S(ae._f)) : Ne(Q, V), s.mount && x();
    }
  }, A = (Q, T, U, X, ae) => {
    let V = !1, G = !1;
    const fe = {
      name: Q
    };
    if (!n.disabled) {
      if (!U || X) {
        (u.isDirty || f.isDirty) && (G = r.isDirty, r.isDirty = fe.isDirty = R(), V = G !== fe.isDirty);
        const _e = mi(an(a, Q), T);
        G = !!an(r.dirtyFields, Q), _e ? Nt(r.dirtyFields, Q) : at(r.dirtyFields, Q, !0), fe.dirtyFields = r.dirtyFields, V = V || (u.dirtyFields || f.dirtyFields) && G !== !_e;
      }
      if (U) {
        const _e = an(r.touchedFields, Q);
        _e || (at(r.touchedFields, Q, U), fe.touchedFields = r.touchedFields, V = V || (u.touchedFields || f.touchedFields) && _e !== U);
      }
      V && ae && h.state.next(fe);
    }
    return V ? fe : {};
  }, q = (Q, T, U, X) => {
    const ae = an(r.errors, Q), V = (u.isValid || f.isValid) && lr(T) && r.isValid !== T;
    if (n.delayError && U ? (d = N(() => I(Q, U)), d(n.delayError)) : (clearTimeout(m), d = null, U ? at(r.errors, Q, U) : Nt(r.errors, Q)), (U ? !mi(ae, U) : ae) || !Kt(X) || V) {
      const G = {
        ...X,
        ...V && lr(T) ? { isValid: T } : {},
        errors: r.errors,
        name: Q
      };
      r = {
        ...r,
        ...G
      }, h.state.next(G);
    }
  }, Y = async (Q) => {
    g(Q, !0);
    const T = await n.resolver(o, n.context, e6(Q || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(Q), T;
  }, te = async (Q) => {
    const { errors: T } = await Y(Q);
    if (Q)
      for (const U of Q) {
        const X = an(T, U);
        X ? at(r.errors, U, X) : Nt(r.errors, U);
      }
    else
      r.errors = T;
    return T;
  }, K = async (Q, T, U = {
    valid: !0
  }) => {
    for (const X in Q) {
      const ae = Q[X];
      if (ae) {
        const { _f: V, ...G } = ae;
        if (V) {
          const fe = l.array.has(V.name), _e = ae._f && n6(ae._f);
          _e && u.validatingFields && g([X], !0);
          const Te = await AS(ae, l.disabled, o, j, n.shouldUseNativeValidation && !T, fe);
          if (_e && u.validatingFields && g([X]), Te[V.name] && (U.valid = !1, T))
            break;
          !T && (an(Te, V.name) ? fe ? s6(r.errors, Te, V.name) : at(r.errors, V.name, Te[V.name]) : Nt(r.errors, V.name));
        }
        !Kt(G) && await K(G, T, U);
      }
    }
    return U.valid;
  }, J = () => {
    for (const Q of l.unMount) {
      const T = an(i, Q);
      T && (T._f.refs ? T._f.refs.every((U) => !Fm(U)) : !Fm(T._f.ref)) && Be(Q);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (Q, T) => !n.disabled && (Q && T && at(o, Q, T), !mi($e(), a)), B = (Q, T, U) => J1(Q, l, {
    ...s.mount ? o : ht(T) ? a : Br(Q) ? { [Q]: T } : T
  }, U, T), ne = (Q) => Hl(an(s.mount ? o : a, Q, n.shouldUnregister ? an(a, Q, []) : [])), Ne = (Q, T, U = {}) => {
    const X = an(i, Q);
    let ae = T;
    if (X) {
      const V = X._f;
      V && (!V.disabled && at(o, Q, nF(T, V)), ae = fl(V.ref) && Yt(T) ? "" : T, Q1(V.ref) ? [...V.ref.options].forEach((G) => G.selected = ae.includes(G.value)) : V.refs ? Wo(V.ref) ? V.refs.length > 1 ? V.refs.forEach((G) => (!G.defaultChecked || !G.disabled) && (G.checked = Array.isArray(ae) ? !!ae.find((fe) => fe === G.value) : ae === G.value)) : V.refs[0] && (V.refs[0].checked = !!ae) : V.refs.forEach((G) => G.checked = G.value === ae) : _g(V.ref) ? V.ref.value = "" : (V.ref.value = ae, V.ref.type || h.state.next({
        name: Q,
        values: Pt(o)
      })));
    }
    (U.shouldDirty || U.shouldTouch) && A(Q, ae, U.shouldTouch, U.shouldDirty, !0), U.shouldValidate && ke(Q);
  }, ue = (Q, T, U) => {
    for (const X in T) {
      const ae = T[X], V = `${Q}.${X}`, G = an(i, V);
      (l.array.has(Q) || vt(ae) || G && !G._f) && !Ti(ae) ? ue(V, ae, U) : Ne(V, ae, U);
    }
  }, oe = (Q, T, U = {}) => {
    const X = an(i, Q), ae = l.array.has(Q), V = Pt(T);
    at(o, Q, V), ae ? (h.array.next({
      name: Q,
      values: Pt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && U.shouldDirty && h.state.next({
      name: Q,
      dirtyFields: so(a, o),
      isDirty: R(Q, V)
    })) : X && !X._f && !Yt(V) ? ue(Q, V, U) : Ne(Q, V, U), DS(Q, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? Q : void 0,
      values: Pt(o)
    });
  }, pe = async (Q) => {
    s.mount = !0;
    const T = Q.target;
    let U = T.name, X = !0;
    const ae = an(i, U), V = (G) => {
      X = Number.isNaN(G) || Ti(G) && isNaN(G.getTime()) || mi(G, an(o, U, G));
    };
    if (ae) {
      let G, fe;
      const _e = T.type ? $S(ae._f) : W1(Q), Te = Q.type === pl.BLUR || Q.type === pl.FOCUS_OUT, tn = !t6(ae._f) && !n.resolver && !an(r.errors, U) && !ae._f.deps || a6(Te, an(r.touchedFields, U), r.isSubmitted, F, k), vn = DS(U, l, Te);
      at(o, U, _e), Te ? (ae._f.onBlur && ae._f.onBlur(Q), d && d(0)) : ae._f.onChange && ae._f.onChange(Q);
      const on = A(U, _e, Te), pn = !Kt(on) || vn;
      if (!Te && h.state.next({
        name: U,
        type: Q.type,
        values: Pt(o)
      }), tn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Te && x() : Te || x()), pn && h.state.next({ name: U, ...vn ? {} : on });
      if (!Te && vn && h.state.next({ ...r }), n.resolver) {
        const { errors: In } = await Y([U]);
        if (V(_e), X) {
          const _n = PS(r.errors, i, U), En = PS(In, i, _n.name || U);
          G = En.error, U = En.name, fe = Kt(In);
        }
      } else
        g([U], !0), G = (await AS(ae, l.disabled, o, j, n.shouldUseNativeValidation))[U], g([U]), V(_e), X && (G ? fe = !1 : (u.isValid || f.isValid) && (fe = await K(i, !0)));
      X && (ae._f.deps && ke(ae._f.deps), q(U, fe, G, on));
    }
  }, z = (Q, T) => {
    if (an(r.errors, T) && Q.focus)
      return Q.focus(), 1;
  }, ke = async (Q, T = {}) => {
    let U, X;
    const ae = No(Q);
    if (n.resolver) {
      const V = await te(ht(Q) ? Q : ae);
      U = Kt(V), X = Q ? !ae.some((G) => an(V, G)) : U;
    } else Q ? (X = (await Promise.all(ae.map(async (V) => {
      const G = an(i, V);
      return await K(G && G._f ? { [V]: G } : G);
    }))).every(Boolean), !(!X && !r.isValid) && x()) : X = U = await K(i);
    return h.state.next({
      ...!Br(Q) || (u.isValid || f.isValid) && U !== r.isValid ? {} : { name: Q },
      ...n.resolver || !Q ? { isValid: U } : {},
      errors: r.errors
    }), T.shouldFocus && !X && jo(i, z, Q ? ae : l.mount), X;
  }, $e = (Q) => {
    const T = {
      ...s.mount ? o : a
    };
    return ht(Q) ? T : Br(Q) ? an(T, Q) : Q.map((U) => an(T, U));
  }, H = (Q, T) => ({
    invalid: !!an((T || r).errors, Q),
    isDirty: !!an((T || r).dirtyFields, Q),
    error: an((T || r).errors, Q),
    isValidating: !!an(r.validatingFields, Q),
    isTouched: !!an((T || r).touchedFields, Q)
  }), Ge = (Q) => {
    Q && No(Q).forEach((T) => Nt(r.errors, T)), h.state.next({
      errors: Q ? r.errors : {}
    });
  }, sn = (Q, T, U) => {
    const X = (an(i, Q, { _f: {} })._f || {}).ref, ae = an(r.errors, Q) || {}, { ref: V, message: G, type: fe, ..._e } = ae;
    at(r.errors, Q, {
      ..._e,
      ...T,
      ref: X
    }), h.state.next({
      name: Q,
      errors: r.errors,
      isValid: !1
    }), U && U.shouldFocus && X && X.focus && X.focus();
  }, Fe = (Q, T) => Ir(Q) ? h.state.subscribe({
    next: (U) => Q(B(void 0, T), U)
  }) : B(Q, T, !0), Ue = (Q) => h.state.subscribe({
    next: (T) => {
      i6(Q.name, T.name, Q.exact) && r6(T, Q.formState || u, Re, Q.reRenderRoot) && Q.callback({
        values: { ...o },
        ...r,
        ...T
      });
    }
  }).unsubscribe, Pe = (Q) => (s.mount = !0, f = {
    ...f,
    ...Q.formState
  }, Ue({
    ...Q,
    formState: f
  })), Be = (Q, T = {}) => {
    for (const U of Q ? No(Q) : l.mount)
      l.mount.delete(U), l.array.delete(U), T.keepValue || (Nt(i, U), Nt(o, U)), !T.keepError && Nt(r.errors, U), !T.keepDirty && Nt(r.dirtyFields, U), !T.keepTouched && Nt(r.touchedFields, U), !T.keepIsValidating && Nt(r.validatingFields, U), !n.shouldUnregister && !T.keepDefaultValue && Nt(a, U);
    h.state.next({
      values: Pt(o)
    }), h.state.next({
      ...r,
      ...T.keepDirty ? { isDirty: R() } : {}
    }), !T.keepIsValid && x();
  }, Ae = ({ disabled: Q, name: T }) => {
    (lr(Q) && s.mount || Q || l.disabled.has(T)) && (Q ? l.disabled.add(T) : l.disabled.delete(T));
  }, Qe = (Q, T = {}) => {
    let U = an(i, Q);
    const X = lr(T.disabled) || lr(n.disabled);
    return at(i, Q, {
      ...U || {},
      _f: {
        ...U && U._f ? U._f : { ref: { name: Q } },
        name: Q,
        mount: !0,
        ...T
      }
    }), l.mount.add(Q), U ? Ae({
      disabled: lr(T.disabled) ? T.disabled : n.disabled,
      name: Q
    }) : w(Q, !0, T.value), {
      ...X ? { disabled: T.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!T.required,
        min: lo(T.min),
        max: lo(T.max),
        minLength: lo(T.minLength),
        maxLength: lo(T.maxLength),
        pattern: lo(T.pattern)
      } : {},
      name: Q,
      onChange: pe,
      onBlur: pe,
      ref: (ae) => {
        if (ae) {
          Qe(Q, T), U = an(i, Q);
          const V = ht(ae.value) && ae.querySelectorAll && ae.querySelectorAll("input,select,textarea")[0] || ae, G = Qq(V), fe = U._f.refs || [];
          if (G ? fe.find((_e) => _e === V) : V === U._f.ref)
            return;
          at(i, Q, {
            _f: {
              ...U._f,
              ...G ? {
                refs: [
                  ...fe.filter(Fm),
                  V,
                  ...Array.isArray(an(a, Q)) ? [{}] : []
                ],
                ref: { type: V.type, name: Q }
              } : { ref: V }
            }
          }), w(Q, !1, void 0, V);
        } else
          U = an(i, Q, {}), U._f && (U._f.mount = !1), (n.shouldUnregister || T.shouldUnregister) && !(K1(l.array, Q) && s.action) && l.unMount.add(Q);
      }
    };
  }, Ce = () => n.shouldFocusError && jo(i, z, l.mount), Me = (Q) => {
    lr(Q) && (h.state.next({ disabled: Q }), jo(i, (T, U) => {
      const X = an(i, U);
      X && (T.disabled = X._f.disabled || Q, Array.isArray(X._f.refs) && X._f.refs.forEach((ae) => {
        ae.disabled = X._f.disabled || Q;
      }));
    }, 0, !1));
  }, nn = (Q, T) => async (U) => {
    let X;
    U && (U.preventDefault && U.preventDefault(), U.persist && U.persist());
    let ae = Pt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: V, values: G } = await Y();
      r.errors = V, ae = G;
    } else
      await K(i);
    if (l.disabled.size)
      for (const V of l.disabled)
        at(ae, V, void 0);
    if (Nt(r.errors, "root"), Kt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await Q(ae, U);
      } catch (V) {
        X = V;
      }
    } else
      T && await T({ ...r.errors }, U), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Kt(r.errors) && !X,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), X)
      throw X;
  }, le = (Q, T = {}) => {
    an(i, Q) && (ht(T.defaultValue) ? oe(Q, Pt(an(a, Q))) : (oe(Q, T.defaultValue), at(a, Q, Pt(T.defaultValue))), T.keepTouched || Nt(r.touchedFields, Q), T.keepDirty || (Nt(r.dirtyFields, Q), r.isDirty = T.defaultValue ? R(Q, Pt(an(a, Q))) : R()), T.keepError || (Nt(r.errors, Q), u.isValid && x()), h.state.next({ ...r }));
  }, ce = (Q, T = {}) => {
    const U = Q ? Pt(Q) : a, X = Pt(U), ae = Kt(Q), V = ae ? a : X;
    if (T.keepDefaultValues || (a = U), !T.keepValues) {
      if (T.keepDirtyValues) {
        const G = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(so(a, o))
        ]);
        for (const fe of Array.from(G))
          an(r.dirtyFields, fe) ? at(V, fe, an(o, fe)) : oe(fe, an(V, fe));
      } else {
        if (kg && ht(Q))
          for (const G of l.mount) {
            const fe = an(i, G);
            if (fe && fe._f) {
              const _e = Array.isArray(fe._f.refs) ? fe._f.refs[0] : fe._f.ref;
              if (fl(_e)) {
                const Te = _e.closest("form");
                if (Te) {
                  Te.reset();
                  break;
                }
              }
            }
          }
        for (const G of l.mount)
          oe(G, an(V, G));
      }
      o = Pt(V), h.array.next({
        values: { ...V }
      }), h.state.next({
        values: { ...V }
      });
    }
    l = {
      mount: T.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!T.keepIsValid || !!T.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: T.keepSubmitCount ? r.submitCount : 0,
      isDirty: ae ? !1 : T.keepDirty ? r.isDirty : !!(T.keepDefaultValues && !mi(Q, a)),
      isSubmitted: T.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: ae ? {} : T.keepDirtyValues ? T.keepDefaultValues && o ? so(a, o) : r.dirtyFields : T.keepDefaultValues && Q ? so(a, Q) : T.keepDirty ? r.dirtyFields : {},
      touchedFields: T.keepTouched ? r.touchedFields : {},
      errors: T.keepErrors ? r.errors : {},
      isSubmitSuccessful: T.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Se = (Q, T) => ce(Ir(Q) ? Q(o) : Q, T), Le = (Q, T = {}) => {
    const U = an(i, Q), X = U && U._f;
    if (X) {
      const ae = X.refs ? X.refs[0] : X.ref;
      ae.focus && (ae.focus(), T.shouldSelect && Ir(ae.select) && ae.select());
    }
  }, Re = (Q) => {
    r = {
      ...r,
      ...Q
    };
  }, gn = {
    control: {
      register: Qe,
      unregister: Be,
      getFieldState: H,
      handleSubmit: nn,
      setError: sn,
      _subscribe: Ue,
      _runSchema: Y,
      _getWatch: B,
      _getDirty: R,
      _setValid: x,
      _setFieldArray: D,
      _setDisabledField: Ae,
      _setErrors: C,
      _getFieldArray: ne,
      _reset: ce,
      _resetDefaultValues: () => Ir(n.defaultValues) && n.defaultValues().then((Q) => {
        Se(Q, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: J,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(Q) {
        s = Q;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(Q) {
        l = Q;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(Q) {
        n = {
          ...n,
          ...Q
        };
      }
    },
    subscribe: Pe,
    trigger: ke,
    register: Qe,
    handleSubmit: nn,
    watch: Fe,
    setValue: oe,
    getValues: $e,
    reset: Se,
    resetField: le,
    clearErrors: Ge,
    unregister: Be,
    setError: sn,
    setFocus: Le,
    getFieldState: H
  };
  return {
    ...gn,
    formControl: gn
  };
}
function d6(e = {}) {
  const n = qe.useRef(void 0), r = qe.useRef(void 0), [i, a] = qe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Ir(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Ir(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : c6(e),
    formState: i
  }, e.formControl && e.defaultValues && !Ir(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, qe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), qe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), qe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), qe.useEffect(() => {
    e.values && !mi(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), qe.useEffect(() => {
    e.errors && !Kt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), qe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), qe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Y1(i, o), n.current;
}
var _s = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function rF(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Im = { exports: {} }, co = {}, LS;
function u6() {
  if (LS) return co;
  LS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return co.Fragment = r, co.jsx = s, co.jsxs = s, co;
}
var Ss = {}, VS;
function m6() {
  return VS || (VS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Ss.Fragment = i, Ss.jsx = Un, Ss.jsxs = Kn;
  })()), Ss;
}
var zS;
function p6() {
  return zS || (zS = 1, process.env.NODE_ENV === "production" ? Im.exports = u6() : Im.exports = m6()), Im.exports;
}
var wo = p6();
function f6(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Em, US;
function vi() {
  if (US) return Em;
  US = 1;
  var e = Array.isArray;
  return Em = e, Em;
}
var $m, MS;
function iF() {
  if (MS) return $m;
  MS = 1;
  var e = typeof _s == "object" && _s && _s.Object === Object && _s;
  return $m = e, $m;
}
var Tm, BS;
function Gr() {
  if (BS) return Tm;
  BS = 1;
  var e = iF(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Tm = r, Tm;
}
var Om, qS;
function Ko() {
  if (qS) return Om;
  qS = 1;
  var e = Gr(), n = e.Symbol;
  return Om = n, Om;
}
var Dm, HS;
function h6() {
  if (HS) return Dm;
  HS = 1;
  var e = Ko(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return Dm = o, Dm;
}
var Pm, WS;
function y6() {
  if (WS) return Pm;
  WS = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Pm = r, Pm;
}
var Rm, KS;
function Ea() {
  if (KS) return Rm;
  KS = 1;
  var e = Ko(), n = h6(), r = y6(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Rm = s, Rm;
}
var Am, GS;
function Hi() {
  if (GS) return Am;
  GS = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Am = e, Am;
}
var Lm, YS;
function Ng() {
  if (YS) return Lm;
  YS = 1;
  var e = Ea(), n = Hi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Lm = i, Lm;
}
var Vm, JS;
function g6() {
  if (JS) return Vm;
  JS = 1;
  var e = vi(), n = Ng(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Vm = a, Vm;
}
var zm, QS;
function $a() {
  if (QS) return zm;
  QS = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return zm = e, zm;
}
var Um, XS;
function aF() {
  if (XS) return Um;
  XS = 1;
  var e = Ea(), n = $a(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return Um = s, Um;
}
var Mm, ZS;
function v6() {
  if (ZS) return Mm;
  ZS = 1;
  var e = Gr(), n = e["__core-js_shared__"];
  return Mm = n, Mm;
}
var Bm, e0;
function k6() {
  if (e0) return Bm;
  e0 = 1;
  var e = v6(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Bm = r, Bm;
}
var qm, n0;
function oF() {
  if (n0) return qm;
  n0 = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return qm = r, qm;
}
var Hm, t0;
function b6() {
  if (t0) return Hm;
  t0 = 1;
  var e = aF(), n = k6(), r = $a(), i = oF(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var k = e(h) ? u : o;
    return k.test(i(h));
  }
  return Hm = f, Hm;
}
var Wm, r0;
function x6() {
  if (r0) return Wm;
  r0 = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Wm = e, Wm;
}
var Km, i0;
function Wi() {
  if (i0) return Km;
  i0 = 1;
  var e = b6(), n = x6();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Km = r, Km;
}
var Gm, a0;
function Wl() {
  if (a0) return Gm;
  a0 = 1;
  var e = Wi(), n = e(Object, "create");
  return Gm = n, Gm;
}
var Ym, o0;
function _6() {
  if (o0) return Ym;
  o0 = 1;
  var e = Wl();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Ym = n, Ym;
}
var Jm, s0;
function S6() {
  if (s0) return Jm;
  s0 = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Jm = e, Jm;
}
var Qm, l0;
function N6() {
  if (l0) return Qm;
  l0 = 1;
  var e = Wl(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Qm = a, Qm;
}
var Xm, c0;
function j6() {
  if (c0) return Xm;
  c0 = 1;
  var e = Wl(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Xm = i, Xm;
}
var Zm, d0;
function w6() {
  if (d0) return Zm;
  d0 = 1;
  var e = Wl(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Zm = r, Zm;
}
var ep, u0;
function C6() {
  if (u0) return ep;
  u0 = 1;
  var e = _6(), n = S6(), r = N6(), i = j6(), a = w6();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, ep = o, ep;
}
var np, m0;
function F6() {
  if (m0) return np;
  m0 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return np = e, np;
}
var tp, p0;
function sF() {
  if (p0) return tp;
  p0 = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return tp = e, tp;
}
var rp, f0;
function Kl() {
  if (f0) return rp;
  f0 = 1;
  var e = sF();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return rp = n, rp;
}
var ip, h0;
function I6() {
  if (h0) return ip;
  h0 = 1;
  var e = Kl(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return ip = i, ip;
}
var ap, y0;
function E6() {
  if (y0) return ap;
  y0 = 1;
  var e = Kl();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return ap = n, ap;
}
var op, g0;
function $6() {
  if (g0) return op;
  g0 = 1;
  var e = Kl();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return op = n, op;
}
var sp, v0;
function T6() {
  if (v0) return sp;
  v0 = 1;
  var e = Kl();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return sp = n, sp;
}
var lp, k0;
function Gl() {
  if (k0) return lp;
  k0 = 1;
  var e = F6(), n = I6(), r = E6(), i = $6(), a = T6();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, lp = o, lp;
}
var cp, b0;
function jg() {
  if (b0) return cp;
  b0 = 1;
  var e = Wi(), n = Gr(), r = e(n, "Map");
  return cp = r, cp;
}
var dp, x0;
function O6() {
  if (x0) return dp;
  x0 = 1;
  var e = C6(), n = Gl(), r = jg();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return dp = i, dp;
}
var up, _0;
function D6() {
  if (_0) return up;
  _0 = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return up = e, up;
}
var mp, S0;
function Yl() {
  if (S0) return mp;
  S0 = 1;
  var e = D6();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return mp = n, mp;
}
var pp, N0;
function P6() {
  if (N0) return pp;
  N0 = 1;
  var e = Yl();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return pp = n, pp;
}
var fp, j0;
function R6() {
  if (j0) return fp;
  j0 = 1;
  var e = Yl();
  function n(r) {
    return e(this, r).get(r);
  }
  return fp = n, fp;
}
var hp, w0;
function A6() {
  if (w0) return hp;
  w0 = 1;
  var e = Yl();
  function n(r) {
    return e(this, r).has(r);
  }
  return hp = n, hp;
}
var yp, C0;
function L6() {
  if (C0) return yp;
  C0 = 1;
  var e = Yl();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return yp = n, yp;
}
var gp, F0;
function lF() {
  if (F0) return gp;
  F0 = 1;
  var e = O6(), n = P6(), r = R6(), i = A6(), a = L6();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, gp = o, gp;
}
var vp, I0;
function V6() {
  if (I0) return vp;
  I0 = 1;
  var e = lF(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, vp = r, vp;
}
var kp, E0;
function z6() {
  if (E0) return kp;
  E0 = 1;
  var e = V6(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return kp = r, kp;
}
var bp, $0;
function U6() {
  if ($0) return bp;
  $0 = 1;
  var e = z6(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return bp = i, bp;
}
var xp, T0;
function cF() {
  if (T0) return xp;
  T0 = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return xp = e, xp;
}
var _p, O0;
function M6() {
  if (O0) return _p;
  O0 = 1;
  var e = Ko(), n = cF(), r = vi(), i = Ng(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return _p = s, _p;
}
var Sp, D0;
function B6() {
  if (D0) return Sp;
  D0 = 1;
  var e = M6();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Sp = n, Sp;
}
var Np, P0;
function Ta() {
  if (P0) return Np;
  P0 = 1;
  var e = vi(), n = g6(), r = U6(), i = B6();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Np = a, Np;
}
var jp, R0;
function Jl() {
  if (R0) return jp;
  R0 = 1;
  var e = Ng();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return jp = n, jp;
}
var wp, A0;
function dF() {
  if (A0) return wp;
  A0 = 1;
  var e = Ta(), n = Jl();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return wp = r, wp;
}
var Cp, L0;
function uF() {
  if (L0) return Cp;
  L0 = 1;
  var e = Wi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Cp = n, Cp;
}
var Fp, V0;
function mF() {
  if (V0) return Fp;
  V0 = 1;
  var e = uF();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Fp = n, Fp;
}
var Ip, z0;
function wg() {
  if (z0) return Ip;
  z0 = 1;
  var e = mF(), n = sF(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Ip = a, Ip;
}
var Ep, U0;
function Cg() {
  if (U0) return Ep;
  U0 = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Ep = r, Ep;
}
var $p, M0;
function q6() {
  if (M0) return $p;
  M0 = 1;
  var e = wg(), n = Ta(), r = Cg(), i = $a(), a = Jl();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, k = s; k != null && ++u < f; ) {
      var F = a(l[u]), j = d;
      if (F === "__proto__" || F === "constructor" || F === "prototype")
        return s;
      if (u != h) {
        var N = k[F];
        j = m ? m(N, F, k) : void 0, j === void 0 && (j = i(N) ? N : r(l[u + 1]) ? [] : {});
      }
      e(k, F, j), k = k[F];
    }
    return s;
  }
  return $p = o, $p;
}
var Tp, B0;
function H6() {
  if (B0) return Tp;
  B0 = 1;
  var e = dF(), n = q6(), r = Ta();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Tp = i, Tp;
}
var Op, q0;
function W6() {
  if (q0) return Op;
  q0 = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Op = e, Op;
}
var Dp, H0;
function K6() {
  if (H0) return Dp;
  H0 = 1;
  var e = Ea(), n = Hi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Dp = i, Dp;
}
var Pp, W0;
function Fg() {
  if (W0) return Pp;
  W0 = 1;
  var e = K6(), n = Hi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Pp = o, Pp;
}
var Rp, K0;
function Ig() {
  if (K0) return Rp;
  K0 = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Rp = n, Rp;
}
var Ap, G0;
function G6() {
  if (G0) return Ap;
  G0 = 1;
  var e = Ta(), n = Fg(), r = vi(), i = Cg(), a = Ig(), o = Jl();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var k = o(d[u]);
      if (!(h = l != null && m(l, k)))
        break;
      l = l[k];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(k, f) && (r(l) || n(l)));
  }
  return Ap = s, Ap;
}
var Lp, Y0;
function Y6() {
  if (Y0) return Lp;
  Y0 = 1;
  var e = W6(), n = G6();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Lp = r, Lp;
}
var Vp, J0;
function J6() {
  if (J0) return Vp;
  J0 = 1;
  var e = H6(), n = Y6();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Vp = r, Vp;
}
var zp, Q0;
function Eg() {
  if (Q0) return zp;
  Q0 = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return zp = e, zp;
}
var Up, X0;
function Q6() {
  if (X0) return Up;
  X0 = 1;
  var e = Ko(), n = Fg(), r = vi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Up = a, Up;
}
var Mp, Z0;
function X6() {
  if (Z0) return Mp;
  Z0 = 1;
  var e = Eg(), n = Q6();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return Mp = r, Mp;
}
var Bp, eN;
function Z6() {
  if (eN) return Bp;
  eN = 1;
  var e = X6();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Bp = n, Bp;
}
var qp, nN;
function eH() {
  if (nN) return qp;
  nN = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return qp = e, qp;
}
var Hp, tN;
function nH() {
  if (tN) return Hp;
  tN = 1;
  var e = eH(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return Hp = r, Hp;
}
var Wp, rN;
function tH() {
  if (rN) return Wp;
  rN = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Wp = e, Wp;
}
var Kp, iN;
function pF() {
  if (iN) return Kp;
  iN = 1;
  function e(n) {
    return n;
  }
  return Kp = e, Kp;
}
var Gp, aN;
function rH() {
  if (aN) return Gp;
  aN = 1;
  var e = tH(), n = uF(), r = pF(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Gp = i, Gp;
}
var Yp, oN;
function iH() {
  if (oN) return Yp;
  oN = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Yp = i, Yp;
}
var Jp, sN;
function aH() {
  if (sN) return Jp;
  sN = 1;
  var e = rH(), n = iH(), r = n(e);
  return Jp = r, Jp;
}
var Qp, lN;
function fF() {
  if (lN) return Qp;
  lN = 1;
  var e = Z6(), n = nH(), r = aH();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Qp = i, Qp;
}
var Xp, cN;
function oH() {
  if (cN) return Xp;
  cN = 1;
  var e = J6(), n = fF(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Xp = r, Xp;
}
var sH = oH();
const hF = /* @__PURE__ */ rF(sH), lH = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function yF(e) {
  const n = hF(e, lH);
  return {
    controller: Yq(n),
    controllerProps: n
  };
}
const cH = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function dH(e) {
  const { controller: n, controllerProps: r } = yF(e), i = {
    ...hF(e, cH),
    required: f6(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Zp, dN;
function uH() {
  if (dN) return Zp;
  dN = 1;
  var e = Gl();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Zp = n, Zp;
}
var ef, uN;
function mH() {
  if (uN) return ef;
  uN = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return ef = e, ef;
}
var nf, mN;
function pH() {
  if (mN) return nf;
  mN = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return nf = e, nf;
}
var tf, pN;
function fH() {
  if (pN) return tf;
  pN = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return tf = e, tf;
}
var rf, fN;
function hH() {
  if (fN) return rf;
  fN = 1;
  var e = Gl(), n = jg(), r = lF(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return rf = a, rf;
}
var af, hN;
function yH() {
  if (hN) return af;
  hN = 1;
  var e = Gl(), n = uH(), r = mH(), i = pH(), a = fH(), o = hH();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, af = s, af;
}
var of, yN;
function gH() {
  if (yN) return of;
  yN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return of = e, of;
}
var sf, gN;
function Go() {
  if (gN) return sf;
  gN = 1;
  var e = wg(), n = mF();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return sf = r, sf;
}
var lf, vN;
function vH() {
  if (vN) return lf;
  vN = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return lf = e, lf;
}
var Hs = { exports: {} }, cf, kN;
function kH() {
  if (kN) return cf;
  kN = 1;
  function e() {
    return !1;
  }
  return cf = e, cf;
}
Hs.exports;
var bN;
function gF() {
  return bN || (bN = 1, (function(e, n) {
    var r = Gr(), i = kH(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(Hs, Hs.exports)), Hs.exports;
}
var df, xN;
function bH() {
  if (xN) return df;
  xN = 1;
  var e = Ea(), n = Ig(), r = Hi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", k = "[object Set]", F = "[object String]", j = "[object WeakMap]", N = "[object ArrayBuffer]", x = "[object DataView]", g = "[object Float32Array]", D = "[object Float64Array]", I = "[object Int8Array]", C = "[object Int16Array]", w = "[object Int32Array]", A = "[object Uint8Array]", q = "[object Uint8ClampedArray]", Y = "[object Uint16Array]", te = "[object Uint32Array]", K = {};
  K[g] = K[D] = K[I] = K[C] = K[w] = K[A] = K[q] = K[Y] = K[te] = !0, K[i] = K[a] = K[N] = K[o] = K[x] = K[s] = K[l] = K[d] = K[m] = K[u] = K[f] = K[h] = K[k] = K[F] = K[j] = !1;
  function J(R) {
    return r(R) && n(R.length) && !!K[e(R)];
  }
  return df = J, df;
}
var uf, _N;
function $g() {
  if (_N) return uf;
  _N = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return uf = e, uf;
}
var Ws = { exports: {} };
Ws.exports;
var SN;
function Tg() {
  return SN || (SN = 1, (function(e, n) {
    var r = iF(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(Ws, Ws.exports)), Ws.exports;
}
var mf, NN;
function xH() {
  if (NN) return mf;
  NN = 1;
  var e = bH(), n = $g(), r = Tg(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return mf = a, mf;
}
var pf, jN;
function vF() {
  if (jN) return pf;
  jN = 1;
  var e = vH(), n = Fg(), r = vi(), i = gF(), a = Cg(), o = xH(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), k = !f && !h && i(m), F = !f && !h && !k && o(m), j = f || h || k || F, N = j ? e(m.length, String) : [], x = N.length;
    for (var g in m)
      (u || l.call(m, g)) && !(j && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      k && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      F && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, x))) && N.push(g);
    return N;
  }
  return pf = d, pf;
}
var ff, wN;
function Og() {
  if (wN) return ff;
  wN = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return ff = n, ff;
}
var hf, CN;
function kF() {
  if (CN) return hf;
  CN = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return hf = e, hf;
}
var yf, FN;
function _H() {
  if (FN) return yf;
  FN = 1;
  var e = kF(), n = e(Object.keys, Object);
  return yf = n, yf;
}
var gf, IN;
function SH() {
  if (IN) return gf;
  IN = 1;
  var e = Og(), n = _H(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return gf = a, gf;
}
var vf, EN;
function bF() {
  if (EN) return vf;
  EN = 1;
  var e = aF(), n = Ig();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return vf = r, vf;
}
var kf, $N;
function Dg() {
  if ($N) return kf;
  $N = 1;
  var e = vF(), n = SH(), r = bF();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return kf = i, kf;
}
var bf, TN;
function NH() {
  if (TN) return bf;
  TN = 1;
  var e = Go(), n = Dg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return bf = r, bf;
}
var xf, ON;
function jH() {
  if (ON) return xf;
  ON = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return xf = e, xf;
}
var _f, DN;
function wH() {
  if (DN) return _f;
  DN = 1;
  var e = $a(), n = Og(), r = jH(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return _f = o, _f;
}
var Sf, PN;
function Pg() {
  if (PN) return Sf;
  PN = 1;
  var e = vF(), n = wH(), r = bF();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return Sf = i, Sf;
}
var Nf, RN;
function CH() {
  if (RN) return Nf;
  RN = 1;
  var e = Go(), n = Pg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Nf = r, Nf;
}
var Ks = { exports: {} };
Ks.exports;
var AN;
function FH() {
  return AN || (AN = 1, (function(e, n) {
    var r = Gr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(Ks, Ks.exports)), Ks.exports;
}
var jf, LN;
function IH() {
  if (LN) return jf;
  LN = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return jf = e, jf;
}
var wf, VN;
function EH() {
  if (VN) return wf;
  VN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return wf = e, wf;
}
var Cf, zN;
function xF() {
  if (zN) return Cf;
  zN = 1;
  function e() {
    return [];
  }
  return Cf = e, Cf;
}
var Ff, UN;
function Rg() {
  if (UN) return Ff;
  UN = 1;
  var e = EH(), n = xF(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Ff = o, Ff;
}
var If, MN;
function $H() {
  if (MN) return If;
  MN = 1;
  var e = Go(), n = Rg();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return If = r, If;
}
var Ef, BN;
function Ag() {
  if (BN) return Ef;
  BN = 1;
  var e = kF(), n = e(Object.getPrototypeOf, Object);
  return Ef = n, Ef;
}
var $f, qN;
function _F() {
  if (qN) return $f;
  qN = 1;
  var e = Eg(), n = Ag(), r = Rg(), i = xF(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return $f = o, $f;
}
var Tf, HN;
function TH() {
  if (HN) return Tf;
  HN = 1;
  var e = Go(), n = _F();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Tf = r, Tf;
}
var Of, WN;
function SF() {
  if (WN) return Of;
  WN = 1;
  var e = Eg(), n = vi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Of = r, Of;
}
var Df, KN;
function OH() {
  if (KN) return Df;
  KN = 1;
  var e = SF(), n = Rg(), r = Dg();
  function i(a) {
    return e(a, r, n);
  }
  return Df = i, Df;
}
var Pf, GN;
function NF() {
  if (GN) return Pf;
  GN = 1;
  var e = SF(), n = _F(), r = Pg();
  function i(a) {
    return e(a, r, n);
  }
  return Pf = i, Pf;
}
var Rf, YN;
function DH() {
  if (YN) return Rf;
  YN = 1;
  var e = Wi(), n = Gr(), r = e(n, "DataView");
  return Rf = r, Rf;
}
var Af, JN;
function PH() {
  if (JN) return Af;
  JN = 1;
  var e = Wi(), n = Gr(), r = e(n, "Promise");
  return Af = r, Af;
}
var Lf, QN;
function RH() {
  if (QN) return Lf;
  QN = 1;
  var e = Wi(), n = Gr(), r = e(n, "Set");
  return Lf = r, Lf;
}
var Vf, XN;
function AH() {
  if (XN) return Vf;
  XN = 1;
  var e = Wi(), n = Gr(), r = e(n, "WeakMap");
  return Vf = r, Vf;
}
var zf, ZN;
function Lg() {
  if (ZN) return zf;
  ZN = 1;
  var e = DH(), n = jg(), r = PH(), i = RH(), a = AH(), o = Ea(), s = oF(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", k = s(e), F = s(n), j = s(r), N = s(i), x = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != m || i && g(new i()) != u || a && g(new a()) != f) && (g = function(D) {
    var I = o(D), C = I == d ? D.constructor : void 0, w = C ? s(C) : "";
    if (w)
      switch (w) {
        case k:
          return h;
        case F:
          return l;
        case j:
          return m;
        case N:
          return u;
        case x:
          return f;
      }
    return I;
  }), zf = g, zf;
}
var Uf, ej;
function LH() {
  if (ej) return Uf;
  ej = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Uf = r, Uf;
}
var Mf, nj;
function VH() {
  if (nj) return Mf;
  nj = 1;
  var e = Gr(), n = e.Uint8Array;
  return Mf = n, Mf;
}
var Bf, tj;
function Vg() {
  if (tj) return Bf;
  tj = 1;
  var e = VH();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Bf = n, Bf;
}
var qf, rj;
function zH() {
  if (rj) return qf;
  rj = 1;
  var e = Vg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return qf = n, qf;
}
var Hf, ij;
function UH() {
  if (ij) return Hf;
  ij = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Hf = n, Hf;
}
var Wf, aj;
function MH() {
  if (aj) return Wf;
  aj = 1;
  var e = Ko(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Wf = i, Wf;
}
var Kf, oj;
function BH() {
  if (oj) return Kf;
  oj = 1;
  var e = Vg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Kf = n, Kf;
}
var Gf, sj;
function qH() {
  if (sj) return Gf;
  sj = 1;
  var e = Vg(), n = zH(), r = UH(), i = MH(), a = BH(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", k = "[object ArrayBuffer]", F = "[object DataView]", j = "[object Float32Array]", N = "[object Float64Array]", x = "[object Int8Array]", g = "[object Int16Array]", D = "[object Int32Array]", I = "[object Uint8Array]", C = "[object Uint8ClampedArray]", w = "[object Uint16Array]", A = "[object Uint32Array]";
  function q(Y, te, K) {
    var J = Y.constructor;
    switch (te) {
      case k:
        return e(Y);
      case o:
      case s:
        return new J(+Y);
      case F:
        return n(Y, K);
      case j:
      case N:
      case x:
      case g:
      case D:
      case I:
      case C:
      case w:
      case A:
        return a(Y, K);
      case l:
        return new J();
      case d:
      case f:
        return new J(Y);
      case m:
        return r(Y);
      case u:
        return new J();
      case h:
        return i(Y);
    }
  }
  return Gf = q, Gf;
}
var Yf, lj;
function HH() {
  if (lj) return Yf;
  lj = 1;
  var e = $a(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Yf = r, Yf;
}
var Jf, cj;
function WH() {
  if (cj) return Jf;
  cj = 1;
  var e = HH(), n = Ag(), r = Og();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Jf = i, Jf;
}
var Qf, dj;
function KH() {
  if (dj) return Qf;
  dj = 1;
  var e = Lg(), n = Hi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Qf = i, Qf;
}
var Xf, uj;
function GH() {
  if (uj) return Xf;
  uj = 1;
  var e = KH(), n = $g(), r = Tg(), i = r && r.isMap, a = i ? n(i) : e;
  return Xf = a, Xf;
}
var Zf, mj;
function YH() {
  if (mj) return Zf;
  mj = 1;
  var e = Lg(), n = Hi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Zf = i, Zf;
}
var eh, pj;
function JH() {
  if (pj) return eh;
  pj = 1;
  var e = YH(), n = $g(), r = Tg(), i = r && r.isSet, a = i ? n(i) : e;
  return eh = a, eh;
}
var nh, fj;
function QH() {
  if (fj) return nh;
  fj = 1;
  var e = yH(), n = gH(), r = wg(), i = NH(), a = CH(), o = FH(), s = IH(), l = $H(), d = TH(), m = OH(), u = NF(), f = Lg(), h = LH(), k = qH(), F = WH(), j = vi(), N = gF(), x = GH(), g = $a(), D = JH(), I = Dg(), C = Pg(), w = 1, A = 2, q = 4, Y = "[object Arguments]", te = "[object Array]", K = "[object Boolean]", J = "[object Date]", R = "[object Error]", B = "[object Function]", ne = "[object GeneratorFunction]", Ne = "[object Map]", ue = "[object Number]", oe = "[object Object]", pe = "[object RegExp]", z = "[object Set]", ke = "[object String]", $e = "[object Symbol]", H = "[object WeakMap]", Ge = "[object ArrayBuffer]", sn = "[object DataView]", Fe = "[object Float32Array]", Ue = "[object Float64Array]", Pe = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Qe = "[object Uint8Array]", Ce = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", nn = "[object Uint32Array]", le = {};
  le[Y] = le[te] = le[Ge] = le[sn] = le[K] = le[J] = le[Fe] = le[Ue] = le[Pe] = le[Be] = le[Ae] = le[Ne] = le[ue] = le[oe] = le[pe] = le[z] = le[ke] = le[$e] = le[Qe] = le[Ce] = le[Me] = le[nn] = !0, le[R] = le[B] = le[H] = !1;
  function ce(Se, Le, Re, gn, Q, T) {
    var U, X = Le & w, ae = Le & A, V = Le & q;
    if (Re && (U = Q ? Re(Se, gn, Q, T) : Re(Se)), U !== void 0)
      return U;
    if (!g(Se))
      return Se;
    var G = j(Se);
    if (G) {
      if (U = h(Se), !X)
        return s(Se, U);
    } else {
      var fe = f(Se), _e = fe == B || fe == ne;
      if (N(Se))
        return o(Se, X);
      if (fe == oe || fe == Y || _e && !Q) {
        if (U = ae || _e ? {} : F(Se), !X)
          return ae ? d(Se, a(U, Se)) : l(Se, i(U, Se));
      } else {
        if (!le[fe])
          return Q ? Se : {};
        U = k(Se, fe, X);
      }
    }
    T || (T = new e());
    var Te = T.get(Se);
    if (Te)
      return Te;
    T.set(Se, U), D(Se) ? Se.forEach(function(on) {
      U.add(ce(on, Le, Re, on, Se, T));
    }) : x(Se) && Se.forEach(function(on, pn) {
      U.set(pn, ce(on, Le, Re, pn, Se, T));
    });
    var tn = V ? ae ? u : m : ae ? C : I, vn = G ? void 0 : tn(Se);
    return n(vn || Se, function(on, pn) {
      vn && (pn = on, on = Se[pn]), r(U, pn, ce(on, Le, Re, pn, Se, T));
    }), U;
  }
  return nh = ce, nh;
}
var th, hj;
function XH() {
  if (hj) return th;
  hj = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return th = e, th;
}
var rh, yj;
function ZH() {
  if (yj) return rh;
  yj = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return rh = e, rh;
}
var ih, gj;
function eW() {
  if (gj) return ih;
  gj = 1;
  var e = dF(), n = ZH();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return ih = r, ih;
}
var ah, vj;
function nW() {
  if (vj) return ah;
  vj = 1;
  var e = Ta(), n = XH(), r = eW(), i = Jl(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return ah = s, ah;
}
var oh, kj;
function tW() {
  if (kj) return oh;
  kj = 1;
  var e = Ea(), n = Ag(), r = Hi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return oh = m, oh;
}
var sh, bj;
function rW() {
  if (bj) return sh;
  bj = 1;
  var e = tW();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return sh = n, sh;
}
var lh, xj;
function iW() {
  if (xj) return lh;
  xj = 1;
  var e = cF(), n = QH(), r = nW(), i = Ta(), a = Go(), o = rW(), s = fF(), l = NF(), d = 1, m = 2, u = 4, f = s(function(h, k) {
    var F = {};
    if (h == null)
      return F;
    var j = !1;
    k = e(k, function(x) {
      return x = i(x, h), j || (j = x.length > 1), x;
    }), a(h, l(h), F), j && (F = n(F, d | m | u, o));
    for (var N = k.length; N--; )
      r(F, k[N]);
    return F;
  });
  return lh = f, lh;
}
iW();
var aW = pF();
const oW = /* @__PURE__ */ rF(aW), ra = ({
  transformValue: e = oW,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = yF(a);
  return /* @__PURE__ */ wo.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ wo.jsx(
      Io,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ wo.jsx(bw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, _j = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = dH(e);
  return /* @__PURE__ */ wo.jsx(He, { ...i, children: /* @__PURE__ */ wo.jsx(
    dr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: He.getStatus(i.meta)
    }
  ) });
}, oy = [
  {
    key: "rivoLoyaltyApiKey",
    defaultValue: "",
    secret: !0,
    type: "string"
  },
  {
    key: vg,
    defaultValue: "",
    secret: !1,
    type: "string"
  },
  {
    key: "rivoLoyaltyShowOrders",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowLoyalty",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyAdjustLoyaltyPoints",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowFavoriteProducts",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowPointsRedemptions",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  }
], Sj = "RIVOLOYALTY", Ns = "Rivo Loyalty", sW = {
  enabled: !1,
  name: "",
  rivoLoyaltyApiKey: "",
  [vg]: "",
  rivoLoyaltyShowOrders: !0,
  rivoLoyaltyShowLoyalty: !0,
  rivoLoyaltyAdjustLoyaltyPoints: !0,
  rivoLoyaltyShowFavoriteProducts: !0,
  rivoLoyaltyShowPointsRedemptions: !0
}, lW = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = d6({
    mode: "onChange",
    defaultValues: sW
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: Sj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: oy,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: I, renderConditionsForSubmit: C } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (q) => hr(q, {
    fieldDefinitions: oy,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), A = s.watch("name");
  return /* @__PURE__ */ be.jsxs(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ be.jsx(yr, { cause: h }),
        /* @__PURE__ */ be.jsxs(nt, { children: [
          /* @__PURE__ */ be.jsx(Z, { children: /* @__PURE__ */ be.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ be.jsx(
            ra,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(
            _j,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(
            _j,
            {
              name: "rivoLoyaltyShopifyApiHostName",
              label: "Shopify API host name",
              control: s.control,
              rules: {
                required: "Shopify API host name is required",
                validate: (q) => bl(q) ?? void 0
              },
              componentProps: {
                placeholder: 'Host name of your Shopify shop, e.g. "my-webshop.myshopify.com"',
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(
            Er,
            {
              name: "rivoLoyaltyApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your Rivo API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(He, { label: "Show orders overview", children: /* @__PURE__ */ be.jsx(
            ra,
            {
              name: "rivoLoyaltyShowOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(He, { label: "Show loyalty", children: /* @__PURE__ */ be.jsx(
            ra,
            {
              name: "rivoLoyaltyShowLoyalty",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(He, { label: "Allow adjusting loyalty points", children: /* @__PURE__ */ be.jsx(
            ra,
            {
              name: "rivoLoyaltyAdjustLoyaltyPoints",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(He, { label: "Show favorite products", children: /* @__PURE__ */ be.jsx(
            ra,
            {
              name: "rivoLoyaltyShowFavoriteProducts",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(He, { label: "Show available rewards", children: /* @__PURE__ */ be.jsx(
            ra,
            {
              name: "rivoLoyaltyShowPointsRedemptions",
              control: s.control
            }
          ) }) }),
          a && D !== null && /* @__PURE__ */ be.jsx(Z, { children: a({
            value: D,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ be.jsx(
          gr,
          {
            integrationType: Sj,
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ be.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ be.jsx(
                ve,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ be.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Ns,
                  " integration, all links between Dixa and ",
                  Ns,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ be.jsxs($.Paragraph, { children: [
                  "All data in ",
                  Ns,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ be.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Ns,
                  " ",
                  'integration "',
                  A,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_1mprq_1{width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_u5m0p_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._strikethrough_u5m0p_6{text-decoration:line-through}._order_u5m0p_10{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_u5m0p_10:hover,._orderIsOpen_u5m0p_18{border-color:var(--dixa-color-neutral-400)}._orderHeader_u5m0p_21{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ch = { exports: {} }, uo = {}, Nj;
function cW() {
  if (Nj) return uo;
  Nj = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return uo.Fragment = r, uo.jsx = s, uo.jsxs = s, uo;
}
var js = {}, jj;
function dW() {
  return jj || (jj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    js.Fragment = i, js.jsx = Un, js.jsxs = Kn;
  })()), js;
}
var wj;
function uW() {
  return wj || (wj = 1, process.env.NODE_ENV === "production" ? ch.exports = cW() : ch.exports = dW()), ch.exports;
}
var v = uW();
const Cj = "__PairingContext__", mW = () => globalThis[Cj] ?? (() => {
  const e = kw({});
  return globalThis[Cj] = e, e;
})(), pW = mW(), fW = () => hy(pW), hW = "_banner_d9pot_1", yW = "_list_d9pot_8", Fj = {
  banner: hW,
  list: yW
}, Ij = "https://apps.shopify.com/dixa-dashboard", gW = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, gl = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = fW(), [i, a] = me(!1), [o, s] = me(null), l = gW[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? Ij,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(Ij, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", className: Fj.banner, children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ v.jsx(b, { children: /* @__PURE__ */ v.jsx(ve, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ v.jsx($.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ v.jsx($.Paragraph, { as: "div", children: /* @__PURE__ */ v.jsx(m, { className: Fj.list, children: l.listItems.map((u, f) => /* @__PURE__ */ v.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ v.jsx($.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ v.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ v.jsx(
      et,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(hn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, vl = [
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "displayRefundOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayEmailMarketingConsent",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "apiAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "shopifyClientId",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "shopifyClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], Ej = "SHOPIFY", vW = [
  { name: "displayRefundOrder", label: "Display the refund order button" },
  {
    name: "displayPartialRefundOrder",
    label: "Displays the partial refund order button"
  },
  { name: "displayCancelOrder", label: "Displays the cancel order button" },
  {
    name: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button'
  },
  { name: "displayOrdersOverview", label: "Displays short orders overview" },
  {
    name: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer"
  },
  {
    name: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer"
  },
  { name: "displayDiscountCodes", label: "Displays available discount codes" },
  {
    name: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button"
  },
  { name: "displayCreateOrder", label: "Displays the create order button" },
  {
    name: "displayCreateDraftOrder",
    label: "Displays the create draft order button"
  },
  {
    name: "displayDuplicateOrder",
    label: "Displays the duplicate order button"
  }
], kW = {
  enabled: !1,
  name: "",
  ...Sl(
    [],
    vl
  )
}, bW = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: kW
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: Ej,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: vl,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: I, renderConditionsForSubmit: C } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = g?.additionalProperties, A = w?.tokenSource === "marketplace_app", q = !!w?.isUsingOAuth, Y = !A, te = (J) => hr(J, {
    fieldDefinitions: vl,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), K = s.watch("name");
  return /* @__PURE__ */ v.jsx(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: te,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: o ? /* @__PURE__ */ v.jsx(nt, { children: /* @__PURE__ */ v.jsx(
        gl,
        {
          label: "Connect your Shopify store",
          bannerVariant: "install"
        }
      ) }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        h && /* @__PURE__ */ v.jsx(yr, { cause: h }),
        /* @__PURE__ */ v.jsxs(nt, { children: [
          Y && /* @__PURE__ */ v.jsx(
            gl,
            {
              label: "Upgrade to simplified connection",
              bannerVariant: "migration"
            }
          ),
          /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ v.jsx(
            xn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ v.jsx(Z, { span: 3 }),
          Y && q && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Er,
              {
                name: "shopifyClientId",
                label: "Client ID",
                control: s.control,
                isCreationMode: o,
                rules: { required: "Client ID is required" },
                componentProps: {
                  placeholder: "Client ID from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Er,
              {
                name: "shopifyClientSecret",
                label: "Client Secret",
                control: s.control,
                isCreationMode: o,
                rules: { required: "Client Secret is required" },
                componentProps: {
                  placeholder: "Client Secret from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 })
          ] }),
          Y && !q && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Er,
              {
                name: "apiAccessToken",
                label: "API Access Token",
                control: s.control,
                isCreationMode: o,
                rules: { required: "API access token is required" },
                componentProps: {
                  placeholder: "API access token from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 })
          ] }),
          A ? /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
            An,
            {
              name: "apiHostName",
              label: "Connected Shopify store",
              control: s.control,
              componentProps: {
                readOnly: !0,
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }) : /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
            An,
            {
              name: "apiHostName",
              label: "API host name",
              control: s.control,
              rules: {
                required: "API host name is required",
                validate: (J) => bl(J) || !0
              },
              componentProps: {
                placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ v.jsx(Z, { span: 3 }),
          vW.map(({ name: J, label: R }) => /* @__PURE__ */ v.jsxs(vw, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(He, { label: R, children: /* @__PURE__ */ v.jsx(
              xn,
              {
                name: J,
                control: s.control
              }
            ) }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 })
          ] }, J)),
          a && D !== null && /* @__PURE__ */ v.jsx(Z, { children: a({
            value: D,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ v.jsx(
          gr,
          {
            integrationType: Ej,
            integrationId: e,
            widgetName: K,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ] })
    }
  );
}, xW = (e) => /* @__PURE__ */ v.jsx(gl, { ...e, bannerVariant: "install" }), _W = (e) => /* @__PURE__ */ v.jsx(gl, { ...e, bannerVariant: "migration" }), SW = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], NW = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], jW = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: xW
  }
], wW = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], $j = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: _W,
    additionalProperties: { renderAboveForm: !0 }
  }
], jF = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Tj = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => bl(e)
  },
  ...jF
];
var oa = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(oa || {}), Ri = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(Ri || {}), Ur = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Ur || {}), wF = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(wF || {}), sy = /* @__PURE__ */ ((e) => (e.Active = "ACTIVE", e.Expired = "EXPIRED", e.Scheduled = "SCHEDULED", e))(sy || {}), Ii = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(Ii || {}), Ai = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Ai || {}), Gs = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(Gs || {}), CF = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(CF || {});
const CW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, FW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, IW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, EW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, $W = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, TW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, OW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, DW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderMarkAsPaid" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderMarkAsPaidInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderMarkAsPaid" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, PW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, RW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, AW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, LW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, VW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, zW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "discountCodes" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }, { kind: "Argument", name: { kind: "Name", value: "refundShipping" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "subtotalSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalTaxSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "maximumRefundableSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalDiscountsSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, UW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "discount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customerGets" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountPercentage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "percentage" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountAmount" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, MW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, BW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifySuggestedRefund" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundLineItems" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundLineItemInput" } } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundShipping" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "suggestFullRefund" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "refundLineItems" }, value: { kind: "Variable", name: { kind: "Name", value: "refundLineItems" } } }, { kind: "Argument", name: { kind: "Name", value: "refundShipping" }, value: { kind: "Variable", name: { kind: "Name", value: "refundShipping" } } }, { kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "Variable", name: { kind: "Name", value: "suggestFullRefund" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "subtotalSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalTaxSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "maximumRefundableSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }] } }] } }] } }] }, qW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, HW = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": CW,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": FW,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": IW,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": EW,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": $W,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": TW,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": OW,
  "\n  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {\n    Shopify {\n      orderMarkAsPaid(input: $input) {\n        order {\n          id\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": DW,
  "\n  mutation refundLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": PW,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": RW,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": AW,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": LW,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": VW,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            discountCodes\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true, refundShipping: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              subtotalSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              totalTaxSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              shipping {\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n                maximumRefundableSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n            currentTotalDiscountsSet {\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": zW,
  "\n  query searchDiscountCodes($query: String, $first: Int, $after: String) {\n    Shopify {\n      discountNodes(query: $query, first: $first, after: $after) {\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n        nodes {\n          id\n          discount {\n            __typename\n\n            ... on Shopify_DiscountCodeApp {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n              customerGets {\n                value {\n                  __typename\n\n                  ... on Shopify_DiscountPercentage {\n                    percentage\n                  }\n\n                  ... on Shopify_DiscountAmount {\n                    amount {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": UW,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": MW,
  "\n  query shopifySuggestedRefund(\n    $orderId: ID!\n    $refundLineItems: [Shopify_RefundLineItemInput!]\n    $refundShipping: Boolean\n    $suggestFullRefund: Boolean\n  ) {\n    Shopify {\n      order(id: $orderId) {\n        id\n        suggestedRefund(\n          refundLineItems: $refundLineItems\n          refundShipping: $refundShipping\n          suggestFullRefund: $suggestFullRefund\n        ) {\n          amountSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          subtotalSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          totalTaxSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          shipping {\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            maximumRefundableSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          suggestedTransactions {\n            accountNumber\n            gateway\n            kind\n            parentTransaction {\n              id\n            }\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          refundLineItems {\n            lineItem {\n              id\n              quantity\n            }\n          }\n        }\n      }\n    }\n  }\n": BW,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": qW
};
function ar(e) {
  return HW[e] ?? {};
}
const WW = ar(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), KW = ar(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            discountCodes
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true, refundShipping: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              subtotalSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              totalTaxSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              shipping {
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
                maximumRefundableSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
            currentTotalDiscountsSet {
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), GW = ar(
  /* GraphQL */
  `
  query shopifySuggestedRefund(
    $orderId: ID!
    $refundLineItems: [Shopify_RefundLineItemInput!]
    $refundShipping: Boolean
    $suggestFullRefund: Boolean
  ) {
    Shopify {
      order(id: $orderId) {
        id
        suggestedRefund(
          refundLineItems: $refundLineItems
          refundShipping: $refundShipping
          suggestFullRefund: $suggestFullRefund
        ) {
          amountSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          subtotalSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          totalTaxSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          shipping {
            amountSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            maximumRefundableSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
          }
          suggestedTransactions {
            accountNumber
            gateway
            kind
            parentTransaction {
              id
            }
            amountSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
          }
          refundLineItems {
            lineItem {
              id
              quantity
            }
          }
        }
      }
    }
  }
`
), YW = ar(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), JW = ar(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), zg = ar(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), QW = ar(
  /* GraphQL */
  `
  query searchDiscountCodes($query: String, $first: Int, $after: String) {
    Shopify {
      discountNodes(query: $query, first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          discount {
            __typename

            ... on Shopify_DiscountCodeApp {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
              customerGets {
                value {
                  __typename

                  ... on Shopify_DiscountPercentage {
                    percentage
                  }

                  ... on Shopify_DiscountAmount {
                    amount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), XW = ar(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), ZW = ar(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), e9 = ar(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), n9 = ar(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), t9 = ar(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), r9 = ar(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), FF = Fl`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, i9 = Fl`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, IF = ar(
  /* GraphQL */
  `
  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {
    Shopify {
      orderMarkAsPaid(input: $input) {
        order {
          id
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), a9 = ({
  conversationContext: e,
  forcePhoneLookup: n
}) => {
  const { useQuery: r } = yn(), i = e.customer?.email, a = e.customer?.phone_number, o = i ? `email:"${i}"` : null, s = a ? `phone:"${a}"` : null, l = n ? s : o ?? s, {
    loading: d,
    error: m,
    data: u,
    refetch: f,
    networkStatus: h
  } = r(WW, {
    skip: !l,
    variables: {
      query: l
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: d,
    customerError: m,
    customerData: u,
    refetchCustomer: f,
    customerNetworkStatus: h
  };
}, o9 = () => {
  const { useLazyQuery: e } = yn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(KW);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function qr(e = !1, n) {
  const [r, i] = me(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const EF = (e, n) => (n ?? []).map(({ amountSet: r, gateway: i, parentTransaction: a }) => ({
  amount: String(r?.presentmentMoney?.amount ?? "0.00"),
  gateway: i ?? "",
  kind: CF.Refund,
  orderId: e,
  parentId: a?.id
})), $F = ({
  orderId: e,
  transactions: n,
  refundLineItems: r,
  refundShipping: i,
  note: a,
  notify: o = !0
}) => ({
  orderId: e,
  notify: o,
  note: a,
  refundLineItems: r,
  transactions: n,
  shipping: {
    fullRefund: i
  }
}), s9 = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    currentTotalDiscountsSet: r.currentTotalDiscountsSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      subtotal: r.suggestedRefund?.subtotalSet?.presentmentMoney?.amount,
      tax: r.suggestedRefund?.totalTaxSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: EF(
        r.id,
        r.suggestedRefund?.suggestedTransactions
      ),
      shipping: {
        fullRefund: !0,
        amount: r.suggestedRefund?.shipping?.amountSet?.presentmentMoney?.amount,
        maximumRefundable: r.suggestedRefund?.shipping?.maximumRefundableSet?.presentmentMoney?.amount
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    discountCodes: r.discountCodes,
    refunds: r.refunds
  }));
}, Oj = [
  {
    value: Ai.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Ai.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Ai.Paid,
    label: "Paid",
    description: "The payment has been completed"
  }
], Dj = [
  {
    value: Gs.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: Gs.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: Gs.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], TF = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), sa = (e) => l9(c9(e)), l9 = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), c9 = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, OF = ({
  orderId: e,
  refundShipping: n,
  refundLineItems: r,
  suggestFullRefund: i,
  skip: a
}) => {
  const { useQuery: o } = yn(), {
    data: s,
    previousData: l,
    loading: d,
    error: m
  } = o(GW, {
    skip: a,
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: !0,
    variables: {
      orderId: e,
      refundShipping: n,
      refundLineItems: r,
      suggestFullRefund: i
    }
  }), u = a ? void 0 : s?.Shopify?.order?.suggestedRefund ?? l?.Shopify?.order?.suggestedRefund;
  return { suggestedRefund: Yn(() => {
    if (u)
      return {
        amount: String(u.amountSet.presentmentMoney.amount),
        subtotal: String(u.subtotalSet.presentmentMoney.amount),
        tax: String(u.totalTaxSet.presentmentMoney.amount),
        currency: u.amountSet.presentmentMoney.currencyCode,
        shipping: {
          amount: String(
            u.shipping.amountSet.presentmentMoney.amount
          ),
          maximumRefundable: String(
            u.shipping.maximumRefundableSet.presentmentMoney.amount
          )
        },
        transactions: EF(
          e,
          u.suggestedTransactions
        ),
        refundLineItems: u.refundLineItems.map(
          ({ lineItem: f }) => ({
            lineItemId: f.id,
            quantity: f.quantity
          })
        )
      };
  }, [u, e]), isLoading: d, error: m };
}, d9 = {
  nodes: [],
  hasMoreResults: !1
}, Pj = (e) => "codes" in e.discount ? e.discount.codes.nodes[0]?.code ?? "" : "", u9 = (e) => [...e].sort(
  (n, r) => Pj(n).localeCompare(Pj(r))
), m9 = (e) => {
  const n = e?.Shopify?.discountNodes;
  return {
    nodes: u9(n?.nodes ?? []),
    hasMoreResults: !!n?.pageInfo?.hasNextPage
  };
}, p9 = 300, Rj = 2, f9 = 250, DF = ({
  enabled: e = !0
} = {}) => {
  const { useLazyQuery: n, showNotification: r } = yn(), [i, a] = me(""), [o, s] = me([]), [l, d] = me(!1), [m, u] = me(!1), f = $r(null), h = $r(0), [k] = n(QW, {
    fetchPolicy: "no-cache"
  }), F = (N) => {
    s(N.nodes), d(N.hasMoreResults);
  }, j = async (N, x) => {
    const g = h.current + 1;
    h.current = g, u(!0);
    try {
      const D = await k({
        variables: { query: N, first: f9 }
      });
      if (g !== h.current)
        return;
      if (D.error)
        throw D.error;
      const I = m9(D.data);
      x && (f.current = I), F(I);
    } catch {
      if (g !== h.current)
        return;
      F(d9), r({
        title: "Something went wrong",
        text: "Could not search for discount codes. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    } finally {
      g === h.current && u(!1);
    }
  };
  return yi(
    () => {
      if (!e)
        return;
      const N = i.trim(), x = N.length === 0;
      if (!(!x && N.length < Rj)) {
        if (x && f.current) {
          F(f.current);
          return;
        }
        j(
          x ? void 0 : N,
          x
        );
      }
    },
    p9,
    [i, e]
  ), {
    discountNodes: o,
    isLoading: m,
    hasMoreResults: l,
    filter: i,
    setFilter: a,
    minSearchCharacters: Rj
  };
}, h9 = "_list_alvh6_1", y9 = "_listItem_alvh6_4", g9 = "_fullWidth_alvh6_15", v9 = "_boxWrapper_alvh6_19", Mt = {
  list: h9,
  listItem: y9,
  fullWidth: g9,
  boxWrapper: v9
}, k9 = "_modal_1vkwz_1", b9 = "_disabled_1vkwz_5", dh = {
  modal: k9,
  disabled: b9
}, Aj = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: Ri.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: Ri.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: Ri.Unknown
  }
], Lj = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Ur.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Ur.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Ur.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Ur.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Ur.Unsubscribed
  }
], x9 = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = Fn(), { useMutation: l, showNotification: d } = yn(), [m, u] = me(), [f, h] = me(), [k, F] = Fx(!0), [j, N] = Fx(!0), x = !!m, g = e.customer?.email, D = e.customer?.phone_number, I = e.customer?.given_name, C = e.customer?.family_name, w = {
    email: g ?? "",
    phone: D ?? "",
    firstName: I ?? "",
    lastName: C ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, A = mt({
    defaultValues: w
  });
  Je(() => {
    f?.forEach((R) => {
      const B = R?.field?.[0];
      B && (A.setError(B, {
        type: "server",
        message: R.message
      }), A.setFocus(B));
    });
  }, [f, A]);
  const [q, { error: Y, reset: te }] = l(t9, {
    onError: (R) => {
      u(R.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (R) => {
      const B = R?.Shopify?.customerCreate?.userErrors || [];
      B.length > 0 ? (h(B), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), K = yt(
    (R) => {
      a(!0), u(void 0), q({
        variables: {
          input: {
            firstName: R.firstName,
            lastName: R.lastName,
            ...k && { email: R.email },
            ...j && { phone: R.phone },
            ...R.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: R.smsMarketingState,
                marketingOptInLevel: R.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [q, a, j, k]
  ), J = () => {
    r(!1), te(), u(void 0), A.reset(w);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: n, onClose: J, className: dh.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: "Create new customer", onClose: J }),
    /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs(nt, { children: [
      /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
        An,
        {
          label: "First name",
          name: "firstName",
          control: A.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
        An,
        {
          label: "Last name",
          name: "lastName",
          control: A.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        An,
        {
          label: "Email",
          name: "email",
          control: A.control,
          rules: {
            required: k ? "Email is required" : void 0
          },
          componentProps: {
            className: dt({
              [dh.disabled]: !k
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ v.jsx(
                Io,
                {
                  disabled: !j,
                  name: "hasEmail",
                  value: "email",
                  checked: k,
                  onChange: () => F()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        An,
        {
          label: "Phone",
          name: "phone",
          control: A.control,
          rules: {
            required: j ? "Phone is required" : void 0
          },
          componentProps: {
            className: dt({
              [dh.disabled]: !j
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ v.jsx(
                Io,
                {
                  disabled: !k,
                  name: "hasPhone",
                  value: "phone",
                  checked: j,
                  onChange: () => N()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        _r,
        {
          control: A.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (R, B) => R === B,
            getItemTitleByValue: (R) => {
              const B = Lj.find(
                (ne) => ne.value === R
              );
              return /* @__PURE__ */ v.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: B.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: B.description })
                  ]
                }
              );
            }
          },
          children: Lj.map((R) => /* @__PURE__ */ v.jsx(ut.Item, { value: R.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        _r,
        {
          control: A.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (R, B) => R === B,
            getItemTitleByValue: (R) => {
              const B = Aj.find(
                (ne) => ne.value === R
              );
              return /* @__PURE__ */ v.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: B.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: B.description })
                  ]
                }
              );
            }
          },
          children: Aj.map((R) => /* @__PURE__ */ v.jsx(ut.Item, { value: R.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      x && /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(ve, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(A.formState.isValid && A.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 })
        },
        confirmOnClick: A.handleSubmit(K),
        cancelOnClick: J,
        confirmName: Y ? "Close" : "Save",
        cancelName: Y ? void 0 : "Cancel"
      }
    )
  ] });
}, _9 = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = me(!1), [a, o] = me(!1);
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      et,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
        slotStart: /* @__PURE__ */ v.jsx(ve, { size: 14, name: "user-plus", color: "green.500" }),
        className: Mt.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ v.jsx(
      x9,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Ug = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, ly = "DD MMM YYYY @ HH:mm", S9 = "_wrapper_10fld_1", N9 = "_copyIcon_10fld_7", ws = {
  wrapper: S9,
  copyIcon: N9
}, j9 = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = qr(), { isCopied: l, copy: d } = qr(), { track: m } = Fn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: k,
    tags: F = [],
    verifiedEmail: j
  } = e, N = h?.emailAddress, x = k?.phoneNumber, g = Ug(u), D = `https://${n}/admin/customers/${g ?? ""}`, I = i && a === rr.refetch, C = 14;
  return /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { className: ws.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: f }),
        I ? /* @__PURE__ */ v.jsx(hn, { size: C }) : /* @__PURE__ */ v.jsx(Ze, { content: "Reload customer", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: C,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: ws.copyIcon
          }
        ) })
      ] }),
      N && /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(ve, { size: C, name: "mail" }),
          /* @__PURE__ */ v.jsx($.ExternalLink, { href: `mailto:${N}`, children: N }),
          /* @__PURE__ */ v.jsx(
            Ze,
            {
              content: j ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ v.jsx(b, { alignItems: "center", children: /* @__PURE__ */ v.jsx(
                ve,
                {
                  size: C,
                  color: j ? "green.500" : "red.500",
                  name: j ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ v.jsx(Ze, { content: "Copy Email", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: C,
            name: o ? "done" : "copy",
            onClick: () => s(N),
            className: ws.copyIcon
          }
        ) })
      ] }),
      x && /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(ve, { size: C, name: "phone" }),
          /* @__PURE__ */ v.jsx($.ExternalLink, { href: `tel:${x}`, children: x })
        ] }),
        /* @__PURE__ */ v.jsx(Ze, { content: "Copy phone number", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: C,
            name: l ? "done" : "copy",
            onClick: () => d(x),
            className: ws.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ v.jsx(ve, { size: C, name: "external-link" }),
        /* @__PURE__ */ v.jsx(
          $.ExternalLink,
          {
            href: D,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    F.length > 0 && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: F.map((w) => /* @__PURE__ */ v.jsx(Jn, { children: w }, `${u}-${w}`)) })
    ] })
  ] });
}, w9 = "_creationModal_pbe64_1", C9 = "_detailsModal_pbe64_5", F9 = "_percentageSuffix_pbe64_9", uh = {
  creationModal: w9,
  detailsModal: C9,
  percentageSuffix: F9
}, I9 = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, E9 = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: wF.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, Vj = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], zj = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], Uj = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], $9 = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = Jt(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ v.jsxs(Xe, { children: [
      /* @__PURE__ */ v.jsx(Xe.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ v.jsx(Xe.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ v.jsx(
            ve,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ v.jsx(Xe.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ v.jsx(Xe.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ v.jsx(Xe.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: Qn(e?.startsAt).format(jt) })
      ] }) })
    ] }),
    /* @__PURE__ */ v.jsx(He, { label: "Discount code", children: /* @__PURE__ */ v.jsx(
      dr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, T9 = "shopify-discount-code-form", Mj = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, O9 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = Fn(), { useMutation: i, showNotification: a } = yn(), [o, s] = me(
    []
  ), [l, d] = me(), m = mt({
    mode: "all",
    defaultValues: Mj
  });
  Je(() => {
    o?.forEach((C) => {
      const w = C?.field?.[1];
      w && m.setError(w, {
        type: "server",
        message: C.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), k = Yn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      default:
        return "";
    }
  }, [f]), [
    F,
    {
      loading: j,
      error: N,
      reset: x
    }
  ] = i(r9, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (C) => {
      const w = C?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (w && w.length > 0)
        s(w);
      else {
        const A = C?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        A && "codes" in A && d(A), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), g = () => {
    m.setValue("code", I9(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, D = (C) => {
    F({
      variables: {
        input: E9(C)
      }
    });
  }, I = () => {
    m.reset(Mj), s([]), x(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: e,
      onClose: I,
      className: dt({
        [uh.creationModal]: !u,
        [uh.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ v.jsx(
          Ct,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: I
          }
        ),
        /* @__PURE__ */ v.jsxs(Ft, { children: [
          u && /* @__PURE__ */ v.jsx($9, { codeDiscount: l }),
          !u && /* @__PURE__ */ v.jsxs("form", { noValidate: !0, id: T9, onSubmit: m.handleSubmit(D), children: [
            /* @__PURE__ */ v.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ v.jsx(
              jl,
              {
                variant: "info",
                description: /* @__PURE__ */ v.jsx($.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ v.jsxs(nt, { children: [
              /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
                An,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                _r,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (C, w) => C === w,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (C) => {
                      const w = Vj.find(
                        (A) => A.value === C
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: w?.label }) });
                    }
                  },
                  children: Vj.map((C) => /* @__PURE__ */ v.jsx(ut.Item, { value: C.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                An,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (C) => {
                      if (C) {
                        if (h === "percentage" && (C < 0 || C > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && C < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ v.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: uh.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
                An,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: g
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                _r,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (C, w) => C === w,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (C) => {
                      const w = zj.find(
                        (A) => A.value === C
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: w?.label }) });
                    }
                  },
                  children: zj.map((C) => /* @__PURE__ */ v.jsx(ut.Item, { value: C.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                An,
                {
                  name: "minimumRequirementValue",
                  label: k,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (C) => {
                      if (C && f !== "none" && C < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
                _r,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (C, w) => C === w,
                    getItemTitleByValue: (C) => {
                      const w = Uj.find(
                        (A) => A.value === C
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: w?.label }) });
                    }
                  },
                  children: Uj.map((C) => /* @__PURE__ */ v.jsx(ut.Item, { value: C.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) })
            ] })
          ] }),
          N && /* @__PURE__ */ v.jsx(Tn, { error: N })
        ] }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: j,
              loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? I : m.handleSubmit(D),
            cancelOnClick: u ? void 0 : I
          }
        )
      ]
    }
  );
}, D9 = ({ code: e }) => {
  const { isCopied: n, copy: r } = qr();
  return /* @__PURE__ */ v.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ v.jsx(ve, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ v.jsx(
          ir,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, P9 = ({
  discountCode: e
}) => {
  const { discount: n } = e;
  if (!("codes" in n))
    return null;
  const r = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: n.title }),
    /* @__PURE__ */ v.jsx(Xe, { children: r.map((i) => /* @__PURE__ */ v.jsx(Xe.Item, { className: Mt.listItem, children: /* @__PURE__ */ v.jsx(D9, { code: i.code }) }, i.code)) })
  ] });
}, R9 = "_modal_11d6e_1", A9 = "_modalBody_11d6e_4", L9 = "_codeContainer_11d6e_9", mh = {
  modal: R9,
  modalBody: A9,
  codeContainer: L9
}, V9 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const {
    discountNodes: r,
    isLoading: i,
    filter: a,
    setFilter: o,
    minSearchCharacters: s
  } = DF({ enabled: e }), l = r.length === 0, d = () => {
    o(""), n(!1);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: e, onClose: d, className: mh.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: "Discount codes", onClose: d }),
    /* @__PURE__ */ v.jsxs(Ft, { className: mh.modalBody, children: [
      /* @__PURE__ */ v.jsx(
        dr,
        {
          type: "search",
          icon: "search",
          value: a,
          placeholder: `Search discount codes (min. ${s} characters)`,
          onChange: (m) => {
            o(m.target.value);
          }
        }
      ),
      i && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(hn, {}) }),
      !i && l && /* @__PURE__ */ v.jsx(
        Eo,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !i && !l && r.map((m) => /* @__PURE__ */ v.jsx("div", { className: mh.codeContainer, children: /* @__PURE__ */ v.jsx(P9, { discountCode: m }) }, m.id))
    ] }),
    /* @__PURE__ */ v.jsx(Et, { confirmName: "Close", confirmOnClick: d })
  ] });
}, z9 = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = me(!1), [i, a] = me(!1);
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ v.jsx(b, { flex: "1", children: /* @__PURE__ */ v.jsx(
          et,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ v.jsx(b, { flex: "1", children: /* @__PURE__ */ v.jsx(
          et,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      V9,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ v.jsx(
      O9,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, U9 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? fw(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case oa.Invalid:
      case oa.NotSubscribed:
      case Ur.NotSubscribed:
        return "red.500";
      case oa.Pending:
      case Ur.Pending:
      case oa.Unsubscribed:
      case Ur.Unsubscribed:
        return "orange.500";
      case oa.Subscribed:
      case Ur.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case Ri.SingleOptIn:
      case Ri.ConfirmedOptIn:
        return "green.500";
      case Ri.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ve, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ v.jsx(Ze, { content: "Last updated at", children: /* @__PURE__ */ v.jsx(Bn, { size: "small", variant: "info", children: Qn(l).format(ly) }) }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Ze, { content: "Opt-In state", children: /* @__PURE__ */ v.jsx(Jn, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ v.jsx(Ze, { content: "Marketing state", children: /* @__PURE__ */ v.jsx(Jn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(ve, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ v.jsx(Ze, { content: "Last updated at", children: /* @__PURE__ */ v.jsx(Bn, { size: "small", variant: "info", children: Qn(u).format(ly) }) }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Ze, { content: "Opt-In state", children: /* @__PURE__ */ v.jsx(Jn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ v.jsx(Ze, { content: "Marketing state", children: /* @__PURE__ */ v.jsx(Jn, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, M9 = (e) => {
  const { discount: n } = e;
  switch (n.__typename) {
    case "Shopify_DiscountCodeBasic": {
      if (n.status !== sy.Active)
        return null;
      const r = n.codes.nodes[0]?.code;
      if (!r)
        return null;
      const { value: i } = n.customerGets;
      return i.__typename === "Shopify_DiscountPercentage" ? {
        code: r,
        kind: "percentage",
        percentage: Number((i.percentage * 100).toFixed(2))
      } : i.__typename === "Shopify_DiscountAmount" ? {
        code: r,
        kind: "fixedAmount",
        amount: String(i.amount.amount),
        currencyCode: i.amount.currencyCode
      } : null;
    }
    case "Shopify_DiscountCodeFreeShipping": {
      if (n.status !== sy.Active)
        return null;
      const r = n.codes.nodes[0]?.code;
      return r ? { code: r, kind: "freeShipping" } : null;
    }
    default:
      return null;
  }
}, B9 = (e) => {
  const n = e.map(M9).filter(
    (i) => !!i
  ), r = /* @__PURE__ */ new Map();
  return n.forEach((i) => {
    r.has(i.code) || r.set(i.code, i);
  }), Array.from(r.values());
}, PF = (e) => {
  if (e)
    switch (e.kind) {
      case "percentage":
        return {
          itemPercentageDiscountCode: {
            code: e.code,
            percentage: e.percentage
          }
        };
      case "fixedAmount":
        return {
          itemFixedDiscountCode: {
            code: e.code,
            amountSet: {
              shopMoney: {
                amount: e.amount,
                currencyCode: e.currencyCode
              }
            }
          }
        };
      case "freeShipping":
        return { freeShippingDiscountCode: { code: e.code } };
      default:
        return;
    }
}, q9 = (e) => e ? [e.code] : void 0, cy = (e) => {
  switch (e.kind) {
    case "percentage":
      return `${e.percentage}% off`;
    case "fixedAmount":
      return `${e.amount} ${e.currencyCode} off`;
    case "freeShipping":
      return "Free shipping";
    default:
      return "";
  }
}, RF = ({
  enabled: e
}) => {
  const n = Dr(), { discountNodes: r, isLoading: i, filter: a, setFilter: o, minSearchCharacters: s } = DF({ enabled: e }), l = Yn(
    () => B9(r),
    [r]
  ), d = a.trim().length > 0;
  if (!i && !d && l.length === 0)
    return null;
  const m = !i && l.length === 0;
  return /* @__PURE__ */ v.jsx(
    _r,
    {
      label: "Discount code",
      control: n.control,
      name: "discountCode",
      componentProps: {
        clearable: !0,
        placeholder: "Search discount codes",
        tabIndex: 0,
        equalityFn: (u, f) => u?.code === f?.code,
        getItemTitleByValue: (u) => u ? /* @__PURE__ */ v.jsxs($.Paragraph, { children: [
          u.code,
          " · ",
          cy(u)
        ] }) : null,
        filter: {
          value: a,
          placeholder: `Search discount codes (min. ${s} characters)`,
          onChange: (u) => {
            o(u.target.value);
          }
        },
        onToggleDropdown: (u) => {
          !u && a !== "" && o("");
        }
      },
      children: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        i && /* @__PURE__ */ v.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ v.jsx(hn, {}) }) }),
        !i && l.map((u) => /* @__PURE__ */ v.jsx(ut.Item, { value: u, children: /* @__PURE__ */ v.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            gap: "200",
            children: [
              d ? /* @__PURE__ */ v.jsx(
                xw,
                {
                  text: u.code,
                  highlight: a
                }
              ) : /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: u.code }),
              /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "tertiary", children: cy(u) })
            ]
          }
        ) }, u.code)),
        m && /* @__PURE__ */ v.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          Eo,
          {
            title: "No discount codes found",
            description: "Try changing your search criteria."
          }
        ) })
      ] })
    }
  );
}, ji = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ v.jsx(
  xt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ v.jsx(
      tr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), H9 = "_modal_1wlra_1", W9 = {
  modal: H9
};
function Bj(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const qj = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Hj = "shopify-shiping-address-form", K9 = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = yn(), { track: f } = Fn(), [h, k] = me(!1), [F, j] = me({}), N = !l, [
    x,
    { error: g, reset: D }
  ] = m(XW, {
    onError: () => {
      k(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (K) => {
      k(!1);
      const J = K?.Shopify?.orderUpdate?.userErrors;
      if (J != null && J.length > 0) {
        const R = J.reduce(
          (B, ne) => {
            const Ne = ne.field;
            if (Ne == null || Ne.length === 0)
              return B;
            const ue = Ne[Ne.length - 1];
            return ue != null && (B[ue] = ne.message), B;
          },
          {}
        );
        j(R);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), te();
    }
  }), I = yt(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: qj.find(
        (K) => K === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: C, handleSubmit: w, formState: A, reset: q } = mt({
    mode: "all",
    defaultValues: I()
  }), Y = w((K) => {
    if (N) {
      if (k(!0), !o || !a) {
        k(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: J, ...R } = K, B = {
        ...R,
        countryCode: J
      };
      x({
        variables: {
          input: {
            id: a,
            shippingAddress: B
          }
        }
      });
    } else
      l(K), te();
  });
  Je(() => {
    r && q(I());
  }, [r, n, q, I]);
  const te = () => {
    q(I()), j({}), D(), i(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: r,
      onClose: te,
      className: W9.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ v.jsx(Ct, { title: e, onClose: () => te() }),
        /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs("form", { noValidate: !0, id: Hj, onSubmit: Y, children: [
          g && /* @__PURE__ */ v.jsx(Tn, { error: g }),
          /* @__PURE__ */ v.jsxs(nt, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                required: !0,
                control: C,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                required: !0,
                control: C,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                control: C,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                required: !0,
                control: C,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                control: C,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                required: !0,
                control: C,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                required: !0,
                control: C,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              _r,
              {
                name: "countryCodeV2",
                control: C,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (K) => K ? Bj(K) : ""
                },
                children: qj.filter((K) => s.includes(K)).map((K) => /* @__PURE__ */ v.jsx(ut.Item, { value: K, children: /* @__PURE__ */ v.jsx($.Paragraph, { children: Bj(K) }) }, K))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              disabled: !(A.isValid && A.isDirty),
              type: "submit",
              form: Hj,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 })
            },
            confirmOnClick: () => {
              g && te();
            },
            cancelOnClick: () => {
              o && a && !g && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), te();
            },
            confirmName: g ? "Close" : "Save",
            cancelName: g ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, G9 = "_clickableIcon_33mqm_1", ph = {
  clickableIcon: G9
}, Wj = ({
  formFieldName: e,
  ...n
}) => {
  const r = Dr(), { field: i } = Py({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ v.jsx(
    dy,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, dy = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = me(!1), [h, k] = me(m), { isCopied: F, copy: j } = qr(), { track: N } = Fn(), x = 14, g = o && (!!r || !!l), D = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), I = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), C = n?.countryCodeV2 && mI(n.countryCodeV2), w = yt(() => [
    I,
    n?.company,
    n?.address1,
    n?.address2,
    D,
    n?.province,
    C
  ].filter(Boolean).join(`
`), [n, I, D, C]);
  if (!n)
    return null;
  const A = () => {
    i && r && N("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ve, { size: x, name: s, color: "green.500" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => k(!h),
              className: ph.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ v.jsx(
                  ve,
                  {
                    size: x,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
            I && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: I }),
            n?.company && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.address2 }),
            D && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: D }),
            n?.province && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.province }),
            C && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: C })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        g && /* @__PURE__ */ v.jsx(Ze, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: x,
            name: "pen",
            onClick: () => A(),
            className: ph.clickableIcon
          }
        ) }),
        /* @__PURE__ */ v.jsx(Ze, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: x,
            name: F ? "done" : "copy",
            onClick: () => j(w()),
            className: ph.clickableIcon
          }
        ) })
      ] })
    ] }),
    g && /* @__PURE__ */ v.jsx(
      K9,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, AF = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Dr(), i = pi({ control: r.control, name: "lineItems" }), a = pi({
    control: r.control,
    name: "billingAddress"
  }), o = pi({
    control: r.control,
    name: "shippingAddress"
  }), s = pi({
    control: r.control,
    name: "discountCode"
  }), l = Yn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (u) => n.includes(u.id)
  ) : i, [i, n]), d = Yn(() => !l || l.length === 0 ? 0 : l.reduce((u, f) => {
    const h = f.priceRangeV2?.minVariantPrice?.amount || 0, k = f.quantity || 0;
    return u + h * k;
  }, 0), [l]), m = l?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ v.jsx(
        Wj,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ v.jsx(
        Wj,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx(Cl, {}),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Subtotal" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: `${d.toFixed(2)} ${m}` })
    ] }),
    s && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", children: [
          "Discount (",
          s.code,
          ")"
        ] }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: cy(s) })
      ] }),
      /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", variant: "5", children: "The discount will be deducted after the order is created." })
    ] }),
    /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, Y9 = "_productTableHeader_6h6pl_1", J9 = "_productImage_6h6pl_5", Co = {
  productTableHeader: Y9,
  productImage: J9
}, Mg = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, Q9 = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Dr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Mg(e);
  return /* @__PURE__ */ v.jsxs(ot.Tr, { children: [
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ v.jsx(
        xa,
        {
          src: d,
          alt: e.title,
          className: Co.productImage
        }
      ),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(
      An,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ v.jsx(ir, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, X9 = 300, mo = 2, Z9 = 25, e7 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = yn(), [i, a] = me(""), [o, s] = me([]), l = Dr(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(zg, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (j) => {
      const N = j?.Shopify?.products?.nodes || [];
      s(
        N.filter((x) => !!x).sort((x, g) => x.title.localeCompare(g.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  yi(
    () => {
      i.trim().length >= mo && !u && f === rr.ready ? m({
        variables: {
          query: i.trim(),
          productCount: Z9,
          mediaCount: 1
        }
      }) : i.trim().length < mo && s([]);
    },
    X9,
    [i]
  ), Je(() => {
    if (!d) return;
    const j = o.find(
      (N) => N.id === d
    );
    j && e(j), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== rr.ready, k = i.trim().length >= mo, F = !o.length && !h && k;
  return /* @__PURE__ */ v.jsx(
    _r,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${mo} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (j) => {
          const N = o.find(
            (x) => x.id === j
          );
          return N ? /* @__PURE__ */ v.jsx($.Paragraph, { children: N.title }) : null;
        },
        filter: {
          value: i,
          onChange: (j) => {
            a(j.target.value);
          }
        },
        onToggleDropdown: (j) => {
          !j && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        h && /* @__PURE__ */ v.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ v.jsx(hn, {}) }) }),
        !h && o.map((j) => {
          const N = j.totalInventory <= 0, x = Mg(j);
          return /* @__PURE__ */ v.jsx(
            ut.Item,
            {
              value: j.id,
              isDisabled: N,
              children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
                  x && /* @__PURE__ */ v.jsx(
                    xa,
                    {
                      src: x,
                      alt: j.title,
                      className: Co.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ v.jsx(
                    xw,
                    {
                      text: j.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: j.title })
                ] }),
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", children: N ? "Out of stock" : `${j.totalInventory} in stock` })
              ] })
            },
            j.id
          );
        }),
        F && /* @__PURE__ */ v.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          Eo,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !k && !h && /* @__PURE__ */ v.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          Eo,
          {
            title: "Search for products",
            description: `Type at least ${mo} characters to search.`
          }
        ) })
      ] })
    }
  );
}, Bg = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const m = Dr(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (N) => !o.includes(N?.id)
  ) : [], k = h.length > 0 && h.every(
    (N) => a.includes(N?.id)
  ), F = h.some(
    (N) => a.includes(N?.id)
  ) && !k, j = yt(
    (N) => {
      const x = m.getValues("lineItems"), g = x.findIndex(
        (D) => D?.id === N.id
      );
      if (g > -1) {
        const D = m.getValues(`lineItems.${g}.quantity`) || 0, I = [...x];
        I[g] = {
          ...I[g],
          quantity: D + 1
        }, m.setValue("lineItems", I);
      } else
        m.setValue("lineItems", [
          ...x,
          { ...N, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ v.jsx(e7, { onProductSelected: j }),
    !f && e && /* @__PURE__ */ v.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Mt.boxWrapper,
        children: /* @__PURE__ */ v.jsx(hn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ v.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Mt.boxWrapper,
        children: /* @__PURE__ */ v.jsx(
          Eo,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ v.jsx(b, { margin: "300 0", children: /* @__PURE__ */ v.jsxs(
      ot,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Co.productTable,
        children: [
          /* @__PURE__ */ v.jsx(ot.Thead, { className: Co.productTableHeader, children: /* @__PURE__ */ v.jsxs(ot.Tr, { children: [
            n && /* @__PURE__ */ v.jsx(ot.Th, { children: /* @__PURE__ */ v.jsx(
              Xg,
              {
                checked: k,
                indeterminate: F,
                onChange: () => d?.(!k)
              }
            ) }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "Product" }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "In stock" }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "Price" }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "Quantity" }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "Total" }),
            !r && /* @__PURE__ */ v.jsx(ot.Th, {})
          ] }) }),
          /* @__PURE__ */ v.jsx(ot.Tbody, { children: u?.map((N, x) => {
            if (!n)
              return /* @__PURE__ */ v.jsx(
                Q9,
                {
                  product: N,
                  index: x,
                  onRemove: () => {
                    const J = u.filter(
                      (R, B) => B !== x
                    );
                    m.setValue("lineItems", J);
                  }
                },
                `${N?.id}-${x}`
              );
            const g = N, D = g.priceRangeV2.minVariantPrice.amount, I = g.priceRangeV2.minVariantPrice.currencyCode, C = `lineItems.${x}.quantity`, w = m.watch(C) || 0, A = D * w, q = Mg(g), Y = a.includes(g.id), te = o.includes(g.id), K = s?.[g.id] ?? g.totalInventory;
            return /* @__PURE__ */ v.jsxs(
              ot.Tr,
              {
                style: te ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(
                    Xg,
                    {
                      checked: Y,
                      disabled: te,
                      onChange: () => l?.(g.id, !Y)
                    }
                  ) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
                    q && /* @__PURE__ */ v.jsx(
                      xa,
                      {
                        src: q,
                        alt: g.title,
                        className: Co.productImage
                      }
                    ),
                    /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: g.title }),
                      te && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: g.totalInventory }) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${D} ${I}` }) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(
                    An,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: te || K <= 1,
                      name: C,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: K,
                        tabIndex: 0
                      }
                    },
                    `${C}-${m.watch(C)}`
                  ) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${A} ${I}` }) }),
                  !r && /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ v.jsx(
                    ir,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const J = u.filter(
                          (R, B) => B !== x
                        );
                        m.setValue("lineItems", J), Y && l?.(g.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${g.id}-${x}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, LF = ({
  previousOrderStatus: e
} = {}) => {
  const n = Dr();
  return /* @__PURE__ */ v.jsx(
    _r,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = Oj.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ v.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: Oj.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ v.jsx(ut.Item, { value: r.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, VF = () => {
  const e = Dr();
  return /* @__PURE__ */ v.jsx(
    _r,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = Dj.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: Dj.map((n) => /* @__PURE__ */ v.jsx(ut.Item, { value: n.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, n7 = "_modal_1mprq_1", t7 = {
  modal: n7
}, fh = "create-shopify-order-form", r7 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Fn(), [d, m] = me(!1), [
    u,
    f
  ] = me(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, k = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Ai.Pending,
    fulfillmentStatus: void 0,
    discountCode: void 0
  }, [F, j] = me([]), N = mt({
    mode: "all",
    defaultValues: k
  }), x = N.watch("lineItems").length > 0, g = () => {
    N.reset(k), j([]), i(!1);
  };
  Je(() => {
    F.length > 0 && N.setValue("tags", F, { shouldDirty: !0 });
  }, [F, N]);
  const D = $r(!1), I = () => {
    a(), m(!1), s({
      title: "Success",
      text: "The order was created successfully.",
      icon: "check-circle-filled",
      severity: "success"
    }), l("shopify:order:create:succeeded"), g();
  }, C = () => {
    a(), m(!1), s({
      title: "Order created but not marked as paid",
      text: "The order was created but recording the payment failed. You can mark it as paid in Shopify.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), g();
  }, w = () => {
    m(!1), s({
      title: "Something went wrong",
      text: "The order creation was not successful.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), l("shopify:order:create:failed"), g();
  }, [A] = o(IF, {
    onError: C,
    onCompleted: (B) => {
      const ne = B.Shopify?.orderMarkAsPaid?.userErrors;
      if (ne && ne.length > 0) {
        C();
        return;
      }
      I();
    }
  }), [q, { error: Y }] = o(FF, {
    onError: w,
    onCompleted: (B) => {
      const ne = B.Shopify?.orderCreate, Ne = ne?.order?.id;
      if (ne?.userErrors?.length || !Ne) {
        w();
        return;
      }
      if (D.current) {
        A({ variables: { input: { id: Ne } } });
        return;
      }
      I();
    }
  }), [te, { error: K }] = o(
    i9,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), g();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), g();
      }
    }
  ), J = (B) => {
    const ne = B.lineItems.map((pe) => ({
      productId: pe.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: pe.priceRangeV2.maxVariantPrice.amount,
          currencyCode: pe.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: pe.quantity
    }));
    m(!0);
    const Ne = sa(B?.billingAddress), ue = sa(
      B?.shippingAddress
    ), oe = B.financialStatus === Ai.Paid;
    D.current = oe, q({
      variables: {
        order: {
          lineItems: ne,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: B.customNote,
          tags: B.tags,
          financialStatus: oe ? void 0 : B.financialStatus,
          fulfillmentStatus: B.fulfillmentStatus,
          discountCode: PF(B.discountCode),
          shippingAddress: ue,
          billingAddress: Ne
        }
      }
    });
  }, R = (B) => {
    const ne = B.lineItems.map((oe) => ({
      title: oe.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: oe.priceRangeV2.maxVariantPrice.amount,
        currencyCode: oe.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: oe.quantity
    }));
    f(!0);
    const Ne = sa(B?.billingAddress), ue = sa(
      B?.shippingAddress
    );
    te({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: B.customNote,
          tags: B.tags,
          lineItems: ne,
          discountCodes: q9(B.discountCode),
          shippingAddress: ue,
          billingAddress: Ne
        }
      }
    });
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: e,
      onClose: g,
      className: t7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ v.jsx(Ct, { title: "Create new order", onClose: g }),
        /* @__PURE__ */ v.jsxs(Ft, { children: [
          /* @__PURE__ */ v.jsx(Dy, { ...N, children: /* @__PURE__ */ v.jsx("form", { id: fh, children: /* @__PURE__ */ v.jsxs(nt, { children: [
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(Bg, {}) }),
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
              xt,
              {
                name: "tags",
                render: ({ fieldState: { error: B } }) => /* @__PURE__ */ v.jsx(
                  He,
                  {
                    label: "Tags",
                    meta: {
                      error: B?.message
                    },
                    children: /* @__PURE__ */ v.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ne) => {
                          ne.key === "Enter" && (ne.preventDefault(), ne.stopPropagation());
                        },
                        children: /* @__PURE__ */ v.jsx(
                          Nl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: F,
                            onChange: (ne) => {
                              j(ne);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 4, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ v.jsx(LF, {}),
              /* @__PURE__ */ v.jsx(VF, {}),
              /* @__PURE__ */ v.jsx(RF, { enabled: e }),
              /* @__PURE__ */ v.jsx(
                An,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 2, children: /* @__PURE__ */ v.jsx(He, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Mt.boxWrapper,
                children: /* @__PURE__ */ v.jsx(AF, {})
              }
            ) }) })
          ] }) }) }),
          (Y || K) && /* @__PURE__ */ v.jsx(Tn, { error: Y || K })
        ] }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              type: "submit",
              form: fh,
              disabled: !x || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: N.handleSubmit(J),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                N.handleSubmit(R)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: fh,
                disabled: !x || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, i7 = "_modal_al73g_1", a7 = {
  modal: i7
}, Kj = [
  {
    label: "Customer",
    value: Ii.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: Ii.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: Ii.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: Ii.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: Ii.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: Ii.Staff,
    description: "Staff made an error."
  }
], o7 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = Fn(), { useMutation: d, showNotification: m } = yn(), [u, f] = me([]), h = u.length > 0, k = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, F = mt({
    defaultValues: k
  }), [j, { error: N, reset: x }] = d(e9, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (I) => {
      const C = I.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (C.length > 0)
        o(!1), f(C), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const w = I.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, w ? 0 : 4e3), m({
          title: "Success",
          text: `${w ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), g = yt(
    (I) => {
      I.reason != null && (o(!0), j({
        variables: {
          orderId: I.orderId,
          reason: I.reason,
          refundMethod: I.refundMethod,
          restock: I.restock,
          notifyCustomer: I.notifyCustomer,
          staffNote: I.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), D = () => {
    i(!1), x(), f([]), F.reset(k);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: n, onClose: D, className: a7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: `Cancel order ${r}`, onClose: D }),
    /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs(nt, { children: [
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        _r,
        {
          control: F.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (I, C) => I === C,
            getItemTitleByValue: (I) => {
              if (!I)
                return "";
              const C = Kj.find(
                (w) => w.value === I
              );
              return /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: C.label }),
                /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: C.description })
              ] });
            }
          },
          children: Kj.map((I) => /* @__PURE__ */ v.jsx(ut.Item, { value: I.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: I.description })
          ] }) }, I.value))
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(He, { label: "Refund order", children: /* @__PURE__ */ v.jsx(
        xn,
        {
          control: F.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(He, { label: "Restock items", children: /* @__PURE__ */ v.jsx(xn, { control: F.control, name: "restock" }) }) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(He, { label: "Notify the customer", children: /* @__PURE__ */ v.jsx(xn, { control: F.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        An,
        {
          name: "staffNote",
          label: "Staff note",
          control: F.control
        }
      ) }),
      h && /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "column", children: u.map((I) => /* @__PURE__ */ v.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ v.jsx(ve, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I.code }),
            /* @__PURE__ */ v.jsxs($.Paragraph, { children: [
              "(",
              I.field?.join(","),
              ") ",
              I.message
            ] })
          ]
        },
        I.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(F.formState.isValid && F.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 })
        },
        confirmOnClick: F.handleSubmit(g),
        cancelOnClick: D,
        confirmName: N ? "Close" : "Cancel order",
        cancelName: N ? void 0 : "Cancel"
      }
    )
  ] });
}, s7 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = me(!1), [s, l] = me(!1);
  return /* @__PURE__ */ v.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ v.jsx(
      et,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Mt.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ v.jsx(
      o7,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, l7 = "_modal_1mprq_1", c7 = {
  modal: l7
}, d7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = yn(), { track: m } = Fn(), [u, f] = me(!1), [h, k] = me(e?.tags || []), F = "duplicate-shopify-order-form", j = (ue) => ({
    firstName: ue?.firstName,
    lastName: ue?.lastName,
    company: ue?.company,
    address1: ue?.address1,
    address2: ue?.address2,
    city: ue?.city,
    provinceCode: ue?.provinceCode,
    zip: ue?.zip,
    countryCode: ue?.countryCodeV2,
    phone: ue?.phone
  }), N = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: j(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: j(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0,
    discountCode: void 0
  }, x = mt({
    mode: "all",
    defaultValues: N
  }), g = x.watch("lineItems").length > 0, D = Yn(
    () => (e?.lineItems || []).map((ue) => ue.product?.id).filter((ue) => !!ue),
    [e]
  ), I = Yn(
    () => TF(D),
    [D]
  ), {
    data: C,
    loading: w,
    error: A
  } = d(zg, {
    skip: !I,
    variables: {
      query: I,
      productCount: D.length,
      mediaCount: 1
    }
  });
  Je(() => {
    A && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [A, l]), Je(() => {
    if (!r || w || !C || x.getValues("lineItems")?.length)
      return;
    const ue = C?.Shopify?.products?.nodes || [], oe = [];
    e?.lineItems?.forEach((pe) => {
      const z = ue.find(
        (ke) => ke.id === pe.product?.id
      );
      z && oe.push({
        ...z,
        quantity: pe.quantity || 1,
        sku: pe.sku,
        discountedUnitPrice: pe.discountedUnitPriceSet?.shopMoney
      });
    }), oe.length > 0 && x.setValue("lineItems", oe, { shouldDirty: !0 });
  }, [r, C, w, e, x]), Je(() => {
    (h.length > 0 || (x.getValues("tags") || []).length > 0) && x.setValue("tags", h, { shouldDirty: !0 });
  }, [h, x]);
  const q = $r(!1), Y = () => {
    o(), f(!1), l({
      title: "Success",
      text: "The order was duplicated successfully.",
      icon: "check-circle-filled",
      severity: "success"
    }), m("shopify:order:duplicate:succeeded"), Ne();
  }, te = () => {
    o(), f(!1), l({
      title: "Order duplicated but not marked as paid",
      text: "The order was duplicated but recording the payment failed. You can mark it as paid in Shopify.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), Ne();
  }, K = () => {
    f(!1), l({
      title: "Something went wrong",
      text: "The order duplication was not successful.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), m("shopify:order:duplicate:failed"), Ne();
  }, [J] = s(IF, {
    onError: te,
    onCompleted: (ue) => {
      const oe = ue.Shopify?.orderMarkAsPaid?.userErrors;
      if (oe && oe.length > 0) {
        te();
        return;
      }
      Y();
    }
  }), [R, { error: B }] = s(FF, {
    onError: K,
    onCompleted: (ue) => {
      const oe = ue.Shopify?.orderCreate, pe = oe?.order?.id;
      if (oe?.userErrors?.length || !pe) {
        K();
        return;
      }
      if (q.current) {
        J({ variables: { input: { id: pe } } });
        return;
      }
      Y();
    }
  }), ne = (ue) => {
    const oe = ue.lineItems.map((ke) => ({
      productId: ke.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ke.discountedUnitPrice?.amount ?? ke.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ke.discountedUnitPrice?.currencyCode ?? ke.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ke.quantity,
      sku: ke.sku
    })), pe = (e?.shippingLines ?? []).map(
      (ke) => ({
        title: ke.title,
        code: ke.code,
        source: ke.source,
        priceSet: {
          shopMoney: {
            amount: ke.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: ke.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0);
    const z = ue.financialStatus === Ai.Paid;
    q.current = z, R({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: oe,
          shippingLines: pe,
          note: ue.customNote,
          tags: ue.tags,
          financialStatus: z ? void 0 : ue.financialStatus,
          fulfillmentStatus: ue.fulfillmentStatus,
          discountCode: PF(ue.discountCode),
          shippingAddress: sa(ue?.shippingAddress),
          billingAddress: sa(ue?.billingAddress)
        }
      }
    });
  }, Ne = () => {
    x.reset(N), k(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: r,
      onClose: Ne,
      className: c7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ v.jsx(Ct, { title: `Duplicate order ${n}`, onClose: Ne }),
        /* @__PURE__ */ v.jsxs(Ft, { children: [
          /* @__PURE__ */ v.jsx(Dy, { ...x, children: /* @__PURE__ */ v.jsx("form", { id: F, children: /* @__PURE__ */ v.jsxs(nt, { children: [
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(Bg, { loading: w }) }),
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
              xt,
              {
                name: "tags",
                render: ({ fieldState: { error: ue } }) => /* @__PURE__ */ v.jsx(
                  He,
                  {
                    label: "Tags",
                    meta: {
                      error: ue?.message
                    },
                    children: /* @__PURE__ */ v.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (oe) => {
                          oe.key === "Enter" && (oe.preventDefault(), oe.stopPropagation());
                        },
                        children: /* @__PURE__ */ v.jsx(
                          Nl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (oe) => {
                              k(oe);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(RF, { enabled: r }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 4, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ v.jsx(
                LF,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ v.jsx(VF, {}),
              /* @__PURE__ */ v.jsx(
                An,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 2, children: /* @__PURE__ */ v.jsx(He, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Mt.boxWrapper,
                children: /* @__PURE__ */ v.jsx(AF, {})
              }
            ) }) })
          ] }) }) }),
          B && /* @__PURE__ */ v.jsx(Tn, { error: B })
        ] }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              type: "submit",
              form: F,
              disabled: !g || u || w,
              isLoading: u || w,
              loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: x.handleSubmit(ne)
          }
        )
      ]
    }
  );
}, u7 = "_copyIcon_1dlzg_1", m7 = {
  copyIcon: u7
}, p7 = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  const { isCopied: i, copy: a } = qr();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(r).some(
    (d) => d > 0
  ), s = n.every(
    ({ id: d, quantity: m }) => (r[d] || 0) >= m
  ), l = n.map(
    ({ title: d, quantity: m, variantTitle: u }) => u ? `${m}x ${d} (${u})` : `${m}x ${d}`
  ).join(`
`);
  return /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ v.jsx(ve, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ v.jsx(Ze, { content: "Copy line items", children: /* @__PURE__ */ v.jsx(
            ve,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(l),
              className: m7.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ v.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ v.jsx(Jn, { color: "red.500", children: s ? "The order has been refunded" : "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ v.jsx(Xe, { children: n.map(({ id: d, title: m, quantity: u, variantTitle: f, image: h }) => {
      const k = r[d], F = k > 0, j = k > 1 ? `Refunded (${k} items)` : "Refunded";
      return /* @__PURE__ */ v.jsx(
        Xe.Item,
        {
          contentLeft: /* @__PURE__ */ v.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { children: u }),
            /* @__PURE__ */ v.jsx($.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", children: [
            m,
            " ",
            f && `(${f})`,
            F && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", color: "red.500", children: j })
          ] }),
          contentRight: h?.url && /* @__PURE__ */ v.jsx(xa, { src: `${h?.url}&height=48`, alt: m })
        },
        `list-${e}-${d}`
      );
    }) })
  ] });
}, f7 = Fl`
  mutation refundLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, h7 = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, zF = (e) => {
  const n = {}, r = h7(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, Cs = (e, n) => `${Number(e || 0).toFixed(2)} ${n}`, UF = ({
  refund: e,
  currencyCode: n,
  refundShipping: r,
  onToggleShipping: i,
  isLoading: a = !1
}) => {
  const o = e?.currency || n, s = Number(e?.shipping.maximumRefundable || 0) > 0, l = s && r;
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Cs(e?.subtotal || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Tax" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Cs(e?.tax || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ v.jsx(
          Io,
          {
            name: "refundShipping",
            value: "shipping",
            checked: l,
            disabled: !s || a,
            onChange: () => i(!r)
          }
        ),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", subdued: !l, children: "Refund shipping" })
      ] }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", subdued: !l, children: Cs(e?.shipping.amount || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Total refund" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: Cs(e?.amount || "0", o) })
    ] })
  ] });
}, y7 = "_modal_1mprq_1", g7 = {
  modal: y7
}, Gj = "partial-refund-shopify-order-form", v7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Fn(), { useQuery: d } = yn(), [m, u] = me(!1), [f, h] = me([]), [k, F] = me(!1), j = Yn(
    () => e?.refunds ? zF(e) : {},
    [e]
  ), N = Yn(
    () => (e?.lineItems || []).filter((oe) => (j[oe.id] || 0) >= (oe.quantity || 0)).map((oe) => oe.product?.id).filter((oe) => !!oe),
    [e, j]
  ), x = Yn(() => {
    const oe = {};
    return (e?.lineItems || []).forEach((pe) => {
      if (pe.product?.id) {
        const z = j[pe.id] || 0, ke = Math.max(
          0,
          (pe.quantity || 0) - z
        );
        oe[pe.product.id] = ke;
      }
    }), oe;
  }, [e, j]), g = Yn(
    () => (e?.lineItems || []).map((oe) => oe.product?.id).filter((oe) => !!oe),
    [e]
  ), D = Yn(
    () => TF(g),
    [g]
  ), {
    data: I,
    loading: C,
    error: w
  } = d(zg, {
    skip: !D,
    variables: {
      query: D,
      productCount: g.length,
      mediaCount: 1
    }
  });
  Je(() => {
    w && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [w, s]);
  const A = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, q = mt({
    mode: "all",
    defaultValues: A
  }), Y = f.length > 0;
  Je(() => {
    !Y && k && F(!1);
  }, [Y, k]);
  const te = pi({
    control: q.control,
    name: "lineItems"
  }), K = Yn(
    () => (te || []).filter(
      (oe) => f.includes(oe.id)
    ).map((oe) => {
      const pe = e?.lineItems?.find(
        (H) => H.product?.id === oe.id
      ), z = j[pe?.id || ""] || 0, ke = (pe?.quantity || 0) - z, $e = Math.max(
        0,
        Math.min(ke, oe.quantity || 0)
      );
      return pe && $e > 0 ? { lineItemId: pe.id, quantity: $e } : void 0;
    }).filter(
      (oe) => !!oe
    ),
    [te, f, e, j]
  ), { suggestedRefund: J, isLoading: R } = OF({
    orderId: e.id,
    refundShipping: k,
    refundLineItems: K,
    skip: !Y
  }), [B, { error: ne }] = o(
    f7,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), ue();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), ue();
      }
    }
  );
  Je(() => {
    if (!r || C || !I || q.getValues("lineItems")?.length)
      return;
    const oe = I?.Shopify?.products?.nodes || [], pe = [];
    e?.lineItems?.forEach((z) => {
      const ke = oe.find(
        ($e) => $e.id === z.product?.id
      );
      if (ke) {
        const $e = j[z.id] || 0, H = (z.quantity || 1) - $e;
        pe.push({
          ...ke,
          quantity: H > 0 ? H : z.quantity || 1
        });
      }
    }), pe.length > 0 && (q.setValue("lineItems", pe, { shouldDirty: !0 }), h([]));
  }, [
    r,
    I,
    C,
    e,
    q,
    j
  ]);
  const Ne = (oe) => {
    u(!0), B({
      variables: {
        input: $F({
          orderId: e.id,
          transactions: J?.transactions,
          refundLineItems: K,
          refundShipping: k,
          note: oe.customNote || void 0,
          notify: !0
        })
      }
    });
  }, ue = () => {
    q.reset(A), u(!1), i(!1);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: r, onClose: ue, className: g7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: `Refund order ${n}`, onClose: ue }),
    /* @__PURE__ */ v.jsxs(Ft, { children: [
      /* @__PURE__ */ v.jsx(Dy, { ...q, children: /* @__PURE__ */ v.jsx("form", { id: Gj, children: /* @__PURE__ */ v.jsxs(nt, { children: [
        /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
          Bg,
          {
            loading: C,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: N,
            maxQuantities: x,
            onToggleSelect: (oe, pe) => {
              h((z) => pe ? Array.from(/* @__PURE__ */ new Set([...z, oe])) : z.filter((ke) => ke !== oe));
            },
            onToggleSelectAll: (oe) => {
              const pe = (q.getValues("lineItems") || []).map((z) => z.id).filter((z) => !N.includes(z));
              h(oe ? pe : []);
            }
          }
        ) }),
        /* @__PURE__ */ v.jsx(Z, { span: 4, children: /* @__PURE__ */ v.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ v.jsx(
          An,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ v.jsx(Z, { span: 2, children: /* @__PURE__ */ v.jsx(He, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Mt.boxWrapper,
            children: /* @__PURE__ */ v.jsx(
              UF,
              {
                refund: J,
                currencyCode: e.currencyCode,
                refundShipping: k,
                onToggleShipping: F,
                isLoading: R
              }
            )
          }
        ) }) })
      ] }) }) }),
      ne && /* @__PURE__ */ v.jsx(Tn, { error: ne })
    ] }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          type: "submit",
          form: Gj,
          disabled: !Y || m || C || R || !J,
          isLoading: m || C,
          loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: q.handleSubmit(Ne)
      }
    )
  ] });
}, k7 = "_modal_al73g_1", b7 = {
  modal: k7
}, x7 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  isOpen: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l } = yn(), { track: d } = Fn(), { id: m, name: u, currencyCode: f } = e, [h, k] = me(!0), [F, j] = me(), { suggestedRefund: N, isLoading: x } = OF({
    orderId: m,
    suggestFullRefund: !0,
    refundShipping: h,
    skip: !i
  }), [g, { loading: D }] = s(
    ZW,
    {
      onError: (w) => j(w),
      onCompleted: (w) => {
        const A = w.Shopify?.refundCreate?.userErrors;
        if (A && A.length > 0) {
          j(
            new jw({
              graphQLErrors: A.map((q) => ({
                message: q.message
              }))
            })
          );
          return;
        }
        l({
          title: "Order refunded",
          text: `You refunded order ${u}`,
          icon: "check-circle-filled",
          severity: "success"
        }), o(), I();
      }
    }
  ), I = () => {
    k(!0), j(void 0), a(!1);
  }, C = () => {
    N && (d("shopify:order:refund:confirmed", { shopifyId: n, orderId: m }), g({
      variables: {
        input: $F({
          orderId: m,
          transactions: N.transactions,
          refundLineItems: N.refundLineItems,
          refundShipping: h,
          notify: e.suggestedRefund.notify
        })
      }
    }));
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: i, onClose: I, className: b7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: `Refund order ${u}`, onClose: I }),
    /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ v.jsx(
        UF,
        {
          refund: N,
          currencyCode: f,
          refundShipping: h,
          onToggleShipping: k,
          isLoading: x
        }
      ),
      F && /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", children: [
        /* @__PURE__ */ v.jsx(Tn, { error: F }),
        /* @__PURE__ */ v.jsx(
          Lt,
          {
            variant: "secondary",
            style: {
              color: "var(--dixa-typography-color-link)",
              padding: "var(--dixa-size-spacer-100)"
            },
            navigate: () => window.open(r, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ v.jsx(ve, { name: "external-link" }),
            children: "View order in Shopify"
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !N || x || D,
          isLoading: D || x,
          loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Confirm order refund",
        confirmOnClick: C
      }
    )
  ] });
}, _7 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { showModal: a } = yn(), { track: o } = Fn(), { suggestedRefund: s, id: l } = e, [d, m] = me(!1), u = parseFloat(String(s?.amount)), f = !isNaN(u) && u > 0, h = yt(() => {
    o("shopify:order:refund:requested", { shopifyId: n, orderId: l }), f ? m(!0) : a({
      headline: `Refund Order ${e.name}`,
      children: /* @__PURE__ */ v.jsx($.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [n, l, e.name, f, a, o]);
  return /* @__PURE__ */ v.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ v.jsx(
      et,
      {
        variant: "secondary",
        onClick: h,
        disabled: s?.refundLineItems?.length === 0 || !f,
        slotStart: /* @__PURE__ */ v.jsx(ve, { size: 14, name: "undo" }),
        className: Mt.fullWidth,
        children: "Full refund"
      }
    ),
    /* @__PURE__ */ v.jsx(
      x7,
      {
        order: e,
        shopifyId: n,
        orderLink: r,
        isOpen: d,
        setIsOpen: m,
        refetchOrders: i
      }
    )
  ] });
}, S7 = "_modal_al73g_1", N7 = {
  modal: S7
}, j7 = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = Fn(), { useMutation: s, showNotification: l } = yn(), [d, m] = me(n), [u, f] = me(!1), h = mt({
    defaultValues: {
      tags: n
    }
  });
  Je(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [k, { error: F, reset: j }] = s(n9, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), N = yt(
    (g) => {
      f(!0), k({
        variables: {
          input: {
            id: e,
            tags: g.tags
          }
        }
      }).then((D) => {
        const I = D.data?.Shopify?.orderUpdate?.order?.tags ?? g.tags;
        h.reset({ tags: I });
      });
    },
    [e, h, k]
  ), x = () => {
    i(!1), j();
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: r, onClose: x, className: N7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: "Manage tags for order", onClose: x }),
    /* @__PURE__ */ v.jsxs(Ft, { children: [
      /* @__PURE__ */ v.jsx(nt, { children: /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        xt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: g } }) => /* @__PURE__ */ v.jsx(
            He,
            {
              label: "Tags",
              meta: {
                error: g?.message
              },
              children: /* @__PURE__ */ v.jsx(
                Nl,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (D) => m(D)
                }
              )
            }
          )
        }
      ) }) }),
      F && /* @__PURE__ */ v.jsx(Tn, { error: F })
    ] }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(N),
        cancelOnClick: x,
        confirmName: F ? "Close" : "Save",
        cancelName: F ? void 0 : "Cancel"
      }
    )
  ] });
}, w7 = "_editIcon_1yp2k_1", C7 = "_copyIcon_1yp2k_2", Yj = {
  editIcon: w7,
  copyIcon: C7
}, F7 = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = me(!1), { isCopied: o, copy: s } = qr(), l = 14, d = n.length > 0;
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ve, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !d && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            d && n.map((m, u) => /* @__PURE__ */ v.jsx(Bn, { size: "small", variant: "primary", children: m }, u))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Ze, { content: "Edit tags", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: l,
            name: "pen",
            className: Yj.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        d && /* @__PURE__ */ v.jsx(Ze, { content: "Copy tags", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: l,
            name: o ? "done" : "copy",
            className: Yj.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      j7,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, I7 = "_icon_cddi1_1", E7 = "_link_cddi1_6", Jj = {
  icon: I7,
  link: E7
}, $7 = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = qr(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ v.jsx(
    Xe.Item,
    {
      contentLeft: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ v.jsx(
        $.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: Jj.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ v.jsx(Ze, { content: "Copy tracking code", children: /* @__PURE__ */ v.jsx(
        ve,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: Jj.icon
        }
      ) })
    }
  );
}, T7 = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ v.jsx(ve, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ v.jsx(Xe, { children: e.map((n) => /* @__PURE__ */ v.jsx($7, { trackingInfo: n }, n.number)) })
] }), O7 = "_copyIcon_u5m0p_1", D7 = "_strikethrough_u5m0p_6", P7 = "_order_u5m0p_10", R7 = "_orderIsOpen_u5m0p_18", A7 = "_orderHeader_u5m0p_21", wi = {
  copyIcon: O7,
  strikethrough: D7,
  order: P7,
  orderIsOpen: R7,
  orderHeader: A7
}, L7 = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = Fn(), { isCopied: h, copy: k } = qr(), { isCopied: F, copy: j } = qr(), { isCopied: N, copy: x } = qr(), [g, D] = me(!1), [I, C] = me(!1), [w, A] = me(r), {
    id: q,
    name: Y,
    createdAt: te,
    status: K,
    currentTotalPriceSet: J,
    currencyCode: R,
    lineItems: B,
    billingAddress: ne,
    shippingAddress: Ne,
    trackingInfos: ue,
    tags: oe,
    discountCodes: pe,
    currentTotalDiscountsSet: z
  } = e, ke = !!Ne, $e = Ug(q), H = `https://${l}/admin/orders/${$e ?? ""}`, Ge = J?.shopMoney?.amount ?? 0, sn = K.includes("cancelled"), Fe = (nn) => new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: R
  }).format(nn), Ue = Number(
    z?.shopMoney?.amount ?? 0
  ), Pe = Ue > 0, Be = pe?.join(", ") ?? "", Ae = Fe(Number(Ge)), Qe = Fe(
    Number(Ge) + Ue
  ), Ce = e?.refunds ? zF(e) : {}, Me = !!B?.length && B.every((nn) => (Ce[nn.id] || 0) >= (nn.quantity || 0));
  return /* @__PURE__ */ v.jsxs(
    b,
    {
      className: dt(wi.order, {
        [wi.orderIsOpen]: w
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ v.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: wi.orderHeader,
            onClick: () => A(!w),
            children: [
              /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
                te && /* @__PURE__ */ v.jsx(b, { alignItems: "center", children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Qn(te).format(ly) }) }),
                /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "1", children: [
                  "Order ",
                  Y
                ] })
              ] }),
              /* @__PURE__ */ v.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: w ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        w && /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(ve, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Y.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Ze, { content: "Copy order number", children: /* @__PURE__ */ v.jsx(
                  ve,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => k(Y.replace("#", "")),
                    className: wi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(ve, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: K })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Ze, { content: "Copy order status", children: /* @__PURE__ */ v.jsx(
                  ve,
                  {
                    size: 14,
                    name: N ? "done" : "copy",
                    onClick: () => x(K),
                    className: wi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(ve, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order value" }),
                    Pe && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", className: wi.strikethrough, children: Qe }),
                    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
                      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Ae }),
                      Be && /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", color: "tertiary", children: [
                        "(",
                        Be,
                        ")"
                      ] })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Ze, { content: "Copy order value", children: /* @__PURE__ */ v.jsx(
                  ve,
                  {
                    size: 14,
                    name: F ? "done" : "copy",
                    onClick: () => j(Ge),
                    className: wi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsx(
            F7,
            {
              orderId: q,
              tags: oe,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            dy,
            {
              openByDefault: !ke,
              labelText: "Billing address",
              address: ne,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            dy,
            {
              openByDefault: ke,
              shopifyId: n,
              orderId: q,
              icon: "map-pin",
              labelText: "Shipping address",
              address: Ne,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            p7,
            {
              orderId: q,
              lineItems: B,
              refundedQuantities: Ce
            }
          ),
          /* @__PURE__ */ v.jsx(T7, { trackingInfos: ue }),
          (o || m) && /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ v.jsx(
              _7,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: H
              }
            ),
            m && /* @__PURE__ */ v.jsx(b, { width: "100%", children: /* @__PURE__ */ v.jsx(
              et,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => C(!0),
                className: Mt.fullWidth,
                disabled: sn || Me,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ v.jsx(b, { width: "100%", children: /* @__PURE__ */ v.jsx(
              et,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => D(!0),
                className: Mt.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ v.jsx(
              s7,
              {
                orderId: q,
                orderName: Y,
                disabled: sn,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ v.jsx(
            Lt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(H, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ v.jsx(ve, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: q
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        g && /* @__PURE__ */ v.jsx(
          d7,
          {
            order: e,
            shopifyId: n,
            orderName: Y,
            isOpen: g,
            setIsOpen: D,
            refetchOrders: u
          }
        ),
        I && /* @__PURE__ */ v.jsx(
          v7,
          {
            order: e,
            orderName: Y,
            isOpen: I,
            setIsOpen: C,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, V7 = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = Fn(), [f, h] = me([]), [k, F] = me(!1), j = Ug(m?.id), N = `https://${n}/admin/orders?customer_id=${j ?? ""}`, {
    getCustomerOrders: x,
    isCustomerOrdersLoading: g,
    customerOrdersError: D,
    customerOrders: I,
    refetchCustomerOrders: C
  } = o9();
  return Je(() => {
    !g && j && x({
      variables: {
        query: `customer_id:${j}`
      }
    });
  }, [j]), Je(() => {
    const w = I?.Shopify?.orders?.edges;
    w && h(s9({ ordersData: w }));
  }, [I]), m ? D ? /* @__PURE__ */ v.jsx(Tn, { error: D }) : /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Customer orders" }),
      !g && /* @__PURE__ */ v.jsx(Bn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ v.jsx(
      et,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => F(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      g && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(hn, {}) }),
      !g && f.length === 0 && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !g && f.length > 0 && /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "column", children: f.map((w, A) => /* @__PURE__ */ v.jsx(
        L7,
        {
          order: w,
          openByDefault: A === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: C,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${A}-${w.id}`
      )) }),
      /* @__PURE__ */ v.jsx(
        Lt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(N, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ v.jsx(ve, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ v.jsx(
      r7,
      {
        isOpen: k,
        setIsOpen: F,
        shopifyCustomer: m,
        refetchCustomerOrders: C,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, z7 = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ v.jsx(v.Fragment, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ v.jsxs(Xe, { className: Mt.list, children: [
      /* @__PURE__ */ v.jsx(Xe.Text, { variant: "dense", className: Mt.listItem, children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ v.jsx(Xe.Text, { variant: "dense", className: Mt.listItem, children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, U7 = "_segmentName_1dkhk_1", M7 = {
  segmentName: U7
}, B7 = 100, Fs = 10, q7 = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = yn(), [i, a] = me([]), [o, s] = me(Fs), [l, d] = me(!1), m = Yn(
    () => i.filter((j) => j.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    YW,
    {
      skip: !e,
      variables: {
        first: B7
      },
      onCompleted: (j) => {
        const N = j?.Shopify?.segments?.edges;
        if (N && N.length > 0) {
          const x = N.map(({ node: g }) => ({
            ...g,
            isMember: !1
          })).sort((g, D) => g.name.localeCompare(D.name));
          a(x), h({
            variables: {
              customerId: e,
              segmentIds: x.map((g) => g.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: k, error: F }
  ] = r(JW, {
    onCompleted: (j) => {
      const N = j?.Shopify?.customerSegmentMembership?.memberships;
      if (N && N.length > 0) {
        const x = i.map((g) => {
          const D = N.find(
            (I) => I.segmentId === g.id
          );
          return {
            ...g,
            ...D?.isMember && { isMember: D.isMember }
          };
        }).sort(
          (g, D) => g.isMember === D.isMember ? 0 : g.isMember ? -1 : 1
        );
        a(x);
      }
    }
  });
  return Je(() => {
    s(l ? i.length : Fs);
  }, [l]), e ? /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ v.jsx(Bn, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(hn, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ v.jsx(Tn, { error: f }),
    F && /* @__PURE__ */ v.jsx(Tn, { error: F }),
    !u && i.length > 0 && /* @__PURE__ */ v.jsxs(Xe, { className: Mt.list, children: [
      i.slice(0, o).map(({ id: j, name: N, isMember: x }) => /* @__PURE__ */ v.jsx(Xe.Text, { className: Mt.listItem, children: /* @__PURE__ */ v.jsx(
        Ze,
        {
          content: `${x ? "Member of" : "Not a member of"} ${N}`,
          children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", className: M7.segmentName, children: N }),
            k && /* @__PURE__ */ v.jsx(hn, { size: 12 }),
            !k && /* @__PURE__ */ v.jsx(b, { children: /* @__PURE__ */ v.jsx(
              ve,
              {
                color: x ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, j)),
      i.length > Fs && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ v.jsx(
        et,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Fs} more`
        }
      ) })
    ] })
  ] }) : null;
}, H7 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me(!1);
  Je(() => {
    i(!1);
  }, [
    e.customer?.phone_number,
    e.customer?.email
  ]);
  const {
    isCustomerLoading: a,
    customerError: o,
    customerData: s,
    refetchCustomer: l,
    customerNetworkStatus: d
  } = a9({ conversationContext: e, forcePhoneLookup: r }), [m, u] = me(), [f, h] = me(
    []
  ), k = n.apiHostName, F = n.displayRefundOrder ?? !1, j = n.displayCancelOrder ?? !1, N = n.enableEditShippingAddress ?? !1, x = n.displayEmailMarketingConsent ?? !1, g = n.displayOrdersOverview ?? !1, D = n.displaySegmentMembership ?? !1, I = n.displayDiscountCodeCreation ?? !1, C = n.displayDiscountCodes ?? !1, w = n.displayCreateOrder ?? !1, A = n.displayDuplicateOrder ?? !1, q = n.displayCreateDraftOrder ?? !1, Y = n.displayPartialRefundOrder ?? !1;
  if (Je(() => {
    const te = s?.Shopify?.customers?.edges[0]?.node, K = !!e.customer?.phone_number && !!e.customer?.email;
    te && !a ? (h(
      s?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), u(te)) : !te && !a && K && !r ? i(!0) : u(void 0);
  }, [s, e]), !a && o)
    return /* @__PURE__ */ v.jsx(Tn, { error: o, retry: l });
  if (!a && !o && !m) {
    const te = `https://${k}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ v.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ v.jsx(
              _9,
              {
                refetchCustomer: l,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ v.jsx(
              Lt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(te, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ v.jsx(ve, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return a && d !== rr.refetch ? /* @__PURE__ */ v.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ v.jsx(hn, {}) }) : /* @__PURE__ */ v.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ v.jsx(
          j9,
          {
            customer: m,
            shopifyDomain: k,
            refresh: l,
            loading: a,
            networkStatus: d
          }
        ),
        g && /* @__PURE__ */ v.jsx(
          z7,
          {
            totalOrders: m?.numberOfOrders,
            amountSpent: m?.amountSpent
          }
        ),
        D && /* @__PURE__ */ v.jsx(q7, { shopifyId: m?.id }),
        x && /* @__PURE__ */ v.jsx(U9, { customer: m }),
        C && /* @__PURE__ */ v.jsx(
          z9,
          {
            displayDiscountCodeCreation: I
          }
        ),
        /* @__PURE__ */ v.jsx(
          V7,
          {
            shopifyCustomer: m,
            shopifyDomain: k,
            displayRefund: F,
            displayCancel: j,
            displayCreateOrder: w,
            displayCreateDraftOrder: q,
            enableEditShippingAddress: N,
            customerCountryCodes: f,
            displayDuplicateOrder: A,
            displayPartialRefundOrder: Y
          }
        )
      ]
    }
  );
}, Ot = [];
for (let e = 0; e < 256; ++e)
  Ot.push((e + 256).toString(16).slice(1));
function W7(e, n = 0) {
  return (Ot[e[n + 0]] + Ot[e[n + 1]] + Ot[e[n + 2]] + Ot[e[n + 3]] + "-" + Ot[e[n + 4]] + Ot[e[n + 5]] + "-" + Ot[e[n + 6]] + Ot[e[n + 7]] + "-" + Ot[e[n + 8]] + Ot[e[n + 9]] + "-" + Ot[e[n + 10]] + Ot[e[n + 11]] + Ot[e[n + 12]] + Ot[e[n + 13]] + Ot[e[n + 14]] + Ot[e[n + 15]]).toLowerCase();
}
const K7 = new Uint8Array(16);
function G7() {
  return crypto.getRandomValues(K7);
}
function Y7(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : J7(e);
}
function J7(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? G7();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, W7(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._pointer_pn2q5_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_pn2q5_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_pn2q5_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_pn2q5_69:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_4z55u_54{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_4z55u_54:hover,._messageIsOpen_4z55u_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_4z55u_66{cursor:pointer}._messageText_4z55u_70{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_4z55u_70::-webkit-scrollbar{width:7px;height:7px}._messageText_4z55u_70::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_4z55u_70::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_4z55u_70::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._buttonLink_4z55u_93{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var hh = { exports: {} }, po = {}, Qj;
function Q7() {
  if (Qj) return po;
  Qj = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return po.Fragment = r, po.jsx = s, po.jsxs = s, po;
}
var Is = {}, Xj;
function X7() {
  return Xj || (Xj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Is.Fragment = i, Is.jsx = Un, Is.jsxs = Kn;
  })()), Is;
}
var Zj;
function Z7() {
  return Zj || (Zj = 1, process.env.NODE_ENV === "production" ? hh.exports = Q7() : hh.exports = X7()), hh.exports;
}
var P = Z7(), MF = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(MF || {}), uy = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(uy || {});
const eK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, nK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, tK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, rK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, iK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, aK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, oK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, sK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, lK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, cK = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": eK,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": nK,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": tK,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": rK,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": iK,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": aK,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": oK,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": sK,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": lK
};
function ii(e) {
  return cK[e] ?? {};
}
const dK = ii(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), uK = ii(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), mK = ii(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), pK = ii(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), fK = ii(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), hK = ii(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), yK = ii(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), gK = ii(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), vK = ii(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), kK = ({
  contactId: e
}) => {
  const { useQuery: n } = yn(), { track: r } = Fn(), [i, a] = me(), [o, s] = me(), [l, d] = me(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(dK, {
    skip: !e,
    variables: { contactId: e }
  });
  return Je(() => {
    const k = f?.Voyado?.ContactsV_GetContactById;
    !m && k && typeof k == "object" && ("id" in k && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in k && a(k.attributes), "preferences" in k && s(k.preferences), "consents" in k && d(
      k?.consents?.filter(
        (F) => F !== null
      ) || void 0
    )), !m && (!k || typeof k != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Yn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function Ys(e = !1, n) {
  const [r, i] = me(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const bK = {
  count: 0,
  items: []
}, xK = ({
  contactId: e
}) => {
  const { useQuery: n } = yn(), { track: r } = Fn(), [i, a] = me(bK), {
    loading: o,
    error: s,
    data: l
  } = n(pK, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Je(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, _K = {
  count: 0,
  totalCount: 0,
  items: []
}, SK = ({
  contactId: e
}) => {
  const { useQuery: n } = yn(), { track: r } = Fn(), [i, a] = me(
    _K
  ), {
    loading: o,
    error: s,
    data: l
  } = n(fK, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Je(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, NK = ({
  conversationContext: e
}) => {
  const { useQuery: n } = yn(), [r, i] = me(void 0), [a, o] = me(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(mK, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return Je(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, jK = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = yn(), [i, a] = me(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(uK, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return Je(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Yn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, wK = "_pointer_pn2q5_54", CK = "_list_pn2q5_59", FK = "_listItem_pn2q5_69", pt = {
  pointer: wK,
  list: CK,
  listItem: FK
}, IK = "_modalBody_1clhs_1", EK = {
  modalBody: IK
}, $K = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Fn(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: k } = mt({
    defaultValues: u,
    mode: "onChange"
  }), F = pi({ control: f }), j = parseInt(F?.balance ?? "0", 10), N = m === j, x = N ? "Change the value to update the points" : "", g = j < 0, D = g ? "Points can not be negative" : "", I = F.description === "", C = I ? "Description can not be empty" : "";
  Je(() => {
    j > m ? h(
      "transactionType",
      uy.Addition
    ) : j < m && h(
      "transactionType",
      uy.Deduction
    );
  }, [m, j, h]);
  const [w, { loading: A, error: q, reset: Y }] = o(vK, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), te = () => {
    if (d) {
      const J = Y7();
      w({
        variables: {
          input: {
            accountId: d,
            transactionId: J,
            amount: Math.abs(j - m),
            transactionType: F.transactionType,
            description: F.description,
            source: MF.UpdateBalance
          }
        }
      }).then(async (R) => {
        R?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), K());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, K = () => {
    k(u), Y(), n();
  };
  return /* @__PURE__ */ P.jsxs(
    wt,
    {
      isOpen: e,
      onClose: K,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ P.jsx(Ct, { title: "Update points balance", onClose: K }),
        /* @__PURE__ */ P.jsxs(Ft, { className: EK.modalBody, children: [
          /* @__PURE__ */ P.jsxs(nt, { children: [
            /* @__PURE__ */ P.jsx(Z, { span: 6, children: /* @__PURE__ */ P.jsx(
              xt,
              {
                name: "balance",
                control: f,
                render: ({ field: J }) => /* @__PURE__ */ P.jsx(
                  tr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: x || D
                    },
                    input: {
                      ...J,
                      value: J.value.toString(),
                      onChange: (R) => J.onChange(R)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ P.jsx(Z, { span: 6, children: /* @__PURE__ */ P.jsx(
              xt,
              {
                name: "description",
                control: f,
                render: ({ field: J }) => /* @__PURE__ */ P.jsx(
                  tr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: J,
                    meta: {
                      warning: C
                    }
                  }
                )
              }
            ) })
          ] }),
          q && /* @__PURE__ */ P.jsx(Tn, { error: q })
        ] }),
        /* @__PURE__ */ P.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => te(),
            confirmProps: {
              isLoading: A,
              disabled: N || g || I,
              loadingIndicator: /* @__PURE__ */ P.jsx(hn, { size: 16 })
            },
            cancelOnClick: K
          }
        )
      ]
    }
  );
}, TK = "_wrapper_1ge6c_1", OK = "_block_1ge6c_12", ew = {
  wrapper: TK,
  block: OK
}, DK = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = yn(), { isCopied: i, copy: a } = Ys(), { isCopied: o, copy: s } = Ys(), { isCopied: l, copy: d } = Ys(), [m, u] = me(!1), [f, h] = me(), [k, F] = me(!1), {
    loading: j,
    data: N,
    refetch: x
  } = r(yK, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  Je(() => {
    if (N) {
      const ne = N?.Voyado?.PointAccountV_GetPointAccounts;
      ne && ne?.length > 0 && h(ne[0]);
    }
  }, [N]);
  const g = !!f?.id, D = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: I,
    lastName: C,
    street: w,
    zipCode: A,
    city: q,
    country: Y,
    isRegistrationCompleted: te,
    email: K,
    mobilePhone: J
  } = e, R = 14, B = `${I || ""} ${C || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", className: ew.wrapper, children: [
    /* @__PURE__ */ P.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: ew.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-2", children: B }),
          j && /* @__PURE__ */ P.jsx(hn, { size: 12 }),
          g && !j && /* @__PURE__ */ P.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ P.jsxs(Bn, { size: "small", variant: "warning", children: [
              D,
              " points"
            ] }),
            /* @__PURE__ */ P.jsx(Ze, { content: "Update points balance", children: /* @__PURE__ */ P.jsx(
              ve,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: pt.pointer
              }
            ) }),
            k && /* @__PURE__ */ P.jsx(Ze, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ P.jsx(
              ve,
              {
                name: "info",
                size: 12,
                className: pt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (w || q || A || Y || J || K) && /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
      J && /* @__PURE__ */ P.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ P.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ P.jsx(ve, { size: R, name: "phone" }),
          /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: J })
        ] }),
        /* @__PURE__ */ P.jsx(
          ve,
          {
            size: R,
            name: o ? "done" : "copy",
            onClick: () => s(J),
            className: pt.pointer
          }
        )
      ] }),
      K && /* @__PURE__ */ P.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ P.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ P.jsx(ve, { size: R, name: "mail" }),
          /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: K })
        ] }),
        /* @__PURE__ */ P.jsx(
          ve,
          {
            size: R,
            name: i ? "done" : "copy",
            onClick: () => a(K),
            className: pt.pointer
          }
        )
      ] }),
      (w || q || A || Y) && /* @__PURE__ */ P.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ P.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ P.jsx(ve, { size: R, name: "home" }),
          /* @__PURE__ */ P.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ P.jsx(lt, { children: w }),
            /* @__PURE__ */ P.jsxs(lt, { children: [
              A,
              " ",
              q
            ] }),
            /* @__PURE__ */ P.jsx(lt, { children: Y })
          ] })
        ] }),
        /* @__PURE__ */ P.jsx(
          ve,
          {
            size: R,
            name: l ? "done" : "copy",
            onClick: () => d(`${w}, ${A} ${q}, ${Y}`),
            className: pt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ P.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ P.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ P.jsx(ve, { size: R, name: "sign-in" }),
          /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ P.jsx(
          ve,
          {
            name: te ? "check-circle-filled" : "close-circle-filled",
            color: te ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    g && /* @__PURE__ */ P.jsx(
      $K,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: F,
        refetchPointsQuery: x
      }
    )
  ] });
}, PK = "_list_yud4a_7", RK = "_listItem_yud4a_11", AK = "_listItemTooltip_yud4a_15", LK = "_listItemTimestamp_yud4a_18", Es = {
  list: PK,
  listItem: RK,
  listItemTooltip: AK,
  listItemTimestamp: LK
}, VK = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ P.jsx(Xe, { className: Es.list, children: e.map((n, r) => /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: Es.listItem, children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ P.jsx(Ze, { content: n?.comment, children: /* @__PURE__ */ P.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: dt({
          [Es.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ P.jsx($.Paragraph, { className: Es.listItemTimestamp, children: Qn(n.date).format(jt) }),
          n?.comment && /* @__PURE__ */ P.jsx(ve, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ P.jsx(
      ve,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), zK = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Qn(e.latestChange).format(jt) : null, o = e?.expires ? `${Qn(e.expires).fromNow()} (${Qn(e.expires).format(jt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ P.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ P.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ P.jsx(Ze, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ P.jsx(
        ve,
        {
          name: "question",
          size: 14,
          className: pt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ P.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ P.jsxs(Xe, { className: pt.list, children: [
      s && /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ P.jsx(Ze, { content: "", children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ P.jsx(Bn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ P.jsx(Ze, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ P.jsx(Bn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ P.jsx(Ze, { content: "", children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ P.jsx(Bn, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ P.jsx(Ze, { content: "", children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ P.jsx(Ze, { content: "", children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, UK = "_tagHover_kzbzk_1", MK = "_channelUnsubscribed_kzbzk_6", nw = {
  tagHover: UK,
  channelUnsubscribed: MK
}, yh = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = Fn(), { useMutation: l } = yn(), [d, m] = me(!1), [u, { loading: f }] = l(gK), h = async ({
    newPreference: F,
    isSubscribed: j,
    channelType: N
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...F
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? j ? s("voyado:channel:unsubscribe:succeeded", { channel: N }) : s("voyado:channel:subscribe:succeeded", { channel: N }) : j ? s("voyado:channel:unsubscribe:failed", { channel: N }) : s("voyado:channel:subscribe:failed", { channel: N }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, k = d || f;
  return /* @__PURE__ */ P.jsx(Ze, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ P.jsx(
    Jn,
    {
      className: nw.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ P.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: dt({
            [nw.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            k ? /* @__PURE__ */ P.jsx(hn, { size: 16 }) : /* @__PURE__ */ P.jsx(ve, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, BK = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ P.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ P.jsx(
        yh,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ P.jsx(
        yh,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ P.jsx(
        yh,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, qK = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = kK({ contactId: e }), {
    isLoading: k,
    error: F,
    memberLevel: j
  } = jK({ contactId: e, skip: !s }), N = k || l, x = Yn(
    () => h?.filter(
      (g) => g !== null
    ),
    [h]
  );
  return d || F ? ba({
    errors: d?.graphQLErrors || F?.graphQLErrors || []
  }) ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ P.jsx($.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ P.jsx(Tn, { error: d || F }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ P.jsx($.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : N ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ P.jsx(hn, {}) }) : /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
    r && /* @__PURE__ */ P.jsx(
      DK,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ P.jsx(zK, { memberLevel: j }),
    i && /* @__PURE__ */ P.jsx(
      BK,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ P.jsx(VK, { contactConsents: x })
  ] });
}, my = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, HK = "_list_zu4s7_1", WK = "_listItem_zu4s7_4", KK = "_listSum_zu4s7_7", $s = {
  list: HK,
  listItem: WK,
  listSum: KK
}, GK = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ P.jsxs(Xe, { className: $s.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: $s.listItem, children: /* @__PURE__ */ P.jsx(Ze, { content: s, children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ P.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ P.jsx(b, { flex: "auto", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ P.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: my(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ P.jsx(
    Xe.Text,
    {
      variant: "dense",
      className: dt($s.listItem, $s.listSum),
      children: /* @__PURE__ */ P.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: my(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), YK = "_transaction_1kr8d_1", JK = "_transactionIsOpen_1kr8d_9", QK = "_transactionHeader_1kr8d_12", XK = "_transactionHeaderSubLine_1kr8d_15", ZK = "_transactionHeaderAlignItemRight_1kr8d_19", ia = {
  transaction: YK,
  transactionIsOpen: JK,
  transactionHeader: QK,
  transactionHeaderSubLine: XK,
  transactionHeaderAlignItemRight: ZK
}, eG = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = me(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", k = f ?? 0, F = m?.length ? m : [];
  return /* @__PURE__ */ P.jsxs(
    b,
    {
      className: dt(ia.transaction, {
        [ia.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ P.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ia.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ P.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "info", children: Qn(o).format(jt) }),
                  /* @__PURE__ */ P.jsxs(
                    $.Heading,
                    {
                      variant: "heading-4",
                      className: ia.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ P.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ia.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-4", children: my(k, h) }),
                      /* @__PURE__ */ P.jsxs(
                        $.Heading,
                        {
                          variant: "heading-4",
                          className: ia.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ P.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ P.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ P.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ P.jsx(Cl, {}),
              /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ P.jsx(Jn, { children: /* @__PURE__ */ P.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ P.jsx(
                  GK,
                  {
                    lineItems: F,
                    localCurrency: h,
                    localNetPriceSum: k
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, nG = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = SK({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ P.jsx(Tn, { error: r }) : /* @__PURE__ */ P.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ P.jsx(hn, {}) }) : /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
          s === 0 && /* @__PURE__ */ P.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ P.jsx(
            eG,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, tG = "_message_4z55u_54", rG = "_messageIsOpen_4z55u_62", iG = "_messageHeader_4z55u_66", aG = "_messageText_4z55u_70", oG = "_buttonLink_4z55u_93", fo = {
  message: tG,
  messageIsOpen: rG,
  messageHeader: iG,
  messageText: aG,
  buttonLink: oG
}, gh = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, vh = (e, n) => n && e in gh && n in gh[e] ? gh[e][n] : null, sG = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = me(n), { track: a } = Fn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, k = l ? vh("type", l) : null, F = d ? vh("source", d) : null, j = u ? vh("status", u) : null, N = l?.replace("Message", "");
  return /* @__PURE__ */ P.jsxs(
    b,
    {
      className: dt(fo.message, {
        [fo.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ P.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: fo.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ P.jsxs(b, { gap: "200", alignItems: "center", children: [
                  k && /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
                    /* @__PURE__ */ P.jsx(ve, { name: k, size: 16 }),
                    " ",
                    N
                  ] }),
                  s && /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "info", children: Qn(s).format(jt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ P.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ P.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ P.jsx(Cl, {}),
          /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            j && /* @__PURE__ */ P.jsx(Jn, { children: /* @__PURE__ */ P.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ P.jsx(ve, { name: j }),
              " ",
              u
            ] }) }),
            F && /* @__PURE__ */ P.jsx(Jn, { children: /* @__PURE__ */ P.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ P.jsx(ve, { name: F }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ P.jsx(Jn, { children: /* @__PURE__ */ P.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ P.jsx(ve, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", className: fo.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ P.jsx(
            Lt,
            {
              slotEnd: /* @__PURE__ */ P.jsx(ve, { name: "external-link" }),
              variant: "tertiary",
              className: fo.buttonLink,
              navigate: () => {
                N && a("voyado:message:external-link:opened", {
                  channel: N.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, lG = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = xK({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ P.jsx(Tn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ P.jsx(Bn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ P.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ P.jsx(hn, {}) }) : /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ P.jsx(
        sG,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, Ql = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, tw = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = Ys(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = yt(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ P.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ P.jsx(ve, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ P.jsx(Ze, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ P.jsx(
      ve,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: pt.pointer
      }
    ) })
  ] });
}, cG = "_order_19t4p_1", dG = "_orderIsOpen_19t4p_9", uG = "_orderHeader_19t4p_12", mG = "_orderIconColor_19t4p_15", Vr = {
  order: cG,
  orderIsOpen: dG,
  orderHeader: uG,
  orderIconColor: mG
}, pG = "_delivery_1m9nb_1", fG = "_deliveryCode_1m9nb_4", kh = {
  delivery: pG,
  deliveryCode: fG
}, hG = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = Jt();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ P.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ P.jsx(
      ve,
      {
        size: l,
        name: "eye",
        className: Vr.orderIconColor
      }
    ),
    /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ P.jsx(
        Ze,
        {
          content: /* @__PURE__ */ P.jsxs($.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Qn(s).format(jt)
          ] }),
          children: /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ P.jsx(
              $.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ P.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: kh.delivery,
                    children: [
                      /* @__PURE__ */ P.jsx(ve, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ P.jsx(
              $.Paragraph,
              {
                variant: "4",
                className: dt(kh.delivery, kh.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ P.jsx(Ze, { content: "Copy tracking code", children: /* @__PURE__ */ P.jsx(
      ve,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: pt.pointer
      }
    ) })
  ] });
}, yG = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ P.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ P.jsx(
        ve,
        {
          size: 14,
          name: "file-text",
          className: Vr.orderIconColor
        }
      ),
      /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ P.jsx(Xe, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ P.jsx(Xe.Item, { className: pt.listItem, children: /* @__PURE__ */ P.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ P.jsx($.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ P.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ P.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: pt.listItemAlignRight,
              children: [
                /* @__PURE__ */ P.jsx($.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: Ql({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, gG = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ P.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ P.jsx(
        ve,
        {
          size: 14,
          name: "tag",
          className: Vr.orderIconColor
        }
      ),
      /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ P.jsx(Xe, { className: pt.list, children: r?.map((i) => /* @__PURE__ */ P.jsx(
      Xe.Item,
      {
        className: pt.listItem,
        contentLeft: /* @__PURE__ */ P.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ P.jsx(
          Ze,
          {
            content: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ P.jsx(b, { children: /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "info", children: Ql({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ P.jsx(
          xa,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, vG = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ P.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ P.jsx(
        ve,
        {
          size: 14,
          name: "credit-card",
          className: Vr.orderIconColor
        }
      ),
      /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ P.jsx(Xe, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ P.jsx(
      Xe.Item,
      {
        className: pt.listItem,
        children: /* @__PURE__ */ P.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ P.jsx($.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ P.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: pt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ P.jsx($.Paragraph, { variant: "5", children: Qn(i?.paidAt).format(jt) }),
                    /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: Ql({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, kG = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = me(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: k,
    totalPrice: F
  } = e, j = 14;
  return /* @__PURE__ */ P.jsxs(
    b,
    {
      className: dt(Vr.order, {
        [Vr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ P.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Vr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ P.jsx(b, { alignItems: "center", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: Qn(m).format(jt) }) }),
                /* @__PURE__ */ P.jsx($.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ P.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ P.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ P.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ P.jsx(
              ve,
              {
                size: j,
                name: "activity",
                className: Vr.orderIconColor
              }
            ),
            /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ P.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ P.jsx(Ze, { content: "Internal status", children: /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "info", children: /* @__PURE__ */ P.jsx(P.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ P.jsx(Ze, { content: "External status", children: /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "info", children: /* @__PURE__ */ P.jsx(P.Fragment, { children: s }) }) }),
                /* @__PURE__ */ P.jsx(Ze, { content: "Last updated at", children: /* @__PURE__ */ P.jsx($.Paragraph, { as: "span", variant: "5", children: Qn(u).format(jt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ P.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ P.jsx(
              ve,
              {
                size: j,
                name: "chart-bar",
                className: Vr.orderIconColor
              }
            ),
            /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: Ql({
                value: F,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ P.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ P.jsx(
              ve,
              {
                size: j,
                name: "channels",
                className: Vr.orderIconColor
              }
            ),
            /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "info", children: /* @__PURE__ */ P.jsx(P.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ P.jsx(tw, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ P.jsx(
            tw,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: k
            }
          ),
          /* @__PURE__ */ P.jsx(hG, { delivery: e.delivery }),
          /* @__PURE__ */ P.jsx(gG, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ P.jsx(yG, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ P.jsx(
            vG,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, bG = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || ba({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ P.jsx(Tn, { error: e }) : /* @__PURE__ */ P.jsx(P.Fragment, { children: r }), xG = ({
  contactId: e
}) => {
  const { useQuery: n } = yn(), [r, i] = me([]), { track: a } = Fn(), {
    loading: o,
    error: s,
    data: l
  } = n(hK, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return Je(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ P.jsx(hn, {}) }) : /* @__PURE__ */ P.jsx(bG, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ P.jsx(
      kG,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, _G = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = NK({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: k,
    showOrders: F
  } = n;
  return s ? /* @__PURE__ */ P.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ P.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? ba({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ P.jsx(Tn, { error: o }) : !d && !m && !u && !f && !h && !k ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ P.jsx(hn, {}) }) : /* @__PURE__ */ P.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ P.jsx(qK, { contactId: i, settings: n }),
        h && /* @__PURE__ */ P.jsx(lG, { contactId: i }),
        k && /* @__PURE__ */ P.jsx(nG, { contactId: i }),
        F && /* @__PURE__ */ P.jsx(xG, { contactId: i }),
        !l && /* @__PURE__ */ P.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, py = [
  {
    key: "voyadoApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "showCustomerAttributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPreferences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAudiences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showConsents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], SG = {
  enabled: !1,
  name: "",
  voyadoApiKey: "",
  apiHostName: "",
  showCustomerAttributes: !0,
  showPreferences: !0,
  showAudiences: !0,
  showConsents: !0,
  showLastMessages: !0,
  showCustomerTransactions: !0,
  showOrders: !0,
  showMemberLevel: !0
}, NG = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: SG
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: "VOYADO",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: py,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: I, renderConditionsForSubmit: C } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (q) => hr(q, {
    fieldDefinitions: py,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), A = s.watch("name");
  return /* @__PURE__ */ P.jsxs(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ P.jsx(yr, { cause: h }),
        /* @__PURE__ */ P.jsxs(nt, { children: [
          /* @__PURE__ */ P.jsx(Z, { children: /* @__PURE__ */ P.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(
            Er,
            {
              name: "voyadoApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "API key from Voyado",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(
            An,
            {
              name: "apiHostName",
              label: "API URL",
              control: s.control,
              rules: { required: "API URL is required" },
              componentProps: {
                placeholder: "The URL of the Voyado API",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show the customer attributes", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showCustomerAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show preferences", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showPreferences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show audiences", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showAudiences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show consents", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showConsents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show the last 5 messages", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showLastMessages",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show customer transactions", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showCustomerTransactions",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show orders by contact", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show member level", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showMemberLevel",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ P.jsx(Z, { children: a({
            value: D,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ P.jsx(
          gr,
          {
            integrationType: "VOYADO",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_1pfts_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1pfts_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1pfts_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_1pfts_69:last-child{box-shadow:none}._listItemHighlighted_1pfts_78{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var bh = { exports: {} }, ho = {}, rw;
function jG() {
  if (rw) return ho;
  rw = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ho.Fragment = r, ho.jsx = s, ho.jsxs = s, ho;
}
var Ts = {}, iw;
function wG() {
  return iw || (iw = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var O = p.map(function(S) {
          return String(S);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, q = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || q || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function K(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function J(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return J(c) + ".Consumer";
          case s:
            var p = t;
            return J(p._context) + ".Provider";
          case d:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, O = E._payload, S = E._init;
            try {
              return R(S(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ne = 0, Ne, ue, oe, pe, z, ke, $e;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ne === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, pe = console.error, z = console.group, ke = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function sn() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: pe
            }),
            group: B({}, t, {
              value: z
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, M = ee.length - 1; L >= 1 && M >= 0 && _[L] !== ee[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ee[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ee[M]) {
                    var de = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = O, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", De = ze ? Pe(ze) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function le(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case m:
          return Pe("Suspense");
        case u:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return le(t.type, c, p);
          case h: {
            var y = t, E = y._payload, O = y._init;
            try {
              return le(O(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var O = Function.call.bind(ce);
        for (var S in t)
          if (O(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(E), g("Failed %s type: %s", p, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function T(t) {
      return Q(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), ae(t);
    }
    var G = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, O, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var O, S = {}, _ = null, ee = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (O in c)
          ce.call(c, O) && !fe.hasOwnProperty(O) && (S[O] = c[O]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (O in L)
            S[O] === void 0 && (S[O] = L[O]);
        }
        if (_ || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ee && In(S, M);
        }
        return _n(t, _, ee, E, y, G.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = le(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var O = E.call(t), S; !(S = O.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, O) {
      {
        var S = te(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, O);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (T(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  Sn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(de, t);
        }
        if (ce.call(c, "key")) {
          var De = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[De + mn]) {
            var Dn = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, De, Dn, De), Cn[De + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Ts.Fragment = i, Ts.jsx = Un, Ts.jsxs = Kn;
  })()), Ts;
}
var aw;
function CG() {
  return aw || (aw = 1, process.env.NODE_ENV === "production" ? bh.exports = jG() : bh.exports = wG()), bh.exports;
}
var je = CG();
const FG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, IG = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": FG
};
function EG(e) {
  return IG[e] ?? {};
}
const $G = EG(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), TG = "_copyIcon_1pfts_54", OG = "_list_1pfts_59", DG = "_listItem_1pfts_69", PG = "_listItemHighlighted_1pfts_78", ka = {
  copyIcon: TG,
  list: OG,
  listItem: DG,
  listItemHighlighted: PG
}, RG = "_wrapper_1xucg_1", AG = "_externalLink_1xucg_7", xh = {
  wrapper: RG,
  externalLink: AG
}, LG = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Jt(), { isCopied: i, copy: a } = Jt();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: d,
    account_created_at: m
  } = e, u = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ je.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ je.jsxs(b, { className: xh.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsx(
      b,
      {
        justifyContent: "space-between",
        className: xh.block,
        alignItems: "center",
        children: /* @__PURE__ */ je.jsx($.Heading, { variant: "heading-2", children: f })
      }
    ),
    m && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", children: Qn(m).format(jt) })
    ] }),
    l && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ je.jsx(ve, { size: u, name: "mail" }),
        /* @__PURE__ */ je.jsx("span", { className: xh.externalLink, children: l })
      ] }),
      /* @__PURE__ */ je.jsx(Ze, { content: "Copy email", children: /* @__PURE__ */ je.jsx(b, { alignItems: "center", children: /* @__PURE__ */ je.jsx(
        ve,
        {
          size: u,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: ka.copyIcon
        }
      ) }) })
    ] }),
    d && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ je.jsx(ve, { size: u, name: "phone" }),
        /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", children: d })
      ] }),
      /* @__PURE__ */ je.jsx(Ze, { content: "Copy phone number", children: /* @__PURE__ */ je.jsx(b, { alignItems: "center", children: /* @__PURE__ */ je.jsx(
        ve,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: ka.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Zn = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = gw(n);
  return /* @__PURE__ */ je.jsx(
    Xe.Text,
    {
      variant: "dense",
      className: dt(ka.listItem, {
        [ka.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ je.jsx(Ze, { content: r, children: /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", children: e }),
        a ? n : Li(n)
      ] }) })
    }
  );
}, VG = ({
  loyalty: e
}) => /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ je.jsx($.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ je.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ je.jsxs(Xe, { className: ka.list, children: [
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), zG = 0.8, UG = 0.4, ow = (e) => {
  if (e != null)
    return e >= zG ? /* @__PURE__ */ je.jsx(Bn, { variant: "success", size: "small", children: "Positive" }) : e <= UG ? /* @__PURE__ */ je.jsx(Bn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ je.jsx(Bn, { variant: "warning", size: "small", children: "Neutral" });
}, MG = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ je.jsx($.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ je.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ je.jsxs(Xe, { className: ka.list, children: [
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: ow(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: ow(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Qn(e.last_review_date).format(
          jt
        )
      }
    ),
    /* @__PURE__ */ je.jsx(
      Zn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ je.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ je.jsx(Bn, { variant: "info", size: "small", children: /* @__PURE__ */ je.jsx(je.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), BG = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = yn(), { track: i } = Fn(), [a, o] = me(), [s, l] = me(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, k = n?.showUserGeneratedContent ?? !1, F = n?.displayLoyalty ?? !1, j = n?.displaySubscriptions ?? !1, N = !f, x = !h && !k && !F && !j, {
    loading: g,
    error: D,
    data: I
  } = r($G, {
    skip: u || N,
    variables: {
      ...d && { email: d },
      ...!d && m && { phone: m },
      storeId: f,
      expand: "all"
    }
  });
  if (Je(() => {
    const C = I?.Yotpo?.getCustomers?.customers?.[0];
    C ? (o(C), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [I?.Yotpo, g]), N)
    return /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ je.jsx(
      Tn,
      {
        error: new jw({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (u)
    return /* @__PURE__ */ je.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (x)
    return /* @__PURE__ */ je.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (g)
    return /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ je.jsx(hn, {}) });
  if (s)
    return /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (D) {
    const C = D.graphQLErrors;
    return xl({ errors: C }) ? /* @__PURE__ */ je.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : _l({ errors: C }) ? /* @__PURE__ */ je.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ je.jsx(Tn, { error: D });
  }
  return /* @__PURE__ */ je.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ je.jsx(LG, { customerDetails: a }),
        k && /* @__PURE__ */ je.jsx(
          MG,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        F && /* @__PURE__ */ je.jsx(VG, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
}, qG = "_settingsWrapper_1ycvy_1", HG = "_settingsWrapperHeader_1ycvy_6", WG = "_settingsWrapperContent_1ycvy_10", KG = "_settingsWrapperContentCode_1ycvy_18", GG = "_settingsWrapperContentCURL_1ycvy_26", yo = {
  settingsWrapper: qG,
  settingsWrapperHeader: HG,
  settingsWrapperContent: WG,
  settingsWrapperContentCode: KG,
  settingsWrapperContentCURL: GG
}, BF = ({
  handleChangeText: e
}) => {
  const [n, r] = me(!1), { isCopied: i, copy: a } = Jt(), { control: o } = mt({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = pi({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = yt(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ je.jsx(je.Fragment, { children: /* @__PURE__ */ je.jsx(Z, { span: 6, children: /* @__PURE__ */ je.jsxs(b, { flexDirection: "column", className: yo.settingsWrapper, children: [
    /* @__PURE__ */ je.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: yo.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ je.jsx($.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ je.jsx(ve, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ je.jsxs(
      b,
      {
        flexDirection: "column",
        className: yo.settingsWrapperContent,
        children: [
          /* @__PURE__ */ je.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ je.jsx(
            jl,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ je.jsxs("ol", { children: [
                /* @__PURE__ */ je.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ je.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ je.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ je.jsx("span", { className: yo.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ je.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ je.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ je.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ je.jsx(
            xt,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ je.jsx(
                tr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ je.jsx(
            xt,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ je.jsx(
                tr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ je.jsxs(je.Fragment, { children: [
            /* @__PURE__ */ je.jsx(He, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ je.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: yo.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ je.jsx(b, { alignContent: "start", children: /* @__PURE__ */ je.jsx(
              Ze,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ je.jsx(
                  et,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, kl = [
  // The store id is populated by the OAuth flow, not edited in the form. It is
  // kept here so the runtime widget render can resolve it and so it round-trips
  // on update.
  {
    key: "yotpoStoreId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  // Secret, only written when editing a legacy token-authenticated widget.
  // Excluded from the read path; omitted from the update payload unless the
  // user re-enters it (preserving the stored value).
  {
    key: "yotpoAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], YG = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: fi
  }
], JG = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: BF
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], _h = "YOTPO", QG = {
  enabled: !1,
  name: "",
  ...Sl(
    [],
    kl
  )
}, XG = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: QG
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: F
  } = ur({
    integrationId: e,
    integrationType: _h,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: D
  } = mr({
    integrationId: e,
    fieldDefinitions: kl,
    form: l,
    onMisconfigured: F
  }), { renderConditions: I, setRenderConditions: C, renderConditionsForSubmit: w } = pr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), A = s || !!D?.additionalProperties?.isUsingOAuth, q = (te) => hr(te, {
    fieldDefinitions: kl,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: w
  }), Y = l.watch("name");
  return /* @__PURE__ */ je.jsxs(
    fr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: q,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        k && /* @__PURE__ */ je.jsx(yr, { cause: k }),
        /* @__PURE__ */ je.jsxs(nt, { children: [
          /* @__PURE__ */ je.jsx(Z, { children: /* @__PURE__ */ je.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ je.jsx(
            xn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(Z, { span: 3, children: /* @__PURE__ */ je.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(Z, { span: 3 }),
          !A && /* @__PURE__ */ je.jsxs(je.Fragment, { children: [
            /* @__PURE__ */ je.jsx(
              BF,
              {
                handleChangeText: (te) => l.setValue("yotpoStoreId", te?.target.value ?? "")
              }
            ),
            /* @__PURE__ */ je.jsx(Z, { span: 3, children: /* @__PURE__ */ je.jsx(
              An,
              {
                name: "yotpoStoreId",
                label: "Yotpo store ID",
                control: l.control,
                rules: { required: "Yotpo store ID is required" },
                componentProps: {
                  placeholder: 'See "How to get the Yotpo access token" above.',
                  readOnly: !0,
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ je.jsx(Z, { span: 3 }),
            /* @__PURE__ */ je.jsx(Z, { span: 3, children: /* @__PURE__ */ je.jsx(
              Er,
              {
                name: "yotpoAccessToken",
                label: "Yotpo access token",
                control: l.control,
                isCreationMode: s,
                rules: { required: "Yotpo access token is required" },
                componentProps: {
                  placeholder: "Insert the Yotpo access token",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ je.jsx(Z, { span: 3 })
          ] }),
          /* @__PURE__ */ je.jsx(Z, { span: 3, children: /* @__PURE__ */ je.jsx(He, { label: "Show customer details", children: /* @__PURE__ */ je.jsx(
            xn,
            {
              name: "showCustomerDetails",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(Z, { span: 3 }),
          /* @__PURE__ */ je.jsx(Z, { span: 3, children: /* @__PURE__ */ je.jsx(He, { label: "Show user generated content", children: /* @__PURE__ */ je.jsx(
            xn,
            {
              name: "showUserGeneratedContent",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(Z, { span: 3 }),
          /* @__PURE__ */ je.jsx(Z, { span: 3, children: /* @__PURE__ */ je.jsx(He, { label: "Show loyalty data", children: /* @__PURE__ */ je.jsx(
            xn,
            {
              name: "displayLoyalty",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(Z, { span: 3 }),
          A && !s && e && /* @__PURE__ */ je.jsx(
            fi,
            {
              configuration: n,
              integrationId: e,
              integrationType: _h,
              label: "Authorize with OAuth"
            }
          ),
          o && I !== null && /* @__PURE__ */ je.jsx(Z, { children: o({
            value: I,
            onChange: C,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ je.jsx(
          gr,
          {
            integrationType: _h,
            integrationId: e,
            widgetName: Y,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
}, ZG = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, e8 = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, n8 = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: jW,
  featureSettings: []
} : n ? {
  authSettings: wW,
  featureSettings: [...jF]
} : e ? {
  authSettings: [
    ...$j,
    ...SW
  ],
  featureSettings: [...Tj]
} : {
  authSettings: [
    ...$j,
    ...NW
  ],
  featureSettings: [...Tj]
}, qF = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, t8 = qF(
  YG,
  JG
), r8 = qF(
  xV,
  _V
), HF = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = e8(a?.value, r), s = i !== void 0 ? i : ZG(
    r
  );
  return o !== void 0 ? o : s;
}, qg = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = n8(n), s = t8(r), l = r8(i);
  return {
    SHOPIFY: {
      widget: H7,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      fieldDefinitions: vl,
      WidgetSettings: bW,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: B2,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      fieldDefinitions: Rh,
      WidgetSettings: W2
    },
    GITHUB: {
      widget: HR,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      fieldDefinitions: Oh,
      WidgetSettings: KR
    },
    MIUROS: {
      widget: EB,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      fieldDefinitions: ny,
      WidgetSettings: TB
    },
    KLAVIYO: {
      widget: hV,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: sl,
      WidgetSettings: NV,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...l]
    },
    LINEAR: {
      widget: Y4,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      fieldDefinitions: Qh,
      WidgetSettings: Q4
    },
    VOYADO: {
      widget: _G,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: py,
      WidgetSettings: NG
    },
    LOYALTYLION: {
      widget: F5,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      fieldDefinitions: Xh,
      WidgetSettings: E5
    },
    RECHARGE: {
      widget: rq,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      fieldDefinitions: iy,
      WidgetSettings: aq
    },
    BRAZE: {
      widget: vP,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      fieldDefinitions: il,
      WidgetSettings: bP
    },
    YOTPO: {
      widget: BG,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      fieldDefinitions: kl,
      WidgetSettings: XG,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...s]
    },
    INGRID: {
      widget: bA,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Dh,
      WidgetSettings: _A
    },
    RIVOLOYALTY: {
      widget: Bq,
      icon: "rivoloyalty",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: oy,
      WidgetSettings: lW
    }
  };
}, i8 = (e, n) => {
  const r = n.find(
    (i) => i.key === e.key
  )?.value;
  return e.type === "boolean" ? pI(r, e.defaultValue) : fI(r, e.defaultValue);
}, a8 = (e, n) => e.map((r) => ({
  key: r.key,
  value: i8(r, n)
})), o8 = (e, n) => e.map(({ key: r, type: i, defaultValue: a }) => ({
  key: r,
  value: HF({
    key: r,
    configuration: n,
    settingType: i,
    settingDefault: a
  })
})), s8 = ({ fieldDefinitions: e, settingsConfiguration: n }, r) => e ? a8(
  e.filter(({ secret: i }) => !i),
  r
) : o8(
  (n ?? []).filter(({ secret: i }) => !i),
  r
), l8 = (e) => {
  const n = qg();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: d
    }) => {
      const u = n[i];
      return {
        id: r,
        type: i,
        name: a,
        settings: s8(u, o),
        misconfigured: s,
        renderConditions: l,
        icon: u.icon,
        iconColors: u.iconColors,
        widget: u.widget,
        integrationKey: d
      };
    }
  );
}, iY = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d,
  renderConditionMatchedIndicator: m,
  widgetAnnotations: u
}) => {
  const f = $r(
    {}
  ), h = (w) => (f.current[w] || (f.current[w] = { current: null }), f.current[w]), { track: k } = Fn(), F = Yn(
    () => l8(e),
    [e]
  ), j = {
    headline: "",
    text: "",
    onConfirm: () => C(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [N, x] = me(j), [g, D] = me(!1), I = (w) => {
    D(!0), x(w);
  }, C = () => {
    D(!1), x(j);
  };
  return /* @__PURE__ */ Ke.jsxs(Ke.Fragment, { children: [
    F.map(
      ({
        id: w,
        name: A,
        type: q,
        widget: Y,
        settings: te,
        misconfigured: K,
        renderConditions: J,
        icon: R,
        iconColors: B,
        integrationKey: ne
      }, Ne) => {
        const ue = `partner-integration-${q}`, oe = u?.get(w) === !1, pe = /* @__PURE__ */ Ke.jsx(yy, { icon: R, color: B }), z = te?.reduce(
          (ke, $e) => (ke[$e.key] = $e.value, ke),
          {}
        );
        return s ? /* @__PURE__ */ Ke.jsx("div", { className: "icon-holder", children: pe }, `partner-icon-${w}`) : /* @__PURE__ */ Ke.jsxs(
          xr,
          {
            onToggle: () => {
              k(
                o(ne) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: w,
                  widgetType: q.toLowerCase()
                }
              ), a(ne);
            },
            isOpen: o(ne),
            className: ue,
            containerRef: (ke) => {
              h(ne).current = ke;
            },
            children: [
              /* @__PURE__ */ Ke.jsx(
                xr.Header,
                {
                  className: dt({
                    [TT.unmatchedHeader]: oe
                  }),
                  wrap: "normal",
                  avatar: pe,
                  slotBeforeTitle: d?.(
                    ne,
                    Ne,
                    h(ne)
                  ),
                  slotAfterTitle: /* @__PURE__ */ Ke.jsx(Ke.Fragment, { children: l?.(ne) }),
                  children: /* @__PURE__ */ Ke.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
                    A,
                    m?.(
                      J ?? [],
                      w
                    )
                  ] })
                }
              ),
              /* @__PURE__ */ Ke.jsx(xr.Content, { children: K ? /* @__PURE__ */ Ke.jsx(Tn, { isMisconfigured: !0 }) : /* @__PURE__ */ Ke.jsx(
                _w.Provider,
                {
                  value: {
                    onError: (ke, $e) => console.warn(
                      `Something went wrong with a partner widget of type '${q}' and id '${w}'`,
                      ke,
                      $e
                    )
                  },
                  children: /* @__PURE__ */ Ke.jsx(
                    iC,
                    {
                      integrationId: w,
                      type: q,
                      configuration: n,
                      showNotification: i,
                      showModal: I,
                      children: SI(Y, {
                        conversationContext: r,
                        settings: z
                      })
                    }
                  )
                }
              ) })
            ]
          },
          ne
        );
      }
    ),
    /* @__PURE__ */ Ke.jsx(
      yw,
      {
        isOpen: g,
        setIsOpen: D,
        headline: N.headline,
        text: N.text,
        confirmLabel: N.confirmLabel,
        confirmVariant: N.confirmVariant,
        cancelLabel: N.cancelLabel,
        cancelVariant: N.cancelVariant,
        onConfirm: N.onConfirm ? () => {
          try {
            N.onConfirm && N.onConfirm();
          } finally {
            D(!1), x(j);
          }
        } : void 0,
        onCancel: N.onCancel ? () => {
          try {
            N.onCancel && N.onCancel();
          } finally {
            D(!1), x(j);
          }
        } : void 0,
        children: N.children
      }
    )
  ] });
}, c8 = Fl`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function aY(e, { skip: n = !1 } = {}) {
  const [r, i] = me([]), [a, o] = me(!1);
  return Je(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), rC(e).query({
      query: c8
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const d8 = ({
  widgetConfiguration: e
}) => {
  const n = Yn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = Yn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, u8 = "FULL_ACCESS", m8 = "2", p8 = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [u8],
        version: m8
      })
    }).then((l) => l.json())
  };
}, f8 = "dixaApiToken", Hg = "dixaApiTokenId", WF = "dixaApiTokenName", sw = (e) => [Hg, WF].every(
  (r) => e.find((i) => i?.key === r)
);
function h8({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = y8(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const y8 = (e) => [
  {
    key: f8,
    value: e.value,
    secret: !0
  },
  {
    key: Hg,
    value: e.id,
    secret: !1
  },
  {
    key: WF,
    value: e.name,
    secret: !1
  }
], g8 = "_wrapper_1lmim_1", v8 = "_wrapperBox_1lmim_4", k8 = "_wrapperBoxErrorBorder_1lmim_9", Sh = {
  wrapper: g8,
  wrapperBox: v8,
  wrapperBoxErrorBorder: k8
}, b8 = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (D) => D.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: k } = f, F = `Insert your ${h.label.toLowerCase()}`, j = `Insert your ${k.label.toLowerCase()}`, [N, x] = me({
    username: "",
    password: ""
  }), g = yt(
    (D) => {
      m({
        target: {
          name: s,
          value: D
        }
      });
    },
    [s, m]
  );
  return Je(() => {
    g(
      N.username !== "" && N.password !== "" ? window.btoa(`${N.username}:${N.password}`) : ""
    );
  }, [N]), /* @__PURE__ */ Ke.jsx(
    He,
    {
      required: e,
      label: a,
      meta: l,
      className: Sh.wrapper,
      children: /* @__PURE__ */ Ke.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: dt(Sh.wrapperBox, {
            [Sh.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ Ke.jsx(
              tr,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: F,
                input: {
                  name: s,
                  value: N.username,
                  onChange: (D) => x({
                    username: D?.target.value ?? "",
                    password: N.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ Ke.jsx(
              tr,
              {
                noAlert: !0,
                required: e,
                label: k.label,
                readOnly: n,
                placeholder: j,
                input: {
                  name: s,
                  value: N.password,
                  onChange: (D) => x({
                    username: N.username,
                    password: D?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function lw({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: k,
  isCreationMode: F,
  prefix: j,
  integrationId: N,
  integrationType: x,
  configuration: g,
  settings: D,
  otherProps: I
}) {
  const C = k === "custom" && I?.component, w = u(n)?.value;
  return C ? /* @__PURE__ */ Ke.jsx(
    C,
    {
      configuration: g,
      integrationId: N,
      integrationType: x,
      label: r,
      settings: D,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ Ke.jsxs(Ke.Fragment, { children: [
    /* @__PURE__ */ Ke.jsx(Z, { span: 3, children: /* @__PURE__ */ Ke.jsx(
      x8,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: F,
        children: k === "input" ? /* @__PURE__ */ Ke.jsx(
          tr,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: w,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: j,
            ...e && !F && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : k === "basicAuthInput" ? /* @__PURE__ */ Ke.jsx(
          b8,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: F,
            label: r,
            widgetSettingsKey: n,
            settings: D,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : k === "switch" ? /* @__PURE__ */ Ke.jsx(He, { label: r, children: /* @__PURE__ */ Ke.jsx(
          wl,
          {
            input: {
              name: n,
              value: "",
              checked: w,
              onChange: l
            }
          }
        ) }) : k === "select" ? /* @__PURE__ */ Ke.jsx(He, { label: r, children: /* @__PURE__ */ Ke.jsx(
          ni,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (A) => d(n, A),
            getItemTitleByValue: (A) => A ? /* @__PURE__ */ Ke.jsx($.Paragraph, { children: A.label }) : /* @__PURE__ */ Ke.jsx(Ke.Fragment, {}),
            value: w ? [
              {
                label: (I?.selectItems || []).find(
                  (A) => A.value === w
                )?.label,
                value: w
              }
            ] : [],
            equalityFn: (A, q) => A.value === q.value,
            children: (I?.selectItems || []).map((A) => /* @__PURE__ */ Ke.jsx(ut.Item, { value: A, children: A.label }, A.value))
          }
        ) }) : /* @__PURE__ */ Ke.jsx(Ke.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ Ke.jsx(Z, { span: 3 })
  ] });
}
function x8({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ Ke.jsx(He, { label: n, children: /* @__PURE__ */ Ke.jsxs(
    et,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Fo = "partner-integrations-widget-name-form-field", cw = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: HF({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), _8 = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = me(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = me({}), s = (I) => i(I), l = (I) => !I || I === "", d = (I) => {
    const { [I]: C, ...w } = a;
    o(w);
  }, m = (I) => ({
    ...I,
    settings: I.settings.filter(({ isEditing: C }) => C).map(({ key: C, value: w, secret: A }) => ({
      key: C,
      value: w,
      secret: A
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (I) => {
    if (!I)
      return;
    const {
      target: { name: C, value: w }
    } = I;
    a[C] && !l(w) && d(C), i({
      ...r,
      settings: r.settings.map(
        (A) => A.key === C ? { ...A, value: w } : A
      )
    });
  }, h = (I) => {
    if (!I)
      return;
    const {
      target: { name: C, checked: w }
    } = I;
    i({
      ...r,
      settings: r.settings.map(
        (A) => A.key === C ? { ...A, value: w } : A
      )
    });
  }, k = (I, C) => {
    if (!C)
      return;
    const { selectedValues: w } = C, A = w?.[0];
    if (A) {
      const q = r.settings.map(
        (Y) => Y.key === I ? { ...Y, value: A?.value } : Y
      );
      i({
        ...r,
        settings: q
      });
    } else {
      const q = r.settings.filter(
        (Y) => Y.key !== I
      );
      i({
        ...r,
        settings: q
      });
    }
  }, F = (I) => {
    i({
      ...r,
      enabled: I
    });
  }, j = (I) => {
    if (!I)
      return;
    const {
      target: { value: C }
    } = I;
    a[Fo] && !l(C) && d(Fo), i({
      ...r,
      name: C
    });
  }, N = (I, C) => {
    const { settings: w } = r, A = w.map((q) => q.key === C ? {
      ...q,
      isEditing: I,
      ...!I && { value: "" }
    } : q);
    a[C] && !I && d(C), i({
      ...r,
      settings: A
    });
  }, x = (I) => r.settings.find(
    (C) => C.key === I
  ), g = async (I) => {
    I.preventDefault(), D() && n(m(r));
  }, D = () => {
    const I = {}, { name: C, settings: w } = r;
    return l(C) && (I[Fo] = u.input), w.forEach(
      ({ key: A, value: q, required: Y, isEditing: te, type: K, customValidation: J }) => {
        if (Y && te)
          if (J) {
            const R = J(q);
            typeof R == "string" && (I[A] = R);
          } else
            typeof q == "string" && l(q) && (I[A] = u[K]);
      }
    ), o(I), !Object.keys(I)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: F,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: k,
    handleEditSecret: N,
    handleChangeName: j,
    handleSubmit: g,
    getSettingValueByKey: x,
    initializeFormData: s,
    validate: D
  };
}, S8 = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], dw = "The configuration of the integration is not correct. Please check the settings.", N8 = (e) => {
  const n = qg()[e.type]?.WidgetSettings;
  return n ? /* @__PURE__ */ Ke.jsx(n, { ...e }) : /* @__PURE__ */ Ke.jsx(j8, { ...e });
}, j8 = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const { track: l } = Fn(), { deleteDixaApiToken: d, createDixaApiToken: m } = p8({
    type: n,
    baseUrl: a.baseUrl
  }), f = LI().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), h = !e && !!n && !!f, k = S8.includes(n), [F, j] = me(), [N, x] = me(!1), [g, D] = me(!1), [I, C] = me(!1), [w, A] = me(null), [q, Y] = me(), [te, K] = me(h ? [] : null);
  Je(() => {
    K(h ? [] : null);
  }, [e, h]), Je(() => {
    q && te === null && K(q.renderConditions ?? []);
  }, [q, te]);
  const { isInboundOAuth: J } = hI(), R = J && h ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: B,
    isShopifyMarketplaceApp: ne,
    initialValuesForShopify: Ne
  } = d8({
    featureFlags: a.featureFlags,
    widgetConfiguration: q
  }), ue = n === "YOTPO" && !!q?.additionalProperties?.isUsingOAuth, oe = n === "KLAVIYO" && !!q?.additionalProperties?.isUsingOAuth, pe = h && n === "SHOPIFY", $e = qg({
    SHOPIFY: {
      hasShopifyOAuth: B,
      isShopifyMarketplaceApp: ne,
      isCreationMode: h
    },
    YOTPO: {
      hasOAuth: ue,
      isCreationMode: h
    },
    KLAVIYO: {
      hasOAuth: oe,
      isCreationMode: h
    }
  })[n].settingsConfiguration ?? [], H = $e.filter(({ type: X }) => X !== "hidden").filter(({ hideOnCreate: X }) => h ? !X : !0), Ge = H.filter(
    ({ additionalProperties: X }) => X?.renderAboveForm === !0
  ), sn = H.filter(
    ({ additionalProperties: X }) => X?.renderAboveForm !== !0
  ), {
    error: Fe,
    loading: Ue,
    refetch: Pe
  } = PI(yI, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (X) => {
      if (Object.keys(X).length === 0)
        C(!0);
      else {
        C(!1);
        const ae = X?.Management?.widgetConfigurations?.[0];
        ae && Y({
          ...ae,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${ae.id}`,
          additionalProperties: ae.additionalProperties ?? void 0
        });
      }
    }
  }), [Be, { error: Ae }] = Zg(
    h ? gI : vI,
    {
      onError: (X) => {
        j(X), x(!1), i({
          title: "Something went wrong",
          text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (X) => {
        if (x(!1), Object.keys(X).length !== 0) {
          if (h && r(
            X.Management?.createWidgetConfiguration?.id
          ), !h) {
            const V = X.Management?.updateWidgetConfiguration;
            V?.misconfigured ? A(
              V.misconfigurationCause ?? dw
            ) : A(null);
          }
          if ((h || s) && te) {
            const ae = (q?.renderConditions?.length ?? 0) > 0;
            kI(
              l,
              h,
              te,
              ae
            );
          }
          i({
            title: `${h ? "Creating" : "Updating"} was successful`,
            text: `${h ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [Qe] = Zg(bI, {
    onError: (X) => {
      j(X), x(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      x(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Ce,
    handleIsEnabled: Me,
    errors: nn,
    handleChangeText: le,
    handleChangeBoolean: ce,
    handleChangeSelect: Se,
    handleEditSecret: Le,
    handleChangeName: Re,
    handleSubmit: gn,
    getSettingValueByKey: Q,
    initializeFormData: T
  } = _8({
    onSubmit: async (X) => {
      h ? l("settings:create:submitted", { widgetType: n }) : e && l("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), x(!0);
      const ae = X.settings.map(
        (_e) => typeof _e.value == "boolean" ? { ..._e, value: _e.value.toString() } : _e
      ), V = sw(ae) && h;
      let G = [];
      if (V) {
        const _e = await m().catch(
          (Te) => {
            x(!1), console.warn("API-Token (creation) error resonse", Te), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        _e?.data && (G = h8({
          token: _e.data,
          settings: ae
        }));
      }
      const fe = {
        ...X,
        settings: [
          ...G.length > 0 ? G : ae
        ]
      };
      (V && G.length > 1 || !V && G.length === 0) && (Be({
        variables: {
          ...!h && { id: e },
          ...h && { type: n },
          ...fe,
          ...(h || !!s) && te !== null && { renderConditions: te }
        }
      }), ae.forEach(
        (Te) => Te.secret && Le(!1, Te.key)
      ));
    },
    ...h && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: cw({
          settingsFromBackend: Ne,
          settingsConfiguration: $e,
          creating: !0
        })
      }
    }
  });
  Je(() => {
    if (q) {
      const X = cw({
        settingsFromBackend: q.settings,
        settingsConfiguration: $e
      });
      T({
        enabled: !!q.enabled,
        name: q.name,
        settings: X
      }), q.misconfigured ? A(
        q?.misconfigurationCause ?? dw
      ) : A(null);
    }
  }, [q]);
  const U = Yn(() => o ? !o.isCoupled : !0, [o]);
  return Fe || Ae || F ? /* @__PURE__ */ Ke.jsx(
    Tn,
    {
      error: Fe || F,
      retry: Fe ? Pe : void 0
    }
  ) : N || Ue ? /* @__PURE__ */ Ke.jsx(hn, { "data-testid": "widget-settings-loading" }) : I ? /* @__PURE__ */ Ke.jsxs($.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ Ke.jsx(Jn, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ Ke.jsxs("form", { children: [
    w && /* @__PURE__ */ Ke.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ke.jsx(
      jl,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ Ke.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ Ke.jsx($.Paragraph, { children: w }),
          /* @__PURE__ */ Ke.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ Ke.jsx($.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ Ke.jsx($.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ Ke.jsxs(
      nt,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          Ge.map(
            ({ key: X, label: ae, ...V }) => /* @__PURE__ */ Ke.jsx(
              lw,
              {
                widgetSettingsKey: X,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: Q,
                isSecret: !1,
                label: ae,
                placeholder: "",
                required: !1,
                errors: nn,
                type: "custom",
                isCreationMode: h,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: $e,
                otherProps: V
              },
              X
            )
          ),
          !pe && /* @__PURE__ */ Ke.jsxs(Ke.Fragment, { children: [
            /* @__PURE__ */ Ke.jsx(Z, { children: /* @__PURE__ */ Ke.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ke.jsx(
              wl,
              {
                input: {
                  name: "enabled",
                  checked: Ce.enabled,
                  value: "dummy",
                  onChange: (X) => Me(X.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ Ke.jsx(Z, { span: 3, children: /* @__PURE__ */ Ke.jsx(
              tr,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: Fo,
                  value: Ce.name,
                  onChange: Re
                },
                meta: {
                  error: nn[Fo]
                }
              }
            ) }),
            /* @__PURE__ */ Ke.jsx(Z, { span: 3 })
          ] }),
          !pe && s && te !== null && /* @__PURE__ */ Ke.jsx(Z, { children: s({
            value: te,
            onChange: K,
            configurationKey: q?.id
          }) }),
          sn?.map(
            ({
              key: X,
              secret: ae,
              label: V,
              placeholder: G = "",
              required: fe = !1,
              type: _e,
              prefix: Te,
              readOnly: tn,
              ...vn
            }) => {
              const { settings: on } = Ce, pn = on.find(
                (In) => In.key === X
              );
              return /* @__PURE__ */ Ke.jsx(vw, { children: /* @__PURE__ */ Ke.jsx(
                lw,
                {
                  widgetSettingsKey: X,
                  isEditingField: !!pn?.isEditing,
                  handleEditSecret: Le,
                  handleChangeText: le,
                  handleChangeBoolean: ce,
                  handleChangeSelect: Se,
                  getValueByKey: Q,
                  isSecret: ae,
                  label: V,
                  placeholder: G,
                  required: fe,
                  errors: nn,
                  type: _e,
                  isCreationMode: h,
                  prefix: Te,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: tn,
                  settings: $e,
                  otherProps: vn
                }
              ) }, X);
            }
          )
        ]
      }
    ),
    !pe && /* @__PURE__ */ Ke.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ Ke.jsx(et, { onClick: gn, children: R }),
      !h && /* @__PURE__ */ Ke.jsx(
        Ze,
        {
          content: "The widget is used in automations",
          disabled: U,
          children: /* @__PURE__ */ Ke.jsx(
            et,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && l("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), D(!0);
              },
              disabled: !U,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Ke.jsx(
      yw,
      {
        isOpen: g,
        setIsOpen: D,
        confirmVariant: k ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && l("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && l("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), sw(Ce.settings)) {
            const X = Ce.settings.find(
              ({ key: ae }) => ae === Hg
            )?.value;
            X && d(X).catch((ae) => {
              console.warn("API-Token (deletion) error response", ae), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          Qe({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ Ke.jsx(b, { children: k ? /* @__PURE__ */ Ke.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ Ke.jsx(
            ve,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ Ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ Ke.jsxs($.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ Ke.jsxs($.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ Ke.jsxs($.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Ce.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ Ke.jsxs(Ke.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Ce.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, oY = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => /* @__PURE__ */ Ke.jsx(
  _w.Provider,
  {
    value: {
      onError: (l, d) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        l,
        d
      )
    },
    children: /* @__PURE__ */ Ke.jsx(
      iC,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ Ke.jsx(
          N8,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o,
            renderConditionsEditor: s
          }
        )
      }
    )
  }
), uw = "__PairingContext__", KF = globalThis[uw] ?? (() => {
  const e = kw({});
  return globalThis[uw] = e, e;
})(), sY = () => hy(KF), lY = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Ke.jsx(KF.Provider, { value: e, children: n });
var Os = { exports: {} }, mw;
function w8() {
  if (mw) return Os.exports;
  mw = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(C, w, A) {
    return Function.prototype.apply.call(C, w, A);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(C) {
    return Object.getOwnPropertyNames(C).concat(Object.getOwnPropertySymbols(C));
  } : r = function(C) {
    return Object.getOwnPropertyNames(C);
  };
  function i(I) {
    console && console.warn && console.warn(I);
  }
  var a = Number.isNaN || function(C) {
    return C !== C;
  };
  function o() {
    o.init.call(this);
  }
  Os.exports = o, Os.exports.once = x, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(I) {
    if (typeof I != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof I);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(I) {
      if (typeof I != "number" || I < 0 || a(I))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + I + ".");
      s = I;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(C) {
    if (typeof C != "number" || C < 0 || a(C))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + C + ".");
    return this._maxListeners = C, this;
  };
  function d(I) {
    return I._maxListeners === void 0 ? o.defaultMaxListeners : I._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(C) {
    for (var w = [], A = 1; A < arguments.length; A++) w.push(arguments[A]);
    var q = C === "error", Y = this._events;
    if (Y !== void 0)
      q = q && Y.error === void 0;
    else if (!q)
      return !1;
    if (q) {
      var te;
      if (w.length > 0 && (te = w[0]), te instanceof Error)
        throw te;
      var K = new Error("Unhandled error." + (te ? " (" + te.message + ")" : ""));
      throw K.context = te, K;
    }
    var J = Y[C];
    if (J === void 0)
      return !1;
    if (typeof J == "function")
      n(J, this, w);
    else
      for (var R = J.length, B = F(J, R), A = 0; A < R; ++A)
        n(B[A], this, w);
    return !0;
  };
  function m(I, C, w, A) {
    var q, Y, te;
    if (l(w), Y = I._events, Y === void 0 ? (Y = I._events = /* @__PURE__ */ Object.create(null), I._eventsCount = 0) : (Y.newListener !== void 0 && (I.emit(
      "newListener",
      C,
      w.listener ? w.listener : w
    ), Y = I._events), te = Y[C]), te === void 0)
      te = Y[C] = w, ++I._eventsCount;
    else if (typeof te == "function" ? te = Y[C] = A ? [w, te] : [te, w] : A ? te.unshift(w) : te.push(w), q = d(I), q > 0 && te.length > q && !te.warned) {
      te.warned = !0;
      var K = new Error("Possible EventEmitter memory leak detected. " + te.length + " " + String(C) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      K.name = "MaxListenersExceededWarning", K.emitter = I, K.type = C, K.count = te.length, i(K);
    }
    return I;
  }
  o.prototype.addListener = function(C, w) {
    return m(this, C, w, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(C, w) {
    return m(this, C, w, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(I, C, w) {
    var A = { fired: !1, wrapFn: void 0, target: I, type: C, listener: w }, q = u.bind(A);
    return q.listener = w, A.wrapFn = q, q;
  }
  o.prototype.once = function(C, w) {
    return l(w), this.on(C, f(this, C, w)), this;
  }, o.prototype.prependOnceListener = function(C, w) {
    return l(w), this.prependListener(C, f(this, C, w)), this;
  }, o.prototype.removeListener = function(C, w) {
    var A, q, Y, te, K;
    if (l(w), q = this._events, q === void 0)
      return this;
    if (A = q[C], A === void 0)
      return this;
    if (A === w || A.listener === w)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete q[C], q.removeListener && this.emit("removeListener", C, A.listener || w));
    else if (typeof A != "function") {
      for (Y = -1, te = A.length - 1; te >= 0; te--)
        if (A[te] === w || A[te].listener === w) {
          K = A[te].listener, Y = te;
          break;
        }
      if (Y < 0)
        return this;
      Y === 0 ? A.shift() : j(A, Y), A.length === 1 && (q[C] = A[0]), q.removeListener !== void 0 && this.emit("removeListener", C, K || w);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(C) {
    var w, A, q;
    if (A = this._events, A === void 0)
      return this;
    if (A.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : A[C] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete A[C]), this;
    if (arguments.length === 0) {
      var Y = Object.keys(A), te;
      for (q = 0; q < Y.length; ++q)
        te = Y[q], te !== "removeListener" && this.removeAllListeners(te);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (w = A[C], typeof w == "function")
      this.removeListener(C, w);
    else if (w !== void 0)
      for (q = w.length - 1; q >= 0; q--)
        this.removeListener(C, w[q]);
    return this;
  };
  function h(I, C, w) {
    var A = I._events;
    if (A === void 0)
      return [];
    var q = A[C];
    return q === void 0 ? [] : typeof q == "function" ? w ? [q.listener || q] : [q] : w ? N(q) : F(q, q.length);
  }
  o.prototype.listeners = function(C) {
    return h(this, C, !0);
  }, o.prototype.rawListeners = function(C) {
    return h(this, C, !1);
  }, o.listenerCount = function(I, C) {
    return typeof I.listenerCount == "function" ? I.listenerCount(C) : k.call(I, C);
  }, o.prototype.listenerCount = k;
  function k(I) {
    var C = this._events;
    if (C !== void 0) {
      var w = C[I];
      if (typeof w == "function")
        return 1;
      if (w !== void 0)
        return w.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function F(I, C) {
    for (var w = new Array(C), A = 0; A < C; ++A)
      w[A] = I[A];
    return w;
  }
  function j(I, C) {
    for (; C + 1 < I.length; C++)
      I[C] = I[C + 1];
    I.pop();
  }
  function N(I) {
    for (var C = new Array(I.length), w = 0; w < C.length; ++w)
      C[w] = I[w].listener || I[w];
    return C;
  }
  function x(I, C) {
    return new Promise(function(w, A) {
      function q(te) {
        I.removeListener(C, Y), A(te);
      }
      function Y() {
        typeof I.removeListener == "function" && I.removeListener("error", q), w([].slice.call(arguments));
      }
      D(I, C, Y, { once: !0 }), C !== "error" && g(I, q, { once: !0 });
    });
  }
  function g(I, C, w) {
    typeof I.on == "function" && D(I, "error", C, w);
  }
  function D(I, C, w, A) {
    if (typeof I.on == "function")
      A.once ? I.once(C, w) : I.on(C, w);
    else if (typeof I.addEventListener == "function")
      I.addEventListener(C, function q(Y) {
        A.once && I.removeEventListener(C, q), w(Y);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof I);
  }
  return Os.exports;
}
var C8 = w8();
function cY() {
  const e = new C8.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  CT as GraphQLClientProvider,
  KF as PairingContext,
  lY as PairingProvider,
  iY as PartnerIntegrations,
  oY as PartnerIntegrationsSettings,
  qg as getWidgetDefinitions,
  cY as initializePartnerEventEmitter,
  sY as usePairing,
  aY as usePartnerIntegrationWidgetConfigurations,
  d8 as useShopifyConfiguration
};
